var PaysafeMethodId = /*#__PURE__*/ function(PaysafeMethodId) {
    PaysafeMethodId["Card"] = "CARD";
    PaysafeMethodId["Paypal"] = "PAYPAL";
    PaysafeMethodId["Skrill"] = "SKRILL";
    PaysafeMethodId["PayByBank"] = "PAY_BY_BANK";
    PaysafeMethodId["Paysafecard"] = "PAYSAFECARD";
    PaysafeMethodId["ApplePay"] = "APPLEPAY";
    PaysafeMethodId["GooglePayWithout3ds"] = "GOOGLE_PAY_WITHOUT_3DS";
    PaysafeMethodId["GooglePayWith3ds"] = "GOOGLE_PAY_WITH_3DS";
    return PaysafeMethodId;
}({});
var DevcodeMethodId = /*#__PURE__*/ function(DevcodeMethodId) {
    DevcodeMethodId["Card"] = "CARD";
    DevcodeMethodId["Paypal"] = "PAYPAL";
    DevcodeMethodId["Skrill"] = "SKRILL";
    DevcodeMethodId["CreditCard"] = "CREDITCARD";
    DevcodeMethodId["AstroPayCard"] = "ASTROPAYCARD";
    DevcodeMethodId["Bank"] = "BANK";
    DevcodeMethodId["PayByBank"] = "BANK::PAYBYBANK";
    DevcodeMethodId["BankIBAN"] = "BANKIBAN";
    DevcodeMethodId["Trustly"] = "TRUSTLY";
    DevcodeMethodId["BankLocal"] = "BANKLOCAL";
    DevcodeMethodId["ApplePay"] = "APPLEPAY";
    DevcodeMethodId["MuchBetter"] = "MUCHBETTER";
    return DevcodeMethodId;
}({});
var DevcodeServiceId = /*#__PURE__*/ function(DevcodeServiceId) {
    DevcodeServiceId["PayByBank"] = "PAYBYBANK";
    return DevcodeServiceId;
}({});
var NuveiMethodId = /*#__PURE__*/ function(NuveiMethodId) {
    NuveiMethodId["Bank"] = "BANK";
    NuveiMethodId["Card"] = "cc_card";
    NuveiMethodId["ExpressCheckout"] = "apmgw_expresscheckout";
    return NuveiMethodId;
}({});
var PaymongoMethodId = /*#__PURE__*/ function(PaymongoMethodId) {
    PaymongoMethodId["Grabpay"] = "GRABPAY";
    PaymongoMethodId["Metrobank"] = "METROBANK";
    PaymongoMethodId["Landbank"] = "LANDBANK";
    PaymongoMethodId["Bpi"] = "BPI";
    PaymongoMethodId["TestBpi"] = "TEST_BPI";
    PaymongoMethodId["Ubp"] = "UBP";
    PaymongoMethodId["TestUbp"] = "TEST_UBP";
    PaymongoMethodId["Paymaya"] = "PAYMAYA";
    PaymongoMethodId["Qrph"] = "QRPH";
    PaymongoMethodId["Instapay"] = "INSTAPAY";
    PaymongoMethodId["Pesonet"] = "PESONET";
    PaymongoMethodId["BDO"] = "BDO";
    return PaymongoMethodId;
}({});
var SolairepayMethodId = /*#__PURE__*/ function(SolairepayMethodId) {
    SolairepayMethodId["GCash"] = "GCASH";
    return SolairepayMethodId;
}({});
var ProviderType = /*#__PURE__*/ function(ProviderType) {
    ProviderType["Paysafe"] = "Paysafe";
    ProviderType["Devcode"] = "Devcode";
    ProviderType["Nuvei"] = "Nuvei";
    ProviderType["Paymongo"] = "Paymongo";
    ProviderType["Solairepay"] = "SolairePay";
    return ProviderType;
}({});
const makeProviderMethodId = (provider, method)=>{
    return `${provider}:${method}`;
};

var WalletQueryParams = /*#__PURE__*/ function(WalletQueryParams) {
    WalletQueryParams["TxState"] = "txState";
    WalletQueryParams["Amount"] = "amount";
    WalletQueryParams["CurrencyCode"] = "currencycode";
    WalletQueryParams["TransactionID"] = "transactionid";
    WalletQueryParams["Status"] = "status";
    return WalletQueryParams;
}({});
var View = /*#__PURE__*/ function(View) {
    View["Deposit"] = "deposit";
    View["Withdraw"] = "withdraw";
    View["Bonuses"] = "bonuses";
    return View;
}({});
const viewTypes = Object.keys(View).map((key)=>View[key]);
var CorexProviderType = /*#__PURE__*/ function(CorexProviderType) {
    CorexProviderType["Paysafe"] = "endeavour-paysafe";
    CorexProviderType["Nuvei"] = "endeavour-nuvei";
    CorexProviderType["Devcode"] = "endeavour-devcode";
    CorexProviderType["Paymongo"] = "endeavour-paymongo";
    CorexProviderType["Solairepay"] = "endeavour-solairepay";
    return CorexProviderType;
}({});
const gatewayMethodType = {
    ["endeavour-paysafe"]: PaysafeMethodId,
    ["endeavour-nuvei"]: NuveiMethodId,
    ["endeavour-devcode"]: DevcodeMethodId,
    ["endeavour-paymongo"]: PaymongoMethodId,
    ["endeavour-solairepay"]: SolairepayMethodId
};
var ListenMessageType = /*#__PURE__*/ function(ListenMessageType) {
    ListenMessageType["InitGateways"] = "init-gateways";
    ListenMessageType["UpdateGateways"] = "update-gateways";
    ListenMessageType["UpdateTranslations"] = "update-translations";
    ListenMessageType["UpdateBalance"] = "update-balance";
    ListenMessageType["Device"] = "device";
    ListenMessageType["UpdateView"] = "update-view";
    ListenMessageType["DepositBonuses"] = "deposit-bonuses";
    ListenMessageType["MonthlyTransactions"] = "monthly-transactions";
    ListenMessageType["PendingWithdrawals"] = "pending-withdrawals";
    ListenMessageType["UpdateProfile"] = "update-profile";
    ListenMessageType["DepositParams"] = "sweepx-deposit-params";
    ListenMessageType["UpdateFeatureFlags"] = "update-feature-flags";
    ListenMessageType["InitMagicPaymentMethods"] = "init-magic-payment-methods";
    return ListenMessageType;
}({});
var DispatchMessageType = /*#__PURE__*/ function(DispatchMessageType) {
    DispatchMessageType["ChangeView"] = "change-view";
    DispatchMessageType["LogMessage"] = "log-message";
    DispatchMessageType["OpenTermsConditions"] = "open-tnc";
    DispatchMessageType["DepositCompleted"] = "deposit-completed";
    DispatchMessageType["WithdrawCompleted"] = "withdraw-completed";
    DispatchMessageType["WithdrawResult"] = "withdraw-result";
    DispatchMessageType["DepositResult"] = "deposit-result";
    DispatchMessageType["WithdrawLinkingCompleted"] = "withdraw-linking-completed";
    return DispatchMessageType;
}({});

var LogActionEventName = /*#__PURE__*/ function(LogActionEventName) {
    LogActionEventName["BonsusesIntent"] = "BonsusesIntent";
    LogActionEventName["DepositIntent"] = "DepositIntent";
    LogActionEventName["DepositAttempt"] = "DepositAttempt";
    LogActionEventName["DepositSuccess"] = "DepositSuccess";
    LogActionEventName["DepositError"] = "DepositError";
    LogActionEventName["WithdrawalIntent"] = "withdrawalIntent";
    LogActionEventName["WithdrawalAttempt"] = "WithdrawalAttempt";
    LogActionEventName["WithdrawalSuccess"] = "WithdrawalSuccess";
    LogActionEventName["WithdrawalError"] = "WithdrawalError";
    return LogActionEventName;
}({});
const viewEventMap = {
    [View.Deposit]: "DepositIntent",
    [View.Withdraw]: "withdrawalIntent",
    [View.Bonuses]: "BonsusesIntent"
};

function _class_private_field_loose_base(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
        throw new TypeError("attempted to use private field on non-instance");
    }
    return receiver;
}

var id = 0;
function _class_private_field_loose_key(name) {
    return "__private_" + id++ + "_" + name;
}

function _extends$1() {
    _extends$1 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends$1.apply(this, arguments);
}

/**
 * A small helper to communicate with web components through DOM CustomEvents.
 *
 * It provides:
 * - waitForMessage: returns a Promise that resolves on the first event of the given type.
 * - subscribeForMessage: attaches a handler and returns an unsubscribe function.
 *
 * @public
 */ class HtmlEventMessageChannel {
    waitForMessage(type) {
        return new Promise((resolve)=>{
            const listener = (event)=>{
                const payload = event.detail;
                resolve(payload);
                this.ref.removeEventListener(type, listener);
            };
            this.ref.addEventListener(type, listener);
        });
    }
    subscribeForMessage(type, handler) {
        this.ref.addEventListener(type, handler);
        return ()=>{
            this.ref.removeEventListener(type, handler);
        };
    }
    constructor(ref){
        this.ref = ref;
    }
}

function _type_of$3(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of$3(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const SINGLETON_KEY = Symbol();
const singleton = ()=>(type)=>new Proxy(type, {
            // this will hijack the constructor
            construct (target, argsList, newTarget) {
                // we should skip the proxy for children of our target class
                if (target.prototype !== newTarget.prototype) {
                    return Reflect.construct(target, argsList, newTarget);
                }
                // if our target class does not have an instance, create it
                if (!target[SINGLETON_KEY]) {
                    target[SINGLETON_KEY] = Reflect.construct(target, argsList, newTarget);
                }
                // return the instance we created!
                return target[SINGLETON_KEY];
            }
        });

const defaultWalletState = Object.freeze({
    selectedTabName: null,
    skippedDecimals: [],
    deposit: {
        selectedMethod: null,
        amount: 0
    },
    withdraw: {
        selectedSavedMethod: null,
        selectedMethod: null
    },
    tabMethods: {
        [View.Deposit]: {
            methods: [],
            state: {
                selectedMethod: null,
                selectedSavedMethod: null
            }
        },
        [View.Withdraw]: {
            methods: [],
            state: {
                selectedMethod: null,
                selectedSavedMethod: null
            }
        },
        [View.Bonuses]: {
            methods: [],
            state: {
                selectedMethod: null,
                selectedSavedMethod: null
            }
        }
    },
    loading: false,
    isMobile: false,
    lockedAmount: 0,
    balanceData: {
        balance: 0,
        currencyCode: 'EUR',
        limit: 0,
        withdrawable: 0
    },
    transactions: [],
    pendingWithdrawals: [],
    depositBonuses: [],
    bonuses: [],
    chosenDepositBonus: '',
    depositExtraData: {},
    locale: 'en-US',
    imageUrl: '',
    closedLoopOnly: false,
    features: {
        isClosedLoopEnabled: false,
        isMethodRemovalEnabled: false,
        skrillClosedLoop: false,
        paysafeSkrillAllowSeveralWithdrawalAccounts: false
    }
});
class AppWalletStateInstance {
    get selectedTabState() {
        switch(this.wallet.selectedTabName){
            case View.Withdraw:
                return this.wallet.withdraw;
            default:
                return this.wallet.deposit;
        }
    }
    get shadowRoot() {
        return this.root.shadowRoot;
    }
    get localRegions() {
        const systemLocale = Array.from(navigator.languages || []);
        if (!this.wallet.locale) {
            return systemLocale;
        }
        const [language, region] = this.wallet.locale.split('-');
        return region ? [
            `${language}-${region}`,
            language
        ] : systemLocale;
    }
    constructor(){
        this.wallet = structuredClone(defaultWalletState);
        this.root = null;
        this.methods = {
            deposit: [],
            savedDepositMethods: [],
            withdraw: [],
            withdrawMethodsToDisplay: [],
            magicPaymentMethodsByProvider: {
                Devcode: [],
                Nuvei: [],
                Paymongo: [],
                Paysafe: [],
                SolairePay: []
            }
        };
        this.savedWithdrawMethods = {
            sessionContextId: '',
            paymentHandles: []
        };
    }
}
AppWalletStateInstance = __decorate([
    singleton()
], AppWalletStateInstance);
const AppState = new AppWalletStateInstance();

var ScreenType = /*#__PURE__*/ function(ScreenType) {
    ScreenType["Desktop"] = "desktop";
    ScreenType["Tablet"] = "tablet";
    ScreenType["Mobile"] = "mobile";
    return ScreenType;
}({});
var ERedirectContainer = /*#__PURE__*/ function(ERedirectContainer) {
    ERedirectContainer["Iframe"] = "iframe";
    return ERedirectContainer;
}({});

const MEDIA_QUERIES = {
    tablet: 768,
    desktop: 1024
};
function getScreenType() {
    const width = window.innerWidth;
    if (width >= MEDIA_QUERIES.desktop) {
        return ScreenType.Desktop;
    } else if (width >= MEDIA_QUERIES.tablet) {
        return ScreenType.Tablet;
    } else {
        return ScreenType.Mobile;
    }
}

const formatDate = (date)=>{
    const padZero = (num)=>num.toString().padStart(2, '0');
    const year = date.getFullYear();
    const month = padZero(date.getMonth() + 1); // Months are 0-based
    const day = padZero(date.getDate());
    const hours = padZero(date.getHours());
    const minutes = padZero(date.getMinutes());
    const seconds = padZero(date.getSeconds());
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
const formatCardExpiryDate = (expiryMonth, expiryYear)=>{
    if (!expiryMonth || !expiryYear) {
        console.error('Invalid expiry date: Month or Year is missing');
        return undefined;
    }
    // Ensure expiryMonth is a valid number (1-12)
    const monthNumber = parseInt(expiryMonth, 10);
    if (isNaN(monthNumber) || monthNumber < 1 || monthNumber > 12) {
        console.error('Invalid expiry month:', expiryMonth);
        return undefined;
    }
    // Ensure expiryYear is a valid 4-digit number
    const yearNumber = parseInt(expiryYear, 10);
    if (isNaN(yearNumber) || expiryYear.length !== 4) {
        console.error('Invalid expiry year:', expiryYear);
        return undefined;
    }
    // Format month to always be two digits (e.g., "1" -> "01")
    const month = expiryMonth.padStart(2, '0');
    // Extract last two digits of the year (e.g., "2031" -> "31")
    const year = expiryYear.slice(-2);
    return `${month}/${year}`;
};

const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
async function fetchApi$1(url, method, headers, data, mockResult) {
    try {
        const response = await fetch(url, {
            method,
            headers: _extends$1({}, defaultHeaders, headers),
            body: data ? JSON.stringify(data) : undefined
        });
        const objectResponse = await response.json();
        if (objectResponse.error) {
            throw new Error(`API failed fetching ${url}. error: ${JSON.stringify(objectResponse)}`);
        }
        return objectResponse;
    } catch (error) {
        console.error(`An error occurred calling the ${url}`, error);
        if (mockResult) {
            return Promise.resolve(mockResult);
        }
        return Promise.reject(error);
    }
}
const httpUtils = {
    fetchApi: fetchApi$1,
    defaultHeaders
};

/**
 * An util to filter and merge payment methods from Magic CMS with
 * the methods cashier calls directly
 */ function mapMagicMethods(methods, magicMethods, matchFn, mergeFn) {
    if (!AppState.wallet.features.enhancedGalleonCashierConfiguration) {
        return methods;
    }
    const mergedPaymentMethods = [];
    methods.forEach((method)=>{
        const magicMethod = magicMethods.find((m)=>matchFn(method, m));
        if (magicMethod) {
            mergedPaymentMethods.push(mergeFn ? mergeFn(method, _extends$1({}, magicMethod, {
                magicPaymentMethodFromCMS: true
            })) : _extends$1({}, method, magicMethod, {
                magicPaymentMethodFromCMS: true
            }));
        }
    });
    return mergedPaymentMethods;
}
function isMagicPaymentMethod(method) {
    return 'magicPaymentMethodFromCMS' in method;
}
/**
 * An util to get the payment method name by language with fallback to english
 */ function getMagicPaymentMethodNameByLanguage(method, language) {
    var _method_markets_language, _method_markets, _method_markets_en, _method_markets1;
    return ((_method_markets = method.markets) == null ? void 0 : (_method_markets_language = _method_markets[language]) == null ? void 0 : _method_markets_language.paymentMethodName) || ((_method_markets1 = method.markets) == null ? void 0 : (_method_markets_en = _method_markets1['en']) == null ? void 0 : _method_markets_en.paymentMethodName);
}
function getMagicPaymentMethodLogoByMarket(method, language) {
    var _method_markets_language, _method_markets, _method_markets_en, _method_markets1;
    const logoUrl = ((_method_markets = method.markets) == null ? void 0 : (_method_markets_language = _method_markets[language]) == null ? void 0 : _method_markets_language.logo) || ((_method_markets1 = method.markets) == null ? void 0 : (_method_markets_en = _method_markets1['en']) == null ? void 0 : _method_markets_en.logo);
    return getMagicCashierLogo(logoUrl);
}
function getMagicCashierLogo(logoUrl) {
    return `${AppState.wallet.imageUrl}/cashier/logo/${logoUrl}`;
}

const emitDepositResult = (data)=>{
    AppState.root.dispatchEvent(new CustomEvent(DispatchMessageType.DepositResult, {
        detail: data
    }));
    AppState.wallet.deposit.selectedMethod = null;
};

const mockupPreselectedAmounts = {
    AUD: [
        25,
        50,
        100
    ],
    CAD: [
        25,
        50,
        100
    ],
    EUR: [
        25,
        50,
        100
    ],
    GBP: [
        25,
        50,
        100
    ],
    NOK: [
        250,
        500,
        1000
    ],
    SEK: [
        250,
        500,
        1000
    ],
    USD: [
        25,
        50,
        100
    ],
    NZD: [
        25,
        50,
        100
    ],
    RON: [
        100,
        250,
        500
    ],
    ZAR: [
        500,
        1000,
        1500
    ],
    ARS: [
        3000,
        6000,
        9000
    ],
    THB: [
        1000,
        2000,
        4000
    ],
    PHP: [
        500,
        1000,
        50000
    ],
    CLP: [
        20000,
        40000,
        80000
    ],
    INR: [
        2000,
        4000,
        8000
    ],
    KRW: [
        35000,
        70000,
        140000
    ],
    LKR: [
        5000,
        10000,
        20000
    ],
    ZMW: [
        500,
        1000,
        2000
    ],
    PEN: [
        100,
        200,
        400
    ],
    BRL: [
        150,
        300,
        600
    ]
};

function calculatePreselectedAmounts(method) {
    var _AppState_wallet_skippedDecimals;
    var _method_maxAmount;
    const maxAmount = (_method_maxAmount = method.maxAmount) != null ? _method_maxAmount : Infinity;
    var _method_minAmount;
    const minAmount = (_method_minAmount = method.minAmount) != null ? _method_minAmount : 0;
    const predefinedAmounts = (mockupPreselectedAmounts[method.currencyCode] || []).map((amount)=>valueInLimits(amount, maxAmount, minAmount));
    const depositTransactions = AppState.wallet.transactions;
    if (depositTransactions.length === 0) {
        return predefinedAmounts;
    }
    const LAST_AMOUNT = Math.max(Number(depositTransactions[0].amount), method.minAmount || 0);
    let lastThreeAmount = 0;
    depositTransactions.slice(0, 3).forEach((transaction)=>{
        lastThreeAmount += Number(transaction.amount);
    });
    const AVG = lastThreeAmount / depositTransactions.slice(0, 3).length;
    const amounts = [
        valueInLimits(LAST_AMOUNT, maxAmount, minAmount),
        valueInLimits(_roundToFive(AVG * 2.5), maxAmount, minAmount),
        valueInLimits(_roundToFive(AVG * 5), maxAmount, minAmount)
    ];
    if ((_AppState_wallet_skippedDecimals = AppState.wallet.skippedDecimals) == null ? void 0 : _AppState_wallet_skippedDecimals.includes(method.currencyCode)) {
        amounts.forEach((amount, index)=>{
            amounts[index] = Math.floor(amount);
        });
    }
    return amounts;
}
function valueInLimits(amount, maxAmount, minAmount = 0) {
    return Math.max(minAmount, Math.min(amount, maxAmount));
}
function _roundToFive(x) {
    return Math.ceil(x / 5) * 5;
}

const regions = Array.from(navigator.languages || []);
/**
 * Formats an amount of money to be displayed with its currency
 * @param amount - amount of money
 * @param currency - the currency of the money, e.g. EUR
 * @param decimals - number of decimals to be used as `maximumFractionDigits`
 */ function formatCurrency(amount, currency, decimals) {
    const locales = getGlobalLocale();
    const currencyFormat = new Intl.NumberFormat(locales, {
        style: 'currency',
        currency,
        // if maximum is less than 2 we need to specify range
        minimumFractionDigits: decimals && decimals < 2 ? 0 : undefined,
        maximumFractionDigits: decimals
    });
    return currencyFormat.format(amount);
}
function getGlobalLocale() {
    return AppState.localRegions || regions;
}
function getCurrencySymbol(iso3Currency) {
    var _numberFormatParts_find;
    if (!iso3Currency) {
        console.error('no currency code provided');
        return '';
    }
    const locales = getGlobalLocale();
    const numberFormat = new Intl.NumberFormat(locales, {
        style: 'currency',
        currency: iso3Currency
    });
    const numberFormatParts = numberFormat.formatToParts(1);
    return numberFormatParts == null ? void 0 : (_numberFormatParts_find = numberFormatParts.find((part)=>part.type === 'currency')) == null ? void 0 : _numberFormatParts_find.value;
}

var _translations = /*#__PURE__*/ _class_private_field_loose_key("_translations");
class WalletTranslations {
    static get instance() {
        if (!this._instance) {
            this._instance = new WalletTranslations();
        }
        return this._instance;
    }
    updateTranslations(translations) {
        _class_private_field_loose_base(this, _translations)[_translations] = translations.reduce((prev, curr)=>Object.assign(prev, {
                [curr.uniqID]: curr.val
            }), {});
    }
    getTranslations() {
        return _class_private_field_loose_base(this, _translations)[_translations];
    }
    constructor(){
        Object.defineProperty(this, _translations, {
            writable: true,
            value: void 0
        });
    }
}
function translate(key) {
    const translations = WalletTranslations.instance.getTranslations();
    if (!translations) {
        console.warn('No translations were found');
        return '';
    }
    return translations[key] || '';
}

function getTooltipTemplate(title, subtitle) {
    return `
   <div class="tooltip" part="tooltip">
    <magic-ui-tooltip type="sticky">
        <div>
          <magic-ui-icon
            name="info"
            class="tooltip__icon"
            part="tooltip__icon"
          ></magic-ui-icon>
        </div>
        <div class="tooltip__content" slot="content">
          <magic-ui-icon
            name="close_tooltip"
            class="tooltip__close-icon"
            part="tooltip__close-icon"
          ></magic-ui-icon>
          <magic-ui-text
            tag="b"
            class="tooltip__heading"
            part="tooltip__heading"
            content="${title}"
          ></magic-ui-text>
          <magic-ui-text
            tag="p"
            class="tooltip__subtitle"
            part="tooltip__subtitle"
            content="${subtitle}"
          ></magic-ui-text>
        </div>
      </magic-ui-tooltip>
   </div>
  `;
}

function renderBonusSection() {
    return `<div class="bonus-section" part="bonus-section"></div>`;
}
function renderSuggestedAmounts(method) {
    const amounts = calculatePreselectedAmounts(method);
    if (amounts.length === 0) {
        return `<div>No suggested amounts available</div>`;
    }
    const currencyDecimals = AppState.wallet.skippedDecimals.includes(method.currencyCode) ? 0 : 2;
    return `
    <div class="suggested-amounts" part="suggested-amounts">
      <magic-ui-text
        tag="b"
        class="suggested-amounts__title"
        part="suggested-amounts__title"
        content="${translate('galleon.amount.suggested')}"
      ></magic-ui-text>
      <div
        class="suggested-amounts__buttons"
        part="suggested-amounts__buttons"
      >
        ${amounts.map((amount)=>`
            <magic-ui-button
              class="button suggested-amounts__button"
              part="button suggested-amounts__button"
              number=${amount}
              value=${amount}
              variant="primary"
              hollow
              small
            >
              ${formatCurrency(amount, method.currencyCode, currencyDecimals)}
            </magic-ui-button>
            `).join('')}
      </div>
    </div>
  `;
}
function renderAmountTitle(currencySymbol, shouldAddCVC = false) {
    const amountHeader = translate('galleon.amount.header.currency').replace('{currency}', currencySymbol);
    const additionalContent = shouldAddCVC ? ` <div class="amount-screen__cvc" part="amount-screen__cvc">
          ${getTooltipTemplate('CVC', translate('galleon.deposit.tooltip.cvc.subtitle'))}
          <magic-ui-text
            tag="b"
            class="amount-screen__title"
            part="amount-screen__title"
            content="CVC"
          ></magic-ui-text>
        </div>` : '';
    return `
    <div class="amount-screen__header" part="amount-screen__header">
      <magic-ui-text
        tag="b"
        class="amount-screen__title"
        part="amount-screen__title"
        content="${amountHeader}"
      ></magic-ui-text>
      ${additionalContent}
    </div>
  `;
}
function renderDepositSection(method, shouldAddCVC = false) {
    const additionalContent = shouldAddCVC ? `<magic-ui-form-field
          class="amount-screen__field cvc-form-field"
          data-method-id=${method.id}
          placeholder="${translate('galleon.input.placeholder')}"
          type="text"
        ></magic-ui-form-field>` : '';
    return `
    <div class="amount-screen__deposit" part="amount-screen__deposit">
      <div class="amount-screen__input" part="amount-screen__input">
        <magic-ui-form-field
          class="amount-screen__field input-form-field"
          data-method-id=${method.id}
          placeholder="${translate('galleon.input.placeholder')}"
          type="text"
        ></magic-ui-form-field>
        ${additionalContent}
      </div>
      <magic-ui-button
        class="button amount-screen__submit"
        part="button amount-screen__submit"
        disabled=${false}
        variant="primary"
      >
        ${translate('galleon.deposit.button') || 'Deposit'}
      </magic-ui-button>
    </div>
  `;
}
function renderErrorMessage(method, shouldAddCVC = false) {
    return `
    <div
      class="amount-screen__container ${shouldAddCVC ? 'half' : ''}" 
      part="amount-screen__error-container">
      <magic-ui-text
        tag="p"
        class="amount-screen__error"
        part="amount-screen__error"
        content='${translate('galleon.deposit.amount.error').replace('{minAmount}', formatCurrency(method.minAmount, method.currencyCode)).replace('{maxAmount}', formatCurrency(method.maxAmount, method.currencyCode))}'
      ></magic-ui-text>
    </div>
  `;
}
function renderCVCErrorMessage() {
    return `
    <magic-ui-text
      tag="p"
      class="amount-screen__error-cvc"
      part="amount-screen__error-cvc"
      content='${translate('galleon.deposit.card.details.cvc.error')}'
    ></magic-ui-text>
  `;
}
function getAmountScreen(method, shouldAddCVC = false) {
    const currencySymbol = getCurrencySymbol(method == null ? void 0 : method.currencyCode);
    const suggestedAmounts = renderSuggestedAmounts(method);
    if (suggestedAmounts === `<div>No suggested amounts available</div>`) {
        return suggestedAmounts;
    }
    return `
    <div class="amount-screen" part="amount-screen" data-method-id=${method.id}>
      ${renderBonusSection()}
      ${suggestedAmounts}
      ${renderAmountTitle(currencySymbol, shouldAddCVC)}
      ${renderDepositSection(method, shouldAddCVC)}
      <div class="amount-screen__errors" part="amount-screen__errors">
        ${renderErrorMessage(method, shouldAddCVC)}
        ${shouldAddCVC ? renderCVCErrorMessage() : ''}
      </div>
    </div>
  `;
}

function handleNumericInput(value, formField, submitButton, errorConfig, options) {
    formField.setAttribute('value', value || '');
    if (value === '' || value === null || value === undefined) {
        resetFieldState(formField, submitButton, errorConfig);
        return;
    }
    const numericValue = Number(value);
    if (isNaN(numericValue)) {
        setFieldError(formField, submitButton, errorConfig, 'invalid');
        return;
    }
    if ((options == null ? void 0 : options.balance) !== undefined && numericValue > (options == null ? void 0 : options.balance)) {
        setFieldError(formField, submitButton, errorConfig, 'balance');
        return;
    }
    if (options == null ? void 0 : options.config) {
        const { minAmount = 0, maxAmount = Infinity } = options.config;
        if (numericValue < minAmount || numericValue > maxAmount) {
            setFieldError(formField, submitButton, errorConfig, 'invalid');
            return;
        }
    }
    var _options_shouldEnableBtn;
    setFieldSuccess(formField, submitButton, errorConfig, (_options_shouldEnableBtn = options == null ? void 0 : options.shouldEnableBtn) != null ? _options_shouldEnableBtn : true);
    return true;
}
function attachSuggestedAmountListeners(buttonWrapper, formField, submitButton, errorConfig, customHandler, shouldEnableBtn = true) {
    const buttonElements = buttonWrapper.querySelectorAll('.suggested-amounts__button');
    buttonElements.forEach((button)=>{
        button.addEventListener('click', ()=>{
            const value = button.getAttribute('value') || '';
            formField.setAttribute('value', value);
            if (value !== '') {
                setFieldSuccess(formField, submitButton, errorConfig, shouldEnableBtn);
            }
            if (customHandler) {
                customHandler(value);
            }
        });
    });
}
function resetFieldState(formField, submitButton, errorConfig) {
    formField.removeAttribute('hasError');
    formField.removeAttribute('hasSuccess');
    submitButton.setAttribute('disabled', 'true');
    Object.values(errorConfig).forEach((errorElement)=>{
        errorElement == null ? void 0 : errorElement.classList.remove('active');
    });
}
function showErrorFieldByType(errorConfig, errorType = 'invalid') {
    Object.entries(errorConfig).forEach(([key, errorElement])=>{
        if (key === errorType) {
            errorElement == null ? void 0 : errorElement.classList.add('active');
        } else {
            errorElement == null ? void 0 : errorElement.classList.remove('active');
        }
    });
}
function setFieldError(formField, submitButton, errorConfig, errorType) {
    formField.setAttribute('hasError', 'true');
    formField.removeAttribute('hasSuccess');
    submitButton.setAttribute('disabled', 'true');
    showErrorFieldByType(errorConfig, errorType);
}
function setFieldSuccess(formField, submitButton, errorConfig, shouldEnableBtn = true) {
    formField.setAttribute('hasSuccess', 'true');
    formField.removeAttribute('hasError');
    if (shouldEnableBtn) {
        submitButton.removeAttribute('disabled');
    }
    Object.values(errorConfig).forEach((errorElement)=>{
        errorElement == null ? void 0 : errorElement.classList.remove('active');
    });
}
function checkErrorMessage(isValid, formField, submitButton, errorConfig) {
    if (!isValid) {
        setFieldError(formField, submitButton, errorConfig, 'invalid');
    } else {
        setFieldSuccess(formField, submitButton, errorConfig, false);
    }
}

function getCurrentTab() {
    var _AppState_root;
    return (_AppState_root = AppState.root) == null ? void 0 : _AppState_root.shadowRoot.querySelector('.tab-content');
}
function getTabs() {
    return AppState.root.shadowRoot.querySelectorAll('.tab-link');
}

const getSelectedBonus = ()=>{
    var _AppState_wallet_depositBonuses, _AppState_wallet;
    return (_AppState_wallet = AppState.wallet) == null ? void 0 : (_AppState_wallet_depositBonuses = _AppState_wallet.depositBonuses) == null ? void 0 : _AppState_wallet_depositBonuses.find((value)=>{
        var _AppState_wallet;
        return value.id === ((_AppState_wallet = AppState.wallet) == null ? void 0 : _AppState_wallet.chosenDepositBonus);
    });
};
function getBonusGoal() {
    var _getSelectedBonus_bonusAmount, _getSelectedBonus;
    return ((_getSelectedBonus = getSelectedBonus()) == null ? void 0 : (_getSelectedBonus_bonusAmount = _getSelectedBonus.bonusAmount) == null ? void 0 : _getSelectedBonus_bonusAmount[AppState.wallet.balanceData.currencyCode]) || 0;
}
function getMinBonus() {
    var _getSelectedBonus_minAmount, _getSelectedBonus;
    return ((_getSelectedBonus = getSelectedBonus()) == null ? void 0 : (_getSelectedBonus_minAmount = _getSelectedBonus.minAmount) == null ? void 0 : _getSelectedBonus_minAmount[AppState.wallet.balanceData.currencyCode]) || 0;
}

const getBonusBarTemplate = (deposit = '0', bonusData = getSelectedBonus())=>{
    const goal = getBonusGoal();
    if (!AppState.wallet.chosenDepositBonus || !bonusData || !goal) {
        return ``;
    }
    const goalValue = formatCurrency('' + goal, AppState.wallet.balanceData.currencyCode);
    const goalText = translate('galleon.bonus.play').replace('{amount}', goalValue);
    return `
    <div class="bonus-bar" part="bonus-bar">
      <magic-ui-text
          tag="b"
          class="bonus-bar__title"
          part="bonus-bar__title"
          content="${bonusData.title}"
        ></magic-ui-text>
      <div class="bonus-bar__progress" part="bonus-bar__progress">
        <div class="bonus-bar__progress-fill" part="bonus-bar__progress-fill"></div>
      </div>
      <div class="bonus-bar__info" part="bonus-bar__info">
      <magic-ui-text
          tag="b"
          class="bonus-bar__info-deposit"
          part="bonus-bar__info-deposit"
          content="${deposit}"
        ></magic-ui-text>
        <magic-ui-text
          tag="b"
          class="bonus-bar__info-goal"
          part="bonus-bar__info-goal"
          content="${goalText}"
        ></magic-ui-text>
</div>
    </div>
  `;
};

const renderBonusBar = (depositValue = AppState.wallet.deposit.amount)=>{
    const currentTab = getCurrentTab();
    const bonusSection = currentTab.querySelector('.bonus-section');
    if (bonusSection) {
        bonusSection.innerHTML = getBonusBarTemplate(getBonusBarDepositText(depositValue));
        updateProgressBar();
    }
};
function getBonusBarDepositText(deposit) {
    const value = formatCurrency('' + (deposit || '0'), AppState.wallet.balanceData.currencyCode);
    return translate('galleon.bonus.depositing').replace('{amount}', value);
}
const updateProgressBar = ()=>{
    const deposit = AppState.wallet.deposit.amount || 0;
    const goal = getBonusGoal();
    if (!goal) return;
    // Calculate the progress percentage
    const currentTab = getCurrentTab();
    // Select the progress bar fill element
    const progressBarFill = currentTab.querySelector('.bonus-bar__progress-fill');
    // Update the width of the progress bar fill
    if (progressBarFill) {
        const progress = getMinBonus() <= deposit ? Math.min(deposit / goal, 1) * 100 : 0; // Ensure the progress does not exceed 100%
        progressBarFill.style.width = `${progress}%`;
        const goalAchieved = progress >= 100;
        if (goalAchieved) {
            progressBarFill.classList.add('fulfilled');
        } else {
            progressBarFill.classList.remove('fulfilled');
        }
    }
    const inputValue = currentTab.querySelector('.bonus-bar__info-deposit');
    if (inputValue) {
        inputValue == null ? void 0 : inputValue.setAttribute('content', getBonusBarDepositText(deposit));
    }
};

function getActiveMethod(methodDiv, depositMethods) {
    var _methodDiv_querySelector;
    const methodId = (_methodDiv_querySelector = methodDiv.querySelector('.accordion')) == null ? void 0 : _methodDiv_querySelector.getAttribute('data-method-id');
    return depositMethods.find((m)=>m.id === methodId);
}
function attachAccordionListener(methodDiv, onToggle) {
    if (methodDiv) {
        const paymentMethodClickArea = methodDiv.querySelector('.payment-method');
        paymentMethodClickArea.addEventListener('click', function() {
            onToggle(methodDiv);
        });
    }
}
function attachLockedAmountListener(methodDiv, onClick) {
    methodDiv.addEventListener('click', function() {
        onClick(methodDiv);
    });
}
function addAmountScreen(methodDiv, savedMethod, shouldAddCVC = false) {
    const depositMethods = AppState.methods.deposit;
    const depositMethod = getActiveMethod(methodDiv, depositMethods);
    const method = depositMethod || savedMethod;
    if (method) {
        const amountHTML = getAmountScreen(method, shouldAddCVC);
        const amountontainer = document.createElement('div');
        amountontainer.className = 'suggestion-container';
        amountontainer.innerHTML = amountHTML;
        methodDiv.appendChild(amountontainer);
        AppState.wallet.deposit.amount = 0;
        renderBonusBar();
    }
}
function attachInputListener$2(methodDiv, depositMethod, shouldEnableBtn) {
    const formField = methodDiv.querySelector('.input-form-field');
    if (formField) {
        formField.addEventListener('input', function(event) {
            var _customEvent_detail, _customEvent_detail1;
            const customEvent = event;
            const value = (customEvent == null ? void 0 : (_customEvent_detail = customEvent.detail) == null ? void 0 : _customEvent_detail.value) || ((_customEvent_detail1 = customEvent.detail) == null ? void 0 : _customEvent_detail1[0]);
            handleInput(value, methodDiv, depositMethod, shouldEnableBtn);
        });
    }
}
function handleInput(value, methodDiv, depositMethod, shouldEnableBtn = true) {
    const formField = methodDiv.querySelector('.input-form-field');
    formField.setAttribute('value', value || '');
    const depositButton = methodDiv.querySelector('.amount-screen__submit');
    const errorText = methodDiv.querySelector('.amount-screen__error');
    const methodId = depositMethod.id;
    if (!methodId) return;
    const method = depositMethod;
    const { minAmount = 0, maxAmount = Infinity } = method;
    const errorConfig = {
        invalid: errorText
    };
    const fieldConfig = {
        minAmount: minAmount,
        maxAmount: maxAmount
    };
    const isValid = handleNumericInput(value, formField, depositButton, errorConfig, {
        config: fieldConfig,
        shouldEnableBtn
    });
    if (isValid) {
        AppState.wallet.deposit.amount = +value;
    } else {
        AppState.wallet.deposit.amount = 0;
    }
    updateProgressBar();
}
function attachButtonListener(methodDiv, options) {
    const formField = methodDiv.querySelector('.input-form-field');
    const buttonWrapper = methodDiv.querySelector('.suggested-amounts__buttons');
    const depositButton = methodDiv.querySelector('.amount-screen__submit');
    const errorText = methodDiv.querySelector('.amount-screen__error');
    const errorConfig = {
        invalid: errorText
    };
    var _options_shouldEnableBtn;
    attachSuggestedAmountListeners(buttonWrapper, formField, depositButton, errorConfig, (value)=>{
        var _options_onInputChange;
        AppState.wallet.deposit.amount = +value;
        updateProgressBar();
        options == null ? void 0 : (_options_onInputChange = options.onInputChange) == null ? void 0 : _options_onInputChange.call(options, value);
    }, (_options_shouldEnableBtn = options == null ? void 0 : options.shouldEnableBtn) != null ? _options_shouldEnableBtn : true);
    depositButton.addEventListener('click', function() {
        const disabledButton = depositButton.getAttribute('disabled');
        if (disabledButton !== null) {
            return;
        }
        depositButton.setAttribute('disabled', 'true');
        depositButton.setAttribute('loading', 'true');
        const inputValue = formField.getAttribute('value');
        if (options == null ? void 0 : options.isSavedMethod) {
            AppState.wallet.deposit.selectedSavedMethod.deposit(+inputValue);
        } else {
            AppState.wallet.deposit.selectedMethod.deposit(+inputValue);
        }
    });
}
function statusButtonsHandler(content, callback) {
    const button = content.querySelector(`.status-screen__button`);
    button == null ? void 0 : button.addEventListener('click', ()=>{
        if (button.getAttribute('disabled')) {
            return;
        }
        callback();
        button.setAttribute('loading', 'true');
        button.setAttribute('disabled', 'true');
    });
}

const getMethodDivById = (id)=>{
    const content = AppState.shadowRoot.querySelector('.tab-content');
    return content.querySelector(`.method-${id}`);
};
const getAccordionByMethodDiv = (methodDiv)=>{
    return methodDiv.querySelector(`.accordion`);
};
function removeAmountScreen(methodDiv) {
    const suggestionContainer = methodDiv.querySelector('.suggestion-container');
    if (suggestionContainer) {
        suggestionContainer.remove();
    }
}
const handleAccordionToggle$1 = (method)=>(methodDiv)=>{
        const selectedTabState = AppState.selectedTabState;
        const selectedMethod = method.isSavedMethod ? 'selectedSavedMethod' : 'selectedMethod';
        const stateSelectedMethod = selectedTabState == null ? void 0 : selectedTabState[selectedMethod];
        if (stateSelectedMethod == null ? void 0 : stateSelectedMethod.id) {
            const prevMethodDiv = getMethodDivById(stateSelectedMethod.id);
            if (prevMethodDiv) {
                removeAmountScreen(prevMethodDiv);
                toggleAccordionByMethod(prevMethodDiv, true);
            }
        }
        const isTheSameMethod = (stateSelectedMethod == null ? void 0 : stateSelectedMethod.id) === (method == null ? void 0 : method.id);
        toggleAccordionByMethod(methodDiv, isTheSameMethod);
        if (isTheSameMethod) {
            AppState.wallet.deposit[selectedMethod] = null;
            removeAmountScreen(methodDiv);
        } else {
            AppState.wallet.deposit[selectedMethod] = method;
            addAmountScreen(methodDiv, method);
            attachInputListener$2(methodDiv, method);
            attachButtonListener(methodDiv, {
                isSavedMethod: method.isSavedMethod
            });
        }
    };
function toggleAccordionByMethod(methodDiv, collapsed) {
    const currentOpenAccordion = getAccordionByMethodDiv(methodDiv);
    if (collapsed) {
        currentOpenAccordion == null ? void 0 : currentOpenAccordion.removeAttribute('initially-visible');
    } else {
        currentOpenAccordion == null ? void 0 : currentOpenAccordion.setAttribute('initially-visible', 'true');
    }
    currentOpenAccordion.initiallyVisible = !collapsed;
}

function createButtonLoader() {
    const button = document.createElement('magic-ui-button');
    button.setAttribute('icon', '');
    button.setAttribute('round', '');
    button.setAttribute('loading', '');
    button.setAttribute('hollow', '');
    button.setAttribute('no-margin', '');
    button.setAttribute('no-padding', '');
    button.setAttribute('variant', 'transparent');
    button.classList.add('loader-button');
    return button;
}
function createPageLoader() {
    const loader = document.createElement('magic-ui-loader');
    loader.classList.add('page-loader');
    return loader;
}
const scrollToTop = (value = 0, typeMove = 'smooth')=>{
    window.scrollTo({
        top: value,
        behavior: typeMove
    });
};

function getDepositStatusScreenTemplate(data) {
    const title = data.specificTitle || (data.success ? translate('galleon.success.title') : translate('galleon.error.title'));
    const buttonClass = `status-screen__button status-screen__button-${data.success ? 'success' : 'failure'}`;
    return `
    <div class="status-screen" part="status-screen">
        <magic-ui-icon
          name="${data.success ? 'cashier-result-check' : 'cashier-result-close'}"
          class="icon status-screen__icon"
        ></magic-ui-icon>
        <magic-ui-text
          tag="b"
          class="status-screen__title"
          part="status-screen__title"
          content='${title}'
        ></magic-ui-text>
        ${data.success ? getSuccessMessage$1(data) : getErrorMessage$1(data == null ? void 0 : data.errorText)}
        <magic-ui-button
            class="${buttonClass}"
            part="status-screen__button"
            variant="primary"
            small
        >
          ${data.success ? translate('galleon.success.screen.button') : translate('galleon.error.screen.button')}
        </magic-ui-button>
    </div>
  `;
}
function getSuccessMessage$1(data) {
    const specificDescription = translate('galleon.success.description').replace('{amount}', formatCurrency(data.amount, data.currencyCode)).replace('{paymentMethod}', data.paymentMethodLabel).replace('{transactionID}', data.transactionID);
    return `
        <slot name="deposit-success">
                 <magic-ui-text
                    tag="p"
                    class="status-screen__text"
                    part="status-screen__text"
                    content='${data.specificMessage || specificDescription}'
                    is-markdown
                  ></magic-ui-text>
          </slot>
    `;
}
function getErrorMessage$1(specificError) {
    const description = translate('galleon.error.description');
    return `
        <slot name="deposit-error">
                 <magic-ui-text
                    tag="p"
                    class="status-screen__text"
                    part="status-screen__text"
                    content='${specificError || description}'
                    is-markdown
                  ></magic-ui-text>
          </slot>
    `;
}

function getDepositTemplate$1() {
    return `
    <magic-ui-text
      tag="b"
      class="select-method"
      part="select-method"
      content="${translate('galleon.deposit.select')}"
    ></magic-ui-text>
  `;
}
function getSavedDepositTemplate() {
    return `
    <magic-ui-text
      tag="b"
      class="select-method"
      part="select-method"
      content="${translate('galleon.deposit.saved.methods')}"
    ></magic-ui-text>
  `;
}

function getSelectBonusTemplate(chosenDepositBonus) {
    const bonuses = AppState.wallet.depositBonuses;
    if (!bonuses || bonuses.length === 0) {
        return ``;
    }
    const imageUrl = AppState.wallet.imageUrl;
    return `
    <magic-ui-text
          tag="b"
          class="header"
          part="header"
          content="${translate('galleon.bonus.select')}"
        ></magic-ui-text>
    <magic-ui-radio-group class="bonuses" column="true" value="${chosenDepositBonus}">
      ${bonuses.map((bonus)=>{
        var _bonus_background;
        const isActive = chosenDepositBonus === bonus.id;
        const background = `
            background-image: url('${((_bonus_background = bonus.background) == null ? void 0 : _bonus_background.startsWith('http')) ? bonus.background : `${imageUrl}/promos/src/${bonus.background}`}');
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
          `;
        return `
              <magic-ui-radio
                class="bonuses__item"
                value="${bonus.id}"
                checked="${isActive}"
              >
                <magic-ui-accordion class="bonuses__item-accordion" controlled="true" ${isActive ? 'initially-visible' : ''}>
                  <div
                    slot="toggle"
                    class="bonus__item-toggle ${isActive ? 'bonus__item-toggle--active' : ''}"
                    style="${background}"
                  >
                    <img
                      class="bonus__item-logo"
                      src="${imageUrl}/promos/img/${bonus.image}"
                    />
                    <magic-ui-text
                      tag="b"
                      class="bonuses__item-title"
                      part="bonuses__item-title"
                      content="${bonus.title}"
                    ></magic-ui-text>
                  </div>
                  <div class="bonuses__item-description" part="bonuses__item-description" slot="content">
                    <magic-ui-text tag="p" content="${bonus.markdown}"></magic-ui-text>
                  </div>
                </magic-ui-accordion>
              </magic-ui-radio>
            `;
    }).join('')}
      <magic-ui-radio
        class="bonuses__item"
        checked="${chosenDepositBonus === ''}"
        value=""
      >
        <magic-ui-text
          tag="p"
          class="bonuses__item-no-bonus"
          part="bonuses__item-no-bonus"
          content="${translate('galleon.bonus.without')}"
        ></magic-ui-text>
      </magic-ui-radio>
    </magic-ui-radio-group>
  `;
}
const hydrateSelectBonusTemplate = (element, handleSelectBonus)=>{
    const radioClickHandler = (event)=>{
        const target = event.target;
        const id = target.value;
        handleSelectBonus(id);
    };
    const accordionToggleHandler = (event)=>{
        const clickedAccordion = event.target;
        if (!clickedAccordion.matches('magic-ui-accordion')) return;
        const allAccordions = element.querySelectorAll('magic-ui-accordion');
        allAccordions.forEach((accordion)=>accordion.removeAttribute('initially-visible'));
        setTimeout(()=>clickedAccordion.setAttribute('initially-visible', ''), 200);
    };
    const bonuses = element.querySelectorAll('.bonuses__item');
    bonuses.forEach((bonus)=>bonus.addEventListener('change', radioClickHandler));
    const accordions = element.querySelectorAll('magic-ui-accordion');
    accordions.forEach((accordion)=>accordion.addEventListener('toggle', accordionToggleHandler));
};

const isBonusesAvailable = ()=>{
    var _AppState_wallet_depositBonuses, _AppState_wallet;
    return (_AppState_wallet = AppState.wallet) == null ? void 0 : (_AppState_wallet_depositBonuses = _AppState_wallet.depositBonuses) == null ? void 0 : _AppState_wallet_depositBonuses.length;
};
const renderBonuses$1 = ()=>{
    // check the bonuses are empty for deposit tab
    if (AppState.wallet.selectedTabName !== View.Deposit || !isBonusesAvailable()) {
        return;
    }
    const content = AppState.shadowRoot.querySelector('.tab-content');
    const oldBonuses = AppState.shadowRoot.querySelector('[data-id="bonuses"]');
    const bonusesEl = oldBonuses != null ? oldBonuses : document.createElement('div');
    bonusesEl.setAttribute('data-id', 'bonuses');
    bonusesEl.innerHTML = getSelectBonusTemplate(AppState.wallet.chosenDepositBonus);
    if (!oldBonuses) {
        content.appendChild(bonusesEl);
    }
    hydrateSelectBonusTemplate(bonusesEl, handleSelectBonus);
};
const handleSelectBonus = (id)=>{
    AppState.wallet.chosenDepositBonus = id;
    renderBonusBar();
};

const createDepositStatusScreen = (depositResult)=>{
    var _getCurrentTab;
    const content = (_getCurrentTab = getCurrentTab()) != null ? _getCurrentTab : document.createElement('div');
    content.innerHTML = getDepositStatusScreenTemplate(depositResult);
    statusButtonsHandler(content, handleDepositSuccess(depositResult));
    scrollToTop();
};
const handleLockedDepositClick = async (method)=>{
    var _methodDiv_appendChild;
    if (AppState.wallet.deposit.selectedMethod || AppState.wallet.deposit.selectedSavedMethod) {
        return;
    }
    if (method.isSavedMethod) {
        AppState.wallet.deposit.selectedSavedMethod = method;
    } else {
        AppState.wallet.deposit.selectedMethod = method;
    }
    const methodDiv = getMethodDivById(method.id);
    methodDiv == null ? void 0 : (_methodDiv_appendChild = methodDiv.appendChild) == null ? void 0 : _methodDiv_appendChild.call(methodDiv, createButtonLoader());
    method.deposit(AppState.wallet.lockedAmount);
};
const createDepositView$1 = ()=>{
    const content = AppState.shadowRoot.querySelector('.tab-content');
    content.innerHTML = '';
    renderBonuses$1();
    renderSavedDepositMethods(content);
    renderDepositMethods(content);
};
function renderSavedDepositMethods(content) {
    const savedMethods = AppState.methods.savedDepositMethods;
    if (!savedMethods.length) return;
    const savedDepositTemplate = document.createElement('div');
    savedDepositTemplate.innerHTML = getSavedDepositTemplate();
    content.appendChild(savedDepositTemplate);
    savedMethods.forEach((method)=>{
        const methodDiv = method.render();
        content.appendChild(methodDiv);
    });
}
function renderDepositMethods(content) {
    const depositTemplate = document.createElement('div');
    depositTemplate.innerHTML = getDepositTemplate$1();
    content.appendChild(depositTemplate);
    AppState.methods.deposit.forEach((method)=>{
        const methodDiv = method.render();
        content.appendChild(methodDiv);
    });
}
const handleDepositSuccess = (depositResult)=>{
    return ()=>{
        if (depositResult.success) {
            AppState.root.dispatchEvent(new CustomEvent(DispatchMessageType.DepositCompleted));
        } else {
            emitDepositResult(null);
            createDepositView$1();
        }
    };
};

const scriptPromises = new Map();
function findExistingScript(src) {
    const scripts = document.getElementsByTagName('script');
    for(let i = 0; i < scripts.length; i++){
        const s = scripts[i];
        if ((s.getAttribute('src') || '').split('#')[0] === src) {
            return s;
        }
    }
    return null;
}
async function loadScript(src) {
    // Return the existing promise if we are already loading/loaded this src
    const existingPromise = scriptPromises.get(src);
    if (existingPromise) return existingPromise;
    // If a script tag already exists, resolve immediately
    if (findExistingScript(src)) {
        const already = Promise.resolve(true);
        scriptPromises.set(src, already);
        return already;
    }
    const promise = new Promise((resolve)=>{
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = ()=>resolve(true);
        script.onerror = ()=>{
            console.error(`Failed to load script: ${src}`);
            resolve(false);
        };
        // Append the script to the document
        document.body.appendChild(script);
    });
    scriptPromises.set(src, promise);
    return promise;
}

const paysafeSourceUrl = 'https://hosted.paysafe.com/checkout/v2/paysafe.checkout.min.js';
const availableLocales = [
    'en_US',
    'fr_CA'
];
var _config$1 = /*#__PURE__*/ _class_private_field_loose_key("_config"), _result = /*#__PURE__*/ _class_private_field_loose_key("_result"), _initialised$2 = /*#__PURE__*/ _class_private_field_loose_key("_initialised"), _isScriptLoaded$1 = /*#__PURE__*/ _class_private_field_loose_key("_isScriptLoaded"), _formatLocale = /*#__PURE__*/ _class_private_field_loose_key("_formatLocale");
class PaysafeCashier {
    static get instance() {
        if (!this._instance) {
            this._instance = new PaysafeCashier();
        }
        return this._instance;
    }
    async init(config) {
        if (_class_private_field_loose_base(this, _initialised$2)[_initialised$2]) {
            return Promise.resolve();
        }
        _class_private_field_loose_base(this, _initialised$2)[_initialised$2] = true;
        _class_private_field_loose_base(this, _config$1)[_config$1] = config;
        return Promise.resolve();
    }
    async update(config) {
        if (!_class_private_field_loose_base(this, _initialised$2)[_initialised$2]) {
            return Promise.resolve();
        }
        if (config) {
            _class_private_field_loose_base(this, _config$1)[_config$1] = _extends$1({}, _class_private_field_loose_base(this, _config$1)[_config$1], config);
        }
    }
    async launchPaysafeCashier(overrideOptions = {}) {
        if (!_class_private_field_loose_base(this, _isScriptLoaded$1)[_isScriptLoaded$1]) {
            _class_private_field_loose_base(this, _isScriptLoaded$1)[_isScriptLoaded$1] = await loadScript(paysafeSourceUrl);
        }
        if (_class_private_field_loose_base(this, _config$1)[_config$1].redirectUrl) {
            return Promise.resolve({
                paymentHandleToken: ''
            });
        }
        return new Promise((resolve, reject)=>{
            var _class_private_field_loose_base__config_paymentMethods_, _class_private_field_loose_base__config_paymentMethods;
            const { sessionContextId, amount, currency, accountIds, bankAccountIds, externalSingleUseUserProfileToken, locale } = _class_private_field_loose_base(this, _config$1)[_config$1];
            _class_private_field_loose_base(this, _result)[_result] = {
                paymentHandleToken: '',
                cardNumber: '',
                status: ''
            };
            const cardAccountId = accountIds == null ? void 0 : accountIds[currency.toUpperCase()];
            const bankAccountId = bankAccountIds == null ? void 0 : bankAccountIds['USD'];
            const formattedLocale = _class_private_field_loose_base(this, _formatLocale)[_formatLocale](locale);
            let options = {
                currency: currency,
                amount: amount,
                payout: false,
                locale: formattedLocale,
                merchantRefNum: sessionContextId,
                environment: _class_private_field_loose_base(this, _config$1)[_config$1].environment,
                singleUseCustomerToken: externalSingleUseUserProfileToken,
                canEditAmount: false,
                threeDs: {
                    authenticationPurpose: 'PAYMENT_TRANSACTION',
                    deviceChannel: 'BROWSER',
                    merchantUrl: _class_private_field_loose_base(this, _config$1)[_config$1].redirectUrl || 'https://api.qa.paysafe.com/checkout/v2/index.html#/desktop',
                    messageCategory: 'PAYMENT',
                    requestorChallengePreference: 'CHALLENGE_MANDATED'
                },
                displayPaymentMethods: [
                    ..._class_private_field_loose_base(this, _config$1)[_config$1].paymentMethods
                ],
                paymentMethodDetails: {
                    card: {
                        accountId: cardAccountId
                    }
                }
            };
            if (((_class_private_field_loose_base__config_paymentMethods = _class_private_field_loose_base(this, _config$1)[_config$1].paymentMethods) == null ? void 0 : (_class_private_field_loose_base__config_paymentMethods_ = _class_private_field_loose_base__config_paymentMethods[0]) == null ? void 0 : _class_private_field_loose_base__config_paymentMethods_.toLowerCase()) === 'pay_by_bank') {
                const pbbOptions = {
                    simulator: 'EXTERNAL',
                    // buttonColor: '#0000FF', // feel free to change the color of buttons (RGB value)
                    // companyName: 'Example Paysafe Merchant', // Supply Your Company Name here
                    // holderName: 'Alberto Antonaya', // Supply Customer's Name here
                    paymentMethodDetails: {
                        // Please read the Checkout Objects Documentation on developer.paysafe.com .....
                        payByBank: {
                            accountId: bankAccountId,
                            consumerId: _class_private_field_loose_base(this, _config$1)[_config$1].userProfileId
                        }
                    }
                };
                options = _extends$1({}, options, pbbOptions);
            }
            options = _extends$1({}, options, overrideOptions);
            paysafe.checkout.setup(_class_private_field_loose_base(this, _config$1)[_config$1].apiKey, options, (instance, error, result)=>{
                _class_private_field_loose_base(this, _result)[_result].instance = instance;
                if (result && result.paymentHandleToken) {
                    _class_private_field_loose_base(this, _result)[_result].paymentHandleToken = result.paymentHandleToken;
                    resolve(_class_private_field_loose_base(this, _result)[_result]);
                } else {
                    console.error(error);
                    reject(error);
                }
            }, (stage)=>{
                _class_private_field_loose_base(this, _result)[_result].status = stage;
                resolve(_class_private_field_loose_base(this, _result)[_result]);
            });
        });
    }
    constructor(){
        Object.defineProperty(this, _formatLocale, {
            value: formatLocale
        });
        Object.defineProperty(this, _config$1, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _result, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _initialised$2, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _isScriptLoaded$1, {
            writable: true,
            value: void 0
        });
        _class_private_field_loose_base(this, _initialised$2)[_initialised$2] = false;
        _class_private_field_loose_base(this, _isScriptLoaded$1)[_isScriptLoaded$1] = false;
    }
}
function formatLocale(locale) {
    const formattedLocale = locale == null ? void 0 : locale.replace('-', '_');
    if (availableLocales.includes(formattedLocale || '')) {
        return formattedLocale;
    }
    console.error(`This locale ${formattedLocale} is not supported by paysafe. Trying to use the dafault: ${availableLocales[0]}`);
    return availableLocales[0];
}

function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item) && item !== null;
}
function mergeDeep(target, source) {
    const output = Object.assign({}, target);
    const objectedOutput = output;
    const objectedTarget = target;
    const objectedSource = source;
    if (isObject(target) && isObject(source)) {
        Object.keys(objectedSource).forEach((key)=>{
            if (isObject(objectedSource[key])) {
                if (!(key in objectedTarget)) {
                    Object.assign(objectedOutput, {
                        [key]: objectedSource[key]
                    });
                } else output[key] = mergeDeep(objectedTarget[key], objectedSource[key]);
            } else {
                Object.assign(objectedOutput, {
                    [key]: objectedSource[key]
                });
            }
        });
    }
    return output;
}

/**
 * this method could be extended in case of extending and editing user profile data functionality
 */ const getBankDetails = async ()=>{
    const pbbOptions = AppState.wallet.profile;
    if (!pbbOptions) {
        console.error('No any valid profile and billing info exist to make PayByBank deposit');
        return Promise.reject();
    }
    return Promise.resolve(mergeDeep({}, pbbOptions));
};

// Unique identifier for payment callback messages in our application
const PAYMENT_ORIGIN = 'paymentsCallback';
function commonSuccessCondition(data) {
    return (data == null ? void 0 : data.origin) === PAYMENT_ORIGIN;
}
function getUrlParamsAsObject(urlString) {
    if (!urlString) {
        return {};
    }
    try {
        const url = new URL(urlString);
        const searchParams = url.searchParams;
        const result = {};
        searchParams.forEach((value, key)=>{
            result[key] = value;
        });
        return result;
    } catch (error) {
        console.error('parse url error:', urlString, error);
        return {};
    }
}
class ProxyListenerInstance {
    openWindow(url, redirectUrl, customWindow = null) {
        if (!customWindow) {
            this.currentWindow = window.open(url, 'popupWindow', 'width=1200,height=800,left=200,top=100');
            this.currentWindow.focus();
        } else {
            this.currentWindow = customWindow;
        }
        this.currentUrl = new URL(url);
        this.redirectUrl = new URL(redirectUrl);
        return new Promise((resolve)=>{
            const listener = (event)=>{
                var _this_redirectUrl;
                if (event.origin !== ((_this_redirectUrl = this.redirectUrl) == null ? void 0 : _this_redirectUrl.origin)) {
                    // Security check: Ensure the message is from the expected origin
                    return;
                }
                const data = event.data;
                if (commonSuccessCondition(event.data)) {
                    var // The expected message has been received
                    _this_currentWindow;
                    (_this_currentWindow = this.currentWindow) == null ? void 0 : _this_currentWindow.close();
                    resolve(data);
                    window.removeEventListener('message', listener);
                }
            };
            window.addEventListener('message', listener);
            this.checkIfWindowClosed(listener, resolve);
        });
    }
    checkIfWindowClosed(listener, resolve, result = null, listenerType = 'message', customWindow = window) {
        this.checkWindowClosedInterval = window.setInterval(()=>{
            if (this.currentWindow && this.currentWindow.closed) {
                if (this.checkWindowClosedInterval !== null) {
                    clearInterval(this.checkWindowClosedInterval);
                    this.checkWindowClosedInterval = null;
                }
                customWindow.removeEventListener(listenerType, listener);
                this.currentWindow = null;
                resolve(result);
            }
        }, 1000);
    }
    constructor(){
        this.currentWindow = null;
        this.currentUrl = null;
        this.redirectUrl = null;
        this.checkWindowClosedInterval = null;
    }
}
const ProxyListener = new ProxyListenerInstance();

const emitWithdrawResult = (data)=>{
    AppState.root.dispatchEvent(new CustomEvent(DispatchMessageType.WithdrawResult, {
        detail: data
    }));
    AppState.wallet.withdraw.selectedSavedMethod = null;
};
const emitWithdrawCompleted = ()=>{
    AppState.root.dispatchEvent(new CustomEvent(DispatchMessageType.WithdrawCompleted));
};
const emitWithdrawLinkingCompleted = ()=>{
    AppState.root.dispatchEvent(new CustomEvent(DispatchMessageType.WithdrawLinkingCompleted));
};

function getWithdrawalStatusScreenTemplate(data, successMessage, specificTitle) {
    const successTitle = (data == null ? void 0 : data.specificTitle) || translate('galleon.withdrawal.success.title');
    const failureTitle = (data == null ? void 0 : data.specificTitle) || translate('galleon.withdrawal.failure.title');
    const title = data.success ? successTitle : failureTitle;
    const buttonClass = `status-screen__button status-screen__button-${data.success ? 'success' : 'failure'}`;
    const buttonSuccessLabel = data.buttonLabel || translate('galleon.success.screen.button');
    scrollToTop();
    return `
    <div class="status-screen" part="status-screen">
        <magic-ui-icon
          name="${data.success ? 'cashier-result-check' : 'cashier-result-close'}"
          class="icon status-screen__icon"
        ></magic-ui-icon>
        <magic-ui-text
          tag="b"
          class="status-screen__title"
          part="status-screen__title"
          content='${specificTitle || title}'
        ></magic-ui-text>
        ${data.success ? getSuccessMessage(data, successMessage) : getErrorMessage(data == null ? void 0 : data.errorText)}
        <magic-ui-button
            class="${buttonClass}"
            part="status-screen__button"
            variant="primary"
            small
        >
            ${data.success ? buttonSuccessLabel : translate('galleon.error.screen.button')}
        </magic-ui-button>
    </div>
  `;
}
function getSuccessMessage(data, successMessage) {
    const defaultSuccessMessage = translate('galleon.withdrawal.success.description').replace('{amount}', formatCurrency(data.amount, data.currencyCode)).replace('{paymentMethod}', data.paymentMethod || '').replace('{transactionID}', data.transactionID);
    const slotName = data.slotName || 'withdraw-success';
    return `
        <slot name="${slotName}">
                 <magic-ui-text
                    tag="p"
                    class="status-screen__text"
                    part="status-screen__text"
                    content='${successMessage || defaultSuccessMessage}'
                    is-markdown
                  ></magic-ui-text>
          </slot>
    `;
}
function getErrorMessage(specificError) {
    const description = translate('galleon.withdrawal.failure.description');
    return `
        <slot name="withdraw-error">
                 <magic-ui-text
                    tag="p"
                    class="status-screen__text"
                    part="status-screen__text"
                    content='${specificError || description}'
                    is-markdown
                  ></magic-ui-text>
          </slot>
    `;
}

function createElementFromTemplate(tag, template) {
    const element = document.createElement(tag);
    element.innerHTML = template;
    scrollToTop();
    return element;
}

// the list of items that should be displayed in the 'Other withdrawal methods' section
/**
 * unique providerMethod ID list
 */ const getWithdrawalProviderWhiteList = ()=>{
    var _AppState_savedWithdrawMethods;
    const whiteList = [
        makeProviderMethodId(ProviderType.Paysafe, PaysafeMethodId.PayByBank),
        makeProviderMethodId(ProviderType.Devcode, DevcodeMethodId.BankIBAN),
        makeProviderMethodId(ProviderType.Devcode, DevcodeMethodId.Trustly),
        makeProviderMethodId(ProviderType.Devcode, DevcodeMethodId.BankLocal),
        makeProviderMethodId(ProviderType.Devcode, DevcodeMethodId.Bank),
        makeProviderMethodId(ProviderType.Devcode, DevcodeMethodId.PayByBank),
        makeProviderMethodId(ProviderType.Solairepay, SolairepayMethodId.GCash)
    ];
    const paysafeSkrillSavedMethod = (_AppState_savedWithdrawMethods = AppState.savedWithdrawMethods) == null ? void 0 : _AppState_savedWithdrawMethods.paymentHandles.find((method)=>method.paymentMethodExternalId === PaysafeMethodId.Skrill && method.provider === ProviderType.Paysafe);
    if (!AppState.wallet.features.skrillClosedLoop && !paysafeSkrillSavedMethod || AppState.wallet.features.paysafeSkrillAllowSeveralWithdrawalAccounts) {
        whiteList.push(makeProviderMethodId(ProviderType.Paysafe, PaysafeMethodId.Skrill));
    }
    return whiteList;
};

function getAmountsForWithdraw(withdrawable, minAmount, maxAmount) {
    const amounts = [];
    const effectiveMax = Math.min(withdrawable, maxAmount);
    // 1/3 of the max withdrawal amount, rounded down
    const oneThird = Math.floor(effectiveMax / 3);
    amounts.push(Math.max(oneThird, minAmount));
    // 2/3 of the max withdrawal amount, rounded down
    const twoThirds = Math.floor(effectiveMax * 2 / 3);
    amounts.push(Math.max(twoThirds, minAmount));
    // Max withdrawal amount
    amounts.push(effectiveMax);
    return amounts;
}
const getMethodByProviderId = (id, methods)=>{
    return getMethodBy('methodProviderId', id, methods);
};
const getMethodBy = (key, value, withdrawMethods)=>{
    return withdrawMethods.find((method)=>String(method[key]) === value);
};
function shouldDisplayWithdrawMethod(method) {
    return getWithdrawalProviderWhiteList().includes(makeProviderMethodId(method.provider, method.paymentMethodExternalId)) || [
        ProviderType.Paymongo,
        ProviderType.Solairepay
    ].includes(method.provider);
}

function getSavedWithdrawAmountScreen(withdrawMethod, balanceData, netPosition) {
    const { withdrawable } = balanceData;
    const { maxAmount, currencyCode, minAmount } = withdrawMethod;
    const currencySymbol = getCurrencySymbol(currencyCode);
    const amountHeader = translate('galleon.amount.header.currency').replace('{currency}', currencySymbol);
    const resultMaxAmount = Math.min(maxAmount, netPosition || maxAmount);
    const amounts = getAmountsForWithdraw(Number(withdrawable), minAmount, resultMaxAmount);
    if (amounts.length === 0) {
        return `<div>${translate('galleon.amount.error')}</div>`;
    }
    const balanceError = netPosition && netPosition < withdrawable ? translate('galleon.withdrawal.net-position.error') : translate('galleon.withdrawal.balance.error');
    return `
    <div class="amount-screen" part="amount-screen" >
      <div class="suggested-amounts" part="suggested-amounts">
        <magic-ui-text
          tag="b"
          class="suggested-amounts__title"
          part="suggested-amounts__title"
          content="${translate('galleon.amount.suggested')}"
        ></magic-ui-text>
        <div
            class="suggested-amounts__buttons"
            part="suggested-amounts__buttons"
        >
         ${amounts.map((amount)=>`
              <magic-ui-button
                  class="suggested-amounts__button"
                  part="suggested-amounts__button"
                  variant="primary"
                  value=${amount}
                  hollow
                  small
              >
                  ${formatCurrency(amount, currencyCode, 0)}
              </magic-ui-button>
              `).join('')}
        </div>
      </div>
      <magic-ui-text
        tag="b"
        class="amount-screen__title"
        part="amount-screen__title"
        content="${amountHeader}"
       ></magic-ui-text>
      <div class="amount-screen__deposit" part="amount-screen__deposit">
        <div class="amount-screen__input" part="amount-screen__input">
          <magic-ui-form-field
            class="amount-screen__field input-form-field"
            placeholder="${translate('galleon.input.placeholder')}"
            type="text"
          ></magic-ui-form-field>
        </div>
          <magic-ui-button
            class="amount-screen__submit"
            part="amount-screen__submit"
            variant="primary"
            disabled=${true}
          >
          ${translate('galleon.withdrawal.title')}
        </magic-ui-button>
      </div>
      <magic-ui-text
            tag="p"
            class="amount-screen__error"
            part="amount-screen__error"
            content='${translate('galleon.withdrawal.amount.error').replace('{minAmount}', formatCurrency(minAmount, currencyCode)).replace('{maxAmount}', formatCurrency(resultMaxAmount, currencyCode))}'
       ></magic-ui-text>
       <magic-ui-text
            tag="p"
            class="amount-screen__balance__error"
            part="amount-screen__balance__error"
            content='${balanceError}'
       ></magic-ui-text>
    </div>
  `;
}

const infoScreenTemplate = (text = '')=>{
    const defaultText = translate('galleon.withdrawal.net-position.info.disable');
    const resultText = text || defaultText;
    return `
  <div class="info-screen-container">
    <div class="info-screen">
        <magic-ui-icon
            name="info"
            class="tooltip__icon"
            part="tooltip__icon"
          ></magic-ui-icon>
        <magic-ui-text
          tag="b"
          class="info-screen__description"
          part="info-screen__description"
          content="${resultText}"
        ></magic-ui-text>
    </div>
</div>
  `;
};

function getSavedWithdrawTemplate() {
    return `
      <magic-ui-text
        tag="b"
        class="select-method"
        part="select-method"
        content="${translate('galleon.withdrawal.last-redemption')}"
      ></magic-ui-text>
    `;
}

function getWithdrawTemplate() {
    return `
    <magic-ui-text
      tag="b"
      class="select-method"
      part="select-method"
      content="${translate('galleon.withdrawal.other.methods')}"
    ></magic-ui-text>
  `;
}

function getWithdrawBalanceTemplate() {
    return `<div class="payment-method" part="payment-method">
      <div class="payment-method__details" part="payment-method__details">
        ${getTooltipTemplate(translate('wallet.withdrawable-amount.hint'), translate('wallet.withdrawable-balance-info.introduction'))}
        <magic-ui-text
          tag="b"
          class="payment-method__name"
          part="payment-method__name"
          content="${translate('withdrawal.withdrawable-balance.hint')}"
        ></magic-ui-text>
      </div>
      <magic-ui-text
        tag="b"
        class="payment-method__balance"
        part="payment-method__balance"
        content="${AppState.wallet.balanceData.withdrawable}"
      ></magic-ui-text>
    </div>`;
}

function getInsufficientFundsTemplate(data) {
    const description = translate('galleon.withdrawal.insufficient-funds.explanation').replace('{amount}', formatCurrency(data.amount, AppState.wallet.balanceData.currencyCode));
    return `
    <div class="insufficient-funds">
      <magic-ui-icon
        name="insufficient-funds"
        class="insufficient-funds__icon"
        part="insufficient-funds__icon"
      ></magic-ui-icon>
      <magic-ui-text
          tag="b"
          class="insufficient-funds__heading"
          part="insufficient-funds__heading"
          content="${translate('galleon.withdrawal.insufficient-funds.title')}"
        ></magic-ui-text>
      <magic-ui-text
        tag="p"
        class="insufficient-funds__subtitle"
        part="insufficient-funds__subtitle"
        content="${description}"
      ></magic-ui-text>
    </div>
    ${getWithdrawBalanceTemplate()}
  `;
}

const createInsufficientFundsView = (data = {
    amount: '0',
    currencyCode: 'Eur'
})=>{
    const content = AppState.shadowRoot.querySelector('.tab-content');
    const methodDiv = document.createElement('div');
    methodDiv.innerHTML = getInsufficientFundsTemplate(data);
    content.appendChild(methodDiv);
    updateBalanceView();
};
const updateBalanceView = (balanceData = AppState.wallet.balanceData)=>{
    const text = AppState.shadowRoot.querySelector('.payment-method__balance');
    if (!balanceData || !text) {
        return;
    }
    const currencySymbol = getCurrencySymbol(balanceData.currencyCode);
    const value = currencySymbol + (balanceData.withdrawable || '0');
    text.setAttribute('content', value);
};
const appendBalanceTemplate = (container)=>{
    const balanceTemplate = createElementFromTemplate('div', getWithdrawBalanceTemplate());
    container.appendChild(balanceTemplate);
};

function attachWithdrawInputListener(methodDiv, withdrawMethod, maxWithdrawValue) {
    const formField = methodDiv.querySelector('.input-form-field');
    if (formField) {
        formField.addEventListener('input', function(event) {
            var _customEvent_detail, _customEvent_detail1;
            const customEvent = event;
            const value = (customEvent == null ? void 0 : (_customEvent_detail = customEvent.detail) == null ? void 0 : _customEvent_detail.value) || ((_customEvent_detail1 = customEvent.detail) == null ? void 0 : _customEvent_detail1[0]);
            handleWithdrawInput(value, methodDiv, withdrawMethod, maxWithdrawValue);
        });
    }
}
function attachWithdrawButtonListener(methodDiv, method) {
    const formField = methodDiv.querySelector('.input-form-field');
    const withdrawButton = methodDiv.querySelector('.amount-screen__submit');
    const buttonWrapper = methodDiv.querySelector('.suggested-amounts__buttons');
    const errorConfig = {
        invalid: methodDiv.querySelector('.amount-screen__error'),
        balance: methodDiv.querySelector('.amount-screen__balance__error')
    };
    attachSuggestedAmountListeners(buttonWrapper, formField, withdrawButton, errorConfig);
    withdrawButton.addEventListener('click', ()=>{
        const disabledButton = withdrawButton.getAttribute('disabled');
        if (disabledButton !== null) {
            return;
        }
        withdrawButton.setAttribute('disabled', 'true');
        withdrawButton.setAttribute('loading', 'true');
        const inputValue = formField.getAttribute('value');
        method.withdraw(Number(inputValue));
    });
}
function handleWithdrawInput(value, methodDiv, withdrawMethod, balance) {
    const formField = methodDiv.querySelector('.input-form-field');
    const withdrawButton = methodDiv.querySelector('.amount-screen__submit');
    const errorConfig = {
        invalid: methodDiv.querySelector('.amount-screen__error'),
        balance: methodDiv.querySelector('.amount-screen__balance__error')
    };
    const { maxAmount, minAmount } = withdrawMethod;
    const fieldConfig = {
        minAmount: minAmount,
        maxAmount: maxAmount
    };
    handleNumericInput(value, formField, withdrawButton, errorConfig, {
        config: fieldConfig,
        balance: Number(balance)
    });
}

function getPendingWithdrawalsTemplate(withoutButton = false) {
    const withdrawals = AppState.wallet.pendingWithdrawals;
    if (!withdrawals || withdrawals.length === 0) {
        return ``;
    }
    return `<magic-ui-accordion class="pending-withdrawals" part="pending-withdrawals">
    <div class="pending-withdrawals__toggle" slot="toggle">
      <div class="pending-withdrawals__left-part" part="pending-withdrawals__left-part">
        <magic-ui-icon
          name="pending-withdrawals"
          class="payment-method__icon"
          part="payment-method__icon"
        ></magic-ui-icon>
        <magic-ui-text
          tag="b"
          class="pending-withdrawals__name"
          part="pending-withdrawals__name"
          content="${translate('galleon.withdrawal.pending')}"
        ></magic-ui-text>
      </div>
      <magic-ui-text
        tag="b"
        class="pending-withdrawals__pending"
        part="pending-withdrawals__pending"
        content="${translate('galleon.deposit.pending.title')}"
      ></magic-ui-text>
    </div>
    <div slot="content">
      <div class="pending-withdrawals__items">
        ${withdrawals.map(withdrawalTemlate).join('')}
      </div>
      ${withoutButton ? '' : `<magic-ui-button
            class="pending-withdrawals__load-more"
            part="pending-withdrawals__load-more"
            variant="primary"
            small
        >
          ${translate('galleon.withdrawal.more')}
        </magic-ui-button>`}
    </div>
    </magic-ui-accordion>`;
}
const withdrawalTemlate = (withdrawal)=>{
    const method = getMethod(withdrawal);
    return `
      <div class="withdrawal_item" part="withdrawal_item" data-id="${withdrawal.id}">
        <div class="withdrawal_item__left-part" part="withdrawal_item__left-part">
          <magic-ui-text
            tag="b"
            class="withdrawal_item__method"
            part="withdrawal_item__method"
            content="${method} - ${translate('galleon.withdrawal.amount.title')} ${transformAmount(withdrawal)}"
          ></magic-ui-text>
            <magic-ui-text
            tag="p"
            class="withdrawal_item__description"
            part="withdrawal_item__description"
            content="${translate('galleon.withdrawal.requested')} ${transformDate(withdrawal)}"
          ></magic-ui-text>
        </div>
      </div>
        `;
};
const getMethod = (withdrawal)=>{
    if (withdrawal.additionalProperties) {
        return JSON.parse(withdrawal.additionalProperties).Payments.Transaction.PaymentMethod;
    } else {
        return withdrawal.txType;
    }
};
const transformAmount = (withdrawal)=>{
    const symbol = getCurrencySymbol(withdrawal.currency);
    if (typeof withdrawal.amount === 'number') {
        return `${withdrawal.amount}${symbol}`;
    } else {
        return `${withdrawal.amount.slice(1)}${symbol}`;
    }
};
const transformDate = (withdrawal)=>{
    const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ];
    const date = new Date(withdrawal.ts ? withdrawal.ts : withdrawal.created);
    const hours = date.getHours();
    let minutes = date.getMinutes();
    // Ensure minutes are two digits by padding with a leading zero if necessary
    minutes = minutes < 10 ? '0' + minutes : minutes;
    // Format time in the format HH:MM
    const time = `${hours}:${minutes}`;
    return `${time} on ${monthNames[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
};
const registerPendingWithdrawalsListeners = (element)=>{
    const button = element.querySelector('.pending-withdrawals__load-more');
    const listener = ()=>{
        var _AppState_root;
        const withdrawalsCount = AppState.wallet.pendingWithdrawals.length;
        button == null ? void 0 : button.setAttribute('disabled', 'true');
        (_AppState_root = AppState.root) == null ? void 0 : _AppState_root.dispatchEvent(new CustomEvent('cashier-pending-withdrawals', {
            detail: {
                withdrawalsCount
            }
        }));
    };
    button == null ? void 0 : button.addEventListener('click', listener);
};

function getNoMethodsWithdrawTemplate() {
    return `
    <magic-ui-text
      tag="b"
      class="fallback-text"
      part="fallback-text"
      content='${translate('galleon.withdrawal.no.methods')}'
    ></magic-ui-text>
  `;
}

const createWithdrawView = ()=>{
    var _AppState_savedWithdrawMethods_paymentHandles, _AppState_savedWithdrawMethods;
    const content = AppState.shadowRoot.querySelector('.tab-content');
    content.innerHTML = '';
    AppState.wallet.withdraw.selectedMethod = null;
    AppState.wallet.withdraw.selectedSavedMethod = null;
    if (!AppState.wallet.lockedAmount) {
        appendBalanceTemplate(content);
    }
    if (AppState.methods.withdrawMethodsToDisplay.length === 0 && !((_AppState_savedWithdrawMethods = AppState.savedWithdrawMethods) == null ? void 0 : (_AppState_savedWithdrawMethods_paymentHandles = _AppState_savedWithdrawMethods.paymentHandles) == null ? void 0 : _AppState_savedWithdrawMethods_paymentHandles.length)) {
        appendNoMethodsWithdrawTemplate(content);
        updateBalanceView();
        return;
    }
    if (AppState.wallet.features.pendingWithdrawals) {
        appendPendingWithdrawalsTemplate(content);
    }
    appendSavedWithdrawTemplate(content);
    appendWithdrawMethodsTemplate(content);
    updateBalanceView();
};
const createWithdrawStatusScreen = (withdrawalResult, successMessage, specificTitle)=>{
    emitWithdrawResult(withdrawalResult);
    const content = getCurrentTab();
    content.innerHTML = getWithdrawalStatusScreenTemplate(withdrawalResult, successMessage, specificTitle);
    statusButtonsHandler(content, ()=>{
        if (withdrawalResult.success) {
            emitWithdrawCompleted();
        } else {
            emitWithdrawResult(null);
            createWithdrawView();
        }
    });
};
const appendNoMethodsWithdrawTemplate = (container)=>{
    const noMethodsTemplate = createElementFromTemplate('div', getNoMethodsWithdrawTemplate());
    container.appendChild(noMethodsTemplate);
};
const handleWithdrawAccordionToggle = (method)=>(methodDiv)=>{
        const stateSelectedMethod = AppState.wallet.withdraw.selectedMethod;
        if (stateSelectedMethod == null ? void 0 : stateSelectedMethod.id) {
            const prevMethodDiv = getMethodDivById(stateSelectedMethod.id);
            if (prevMethodDiv) {
                removeWithdrawAmountScreen(prevMethodDiv);
                toggleAccordionByMethod(prevMethodDiv, true);
            }
        }
        const isTheSameMethod = (stateSelectedMethod == null ? void 0 : stateSelectedMethod.id) === (method == null ? void 0 : method.id);
        toggleAccordionByMethod(methodDiv, isTheSameMethod);
        if (!isTheSameMethod) {
            AppState.wallet.withdraw.selectedMethod = method;
            expandWithdrawMethod(method, methodDiv);
        } else {
            AppState.wallet.withdraw.selectedMethod = null;
            removeWithdrawAmountScreen(methodDiv);
        }
    };
const handleSavedWithdrawAccordionToggle = (method)=>(methodDiv)=>{
        var _AppState_savedWithdrawMethods_paymentHandles, _AppState_savedWithdrawMethods;
        const stateSelectedMethod = AppState.wallet.withdraw.selectedSavedMethod;
        const stateSelectedMethodId = (_AppState_savedWithdrawMethods = AppState.savedWithdrawMethods) == null ? void 0 : (_AppState_savedWithdrawMethods_paymentHandles = _AppState_savedWithdrawMethods.paymentHandles) == null ? void 0 : _AppState_savedWithdrawMethods_paymentHandles.findIndex((s)=>s.id === (stateSelectedMethod == null ? void 0 : stateSelectedMethod.id));
        if (stateSelectedMethod == null ? void 0 : stateSelectedMethod.id) {
            const prevMethodDiv = getMethodDivById(stateSelectedMethodId);
            if (prevMethodDiv) {
                removeWithdrawAmountScreen(prevMethodDiv);
                toggleAccordionByMethod(prevMethodDiv, true);
            }
        }
        const isTheSameMethod = (stateSelectedMethod == null ? void 0 : stateSelectedMethod.id) === (method == null ? void 0 : method.id);
        toggleAccordionByMethod(methodDiv, isTheSameMethod);
        if (isTheSameMethod) {
            AppState.wallet.withdraw.selectedSavedMethod = null;
            removeWithdrawAmountScreen(methodDiv);
        } else {
            AppState.wallet.withdraw.selectedSavedMethod = method;
            expandWithdrawMethod(method, methodDiv);
        }
    };
const expandWithdrawMethod = (method, methodDiv)=>{
    addSavedWithdrawAmountScreen(methodDiv, method);
    toggleAccordionByMethod(methodDiv, false);
    if (method.netPosition === 0) {
        return;
    }
    const withdrawMethod = getMethodByProviderId(method.methodProviderId, AppState.methods.withdraw);
    const balance = AppState.wallet.balanceData.withdrawable;
    const netPosition = method.netPosition || 0;
    const maxWithdrawValue = netPosition && netPosition < balance ? netPosition : balance;
    attachWithdrawInputListener(methodDiv, withdrawMethod, maxWithdrawValue);
    attachWithdrawButtonListener(methodDiv, method);
};
const appendPendingWithdrawalsTemplate = (container, withoutButton = false)=>{
    const pendingWithdrawalsTemplate = createElementFromTemplate('div', getPendingWithdrawalsTemplate(withoutButton));
    const withdrawalsContainer = container.querySelector('.pending-withdrawals');
    if (!withdrawalsContainer) {
        // Check if there are saved withdraw or withdraw methods templates and insert before them
        const savedWithdrawContainer = container.querySelector('.saved-withdraw-methods');
        const withdrawMethodsContainer = container.querySelector('.withdraw-methods');
        if (savedWithdrawContainer) {
            container.insertBefore(pendingWithdrawalsTemplate, savedWithdrawContainer);
        } else if (withdrawMethodsContainer) {
            container.insertBefore(pendingWithdrawalsTemplate, withdrawMethodsContainer);
        } else {
            container.appendChild(pendingWithdrawalsTemplate);
        }
        registerPendingWithdrawalsListeners(container);
    } else {
        const loadMoreButton = withdrawalsContainer.querySelector('.pending-withdrawals__load-more');
        if (withoutButton) {
            loadMoreButton == null ? void 0 : loadMoreButton.remove();
        } else {
            loadMoreButton == null ? void 0 : loadMoreButton.removeAttribute('disabled');
        }
        const withdrawals = AppState.wallet.pendingWithdrawals;
        const itemsEl = withdrawalsContainer.querySelector('.pending-withdrawals__items');
        if (itemsEl) {
            itemsEl.innerHTML = withdrawals.map(withdrawalTemlate).join('');
        }
    }
};
const resetNetPositionConditions = (paysafeMethods)=>{
    const allDisabledByNetPosition = paysafeMethods.every((method)=>method.disabledByNetPosition);
    const onlyOneMethodToWithdraw = paysafeMethods.length === 1;
    if (allDisabledByNetPosition || onlyOneMethodToWithdraw) {
        paysafeMethods.forEach((paymentMethod)=>{
            paymentMethod.netPosition = undefined;
        });
    }
};
const appendSavedWithdrawTemplate = (container)=>{
    var _savedWithdrawMethods_paymentHandles;
    const savedWithdrawMethods = AppState.savedWithdrawMethods;
    if (savedWithdrawMethods == null ? void 0 : (_savedWithdrawMethods_paymentHandles = savedWithdrawMethods.paymentHandles) == null ? void 0 : _savedWithdrawMethods_paymentHandles.length) {
        const savedWithdrawTemplate = createElementFromTemplate('div', getSavedWithdrawTemplate());
        savedWithdrawTemplate.classList.add('saved-withdraw-methods');
        const paysafeMethods = savedWithdrawMethods.paymentHandles.filter((method)=>method.provider === ProviderType.Paysafe);
        resetNetPositionConditions(paysafeMethods);
        savedWithdrawMethods.paymentHandles.forEach((method, index)=>{
            const methodDiv = method.render(index);
            savedWithdrawTemplate.appendChild(methodDiv);
        });
        container.appendChild(savedWithdrawTemplate);
    }
};
const appendWithdrawMethodsTemplate = (container)=>{
    const displayMethods = AppState.methods.withdrawMethodsToDisplay;
    if (displayMethods.length === 0) return;
    const withdrawTemplate = createElementFromTemplate('div', getWithdrawTemplate());
    withdrawTemplate.classList.add('withdraw-methods');
    displayMethods.forEach((method)=>{
        const methodDiv = method.render();
        withdrawTemplate.appendChild(methodDiv);
    });
    container.appendChild(withdrawTemplate);
};
const removeWithdrawAmountScreen = (methodDiv)=>{
    const amountContainer = methodDiv.querySelector('.saved-withdraw-amount-container');
    if (amountContainer) {
        amountContainer.remove();
    }
};
const addSavedWithdrawAmountScreen = (methodDiv, method)=>{
    const withdrawMethod = getMethodByProviderId(method.methodProviderId, AppState.methods.withdraw);
    let amountHTML = '';
    const savedMethod = method;
    if (savedMethod.disabledByNetPosition) {
        amountHTML = infoScreenTemplate();
    } else {
        amountHTML = getSavedWithdrawAmountScreen(withdrawMethod, AppState.wallet.balanceData, method.netPosition);
    }
    const amountContainer = document.createElement('div');
    amountContainer.className = 'saved-withdraw-amount-container';
    amountContainer.innerHTML = amountHTML;
    methodDiv.appendChild(amountContainer);
};
const handleSavedLockedWithdrawClick = (methodDiv, method)=>{
    if (AppState.wallet.withdraw.selectedSavedMethod) {
        return;
    }
    AppState.wallet.withdraw.selectedSavedMethod = method;
    methodDiv.appendChild(createButtonLoader());
    method.withdraw(AppState.wallet.lockedAmount);
};
const handleLockedWithdrawClick = (methodDiv, method)=>{
    if (AppState.wallet.withdraw.selectedMethod) {
        return;
    }
    AppState.wallet.withdraw.selectedMethod = method;
    methodDiv.appendChild(createButtonLoader());
    method.withdraw(AppState.wallet.lockedAmount);
};
function renderSavedWithdrawMethod(index, method, methodDiv) {
    methodDiv.classList.add('method-container', 'saved-withdraw-method-container', `method-${index}`);
    const isFirstElement = index === 0;
    if (isFirstElement && !AppState.wallet.lockedAmount) {
        AppState.wallet.withdraw.selectedSavedMethod = method;
        expandWithdrawMethod(method, methodDiv);
    }
    if (AppState.wallet.lockedAmount) {
        const innerMethodDiv = methodDiv.querySelector('.payment-method');
        innerMethodDiv.classList.add('payment-method--locked-amount');
        attachLockedAmountListener(innerMethodDiv, ()=>{
            handleSavedLockedWithdrawClick(innerMethodDiv, method);
        });
    } else {
        attachAccordionListener(methodDiv, handleSavedWithdrawAccordionToggle(method));
    }
    return methodDiv;
}

const getConfirmPopupTemplate = (popupData)=>{
    return `
  <magic-ui-tooltip class="controls-wrapper__tooltip-popup confirm-popup" data-tooltip-id="${popupData.id}"
          controlled="true"
          position="top"
          type="sticky">
            <div slot="content" class="popup">
              <magic-ui-text
                tag="b"
                class="popup__title"
                part="popup__title"
                content="${popupData.title}"
              ></magic-ui-text>
              <magic-ui-text
                tag="b"
                class="popup__intro"
                part="popup__intro"
                content="${popupData.introduction}"
              ></magic-ui-text>
              <magic-ui-button
                variant="primary"
                class="popup__forfeit popup__ok"
                data-bonus-id="${popupData.id}"
                data-update-type="${popupData.updateType}">
                ${popupData.agreedText}
              </magic-ui-button>
              <magic-ui-text
                tag="p"
                data-cancel="${popupData.id}"
                class="popup__cancel"
                part="popup__cancel"
                content="${popupData.cancelText}"
            ></magic-ui-text>
            </div>
        </magic-ui-tooltip>
  `;
};

function getMethodControlsTemplate(controlsData) {
    const defaultControlsData = {
        currencyCode: AppState.wallet.balanceData.currencyCode,
        popupConfig: {
            updateType: 'confirm',
            title: '',
            introduction: translate('galleon.payment.popup.confirm.description'),
            agreedText: translate('galleon.payment.popup.confirm.ok'),
            cancelText: translate('galleon.payment.popup.confirm.cancel')
        }
    };
    const resutControlsData = mergeDeep(defaultControlsData, controlsData);
    const { netPosition, lockedAmount, currencyCode, popupConfig } = resutControlsData;
    const disabledStyle = ()=>{
        return netPosition === 0 ? ' disabled' : '';
    };
    const hideStyle = ()=>{
        return netPosition === null || netPosition === undefined ? ' hidden' : ''; // More explicit check for null/undefined
    };
    const hiddenLockedClass = lockedAmount ? ' hidden' : '';
    const netPositionValue = formatCurrency(netPosition || 0, currencyCode);
    const netPositionText = translate('galleon.withdrawal.net-position.value').replace('{value}', netPositionValue);
    const hideRemoveButtonClass = controlsData.isRemovable ? '' : ' hidden';
    const confirmPopupTemplate = getConfirmPopupTemplate(popupConfig);
    const accordionSwitch = lockedAmount ? '' : `<magic-ui-accordion
              class="accordion"
              part="accordion"
              exportparts="accordion"
            ></magic-ui-accordion>`;
    return `<div class="controls-wrapper${disabledStyle()}"
      part="controls-wrapper${disabledStyle()}">
      <div class="net-position-container${hideStyle()}${hiddenLockedClass}"
            part="net-position-container${hideStyle()}">
              ${getTooltipTemplate('', translate('galleon.withdrawal.net-position.popup.description'))}
              <magic-ui-text
                tag="b"
                class="net-position-container__name"
                part="net-position-container__name"
                content="${netPositionText}"
              ></magic-ui-text>
      </div>

      ${confirmPopupTemplate}

      <magic-ui-icon
                name="delete"
                class="icon controls-wrapper__remove-icon${hideRemoveButtonClass}"
              ></magic-ui-icon>
      <magic-ui-icon
                name="loading-primary"
                class="icon controls-wrapper__loading-icon hidden"
              ></magic-ui-icon>
      ${accordionSwitch}
      </div>
    `;
}
function getRemoveErrorTemplate() {
    return `
  <div class="payment-error hidden">
       <magic-ui-text
              tag="p"
              class="payment-error-_text"
              part="payment-error-_text"
              content='${translate('galleon.payment.remove.error')}'
       ></magic-ui-text>
      </div>
  `;
}

var IconType = /*#__PURE__*/ function(IconType) {
    IconType["Card"] = "card";
    IconType["ACH"] = "achd";
    IconType["PayByBank"] = "pay_by_bank";
    IconType["PayByBankDevcode"] = "bank";
    IconType["PayByBankDevcodeService"] = "bank::paybybank";
    IconType["Paypal"] = "paypal";
    IconType["Skrill"] = "skrill";
    IconType["ApplePay"] = "applepay";
    IconType["GRABPAY"] = "grabpay";
    IconType["BDO"] = "bdo";
    IconType["METROBANK"] = "metrobank";
    IconType["LANDBANK"] = "landbank";
    IconType["BPI"] = "bpi";
    IconType["INSTAPAY"] = "instapay";
    IconType["PESONET"] = "pesonet";
    IconType["TESTUBP"] = "test_ubp";
    IconType["UBP"] = "ubp";
    IconType["PAYMAYA"] = "paymaya";
    IconType["QRPPH"] = "qrph";
    IconType["Paysafecard"] = "paysafecard";
    IconType["Neteller"] = "apmgw_neteller";
    IconType["BankTransfer"] = "apmgw_fast_bank_transfer";
    IconType["ExpressCheckout"] = "apmgw_expresscheckout";
    IconType["Trustly"] = "trustly";
    IconType["Interac"] = "interac";
    IconType["MuchBetter"] = "muchbetter";
    IconType["WebRedirect"] = "webredirect";
    IconType["GooglePay"] = "google_pay_without_3ds";
    IconType["GooglePay3DS"] = "google_pay_with_3ds";
    return IconType;
}({});
const iconTypes = Object.keys(IconType).map((key)=>IconType[key]);
const icons = {
    ["card"]: [
        'creditcard'
    ],
    ["webredirect"]: [
        'creditcard'
    ],
    ["pay_by_bank"]: [
        'banktransfer'
    ],
    ["bank"]: [
        'banktransfer'
    ],
    ["bank::paybybank"]: [
        'banktransfer'
    ],
    ["achd"]: [
        'banktransfer'
    ],
    ["apmgw_fast_bank_transfer"]: [
        'banktransfer'
    ],
    ["paypal"]: [
        'paypal'
    ],
    ["apmgw_expresscheckout"]: [
        'paypal'
    ],
    ["skrill"]: [
        'skrill'
    ],
    ["applepay"]: [
        'applepay'
    ],
    ["grabpay"]: [
        'grabpay'
    ],
    ["bdo"]: [
        'bdo'
    ],
    ["instapay"]: [
        'instapay'
    ],
    ["pesonet"]: [
        'pesonet'
    ],
    ["metrobank"]: [
        'metrobank'
    ],
    ["landbank"]: [
        'landbank'
    ],
    ["bpi"]: [
        'bpi'
    ],
    ["test_ubp"]: [
        'test_ubp'
    ],
    ["ubp"]: [
        'ubp'
    ],
    ["paymaya"]: [
        'paymaya'
    ],
    ["qrph"]: [
        'qrph'
    ],
    ["apmgw_neteller"]: [
        'neteller'
    ],
    ["trustly"]: [
        'trustly'
    ],
    ["interac"]: [
        'interac'
    ],
    ["muchbetter"]: [
        'muchbetter'
    ],
    ["google_pay_without_3ds"]: [
        'google-pay'
    ],
    ["google_pay_with_3ds"]: [
        'google-pay'
    ]
};
const getPaymentIconByTitle = (title, index = 0)=>{
    let iconName = title.toLowerCase();
    for(const value in iconTypes){
        if ((title == null ? void 0 : title.toLowerCase().indexOf(iconTypes[value])) >= 0) {
            const variantsIcons = icons[iconTypes[value]];
            if (variantsIcons) {
                const len = variantsIcons.length;
                let randIndex = Math.round(Math.random() * (len - 1));
                if (index >= 0) {
                    randIndex = Math.min(index, len - 1);
                }
                iconName = variantsIcons[randIndex];
                break;
            }
        }
    }
    return iconName;
};

function getMethodIcon(method) {
    const icon = getPaymentIconByTitle(method.paymentMethodExternalId);
    return `${method.logoUrl ? `<img
            class="payment-method__logo"
            part="payment-method__logo"
            src="${method.logoUrl}"
          />` : `<magic-ui-icon
          name="${icon}"
          class="payment-method__logo"
          part="payment-method__logo"
        ></magic-ui-icon>`}`;
}

function getWithdrawMethodTemplate(method, lockedAmount) {
    return `
    <div class="payment-method" part="payment-method">
      <div class="payment-method__details" part="payment-method__details">
        ${getMethodIcon(method)}
        <div>
          <magic-ui-text
            tag="b"
            class="payment-method__name"
            part="payment-method__name"
            content="${method.title}"
          ></magic-ui-text>
          <magic-ui-text
            tag="p"
            class="payment-method__subtitle"
            part="payment-method__subtitle"
            content="${formatCurrency(method.minAmount, method.currencyCode)}-${formatCurrency(method.maxAmount, method.currencyCode)}. No fee"
          ></magic-ui-text>
        </div>
      </div>
      ${lockedAmount ? '' : getAccordion()}
    </div>
    ${getRemoveErrorTemplate()}
  `;
}
function getAccordion() {
    return `<magic-ui-accordion
        class="accordion"
        part="accordion"
        exportparts="accordion"
      ></magic-ui-accordion>`;
}
function getSavedWithdrawMethodTemplate(config) {
    const { holderContent, methodContent, lockedAmount, netPosition, id, isRemovable, method } = config;
    const controlsData = {
        netPosition: netPosition,
        lockedAmount: lockedAmount,
        isRemovable: isRemovable,
        popupConfig: {
            id: id
        }
    };
    const sideControlsTemplate = getMethodControlsTemplate(controlsData);
    const icon = getMethodIcon(method);
    return `
        <div class="payment-method" part="payment-method">
          <div class="payment-method__details" part="payment-method__details">
            ${icon}
            <div>
              <magic-ui-text
                tag="b"
                class="payment-method__name"
                part="payment-method__name"
                content="${holderContent}"
              ></magic-ui-text>
              <magic-ui-text
                tag="p"
                class="payment-method__subtitle"
                part="payment-method__subtitle"
                content="${methodContent}"
              ></magic-ui-text>
            </div>
          </div>
          ${sideControlsTemplate}
        </div>
        ${getRemoveErrorTemplate()}
      `;
}

const removePlusSign = (phoneNumber)=>{
    if (!phoneNumber) return '';
    return phoneNumber.startsWith('+') ? phoneNumber.slice(1) : phoneNumber;
};
const extractUSAPhone = (phoneNumber)=>{
    if (!phoneNumber) return '';
    if (phoneNumber.startsWith('+1')) {
        return phoneNumber.slice(2);
    }
    return removePlusSign(phoneNumber);
};

var ERedirectStatus = /*#__PURE__*/ function(ERedirectStatus) {
    ERedirectStatus["Success"] = "success";
    ERedirectStatus["Cancel"] = "cancel";
    ERedirectStatus["Fail"] = "fail";
    ERedirectStatus["Default"] = "default";
    ERedirectStatus["PopupClosed"] = "popupClosed";
    //TODO: add pending translations for status screen???
    ERedirectStatus["Pending"] = "pending";
    return ERedirectStatus;
}({});

var GatewayType = /*#__PURE__*/ function(GatewayType) {
    GatewayType["Corex"] = "Corex";
    GatewayType["Paysafe"] = "Paysafe";
    GatewayType["Devcode"] = "Devcode";
    GatewayType["Nuvei"] = "Nuvei";
    GatewayType["Paymongo"] = "Paymongo";
    GatewayType["Solairepay"] = "Solairepay";
    return GatewayType;
}({});

class GatewayRegistryInstance {
    /**
   * Register a service by name
   */ register(name, service) {
        this.services.set(name, service);
    }
    /**
   * Register a gateway service by type
   */ registerGateway(type, service) {
        this.services.set(`gateway:${type}`, service);
    }
    /**
   * Get a service by name
   */ get(name) {
        return this.services.get(name);
    }
    /**
   * Get a gateway by type
   */ getGateway(type) {
        return this.services.get(`gateway:${type}`);
    }
    getCorexAdaptedGateway(type) {
        return this.getGateway(type);
    }
    /**
   * Clear all registered services (useful for testing)
   */ clear() {
        this.services.clear();
    }
    constructor(){
        this.services = new Map();
    }
}
GatewayRegistryInstance = __decorate([
    singleton()
], GatewayRegistryInstance);
const GatewayRegistry = new GatewayRegistryInstance();

function getDepositMethodTemplate(method, config) {
    const { lockedAmount, isRemovable, id } = config;
    const noFeeText = translate('galleon.no-fee.hint');
    let totalFormatedFee = '';
    if (method.percentageFee) {
        totalFormatedFee += (method.percentageFee * 100).toFixed(2) + '%';
    }
    if (method.fixedFee) {
        const space = totalFormatedFee ? ' ' : '';
        totalFormatedFee += space + formatCurrency(method.fixedFee, method.currencyCode);
    }
    const totalFeeText = translate('galleon.fee.hint').replace('{fee}', totalFormatedFee);
    const feeText = method.fixedFee || method.percentageFee ? totalFeeText : noFeeText;
    const subtitle = `${formatCurrency(method.minAmount, method.currencyCode)}-${formatCurrency(method.maxAmount, method.currencyCode)}. ${feeText}`;
    const controlsData = {
        lockedAmount: lockedAmount,
        isRemovable: isRemovable,
        popupConfig: {
            id: id
        }
    };
    const sideControlsTemplate = getMethodControlsTemplate(controlsData);
    return `
      <div class="payment-method" part="payment-method">
        <div class="payment-method__details" part="payment-method__details">
          ${getMethodIcon(method)}
          <div>
            <magic-ui-text
              tag="b"
              class="payment-method__name"
              part="payment-method__name"
              content="${config.specificTitle || method.title}"
            ></magic-ui-text>
            <magic-ui-text
              tag="p"
              class="payment-method__subtitle"
              part="payment-method__subtitle"
              content="${config.specificSubtitle || subtitle}"
            ></magic-ui-text>
          </div>
        </div>
        ${sideControlsTemplate}
     </div>
     ${getRemoveErrorTemplate()}
  `;
}

var EMethodFlowType = /*#__PURE__*/ function(EMethodFlowType) {
    EMethodFlowType["NestedIframe"] = "NestedIframe";
    EMethodFlowType["RedirectPopup"] = "RedirectPopup";
    EMethodFlowType["Custom"] = "Custom";
    return EMethodFlowType;
}({});

function attachOpenListener(button, popupId) {
    const content = AppState.shadowRoot.querySelector('.tab-content');
    button == null ? void 0 : button.addEventListener('click', ()=>{
        const tooltipEl = content.querySelector(`[data-tooltip-id="${popupId}"]`);
        if (!tooltipEl) {
            console.error(`no tooltip element found for ${popupId}`);
        }
        tooltipEl == null ? void 0 : tooltipEl.setAttribute('is-controlled-open', 'true');
    });
}
function attachCloseListener(button, bonusId) {
    const content = AppState.shadowRoot.querySelector('.tab-content');
    button.addEventListener('click', ()=>{
        const tooltipEl = content.querySelector(`[data-tooltip-id="${bonusId}"]`);
        tooltipEl.setAttribute('is-controlled-open', 'false');
    });
}
function attachResultListener(methodDiv, methodId, callback) {
    const tooltipEl = methodDiv == null ? void 0 : methodDiv.querySelector(`[data-tooltip-id="${methodId}"]`);
    tooltipEl == null ? void 0 : tooltipEl.addEventListener('click', (event)=>{
        event.stopPropagation();
    });
    const okButton = tooltipEl == null ? void 0 : tooltipEl.querySelector(`.popup__ok`);
    okButton == null ? void 0 : okButton.addEventListener('click', (event)=>{
        event.stopPropagation();
        tooltipEl.setAttribute('is-controlled-open', 'false');
        callback(true);
    });
    const cancelButton = tooltipEl == null ? void 0 : tooltipEl.querySelector(`.popup__cancel`);
    cancelButton == null ? void 0 : cancelButton.addEventListener('click', (event)=>{
        event.stopPropagation();
        tooltipEl.setAttribute('is-controlled-open', 'false');
        callback(false);
    });
}
const confirmPoupListeners = {
    attachCloseListener,
    attachOpenListener,
    attachResultListener
};

function attachRemoveButtonListener(methodDiv, methodId, onClick) {
    if (methodDiv) {
        const removeMethodIcon = methodDiv.querySelector('.controls-wrapper__remove-icon');
        removeMethodIcon == null ? void 0 : removeMethodIcon.addEventListener('click', function(event) {
            event.stopPropagation();
            onClick(removeMethodIcon);
        });
        confirmPoupListeners.attachOpenListener(removeMethodIcon, methodId);
    }
}
const methodListeners = {
    attachRemoveButtonListener
};

const removeErrorTimeouts = {};
function initBaseMethodControls(methodDiv, methodId, removeHandler) {
    methodListeners.attachRemoveButtonListener(methodDiv, methodId, ()=>{
        showError(methodDiv, false);
    });
    confirmPoupListeners.attachResultListener(methodDiv, methodId, (result)=>{
        removeHandler == null ? void 0 : removeHandler(result);
    });
}
function setRemoveButtonLoading(methodDiv, isLoading = true) {
    const removeMethodIcon = methodDiv.querySelector('.controls-wrapper__remove-icon');
    const loadingIcon = methodDiv.querySelector('.controls-wrapper__loading-icon');
    if (isLoading) {
        removeMethodIcon == null ? void 0 : removeMethodIcon.classList.add('hidden');
        loadingIcon == null ? void 0 : loadingIcon.classList.remove('hidden');
    } else {
        removeMethodIcon == null ? void 0 : removeMethodIcon.classList.remove('hidden');
        loadingIcon == null ? void 0 : loadingIcon.classList.add('hidden');
    }
}
function showError(methodDiv, isShow = false) {
    const errorLabel = methodDiv.querySelector('.payment-error');
    if (isShow) {
        errorLabel == null ? void 0 : errorLabel.classList.remove('hidden');
        removeErrorTimeouts['' + methodDiv] = setTimeout(()=>{
            errorLabel == null ? void 0 : errorLabel.classList.add('hidden');
        }, 5000);
    } else {
        const removeErrorTimeout = removeErrorTimeouts['' + methodDiv];
        if (removeErrorTimeout) {
            clearTimeout(removeErrorTimeout);
            removeErrorTimeouts['' + methodDiv] = undefined;
        }
        errorLabel == null ? void 0 : errorLabel.classList.add('hidden');
    }
}

class LogEventServiceInstance {
    logEvent(event) {
        AppState.root.dispatchEvent(new CustomEvent(DispatchMessageType.LogMessage, {
            detail: event
        }));
        return Promise.resolve(true);
    }
}
LogEventServiceInstance = __decorate([
    singleton()
], LogEventServiceInstance);
const LogEventService = new LogEventServiceInstance();

class PendingBalanceCheckInstance {
    checkBalance(data, deposit = true, callback) {
        var _content_querySelector;
        var _this_prevBalance;
        const prevBalance = (_this_prevBalance = this.prevBalance) != null ? _this_prevBalance : AppState.wallet.balanceData.balance;
        const content = getCurrentTab();
        const iframeContainer = content == null ? void 0 : (_content_querySelector = content.querySelector) == null ? void 0 : _content_querySelector.call(content, `.status-screen__container`);
        return new Promise((resolve)=>{
            const interval = setInterval(()=>{
                if (AppState.wallet.balanceData.balance === prevBalance) {
                    return;
                }
                if (!iframeContainer || !data.success) {
                    clearInterval(interval);
                    this.prevBalance = null;
                    resolve(false);
                }
                const direction = deposit ? 1 : -1;
                const balanceDelta = AppState.wallet.balanceData.balance - prevBalance;
                const absoluteAmount = data.amount * direction;
                if (Math.abs(balanceDelta - absoluteAmount) <= Number.EPSILON) {
                    clearInterval(interval);
                    this.prevBalance = null;
                    callback == null ? void 0 : callback(data);
                    resolve(true);
                }
            }, 500);
        });
    }
    updatePrevBalance(prevBalanceValue) {
        this.prevBalance = prevBalanceValue != null ? prevBalanceValue : AppState.wallet.balanceData.balance;
    }
    checkWithdrawalBalance(data, callback) {
        return this.checkBalance(data, false, callback || createWithdrawStatusScreen);
    }
    checkDepositBalance(data, callback) {
        return this.checkBalance(data, true, callback || createDepositStatusScreen);
    }
    constructor(){
        this.prevBalance = null;
    }
}
const PendingBalanceCheck = new PendingBalanceCheckInstance();

class BasePaymentMethod {
    get provider() {
        return this.params.provider;
    }
    get id() {
        return this.params.id;
    }
    get methodProviderId() {
        return makeProviderMethodId(this.provider, this.paymentMethodExternalId);
    }
    get externalAccountId() {
        return this.params.externalAccountId;
    }
    get title() {
        return this.params.title;
    }
    get minAmount() {
        return this.params.minAmount;
    }
    set minAmount(value) {
        this.params.minAmount = value;
    }
    get maxAmount() {
        return this.params.maxAmount;
    }
    set maxAmount(value) {
        this.params.maxAmount = value;
    }
    get logoUrl() {
        return this.params.logoUrl;
    }
    get currencyCode() {
        return this.params.currencyCode;
    }
    get fixedFee() {
        return this.params.fixedFee;
    }
    get percentageFee() {
        return this.params.percentageFee;
    }
    get paymentMethodExternalId() {
        return this.params.paymentMethodExternalId;
    }
    get paymentType() {
        return this.params.paymentType || '';
    }
    get netPosition() {
        return this.params.netPosition;
    }
    set netPosition(value) {
        this.params.netPosition = value;
    }
    get isDisabled() {
        return this.netPosition === 0;
    }
    get redirectBaseUrl() {
        return this.corexConfig.redirectBaseUrl;
    }
    get position() {
        var _this_params;
        return (_this_params = this.params) == null ? void 0 : _this_params.position;
    }
    get flowType() {
        var _this_params;
        return ((_this_params = this.params) == null ? void 0 : _this_params.flowType) || EMethodFlowType.Custom;
    }
    get corexConfig() {
        return this.corexGateway.config;
    }
    get corexGateway() {
        var _GatewayRegistry_getCorexAdaptedGateway;
        return (_GatewayRegistry_getCorexAdaptedGateway = GatewayRegistry.getCorexAdaptedGateway(this.provider)) == null ? void 0 : _GatewayRegistry_getCorexAdaptedGateway.corexService;
    }
    render(index) {
        return AppState.wallet.selectedTabName === View.Deposit ? this.renderDepositElement() : this.renderWithdrawElement(index);
    }
    logAttempt(amount) {
        const type = AppState.wallet.selectedTabName === View.Deposit ? LogActionEventName.DepositAttempt : LogActionEventName.WithdrawalAttempt;
        void LogEventService.logEvent({
            type,
            params: {
                amount,
                currency: AppState.wallet.balanceData.currencyCode,
                method: this.methodProviderId
            }
        });
        PendingBalanceCheck.updatePrevBalance();
    }
    logPayment(result) {
        const isDepositTab = AppState.wallet.selectedTabName === View.Deposit;
        let type;
        if (isDepositTab) {
            type = result.success ? LogActionEventName.DepositSuccess : LogActionEventName.DepositError;
        } else {
            type = result.success ? LogActionEventName.WithdrawalSuccess : LogActionEventName.WithdrawalError;
        }
        void LogEventService.logEvent({
            type,
            params: {
                method: this.methodProviderId,
                currency: result.currencyCode,
                amount: result.amount,
                transactionId: result.transactionID
            }
        });
    }
    renderDepositElement() {
        const selectedStateMethod = AppState.wallet.deposit.selectedMethod;
        const methodDiv = createElementFromTemplate('div', getDepositMethodTemplate(this, _extends$1({
            lockedAmount: AppState.wallet.lockedAmount
        }, this.getSpecificDepositTemplate())));
        methodDiv.classList.add('method-container', 'deposit-method-container', `method-${this.id}`);
        const methodId = this.id;
        this.methodDiv = methodDiv;
        initBaseMethodControls(methodDiv, methodId, (result)=>{
            if (result) {
                void this.proceedRemoveMethod();
            }
        });
        if (AppState.wallet.lockedAmount) {
            methodDiv.classList.add('payment-method--locked-amount');
            attachLockedAmountListener(methodDiv, ()=>{
                AppState.wallet.deposit.selectedSavedMethod = null;
                void handleLockedDepositClick(this);
            });
        } else {
            attachAccordionListener(methodDiv, handleAccordionToggle$1(this));
        }
        if ((selectedStateMethod == null ? void 0 : selectedStateMethod.id) === this.id) {
            AppState.wallet.deposit.selectedMethod = null;
            if (!AppState.wallet.lockedAmount) {
                handleAccordionToggle$1(this)(methodDiv);
            }
        }
        return methodDiv;
    }
    renderWithdrawElement(_index) {
        const methodDiv = createElementFromTemplate('div', getWithdrawMethodTemplate(this, AppState.wallet.lockedAmount));
        methodDiv.classList.add(`method-${this.id}`);
        if (AppState.wallet.lockedAmount) {
            const innerMethodDiv = methodDiv.querySelector('.payment-method');
            innerMethodDiv.classList.add('payment-method--locked-amount');
            attachLockedAmountListener(innerMethodDiv, ()=>{
                handleLockedWithdrawClick(innerMethodDiv, this);
            });
        } else {
            attachAccordionListener(methodDiv, handleWithdrawAccordionToggle(this));
        }
        return methodDiv;
    }
    async proceedRemoveMethod() {
        setRemoveButtonLoading(this.methodDiv);
        return this.callRemoveMethod().then((result)=>{
            if (result) {
                this.removeUIMethod();
            } else {
                setRemoveButtonLoading(this.methodDiv, false);
                showError(this.methodDiv, true);
            }
            return result;
        }).catch((error)=>{
            console.error('Proceed remove method error', error);
            setRemoveButtonLoading(this.methodDiv, false);
            showError(this.methodDiv, true);
            return false;
        });
    }
    async callRemoveMethod() {
        return Promise.reject(false);
    }
    removeUIMethod() {
        if (this.methodDiv) {
            this.methodDiv.classList.add('removing');
            setTimeout(()=>{
                var _this_methodDiv;
                (_this_methodDiv = this.methodDiv) == null ? void 0 : _this_methodDiv.remove();
            }, 300);
        }
    }
    getSpecificDepositTemplate() {
        return {};
    }
    getRedirectionUrl(redirectBaseUrl, method, successValue) {
        return `${redirectBaseUrl}?${WalletQueryParams.TxState}=${method}&${WalletQueryParams.Status}=${successValue}`;
    }
    getWaitingForApprovalStatusMessage() {
        return {
            title: translate('galleon.withdrawal.waiting.approval.title'),
            message: translate('galleon.withdrawal.waiting.approval.description')
        };
    }
    constructor(params){
        this.params = params;
    }
}

class BaseCorexMethod extends BasePaymentMethod {
    get corexGateway() {
        var _GatewayRegistry_getCorexAdaptedGateway;
        return (_GatewayRegistry_getCorexAdaptedGateway = GatewayRegistry.getCorexAdaptedGateway(GatewayType.Paysafe)) == null ? void 0 : _GatewayRegistry_getCorexAdaptedGateway.corexService;
    }
    getDepositConfig(amount) {
        const config = {
            depositConfig: {
                apiUrl: this.corexGateway.config.apiUrl,
                tenant: this.corexGateway.config.tenant,
                paymentDetails: {
                    currencyCode: this.currencyCode,
                    externalPaymentMethodId: this.paymentMethodExternalId
                },
                serviceName: this.corexGateway.providerType
            },
            paysafeConfig: {
                amount: Number(amount),
                currencyCode: this.currencyCode
            }
        };
        if (AppState.wallet.chosenDepositBonus !== '') {
            config.promoCode = AppState.wallet.chosenDepositBonus;
        }
        return config;
    }
}

function getSuccessStatusTemplate(customStatus) {
    return `
    <div data-v-test-id="quick-payment__success" class="quick-payment__success slide-in">
      <magic-ui-icon
        name="quick-deposit-success"
        class="icon icon--payment"
        part="icon icon--payment"
      ></magic-ui-icon>
      <magic-ui-text
        class="quick-payment__message"
        tag="b"
        content="${customStatus ? customStatus : translate('quick-deposit.deposit-successful')}"
        data-v-test-id="quick-deposit-success-message"
      ></magic-ui-text>
    </div>
  `;
}

function getFailedStatusTemplate() {
    return `
    <div data-v-test-id="quick-payment__failed" class="quick-payment__failed slide-in">
      <magic-ui-icon
        name="quick-deposit-failed"
        class="icon icon--payment"
        part="icon icon--payment"
      ></magic-ui-icon>
      <magic-ui-text
        class="quick-payment__message"
        tag="b"
        content="${translate('quick-deposit.deposit-failed')}"
        data-v-test-id="quick-deposit-fail-message"
      ></magic-ui-text>
    </div>
  `;
}

// Registry of payment provider
const paymentProviders = {
    Paysafe: {
        getAvailableOptions () {
            const options = [];
            const paypalMethod = AppState.methods.deposit.find((method)=>method.paymentMethodExternalId === PaysafeMethodId.Paypal && method.provider === 'Paysafe');
            if (paypalMethod) {
                options.push({
                    name: 'Paypal',
                    value: PaysafeMethodId.Paypal
                });
            }
            const cardMethod = AppState.methods.deposit.find((method)=>method.paymentMethodExternalId === PaysafeMethodId.Card && method.provider === 'Paysafe');
            if (cardMethod) {
                options.push({
                    name: 'Card',
                    value: PaysafeMethodId.Card
                });
            }
            return options;
        },
        validateForm: (form)=>!!form.amount,
        handleDeposit: (amount)=>{
            if (!AppState.wallet.deposit.selectedMethod) return;
            AppState.wallet.deposit.selectedMethod.deposit(amount);
        },
        setupProviderSpecificUI: (content)=>{
            var _content_shadowRoot;
            const cvvWrapper = (_content_shadowRoot = content.shadowRoot) == null ? void 0 : _content_shadowRoot.querySelector('.quick-payment__cvv-wrapper');
            if (cvvWrapper) {
                cvvWrapper.classList.add('none');
            }
        },
        requiresCVV: false
    },
    Devcode: {
        getAvailableOptions () {
            const options = [];
            const cards = AppState.methods.savedDepositMethods.filter((method)=>method.methodLabel === 'Creditcard');
            options.push(...cards.map((card)=>{
                var _card_maskedAccount;
                var _card_maskedAccount_slice;
                return {
                    name: (_card_maskedAccount_slice = (_card_maskedAccount = card.maskedAccount) == null ? void 0 : _card_maskedAccount.slice(-6)) != null ? _card_maskedAccount_slice : 'Credit Card',
                    value: card.id
                };
            }));
            return options;
        },
        validateForm: (form)=>!!form.amount && !!form.cvv && form.cvv.length >= 3,
        handleDeposit: (amount, cvv)=>{
            if (!AppState.wallet.deposit.selectedSavedMethod) {
                const cards = AppState.methods.savedDepositMethods.filter((method)=>method.methodLabel === 'Creditcard');
                AppState.wallet.deposit.selectedSavedMethod = cards[0];
            }
            const method = AppState.wallet.deposit.selectedSavedMethod;
            // @ts-expect-error missing typings to avoid circular deps
            method.setCVV(cvv);
            method.deposit(amount);
        },
        setupProviderSpecificUI: (content)=>{
            var _content_shadowRoot;
            const cvvWrapper = (_content_shadowRoot = content.shadowRoot) == null ? void 0 : _content_shadowRoot.querySelector('.quick-payment__cvv-wrapper');
            if (cvvWrapper && cvvWrapper.classList.contains('none')) {
                cvvWrapper.classList.remove('none');
            }
        },
        requiresCVV: true
    }
};
function getCurrentPaymentProvider() {
    var _AppState_wallet_deposit_selectedMethod;
    const providerName = ((_AppState_wallet_deposit_selectedMethod = AppState.wallet.deposit.selectedMethod) == null ? void 0 : _AppState_wallet_deposit_selectedMethod.provider) || (AppState.wallet.deposit.selectedSavedMethod ? 'Devcode' : 'Paysafe');
    return paymentProviders[providerName] || paymentProviders['Devcode'];
}
function isQuickPayment() {
    // if not cashier, then it's quick payment
    const content = getCurrentTab();
    return !(content == null ? void 0 : content.classList.contains('tab-content'));
}

function getInputElement(root, className) {
    var _root_shadowRoot, _wrapper_shadowRoot, _magicInput_shadowRoot;
    const wrapper = (_root_shadowRoot = root.shadowRoot) == null ? void 0 : _root_shadowRoot.querySelector(className);
    const magicInput = wrapper == null ? void 0 : (_wrapper_shadowRoot = wrapper.shadowRoot) == null ? void 0 : _wrapper_shadowRoot.querySelector('magic-ui-input');
    return magicInput == null ? void 0 : (_magicInput_shadowRoot = magicInput.shadowRoot) == null ? void 0 : _magicInput_shadowRoot.querySelector('input');
}
function attachInputListener$1(content) {
    var _content_shadowRoot, _content_shadowRoot1, _content_shadowRoot2;
    const form = {
        amount: '',
        cvv: ''
    };
    const depositButton = (_content_shadowRoot = content.shadowRoot) == null ? void 0 : _content_shadowRoot.querySelector('.quick-payment__button');
    const cvvInput = (_content_shadowRoot1 = content.shadowRoot) == null ? void 0 : _content_shadowRoot1.querySelector('.quick-payment__cvv');
    const amountInput = (_content_shadowRoot2 = content.shadowRoot) == null ? void 0 : _content_shadowRoot2.querySelector('.quick-payment__amount');
    const updateButtonState = ()=>{
        const currentProvider = getCurrentPaymentProvider();
        if (currentProvider.validateForm(form)) {
            depositButton.removeAttribute('disabled');
        } else {
            depositButton.setAttribute('disabled', 'true');
        }
    };
    const handleInput = (field)=>(event)=>{
            form[field] = event.detail[0];
            updateButtonState();
        };
    cvvInput == null ? void 0 : cvvInput.addEventListener('input', handleInput('cvv'));
    amountInput == null ? void 0 : amountInput.addEventListener('input', handleInput('amount'));
}
function attachDepositButtonListener(content) {
    var _content_shadowRoot;
    const depositButton = (_content_shadowRoot = content.shadowRoot) == null ? void 0 : _content_shadowRoot.querySelector('.quick-payment__button');
    depositButton.addEventListener('click', function() {
        if (depositButton.getAttribute('disabled') !== null) {
            return;
        }
        depositButton.setAttribute('disabled', 'true');
        depositButton.setAttribute('loading', 'true');
        try {
            const amountInput = getInputElement(content, '.quick-payment__amount');
            const amount = Number((amountInput == null ? void 0 : amountInput.value) || 0);
            const currentProvider = getCurrentPaymentProvider();
            if (currentProvider.requiresCVV) {
                const cvvInput = getInputElement(content, '.quick-payment__cvv');
                const cvv = (cvvInput == null ? void 0 : cvvInput.value) || '';
                currentProvider.handleDeposit(amount, cvv);
            } else {
                currentProvider.handleDeposit(amount);
            }
        } catch (e) {
            console.error(`error:`, e);
            quickDepositCompleted('popupClosed');
        }
    });
}
function quickDepositCompleted(status) {
    var _paymentContent_shadowRoot, _content_shadowRoot, _content_shadowRoot_querySelector, _content_shadowRoot1;
    const paymentContent = document.querySelector('magic-quick-payment-content');
    if (!paymentContent) {
        return;
    }
    const content = paymentContent == null ? void 0 : (_paymentContent_shadowRoot = paymentContent.shadowRoot) == null ? void 0 : _paymentContent_shadowRoot.querySelector('magic-quick-payment');
    const statusElement = content == null ? void 0 : (_content_shadowRoot = content.shadowRoot) == null ? void 0 : _content_shadowRoot.querySelector('.quick-payment__status');
    // Map of status codes to handlers
    const statusHandlers = {
        success: ()=>statusElement == null ? void 0 : statusElement.setHTMLUnsafe(getSuccessStatusTemplate()),
        popupClosed: ()=>statusElement == null ? void 0 : statusElement.setHTMLUnsafe(getFailedStatusTemplate()),
        fail: ()=>statusElement == null ? void 0 : statusElement.setHTMLUnsafe(getFailedStatusTemplate()),
        paypalSuccess: ()=>statusElement == null ? void 0 : statusElement.setHTMLUnsafe(getSuccessStatusTemplate(translate('quick-deposit.deposit-paypal')))
    };
    // Execute the appropriate handler
    const handler = statusHandlers[status];
    if (handler) {
        handler();
    }
    (_content_shadowRoot1 = content.shadowRoot) == null ? void 0 : (_content_shadowRoot_querySelector = _content_shadowRoot1.querySelector('.quick-payment__content')) == null ? void 0 : _content_shadowRoot_querySelector.classList.add('hidden');
    setTimeout(()=>{
        resetState$1(content);
    }, 2500);
}
function resetState$1(content) {
    var _content_shadowRoot, _content_shadowRoot_querySelector, _content_shadowRoot1, _content_shadowRoot2;
    const depositButton = (_content_shadowRoot = content.shadowRoot) == null ? void 0 : _content_shadowRoot.querySelector('.quick-payment__button');
    (_content_shadowRoot1 = content.shadowRoot) == null ? void 0 : (_content_shadowRoot_querySelector = _content_shadowRoot1.querySelector('.quick-payment__content')) == null ? void 0 : _content_shadowRoot_querySelector.classList.remove('hidden');
    const status = (_content_shadowRoot2 = content.shadowRoot) == null ? void 0 : _content_shadowRoot2.querySelector('.quick-payment__status');
    status == null ? void 0 : status.setHTMLUnsafe('');
    depositButton.removeAttribute('disabled');
    depositButton.removeAttribute('loading');
    if (AppState.wallet.isMobile) {
        AppState.root.dispatchEvent(new CustomEvent('close-payment'));
    }
}
function attachChangeCardListener(content) {
    var _content_shadowRoot;
    const cards = AppState.methods.savedDepositMethods.filter((method)=>method.methodLabel === 'Creditcard');
    if (cards.length > 0) {
        // @ts-expect-error missing typings to avoid circular deps
        cards[0].injectEncryption();
        AppState.wallet.deposit.selectedSavedMethod = cards[0];
    }
    const cardDropdown = (_content_shadowRoot = content.shadowRoot) == null ? void 0 : _content_shadowRoot.querySelector('.quick-payment__dropdown');
    cardDropdown == null ? void 0 : cardDropdown.addEventListener('change', (event)=>{
        const cardId = event.detail[0];
        // Handle Paysafe payment methods
        if (cardId === PaysafeMethodId.Paypal || cardId === PaysafeMethodId.Card) {
            const methodName = cardId === PaysafeMethodId.Paypal ? PaysafeMethodId.Paypal : PaysafeMethodId.Card;
            AppState.wallet.deposit.selectedMethod = AppState.methods.deposit.find((method)=>method.paymentMethodExternalId === methodName);
            AppState.wallet.deposit.selectedSavedMethod = null;
            getCurrentPaymentProvider().setupProviderSpecificUI(content);
        } else {
            AppState.wallet.deposit.selectedMethod = null;
            AppState.wallet.deposit.selectedSavedMethod = cards.find((card)=>card.id === cardId);
            getCurrentPaymentProvider().setupProviderSpecificUI(content);
        }
    });
}
function attachListeners$3(content) {
    attachInputListener$1(content);
    attachChangeCardListener(content);
    attachDepositButtonListener(content);
    // Set up initial UI based on current provider
    getCurrentPaymentProvider().setupProviderSpecificUI(content);
}

function getDepositPaypalCompleteTemplate(data) {
    const title = translate('galleon.deposit.pending.title');
    const btnLabel = translate('galleon.success.screen.button');
    return `
    <div class="paypal status-screen" part="paypal status-screen">
      <magic-ui-text
          tag="b"
          class="status-screen__title"
          part="status-screen__title"
          content='${title}'
        ></magic-ui-text>
        ${getStatusPaypalMessage(data)}
        <magic-ui-button
            class="status-screen__button"
            part="status-screen__button"
            variant="primary"
            small
        >
        ${btnLabel}
        </magic-ui-button>
    </div>
  `;
}
function getStatusPaypalMessage(data) {
    const description = translate('galleon.deposit.pending.description').replace('{amount}', formatCurrency(data.amount, data.currencyCode)).replace('{transactionID}', data.transactionID);
    return `
      <magic-ui-text
        tag="p"
        class="status-screen__text"
        part="status-screen__text"
        content='${description}'
        is-markdown
      ></magic-ui-text>
    `;
}

function capitalize(str) {
    var _str_toLowerCase_split_map_join, _str_toLowerCase_split_map, _str_toLowerCase_split, _str_toLowerCase;
    if (!str) return '';
    return str == null ? void 0 : (_str_toLowerCase = str.toLowerCase()) == null ? void 0 : (_str_toLowerCase_split = _str_toLowerCase.split(' ')) == null ? void 0 : (_str_toLowerCase_split_map = _str_toLowerCase_split.map((word)=>word.charAt(0).toUpperCase() + word.slice(1))) == null ? void 0 : (_str_toLowerCase_split_map_join = _str_toLowerCase_split_map.join(' ')) == null ? void 0 : _str_toLowerCase_split_map_join.trim();
}
function prettifyId(str) {
    if (!str) return '';
    return capitalize(str == null ? void 0 : str.replace(/[-_]/g, ' '));
}

function getContinuePaypalMessage(data) {
    const description = translate('galleon.deposit.continue.introduction').replace('{depositAmount}', formatCurrency(data.amount, data.currencyCode)).replace('{depositMethodSelected}', data.paymentMethodLabel || prettifyId(data.paymentMethod));
    return `
        <slot name="deposit-continue">
                 <magic-ui-text
                    tag="p"
                    class="status-screen__text"
                    part="status-screen__text"
                    content='${description}'
                    is-markdown
                  ></magic-ui-text>
          </slot>
    `;
}
function getPaypalContinueScreenTemplate(data) {
    const title = translate('galleon.deposit.complete');
    const continueLabel = translate('galleon.deposit.continue');
    return `
    <div class="paypal status-screen" part="paypal status-screen">
        <magic-ui-text
          tag="b"
          class="status-screen__title"
          part="status-screen__title"
          content='${title}'
        ></magic-ui-text>
       ${getContinuePaypalMessage(data)}
        <magic-ui-button
            class="paypal status-screen__button"
            part="paypal status-screen__button"
            variant="primary"
            small
        >
        ${continueLabel}
        </magic-ui-button>
    </div>
  `;
}

const createDepositPaypalContinueMessage = (depositResult, callback)=>{
    return new Promise((resolve)=>{
        var _getCurrentTab;
        const content = (_getCurrentTab = getCurrentTab()) != null ? _getCurrentTab : document.createElement('div');
        content.innerHTML = getPaypalContinueScreenTemplate(depositResult);
        scrollToTop();
        if (isQuickPayment()) {
            if (depositResult.success) {
                resolve(true);
            } else {
                quickDepositCompleted('fail');
            }
        }
        statusButtonsHandler(content, ()=>{
            resolve(true);
        });
    });
};
const createDepositPaypalCompleteMessage = (depositResult, callback)=>{
    var _getCurrentTab;
    const content = (_getCurrentTab = getCurrentTab()) != null ? _getCurrentTab : document.createElement('div');
    content.innerHTML = getDepositPaypalCompleteTemplate(depositResult);
    statusButtonsHandler(content, ()=>{
        callback == null ? void 0 : callback();
    });
    void PendingBalanceCheck.checkDepositBalance(depositResult);
};

var _handleWithdrawAccordionToggle = /*#__PURE__*/ _class_private_field_loose_key("_handleWithdrawAccordionToggle"), _expandWithdrawMethod = /*#__PURE__*/ _class_private_field_loose_key("_expandWithdrawMethod"), _attachButtonListener = /*#__PURE__*/ _class_private_field_loose_key("_attachButtonListener"), _getTemplate = /*#__PURE__*/ _class_private_field_loose_key("_getTemplate"), _showWithdrawResult = /*#__PURE__*/ _class_private_field_loose_key("_showWithdrawResult"), _showDepositResult$3 = /*#__PURE__*/ _class_private_field_loose_key("_showDepositResult"), _proceedPayByBank = /*#__PURE__*/ _class_private_field_loose_key("_proceedPayByBank"), _openPaySafePage$1 = /*#__PURE__*/ _class_private_field_loose_key("_openPaySafePage");
class PayByBankMethod extends BaseCorexMethod {
    async deposit(amount) {
        const config = this.getDepositConfig(amount);
        if (AppState.wallet.chosenDepositBonus !== '') {
            config.promoCode = AppState.wallet.chosenDepositBonus;
        }
        const result = {
            amount: amount,
            creditCard: '',
            currencyCode: this.currencyCode,
            success: false,
            paymentMethod: PaysafeMethodId.PayByBank,
            paymentMethodLabel: translate('galleon.payment.paybybank.label') || 'Pay by Bank',
            transactionID: '',
            buttonUrl: '',
            popupUrl: '',
            promoCode: config.promoCode
        };
        try {
            var _paysafeResult_instance;
            this.logAttempt(amount);
            const launchResult = await this.corexGateway.launchDeposit(config);
            const paysafeResult = await _class_private_field_loose_base(this, _proceedPayByBank)[_proceedPayByBank](config, launchResult);
            if (paysafeResult.paymentHandleToken) {
                const authorizeResult = await this.corexGateway.depositSubmit(paysafeResult.paymentHandleToken, PaysafeMethodId.PayByBank);
                if (authorizeResult.transactionId) {
                    result.success = true;
                    result.transactionID = authorizeResult.transactionId;
                }
            }
            (_paysafeResult_instance = paysafeResult.instance) == null ? void 0 : _paysafeResult_instance.close();
            return result;
        } catch (error) {
            console.error('Error during card deposit:', error);
            return result;
        } finally{
            _class_private_field_loose_base(this, _showDepositResult$3)[_showDepositResult$3](result);
        }
    }
    async withdraw(amount) {
        const method = this.paymentMethodExternalId;
        const specificParams = {
            defaultRedirectionUrl: this.getRedirectionUrl(this.redirectBaseUrl, method, ERedirectStatus.Default),
            completeRedirectionUrl: this.getRedirectionUrl(this.redirectBaseUrl, method, ERedirectStatus.Success),
            cancelRedirectionUrl: this.getRedirectionUrl(this.redirectBaseUrl, method, ERedirectStatus.Cancel),
            failRedirectionUrl: this.getRedirectionUrl(this.redirectBaseUrl, method, ERedirectStatus.Fail)
        };
        const profile = AppState.wallet.profile;
        if (!profile) {
            throw new Error('User profile is missing');
        }
        const { customer } = profile;
        const payByBankLaunchConfig = _extends$1({
            currencyCode: this.currencyCode,
            externalPaymentMethodId: this.paymentMethodExternalId,
            isNewAccount: true,
            customerDetails: _extends$1({}, customer, {
                phone: extractUSAPhone(customer.phone)
            }),
            billingDetails: profile.billingAddress
        }, specificParams);
        const openLoopLaunchResult = await this.corexGateway.launchOpenLoopWithdraw(payByBankLaunchConfig);
        const submitResult = {
            success: false,
            transactionID: '',
            errorText: '',
            specificTitle: '',
            buttonLabel: ''
        };
        const handleError = ()=>{
            submitResult.errorText = translate('galleon.withdrawal.linking.message.failure');
            submitResult.specificTitle = translate('galleon.withdrawal.linking.title.failure');
        };
        if (openLoopLaunchResult.redirectUrl) {
            await createDepositPaypalContinueMessage({
                amount: amount,
                currencyCode: this.currencyCode,
                success: true,
                buttonLabel: translate('galleon.deposit.continue'),
                paymentMethod: PaysafeMethodId.PayByBank,
                paymentMethodLabel: translate('galleon.payment.paybybank.label')});
            const redirectResult = await ProxyListener.openWindow(openLoopLaunchResult.redirectUrl, this.redirectBaseUrl);
            if ((redirectResult == null ? void 0 : redirectResult.txState) === PaysafeMethodId.PayByBank) {
                if (redirectResult.status === 'success') {
                    submitResult.success = true;
                    submitResult.specificTitle = translate('galleon.withdrawal.linking.title.success');
                    submitResult.buttonLabel = translate('galleon.withdrawal.link.success.continue.button');
                } else {
                    handleError();
                }
            } else {
                handleError();
            }
        }
        const result = {
            success: submitResult.success,
            transactionID: submitResult.transactionID,
            amount: amount,
            currencyCode: this.currencyCode,
            paymentMethod: this.paymentMethodExternalId,
            errorText: submitResult.errorText,
            specificTitle: submitResult.specificTitle,
            buttonLabel: submitResult.buttonLabel,
            slotName: 'withdraw-link-success'
        };
        this.logPayment(result);
        _class_private_field_loose_base(this, _showWithdrawResult)[_showWithdrawResult](result, this.getSuccessMessage());
        return result;
    }
    render() {
        if (AppState.wallet.selectedTabName === View.Withdraw) {
            return this.renderWithdrawElement();
        }
        return super.render();
    }
    renderWithdrawElement() {
        const methodDiv = createElementFromTemplate('div', getWithdrawMethodTemplate(this, AppState.wallet.lockedAmount));
        methodDiv.classList.add(`type-paysafe-${this.paymentMethodExternalId}`);
        if (AppState.wallet.lockedAmount) {
            const innerMethodDiv = methodDiv.querySelector('.payment-method');
            innerMethodDiv.classList.add('payment-method--locked-amount');
            attachLockedAmountListener(innerMethodDiv, ()=>{
                handleLockedWithdrawClick(innerMethodDiv, this);
            });
        } else {
            attachAccordionListener(methodDiv, _class_private_field_loose_base(this, _handleWithdrawAccordionToggle)[_handleWithdrawAccordionToggle](this));
        }
        return methodDiv;
    }
    getSuccessMessage() {
        return translate('galleon.withdrawal.linking.message.success');
    }
    constructor(...args){
        super(...args), Object.defineProperty(this, _showWithdrawResult, {
            value: showWithdrawResult
        }), Object.defineProperty(this, _showDepositResult$3, {
            value: showDepositResult$3
        }), Object.defineProperty(this, _openPaySafePage$1, {
            value: openPaySafePage$1
        }), Object.defineProperty(this, _handleWithdrawAccordionToggle, {
            writable: true,
            value: void 0
        }), Object.defineProperty(this, _expandWithdrawMethod, {
            writable: true,
            value: void 0
        }), Object.defineProperty(this, _attachButtonListener, {
            writable: true,
            value: void 0
        }), Object.defineProperty(this, _getTemplate, {
            writable: true,
            value: void 0
        }), Object.defineProperty(this, _proceedPayByBank, {
            writable: true,
            value: void 0
        }), _class_private_field_loose_base(this, _handleWithdrawAccordionToggle)[_handleWithdrawAccordionToggle] = (method)=>(methodDiv)=>{
                const stateSelectedMethod = AppState.wallet.withdraw.selectedMethod;
                if (stateSelectedMethod == null ? void 0 : stateSelectedMethod.id) {
                    const prevMethodDiv = getMethodDivById(stateSelectedMethod.id);
                    if (prevMethodDiv) {
                        removeWithdrawAmountScreen(prevMethodDiv);
                        toggleAccordionByMethod(prevMethodDiv, true);
                    }
                }
                const isTheSameMethod = (stateSelectedMethod == null ? void 0 : stateSelectedMethod.id) === (method == null ? void 0 : method.id);
                toggleAccordionByMethod(methodDiv, isTheSameMethod);
                if (!isTheSameMethod) {
                    AppState.wallet.withdraw.selectedMethod = method;
                    _class_private_field_loose_base(this, _expandWithdrawMethod)[_expandWithdrawMethod](methodDiv);
                } else {
                    AppState.wallet.withdraw.selectedMethod = null;
                    removeWithdrawAmountScreen(methodDiv);
                }
            }, _class_private_field_loose_base(this, _expandWithdrawMethod)[_expandWithdrawMethod] = (methodDiv)=>{
            const template = _class_private_field_loose_base(this, _getTemplate)[_getTemplate]();
            const amountContainer = document.createElement('div');
            amountContainer.className = 'saved-withdraw-amount-container';
            amountContainer.innerHTML = template;
            methodDiv.appendChild(amountContainer);
            toggleAccordionByMethod(methodDiv, false);
            _class_private_field_loose_base(this, _attachButtonListener)[_attachButtonListener](methodDiv);
        }, _class_private_field_loose_base(this, _attachButtonListener)[_attachButtonListener] = (methodDiv)=>{
            const btn = methodDiv.querySelector('.amount-screen__submit');
            btn.addEventListener('click', ()=>{
                btn.setAttribute('disabled', 'true');
                btn.setAttribute('loading', 'true');
                this.withdraw(10);
            });
        }, _class_private_field_loose_base(this, _getTemplate)[_getTemplate] = ()=>{
            return `<div class="amount-screen" part="amount-screen" >
              <magic-ui-button
              class="amount-screen__submit"
              part="amount-screen__submit"
              variant="primary"
              >
              ${translate('galleon.withdrawal.linking.button')}
              </magic-ui-button>
            </div>`;
        }, _class_private_field_loose_base(this, _proceedPayByBank)[_proceedPayByBank] = async (config, launchResult)=>{
            const bankDetails = await getBankDetails();
            bankDetails.customer.phone = extractUSAPhone(bankDetails.customer.phone);
            return await _class_private_field_loose_base(this, _openPaySafePage$1)[_openPaySafePage$1](config, launchResult, bankDetails);
        };
    }
}
function showWithdrawResult(result, successMessage) {
    emitWithdrawResult(result);
    const content = AppState.shadowRoot.querySelector('.tab-content');
    content.innerHTML = getWithdrawalStatusScreenTemplate(result, successMessage);
    statusButtonsHandler(content, ()=>{
        if (result.success) {
            AppState.root.dispatchEvent(new CustomEvent(ListenMessageType.UpdateView, {
                detail: {
                    view: View.Withdraw,
                    lockedAmount: AppState.wallet.lockedAmount
                }
            }));
            emitWithdrawLinkingCompleted();
        } else {
            emitWithdrawResult(null);
            createWithdrawView();
        }
    });
}
function showDepositResult$3(depositResult) {
    emitDepositResult(depositResult);
    this.logPayment(depositResult);
    createDepositStatusScreen(depositResult);
}
async function openPaySafePage$1(config, lauchResult, bankDetails) {
    var _AppState_wallet_profile;
    await PaysafeCashier.instance.update({
        amount: Math.round(config.paysafeConfig.amount * 100),
        currency: config.paysafeConfig.currencyCode,
        sessionContextId: lauchResult.sessionContextId,
        externalSingleUseUserProfileToken: lauchResult.externalSingleUseUserProfileToken,
        externalUserProfileId: lauchResult.externalUserProfileId,
        paymentMethods: [
            config.depositConfig.paymentDetails.externalPaymentMethodId.toLowerCase()
        ],
        redirectUrl: lauchResult.redirectUrl
    });
    const paysafeBPBOptions = {
        billingAddress: bankDetails.billingAddress,
        customer: bankDetails.customer
    };
    const billingAddress = (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile.billingAddress;
    if (billingAddress) {
        paysafeBPBOptions.billingAddress = _extends$1({}, billingAddress);
    }
    return await PaysafeCashier.instance.launchPaysafeCashier(paysafeBPBOptions);
}

function getSpecificErrorText(error, view) {
    const message = Object.values(error).flatMap((value)=>value)[0];
    return translate(`galleon.error.${view}.${message}`) || translate('galleon.error.generic');
}

var _showDepositResult$2 = /*#__PURE__*/ _class_private_field_loose_key("_showDepositResult"), _openPaySafePage = /*#__PURE__*/ _class_private_field_loose_key("_openPaySafePage"), _patchPaySafeCloseButton = /*#__PURE__*/ _class_private_field_loose_key("_patchPaySafeCloseButton"), _disablePaysafeRedirectionOnClose = /*#__PURE__*/ _class_private_field_loose_key("_disablePaysafeRedirectionOnClose");
class PaysafeCardMethod extends BaseCorexMethod {
    async deposit(amount) {
        const config = this.getDepositConfig(amount);
        if (AppState.wallet.chosenDepositBonus !== '') {
            config.promoCode = AppState.wallet.chosenDepositBonus;
        }
        if (AppState.wallet.depositExtraData.sweepstakesShopItemId !== '') {
            config.sweepStakesShopItemID = AppState.wallet.depositExtraData.sweepstakesShopItemId;
        }
        const result = {
            amount,
            creditCard: '',
            currencyCode: this.currencyCode,
            success: false,
            paymentMethod: PaysafeMethodId.Card,
            paymentMethodLabel: 'card',
            transactionID: '',
            buttonUrl: '',
            popupUrl: '',
            promoCode: config.promoCode
        };
        try {
            var _paysafeResult_instance;
            this.logAttempt(amount);
            const launchResult = await this.corexGateway.launchDeposit(config);
            const paysafeResult = await _class_private_field_loose_base(this, _openPaySafePage)[_openPaySafePage](config, launchResult);
            if (paysafeResult.paymentHandleToken) {
                const authorizeResult = await this.corexGateway.depositSubmit(paysafeResult.paymentHandleToken, this.paymentMethodExternalId);
                if (authorizeResult.transactionId) {
                    result.success = true;
                    result.transactionID = authorizeResult.transactionId;
                }
                if (authorizeResult.errors) {
                    result.errorText = getSpecificErrorText(authorizeResult.errors, View.Deposit);
                }
            }
            _class_private_field_loose_base(this, _disablePaysafeRedirectionOnClose)[_disablePaysafeRedirectionOnClose]();
            (_paysafeResult_instance = paysafeResult.instance) == null ? void 0 : _paysafeResult_instance.close();
            // workaround for scrolling to the top after payssafe checkout
            setTimeout(()=>{
                scrollToTop();
            }, 100);
            if (result.success) {
                quickDepositCompleted('success');
            } else {
                quickDepositCompleted('fail');
            }
            return result;
        } catch (error) {
            console.error('Error during card deposit:', error);
            return result;
        } finally{
            _class_private_field_loose_base(this, _showDepositResult$2)[_showDepositResult$2](result);
        }
    }
    async withdraw(amount) {
        const launchResult = await this.corexGateway.launchWithdraw({
            currencyCode: this.currencyCode,
            externalPaymentMethodId: this.paymentMethodExternalId,
            amount: amount
        });
        const submitResult = await this.corexGateway.submitWithdraw({
            externalPaymentMethodId: this.paymentMethodExternalId,
            sessionContextId: launchResult.sessionContextId,
            amount: amount,
            currencyCode: this.currencyCode,
            // todo: remove when implementing withdrawals with new methods
            externalPaymentToken: 'todo: obtain from the user',
            paymentMethod: this.paymentMethodExternalId
        });
        const result = {
            success: submitResult.success,
            transactionID: submitResult.transactionID,
            amount: amount,
            currencyCode: this.currencyCode,
            paymentMethod: this.paymentMethodExternalId
        };
        this.logPayment(result);
        return result;
    }
    constructor(...args){
        super(...args), Object.defineProperty(this, _showDepositResult$2, {
            value: showDepositResult$2
        }), Object.defineProperty(this, _openPaySafePage, {
            value: openPaySafePage
        }), Object.defineProperty(this, _patchPaySafeCloseButton, {
            value: patchPaySafeCloseButton
        }), Object.defineProperty(this, _disablePaysafeRedirectionOnClose, {
            value: disablePaysafeRedirectionOnClose
        });
    }
}
function showDepositResult$2(depositResult) {
    emitDepositResult(depositResult);
    this.logPayment(depositResult);
    createDepositStatusScreen(depositResult);
}
async function openPaySafePage(config, launchResult) {
    var _AppState_wallet_profile;
    await PaysafeCashier.instance.update({
        amount: Math.round(config.paysafeConfig.amount * 100),
        currency: config.paysafeConfig.currencyCode,
        sessionContextId: launchResult.sessionContextId,
        externalSingleUseUserProfileToken: launchResult.externalSingleUseUserProfileToken,
        externalUserProfileId: launchResult.externalUserProfileId,
        paymentMethods: [
            config.depositConfig.paymentDetails.externalPaymentMethodId.toLowerCase()
        ]
    });
    const profile = AppState.wallet.profile;
    const { email, firstName, lastName } = profile.customer;
    const paysafeCardOptions = {
        customer: {
            email,
            firstName,
            lastName
        }
    };
    const billingAddress = (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile.billingAddress;
    if (billingAddress) {
        paysafeCardOptions.billingAddress = _extends$1({}, billingAddress);
    }
    _class_private_field_loose_base(this, _patchPaySafeCloseButton)[_patchPaySafeCloseButton]();
    return await PaysafeCashier.instance.launchPaysafeCashier(paysafeCardOptions);
}
function patchPaySafeCloseButton() {
    setTimeout(()=>{
        _class_private_field_loose_base(this, _disablePaysafeRedirectionOnClose)[_disablePaysafeRedirectionOnClose]();
    }, 2000);
}
function disablePaysafeRedirectionOnClose() {
    history.replaceState({}, '');
}

function getSummarySection(amount) {
    return `
    <div class="card-details__summary" part="card-details__summary">
        ${getSummaryTitle()}
        <div class="card-details__summary-info">
            ${getPaymentMethodInfo(amount)}
            ${getChangeButton()}
        </div>
    </div>
  `;
}
function getPaymentMethodInfo(amount) {
    const selectedTabName = AppState.wallet.selectedTabName;
    if (selectedTabName === View.Bonuses || !selectedTabName) {
        return '';
    }
    const currencySymbol = getCurrencySymbol(AppState.wallet.balanceData.currencyCode);
    const selectedMethod = AppState.wallet[selectedTabName].selectedMethod || AppState.wallet[selectedTabName].selectedSavedMethod;
    const bonusExists = !!AppState.wallet.chosenDepositBonus;
    const bonus = bonusExists ? `- ${translate('galleon.deposit.bonus.selected')}` : '';
    const withdrawSubtitle = `${amount}${currencySymbol} ${translate('galleon.withdraw.summary.withdrawn')}`;
    const depositSubtitle = `${amount}${currencySymbol} ${translate('galleon.deposit.summary.deposited')} ${bonus}`;
    const subtitle = selectedTabName === View.Deposit ? depositSubtitle : withdrawSubtitle;
    return `
      <div class="card-details__summary-method">
        ${getMethodIcon(selectedMethod)}
        <div>
            <magic-ui-text
                tag="b"
                class="card-details__summary-title"
                part="card-details__summary-title"
                content='${selectedMethod.title}'
            ></magic-ui-text>
            <magic-ui-text
                tag="p"
                class="card-details__summary-subtitle"
                part="card-details__summary-subtitle"
                content='${subtitle}'
            ></magic-ui-text>
        </div>
    </div>
    `;
}
function getSummaryTitle() {
    return `
      <magic-ui-text
          tag="b"
          class="card-details__summary-text"
          part="card-details__summary-text"
          content='${translate('galleon.deposit.summary.title')}'
      ></magic-ui-text>
    `;
}
function getChangeButton() {
    return `
      <magic-ui-button
          class="button details__change-button card-details__summary-button"
          part="button details__change-button card-details__summary-button"
          variant="primary"
          small
      >
          ${translate('galleon.deposit.summary.btn')}
      </magic-ui-button>
    `;
}

function getApplePayPage(amount) {
    return `
    ${getSummarySection(amount)}
    <div class="apple-pay__loader" part="apple-pay__loader">
      <magic-ui-loader></magic-ui-loader>
    </div>
    <div class="apple-pay" part="apple-pay">
      <div id="paysafe-apple-pay-anchor" class="apple-pay__anchor"></div>
    </div>
  `;
}

const paysafeApplePayId = 'paysafe-apple-pay';
const paysafeApplePaySourceUrl = 'https://hosted.paysafe.com/js/v1/latest/paysafe.min.js';
var _renderContent$1 = /*#__PURE__*/ _class_private_field_loose_key("_renderContent"), _getAnchor = /*#__PURE__*/ _class_private_field_loose_key("_getAnchor"), _ensureApplePayContainer = /*#__PURE__*/ _class_private_field_loose_key("_ensureApplePayContainer"), _createRepositionAndCleanup = /*#__PURE__*/ _class_private_field_loose_key("_createRepositionAndCleanup"), _attachChangeButton = /*#__PURE__*/ _class_private_field_loose_key("_attachChangeButton"), _buildInitialResult = /*#__PURE__*/ _class_private_field_loose_key("_buildInitialResult"), _buildPaysafeOptions = /*#__PURE__*/ _class_private_field_loose_key("_buildPaysafeOptions"), _handlePaymentMethods = /*#__PURE__*/ _class_private_field_loose_key("_handlePaymentMethods"), _onApplePayClick = /*#__PURE__*/ _class_private_field_loose_key("_onApplePayClick"), _showDepositResult$1 = /*#__PURE__*/ _class_private_field_loose_key("_showDepositResult"), _extractDisplayMessage = /*#__PURE__*/ _class_private_field_loose_key("_extractDisplayMessage"), _showApplePaySetupError = /*#__PURE__*/ _class_private_field_loose_key("_showApplePaySetupError"), _hideApplePayLoader = /*#__PURE__*/ _class_private_field_loose_key("_hideApplePayLoader");
class PaysafeApplePayMethod extends BaseCorexMethod {
    async deposit(amount) {
        // Load Paysafe SDK once per app lifetime. The loader is idempotent and cached by URL.
        await loadScript(paysafeApplePaySourceUrl);
        const config = this.getDepositConfig(amount);
        const content = _class_private_field_loose_base(this, _renderContent$1)[_renderContent$1](amount);
        const anchor = _class_private_field_loose_base(this, _getAnchor)[_getAnchor](content);
        const applePayContainer = _class_private_field_loose_base(this, _ensureApplePayContainer)[_ensureApplePayContainer]();
        const { reposition, cleanup } = _class_private_field_loose_base(this, _createRepositionAndCleanup)[_createRepositionAndCleanup](anchor, applePayContainer);
        // Initial position and on the next frame to avoid layout thrash
        reposition();
        requestAnimationFrame(reposition);
        window.addEventListener('resize', reposition);
        window.addEventListener('scroll', reposition, true);
        _class_private_field_loose_base(this, _attachChangeButton)[_attachChangeButton](content, cleanup);
        const result = _class_private_field_loose_base(this, _buildInitialResult)[_buildInitialResult](amount);
        try {
            const { sessionContextId } = await this.corexGateway.launchDeposit(config);
            const options = _class_private_field_loose_base(this, _buildPaysafeOptions)[_buildPaysafeOptions]();
            let applePayInstance;
            const paysafeGlobal = globalThis.paysafe;
            if (!paysafeGlobal || !paysafeGlobal.fields) {
                throw new Error('Paysafe SDK not available. The script may have failed to load.');
            }
            paysafeGlobal.fields.setup(this.corexGateway.config.paysafeApiKey, options).then((instance)=>{
                applePayInstance = instance;
                return instance.show();
            }).then((paymentMethods)=>{
                // Ensure the container is correctly positioned when methods are shown
                requestAnimationFrame(reposition);
                _class_private_field_loose_base(this, _handlePaymentMethods)[_handlePaymentMethods](paymentMethods, applePayContainer, ()=>_class_private_field_loose_base(this, _onApplePayClick)[_onApplePayClick](applePayInstance, amount, sessionContextId, result, cleanup), cleanup);
            }).catch((error)=>{
                console.error(error);
                const message = _class_private_field_loose_base(this, _extractDisplayMessage)[_extractDisplayMessage](error);
                _class_private_field_loose_base(this, _showApplePaySetupError)[_showApplePaySetupError](message);
                cleanup();
            });
            return result;
        } catch (error) {
            console.error('Error during card deposit:', error);
            return result;
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    withdraw(amount) {}
    constructor(...args){
        super(...args), Object.defineProperty(this, _renderContent$1, {
            value: renderContent$1
        }), Object.defineProperty(this, _getAnchor, {
            value: getAnchor
        }), Object.defineProperty(this, _ensureApplePayContainer, {
            value: ensureApplePayContainer
        }), Object.defineProperty(this, _createRepositionAndCleanup, {
            value: createRepositionAndCleanup
        }), Object.defineProperty(this, _attachChangeButton, {
            value: attachChangeButton
        }), Object.defineProperty(this, _buildInitialResult, {
            value: buildInitialResult
        }), Object.defineProperty(this, _buildPaysafeOptions, {
            value: buildPaysafeOptions
        }), Object.defineProperty(this, _handlePaymentMethods, {
            value: handlePaymentMethods
        }), Object.defineProperty(this, _onApplePayClick, {
            value: onApplePayClick
        }), Object.defineProperty(this, _showDepositResult$1, {
            value: showDepositResult$1
        }), Object.defineProperty(this, _extractDisplayMessage, {
            value: extractDisplayMessage
        }), Object.defineProperty(this, _showApplePaySetupError, {
            value: showApplePaySetupError
        }), Object.defineProperty(this, _hideApplePayLoader, {
            value: hideApplePayLoader
        });
    }
}
function renderContent$1(amount) {
    const content = getCurrentTab();
    content.innerHTML = getApplePayPage(amount);
    scrollToTop();
    return content;
}
function getAnchor(content) {
    return content.querySelector('#paysafe-apple-pay-anchor');
}
function ensureApplePayContainer() {
    let applePayContainer = document.getElementById(paysafeApplePayId);
    if (!applePayContainer) {
        applePayContainer = document.createElement('div');
        applePayContainer.id = paysafeApplePayId;
        applePayContainer.style.position = 'fixed';
        applePayContainer.style.zIndex = '4';
        applePayContainer.style.pointerEvents = 'auto';
        applePayContainer.style.cursor = 'pointer';
        document.body.appendChild(applePayContainer);
    }
    applePayContainer.style.setProperty('--apple-pay-button-width', '100%');
    return applePayContainer;
}
function createRepositionAndCleanup(anchor, applePayContainer) {
    let observer = null;
    let modalObserver = null;
    let modalEl = null;
    const onModalClose = ()=>cleanup();
    const reposition = ()=>{
        if (!anchor || !applePayContainer) return;
        const rect = anchor.getBoundingClientRect();
        applePayContainer.style.top = `${Math.max(0, rect.top)}px`;
        applePayContainer.style.left = `${Math.max(0, rect.left)}px`;
        applePayContainer.style.width = `${Math.max(0, rect.width)}px`;
        applePayContainer.style.height = `${Math.max(0, rect.height)}px`;
    };
    const cleanup = ()=>{
        window.removeEventListener('resize', reposition);
        window.removeEventListener('scroll', reposition, true);
        if (observer) {
            observer.disconnect();
            observer = null;
        }
        if (modalObserver) {
            modalObserver.disconnect();
            modalObserver = null;
        }
        if (modalEl) {
            modalEl.removeEventListener('close', onModalClose);
            modalEl.removeEventListener('back', onModalClose);
            modalEl = null;
        }
        if (applePayContainer && applePayContainer.parentElement) {
            applePayContainer.remove();
        }
    };
    // Observe when the current tab (or the anchor) is removed from DOM to trigger cleanup
    try {
        const root = AppState.root;
        const shadowRoot = root == null ? void 0 : root.shadowRoot;
        // Find the hosting magic-ui-modal (if any) to listen for close/back and detect removal
        try {
            const sr = (anchor == null ? void 0 : anchor.getRootNode) && anchor.getRootNode() || shadowRoot;
            const host = sr && sr.host || root;
            if (host && typeof host.closest === 'function') {
                modalEl = host.closest('magic-galleon');
                if (modalEl) {
                    modalEl.addEventListener('close', onModalClose);
                    modalEl.addEventListener('back', onModalClose);
                    // Observe DOM to detect when modal is removed (e.g., backdrop click)
                    modalObserver = new MutationObserver(()=>{
                        if (!modalEl || !modalEl.isConnected) {
                            cleanup();
                        }
                    });
                    const parentNode = modalEl.getRootNode && modalEl.getRootNode() || document;
                    modalObserver.observe(parentNode, {
                        childList: true,
                        subtree: true
                    });
                }
            }
        } catch (e) {
        // ignore if top-level modal is not found
        }
        const checkStillInDom = ()=>{
            const currentTab = getCurrentTab();
            const stillInDom = !!currentTab && !!anchor && currentTab.contains(anchor);
            if (!stillInDom) {
                cleanup();
                return false;
            }
            return true;
        };
        // Need to add cleanup for closing cashier or switch the tab
        if (shadowRoot) {
            // Immediate check in case the tab was already removed
            if (!checkStillInDom()) {
                return {
                    reposition,
                    cleanup
                };
            }
            observer = new MutationObserver(()=>{
                checkStillInDom();
            });
            observer.observe(shadowRoot, {
                childList: true,
                subtree: true
            });
        } else {
            // Fallback: observe the document body
            observer = new MutationObserver(()=>{
                checkStillInDom();
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
            // Immediate check as well
            checkStillInDom();
        }
    } catch (e) {
    // no-op: observer is an optional safeguard
    }
    return {
        reposition,
        cleanup
    };
}
function attachChangeButton(content, cleanup) {
    const changeButton = content.querySelector('.details__change-button');
    changeButton == null ? void 0 : changeButton.addEventListener('click', ()=>{
        cleanup();
        createDepositView$1();
    });
}
function buildInitialResult(amount) {
    return {
        amount,
        creditCard: '',
        currencyCode: this.currencyCode,
        success: false,
        paymentMethod: PaysafeMethodId.ApplePay,
        paymentMethodLabel: PaysafeMethodId.ApplePay,
        transactionID: '',
        buttonUrl: '',
        popupUrl: ''
    };
}
function buildPaysafeOptions() {
    return {
        currencyCode: this.currencyCode,
        environment: this.corexGateway.config.paysafeEnvironment,
        accounts: {
            default: Number(this.externalAccountId)
        },
        fields: {
            applePay: {
                selector: `#${paysafeApplePayId}`,
                label: 'Apple Pay',
                type: 'pay',
                color: 'white-outline',
                language: AppState.wallet.locale
            }
        }
    };
}
function handlePaymentMethods(paymentMethods, applePayContainer, onClick, cleanup) {
    if (paymentMethods.applePay && !paymentMethods.applePay.error) {
        if (applePayContainer) {
            applePayContainer.style.display = '';
        }
        // Hide the in-content loader once Apple Pay is available
        _class_private_field_loose_base(this, _hideApplePayLoader)[_hideApplePayLoader]();
        const applePayButton = document.querySelector(`#${paysafeApplePayId}`);
        if (applePayButton) {
            applePayButton.addEventListener('click', onClick, {
                once: true
            });
        }
    } else {
        var _paymentMethods_applePay;
        // Extract the error message from paymentMethods.applePay.error if present and show it
        const message = _class_private_field_loose_base(this, _extractDisplayMessage)[_extractDisplayMessage]((_paymentMethods_applePay = paymentMethods.applePay) == null ? void 0 : _paymentMethods_applePay.error);
        _class_private_field_loose_base(this, _showApplePaySetupError)[_showApplePaySetupError](message);
        if (applePayContainer) {
            applePayContainer.style.display = 'none';
        }
        cleanup();
    }
}
function onApplePayClick(applePayInstance, amount, sessionContextId, result, cleanup) {
    var _AppState_wallet_profile_billingAddress, _AppState_wallet_profile, _AppState_wallet_profile1, _AppState_wallet_profile2;
    this.logAttempt(amount);
    applePayInstance.tokenize({
        amount: amount * 100,
        transactionType: 'PAYMENT',
        paymentType: 'APPLEPAY',
        applePay: {
            country: (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : (_AppState_wallet_profile_billingAddress = _AppState_wallet_profile.billingAddress) == null ? void 0 : _AppState_wallet_profile_billingAddress.country
        },
        customerDetails: {
            billingDetails: (_AppState_wallet_profile1 = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile1.billingAddress,
            profile: (_AppState_wallet_profile2 = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile2.customer
        },
        merchantRefNum: sessionContextId
    }).then(async ({ token })=>{
        applePayInstance.complete('success');
        const authorizeResult = await this.corexGateway.depositSubmit(token, this.paymentMethodExternalId);
        if (authorizeResult.transactionId) {
            result.success = true;
            result.transactionID = authorizeResult.transactionId;
        }
        if (authorizeResult.errors) {
            result.errorText = getSpecificErrorText(authorizeResult.errors, View.Deposit);
        }
    }).catch((error)=>{
        console.error(JSON.stringify(error));
        applePayInstance.complete('fail');
    }).finally(()=>{
        cleanup();
        _class_private_field_loose_base(this, _showDepositResult$1)[_showDepositResult$1](result);
    });
}
function showDepositResult$1(depositResult) {
    emitDepositResult(depositResult);
    this.logPayment(depositResult);
    createDepositStatusScreen(depositResult);
}
function extractDisplayMessage(error) {
    try {
        if (!error) return 'Apple Pay is not available.';
        if (typeof error === 'string') return error;
        if (typeof error === 'object') {
            const e = error;
            return e['displayMessage'] || e['detailedMessage'] || e['message'] || JSON.stringify(error);
        }
        return String(error);
    } catch (e) {
        return 'Apple Pay is not available.';
    }
}
function showApplePaySetupError(message) {
    // Hide the loader if present when showing an error
    _class_private_field_loose_base(this, _hideApplePayLoader)[_hideApplePayLoader]();
    const content = getCurrentTab();
    const applePaySection = content.querySelector('.apple-pay');
    if (applePaySection) {
        applePaySection.innerHTML = `
        <magic-ui-text tag="p" class="apple-pay__error" part="apple-pay__error" content='${message.replace(/'/g, '&#39;')}'></magic-ui-text>
      `;
    }
}
function hideApplePayLoader() {
    const content = getCurrentTab();
    const loader = content.querySelector('.apple-pay__loader');
    if (loader) {
        loader.style.display = 'none';
    }
}

const specificRedirectMessages = (isWithdraw)=>{
    const messages = {
        [ERedirectStatus.Cancel]: {
            specificMessage: translate('galleon.deposit.cancelled.description'),
            specificTitle: translate('galleon.deposit.cancelled.title')
        },
        [ERedirectStatus.Default]: {
            specificMessage: translate('galleon.deposit.cancelled.description'),
            specificTitle: translate('galleon.deposit.cancelled.title')
        },
        [ERedirectStatus.PopupClosed]: {
            specificMessage: translate('galleon.deposit.redirect.default.description'),
            specificTitle: translate('galleon.deposit.redirect.default.title')
        }
    };
    if (isWithdraw) {
        messages[ERedirectStatus.PopupClosed].specificTitle = translate('galleon.withdraw.redirect.default.title');
    // other messages are fine for both deposits and withdrawals
    }
    return messages;
};

var EDevcodeMethodFlowType = /*#__PURE__*/ function(EDevcodeMethodFlowType) {
    EDevcodeMethodFlowType["NestedIframe"] = "NestedIframe";
    EDevcodeMethodFlowType["RedirectPopup"] = "RedirectPopup";
    EDevcodeMethodFlowType["CardPage"] = "CardPage";
    EDevcodeMethodFlowType["Bank"] = "Bank";
    EDevcodeMethodFlowType["Custom"] = "Custom";
    return EDevcodeMethodFlowType;
}({});

const setLoading = (loading)=>{
    if (AppState.wallet.loading === loading) {
        return;
    }
    AppState.wallet.loading = loading;
    if (AppState.wallet.loading) {
        const content = AppState.shadowRoot.querySelector('.tab-content');
        content == null ? void 0 : content.appendChild(createPageLoader());
    } else {
        const loader = AppState.shadowRoot.querySelector('.page-loader');
        loader == null ? void 0 : loader.remove();
    }
};

const formatRedirectURL = (url, parameters)=>{
    let resultUrl = url;
    const params = parameters;
    if (params && Object.keys(params).length > 0) {
        const queryParams = Object.entries(params).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
        resultUrl += (resultUrl.includes('?') ? '&' : '?') + queryParams;
    }
    return resultUrl;
};

function getNestedIframe(redirectOutput) {
    const url = formatRedirectURL(redirectOutput.url, redirectOutput.parameters);
    const iframeHTML = `<iframe class="iframe nested-iframe"
    src="${url}"
    width="100%"
    style="border: none; overflow: hidden;"
  ></iframe>`;
    return iframeHTML;
}
function getNestedImage(url) {
    return `<img class="centered-wrapper__image" src="${url}" />`;
}
function getQRCodePage(url) {
    const title = translate('galleon.deposit.qrcode.title');
    const message = translate('galleon.deposit.qrcode.qrph.description');
    return `
    <div class="status-screen" part="status-screen">
        <magic-ui-text
          tag="b"
          class="status-screen__title"
          part="status-screen__title"
          content='${title}'
        ></magic-ui-text>
        ${message}
        ${getNestedImage(url)}
    </div>
  `;
}

const getCloseDialogIframe = (redirectOutput)=>{
    const cancelLabel = translate('galleon.deposit.cancel');
    return `
    <div class="redirect paypal status-screen" part="redirect paypal status-screen">
        <div class="status-screen__container">
     ${getNestedIframe(redirectOutput)}
        </div>
        <magic-ui-button
            class="paypal status-screen__button"
            part="paypal status-screen__button"
            variant="primary"
        >
        ${cancelLabel}
        </magic-ui-button>
    </div>
  `;
};

const createCloseIframeDialog = (redirectOutput, showPreload = true, callback)=>{
    var _getCurrentTab;
    const content = (_getCurrentTab = getCurrentTab()) != null ? _getCurrentTab : document.createElement('div');
    // Handle the case when redirectOutput is a string
    if (typeof redirectOutput === 'string') {
        content.innerHTML = getCloseDialogIframe({
            url: redirectOutput});
    } else {
        content.innerHTML = getCloseDialogIframe(redirectOutput);
    }
    statusButtonsHandler(content, ()=>{
        if (AppState.wallet.selectedTabName === View.Deposit) {
            createDepositView$1();
        } else if (AppState.wallet.selectedTabName === View.Withdraw) {
            createWithdrawView();
        }
    });
    const iframe = content.querySelector(`.nested-iframe`);
    if ((typeof redirectOutput === 'string' || redirectOutput.url) && iframe && showPreload) {
        setLoading(true);
        iframe.addEventListener('load', ()=>{
            // Hide the loader
            setLoading(false);
        });
    }
    return iframe;
};
const createClosedQRPHCodeImageDialog = (redirectOutput, showPreload = false, callback)=>{
    createCloseIframeDialog(redirectOutput, showPreload);
    var _getCurrentTab;
    const content = (_getCurrentTab = getCurrentTab()) != null ? _getCurrentTab : document.createElement('div');
    const iframeContainer = content.querySelector(`.status-screen__container`);
    // Clear existing content (optional)
    iframeContainer.innerHTML = getQRCodePage(redirectOutput);
};

class BaseRedirectCorexMethod extends BaseCorexMethod {
    async deposit(amount) {
        const config = this.getDepositConfig(amount);
        if (AppState.wallet.chosenDepositBonus !== '') {
            config.promoCode = AppState.wallet.chosenDepositBonus;
        }
        const result = {
            amount: amount,
            creditCard: '',
            currencyCode: this.currencyCode,
            success: false,
            paymentMethod: this.paymentMethodExternalId,
            paymentMethodLabel: this.methodLabel,
            transactionID: '',
            buttonUrl: '',
            popupUrl: '',
            promoCode: config.promoCode
        };
        try {
            return await this.processDeposit(result, config);
        } catch (error) {
            console.error(`Error during ${this.methodLabel} deposit:`, error);
            return result;
        } finally{
            void this.showDepositResult(result);
        }
    }
    async withdraw(amount, savedMethod) {
        const result = await this.processWithdraw(amount, savedMethod);
        this.logPayment(result);
        const successMessage = translate('galleon.withdrawal.waiting.approval.title');
        const successTitle = translate('galleon.withdrawal.waiting.approval.description');
        if (result.transactionID) {
            createWithdrawStatusScreen(result, successMessage, successTitle);
            void PendingBalanceCheck.checkWithdrawalBalance(result);
        } else {
            createWithdrawStatusScreen(result);
        }
        return result;
    }
    async processWithdraw(amount, savedMethod, overrideSpecificParams = {}) {
        this.logAttempt(amount);
        const launchResult = await this.corexGateway.launchWithdraw(_extends$1({
            currencyCode: this.currencyCode,
            externalPaymentMethodId: this.paymentMethodExternalId,
            amount: amount,
            externalUserProfileId: savedMethod == null ? void 0 : savedMethod.email
        }, overrideSpecificParams));
        const submitResult = await this.corexGateway.submitWithdraw(_extends$1({
            externalPaymentMethodId: this.paymentMethodExternalId,
            sessionContextId: launchResult.sessionContextId,
            amount: amount,
            currencyCode: this.currencyCode,
            externalPaymentToken: launchResult.paymentHandleToken,
            paymentMethod: this.paymentMethodExternalId
        }, overrideSpecificParams));
        const result = {
            success: submitResult.success,
            transactionID: submitResult.transactionID,
            amount: amount,
            currencyCode: this.currencyCode,
            paymentMethod: this.paymentMethodExternalId
        };
        return result;
    }
    async processDeposit(result, config, overrideSpecificParams = {}) {
        const method = this.paymentMethodExternalId;
        const specificParams = _extends$1({
            amount: result.amount,
            externalUserProfileId: this.corexConfig.userEmail,
            defaultRedirectionUrl: this.getRedirectionUrl(this.redirectBaseUrl, method, ERedirectStatus.Default),
            completeRedirectionUrl: this.getRedirectionUrl(this.redirectBaseUrl, method, ERedirectStatus.Pending),
            cancelRedirectionUrl: this.getRedirectionUrl(this.redirectBaseUrl, method, ERedirectStatus.Cancel),
            failRedirectionUrl: this.getRedirectionUrl(this.redirectBaseUrl, method, ERedirectStatus.Fail)
        }, overrideSpecificParams);
        this.logAttempt(result.amount);
        const launchResult = await this.corexGateway.launchDeposit(config, specificParams);
        if (launchResult.redirectUrl) {
            result.success = true;
            result.buttonUrl = launchResult.redirectUrl;
            result.popupUrl = this.redirectBaseUrl;
        }
        return result;
    }
    get flowType() {
        var _this_params;
        return ((_this_params = this.params) == null ? void 0 : _this_params.flowType) || EMethodFlowType.RedirectPopup;
    }
    async showDepositResult(launchDepositResult) {
        const depositResultData = {
            amount: launchDepositResult.amount,
            currencyCode: this.currencyCode,
            success: false,
            paymentMethod: this.paymentMethodExternalId,
            paymentMethodLabel: this.methodLabel
        };
        if (!launchDepositResult.success) {
            this.logPayment(depositResultData);
            createDepositStatusScreen(depositResultData);
            return;
        }
        scrollToTop();
        const iframeElement = this.createIframeContent(launchDepositResult);
        if (this.flowType === EDevcodeMethodFlowType.RedirectPopup && !AppState.wallet.features.skipIntermediateRedirectStep) {
            await createDepositPaypalContinueMessage(launchDepositResult);
        }
        const customWindow = (iframeElement == null ? void 0 : iframeElement.contentWindow) || null;
        const redirectResult = await this.getRedirectWindowResult(launchDepositResult, customWindow);
        const status = (redirectResult == null ? void 0 : redirectResult.status) || ERedirectStatus.PopupClosed;
        const customResult = this.specificMessages[status];
        if (isQuickPayment()) {
            if (status === ERedirectStatus.Success) {
                quickDepositCompleted('success');
            } else {
                quickDepositCompleted('fail');
            }
        }
        if (this.flowType !== EDevcodeMethodFlowType.RedirectPopup) {
            if (status === ERedirectStatus.PopupClosed) {
                this.logPayment(_extends$1({}, depositResultData, {
                    success: false
                }));
                return;
            }
            if (status === ERedirectStatus.Cancel) {
                this.logPayment(_extends$1({}, depositResultData, {
                    success: false
                }));
                createDepositView$1();
                return;
            }
        }
        // try to get specific translations for different statuses
        depositResultData.errorText = this.prepareMessage(depositResultData, customResult == null ? void 0 : customResult.specificMessage);
        depositResultData.specificTitle = customResult == null ? void 0 : customResult.specificTitle;
        if ((redirectResult == null ? void 0 : redirectResult.txState) === this.paymentMethodExternalId) {
            depositResultData.transactionID = redirectResult.transactionID;
            if (redirectResult.status === ERedirectStatus.Pending) {
                depositResultData.success = true;
                createDepositPaypalCompleteMessage(depositResultData, handleDepositSuccess(depositResultData));
            } else if (redirectResult.status === ERedirectStatus.Success) {
                depositResultData.success = true;
                createDepositStatusScreen(depositResultData);
            } else {
                createDepositStatusScreen(depositResultData);
            }
        } else {
            createDepositStatusScreen(depositResultData);
        }
        this.logPayment(depositResultData);
        emitDepositResult(depositResultData);
    }
    createIframeContent(launchDepositResult) {
        const iframeElement = this.flowType === EDevcodeMethodFlowType.NestedIframe ? createCloseIframeDialog(launchDepositResult.buttonUrl) : null;
        return iframeElement;
    }
    async getRedirectWindowResult(launchDepositResult, customWindow) {
        const redirectResult = await ProxyListener.openWindow(launchDepositResult.buttonUrl, launchDepositResult.popupUrl, customWindow);
        return redirectResult;
    }
    prepareMessage(data, message) {
        if (!message) {
            return '';
        }
        return message.replace('{method}', this.methodLabel).replace('{amount}', formatCurrency(data.amount, data.currencyCode)).replace('{transactionID}', data.transactionID);
    }
    constructor(...args){
        super(...args), this.specificMessages = specificRedirectMessages();
    }
}

class PaysafePayPalMethod extends BaseRedirectCorexMethod {
    get methodLabel() {
        return 'PayPal';
    }
}

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _extends() {
    _extends = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function _type_of$2(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var isMergeableObject = function isMergeableObject(value) {
    return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
    return !!value && (typeof value === "undefined" ? "undefined" : _type_of$2(value)) === 'object';
}
function isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function isReactElement(value) {
    return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return cloneUnlessOtherwiseSpecified(element, options);
    });
}
function getMergeFunction(key, options) {
    if (!options.customMerge) {
        return deepmerge;
    }
    var customMerge = options.customMerge(key);
    return typeof customMerge === 'function' ? customMerge : deepmerge;
}
function getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function getKeys(target) {
    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}
function propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
    return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) {
        getKeys(target).forEach(function(key) {
            destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
        });
    }
    getKeys(source).forEach(function(key) {
        if (propertyIsUnsafe(target, key)) {
            return;
        }
        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
            destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
        } else {
            destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
        }
    });
    return destination;
}
function deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) {
        return cloneUnlessOtherwiseSpecified(source, options);
    } else if (sourceIsArray) {
        return options.arrayMerge(target, source, options);
    } else {
        return mergeObject(target, source, options);
    }
}
deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) {
        throw new Error('first argument should be an array');
    }
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, options);
    }, {});
};
var deepmerge_1 = deepmerge;
var cjs = deepmerge_1;
var deepMerge = /*@__PURE__*/ getDefaultExportFromCjs(cjs);
// TODO: we need to avoid to call the const the same way as the enum
var ValidationDisplay = {
    OnTouchShowMessage: 1,
    OnTypeHighlight: 2,
    OnTypeShowMessage: 3
};
/**
 * Traverses the whole form configuration returning a flat version.
 * It returns an array of ICertainComponent with no children reference.
 *
 * @param formConfig the original form config
 * @returns flattened version of the config
 */ var deepFlattenConfig = function() {
    var formConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var flattenConfig = [];
    formConfig.forEach(function(formConfigStep) {
        flattenConfig = flattenConfig.concat(extractConfig(formConfigStep.components));
    });
    return flattenConfig;
};
/**
 * Recursive function that traverse the config extracting and processing
 * children
 * @param components the list of components' config to process
 * @returns the flatten version of components' config
 */ var extractConfig = function(components) {
    var configItems = [];
    components.forEach(function(component) {
        if (component) {
            var children = component.children, rest = _object_without_properties_loose$1(component, [
                "children"
            ]);
            var childrenItems = [];
            if (children) {
                childrenItems = extractConfig(children);
            }
            configItems = configItems.concat(rest, childrenItems);
        }
    });
    return configItems;
};
function findComponentIdByServerId(components, errorKey) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = components[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var component = _step.value;
            if (component.serverId === errorKey || component.id === errorKey) {
                return component.id;
            }
            if (component.children) {
                var children = Array.isArray(component.children) ? component.children : [
                    component.children
                ];
                var childId = findComponentIdByServerId(children, errorKey);
                if (childId) {
                    return childId;
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
/**
 * Execute dynamic property compute function and returns an object containing
 * computed value for each dynamic property.
 */ function getDynamicProperties(config, formData) {
    return Object.entries(config.dynamicProperties).reduce(function(acc, param) {
        var _param = _sliced_to_array(param, 2), name = _param[0], fx = _param[1];
        return _extends({}, acc, _define_property({}, name, fx(formData)));
    }, {});
}
function patchElementProperties(element, properties) {
    Object.keys(properties).forEach(function(key) {
        setElementAttribute(element, key, properties[key]);
    });
    Object.assign(element, properties);
}
function setElementAttribute(element, name, value) {
    if (value === undefined || value === null || value === false) {
        element.removeAttribute(name);
    } else {
        element.setAttribute(name, value.toString());
    }
}
function debounce(func) {
    var waitMilliseconds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, isImmediate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var timeoutId;
    return function() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var doLater = function doLater() {
            timeoutId = undefined;
            if (!isImmediate) {
                func.apply(_this, args);
            }
        };
        var shouldCallNow = isImmediate && timeoutId === undefined;
        if (timeoutId !== undefined) {
            window.clearTimeout(timeoutId);
        }
        timeoutId = window.setTimeout(doLater, waitMilliseconds);
        if (shouldCallNow) {
            func.apply(this, args);
        }
    };
}
var AsyncDebounceInMs = 200;
var FormBuilderService = /*#__PURE__*/ function() {
    function FormBuilderService(domUpdate) {
        var _this = this;
        _class_call_check(this, FormBuilderService);
        this.domUpdate = domUpdate;
        this.formData = {};
        this.components = [];
        this.debouncedValidators = {};
        this.cachedData = {};
        this.shouldSubmitField = function(key) {
            if (_this.formData[key].hidden || _this.formData[key].disabled) {
                return false;
            }
            var config = _this.findComponent(key);
            return !!(config == null ? void 0 : config.isDataField);
        };
    }
    _create_class(FormBuilderService, [
        {
            key: "getFormData",
            value: function getFormData() {
                return this.formDataPromise;
            }
        },
        {
            key: "initialise",
            value: function initialise(config, initialState) {
                return _async_to_generator(function() {
                    var _;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.destroy();
                                this.setUpProxies(config);
                                this.components = this.getAllComponents(config);
                                _ = this;
                                return [
                                    4,
                                    this.getInitialFormData(config, initialState)
                                ];
                            case 1:
                                _.formData = _state.sent();
                                this.initDebouncedValidators();
                                this.invokeInitialFieldTriggers();
                                this.getFormResolve(this.formData);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "updateField",
            value: function updateField(model) {
                if (!(model == null ? void 0 : model.id)) {
                    return;
                }
                var component = this.findComponent(model.id);
                if (!component) {
                    return;
                }
                if (this.shouldInvokeValidators(model)) {
                    this.invokeValidatorsAndUpdateFormModel(model);
                } else {
                    this.updateFormModel(model);
                }
                if (model.value) {
                    this.invokeTriggeredValidators(component, model.value);
                    this.invokeTriggers(component, model.value);
                }
                this.domUpdate(this.formData);
            }
        },
        {
            key: "shouldInvokeValidators",
            value: function shouldInvokeValidators(model) {
                var component = this.findComponent(model.id);
                if (component.isStandAlone) {
                    return;
                }
                return 'value' in model || model.touched && this.shouldValidateOnBlur(model.id);
            }
        },
        {
            key: "invokeValidatorsAndUpdateFormModel",
            value: function invokeValidatorsAndUpdateFormModel(model) {
                var _this = this;
                var component = this.findComponent(model.id);
                var value = model.value || this.formData[model.id].value;
                var _this_invokeValidators = this.invokeValidators(component, value), error = _this_invokeValidators.error, validationResult = _object_without_properties_loose$1(_this_invokeValidators, [
                    "error"
                ]);
                this.updateFormModel(_extends({}, validationResult, model));
                if (!validationResult.isValid) {
                    Promise.resolve(error).then(function(err) {
                        _this.updateField({
                            id: model.id,
                            error: err
                        });
                    });
                }
            }
        },
        {
            key: "updateFormModel",
            value: function updateFormModel(model) {
                this.formData[model.id] = _extends({}, this.formData[model.id], model);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this = this;
                this.formData = {};
                this.cachedData = {};
                this.components = [];
                this.debouncedValidators = {};
                this.formDataPromise = new Promise(function(resolve) {
                    _this.getFormResolve = resolve;
                });
            }
        },
        {
            key: "getFormValue",
            value: function getFormValue() {
                var _this = this;
                return Object.keys(this.formData).filter(this.shouldSubmitField).reduce(function(acc, key) {
                    var config = _this.findComponent(key);
                    var submitValue = _this.getFieldSubmitValue(config);
                    return deepMerge(acc, submitValue);
                }, {});
            }
        },
        {
            key: "getFieldSubmitValue",
            value: function getFieldSubmitValue(config) {
                var key = config.id;
                var _this_formData_key = this.formData[key], type = _this_formData_key.type, value = _this_formData_key.value;
                if (config.converter) {
                    return config.converter(this.formData);
                }
                return _define_property({}, key, this.getTypedValue(type, value));
            }
        },
        {
            key: "isFormDataInvalid",
            value: function isFormDataInvalid(id, onlyTouched) {
                var formData = this.formData[id];
                if (!formData) {
                    return false;
                }
                return formData && !formData.hidden && !formData.disabled && (!onlyTouched || formData.touched) && (formData.isValid === false || formData.isValidationPending);
            }
        },
        {
            key: "isFormDataTouched",
            value: function isFormDataTouched(id) {
                var formData = this.formData[id];
                if (!formData) {
                    return false;
                }
                return formData.touched;
            }
        },
        {
            key: "isFormDataPending",
            value: function isFormDataPending(id) {
                var formData = this.formData[id];
                if (!formData) {
                    return false;
                }
                return formData.isValidationPending;
            }
        },
        {
            key: "isFormDataValid",
            value: function isFormDataValid(id, onlyTouched) {
                var formData = this.formData[id];
                if (!formData) {
                    return false;
                }
                return !!formData.isValid && !formData.isValidationPending && (!onlyTouched || formData.touched);
            }
        },
        {
            key: "getFormDataMessage",
            value: function getFormDataMessage(id) {
                if (!this.isFormDataInvalid(id, true)) {
                    return;
                }
                if (!this.shouldShowValidationMessages(id)) {
                    return undefined;
                }
                var formData = this.formData[id];
                var _formData_error;
                return (_formData_error = formData.error) != null ? _formData_error : undefined;
            }
        },
        {
            key: "shouldShowValidationMessages",
            value: function shouldShowValidationMessages(id) {
                var validationDisplay = this.findComponent(id).validationDisplay;
                return validationDisplay === ValidationDisplay.OnTouchShowMessage || validationDisplay === ValidationDisplay.OnTypeShowMessage;
            }
        },
        {
            key: "shouldValidateOnBlur",
            value: function shouldValidateOnBlur(id) {
                var validationDisplay = this.findComponent(id).validationDisplay;
                return !(validationDisplay === ValidationDisplay.OnTypeShowMessage || validationDisplay === ValidationDisplay.OnTypeHighlight);
            }
        },
        {
            key: "getTypedValue",
            value: function getTypedValue(type, value) {
                if (type === 'text') {
                    return value && this.trimWhitespace(value.toString());
                }
                return value;
            }
        },
        {
            key: "trimWhitespace",
            value: function trimWhitespace(value) {
                return value.replace(/\s+/g, ' ').trim();
            }
        },
        {
            key: "getAllComponents",
            value: function getAllComponents(config) {
                var all = config.flatMap(function(step) {
                    return step.components;
                });
                return extractConfig(all);
            }
        },
        {
            key: "findComponent",
            value: function findComponent(id) {
                return this.components.find(function(c) {
                    return c.id === id;
                });
            }
        },
        {
            key: "invokeValidators",
            value: function invokeValidators(field, value) {
                var _this_getValidationResult = this.getValidationResult(field, value, this.formData), isValid = _this_getValidationResult.isValid, error = _this_getValidationResult.error;
                if (isValid) {
                    this.invokeAsyncValidators(field, value);
                    return {
                        isValid: isValid,
                        error: error,
                        isValidationPending: this.getAsyncValidators(field).length > 0
                    };
                }
                return {
                    isValid: isValid,
                    error: error,
                    isValidationPending: false
                };
            }
        },
        {
            /**
   * If the field has async validators, they get invoked.
   * In case they exist, a validation pending event is emitted when the validation begins
   * and a value change event is triggered when the async validation finishes.
   *
   * @param value field value
   * @param field field to be validated
   */ key: "invokeAsyncValidators",
            value: function invokeAsyncValidators(field, value) {
                var asyncValidators = this.getAsyncValidators(field);
                if (!asyncValidators.length) {
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = asyncValidators[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var validator = _step.value;
                        var key = this.getDebouncedValidatorKey(field, validator);
                        this.debouncedValidators[key](value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "getDebouncedValidatorKey",
            value: function getDebouncedValidatorKey(field, validator) {
                return "".concat(field.id, "-").concat(validator.name);
            }
        },
        {
            key: "getValidationResult",
            value: function getValidationResult(field, value, formData) {
                var _field_validation;
                var failingValidator = ((_field_validation = field.validation) != null ? _field_validation : []).find(function(validator) {
                    return !validator.isAsync && !validator.fn(value, formData);
                });
                return failingValidator ? {
                    isValid: false,
                    error: this.getValidatorMessage(failingValidator)
                } : {
                    isValid: true,
                    error: null
                };
            }
        },
        {
            key: "getAsyncValidators",
            value: function getAsyncValidators(field) {
                var _field_validation;
                return ((_field_validation = field.validation) != null ? _field_validation : []).filter(function(validator) {
                    return validator.isAsync;
                });
            }
        },
        {
            key: "initDebouncedValidators",
            value: function initDebouncedValidators() {
                var _this = this;
                if (Object.keys(this.debouncedValidators).length) {
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _this1, _loop = function() {
                        var field = _step.value;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _this2, _loop = function() {
                                var validator = _step1.value;
                                var key = _this2.getDebouncedValidatorKey(field, validator);
                                _this2.debouncedValidators[key] = debounce(function(value) {
                                    _this.invokeAsyncValidator(field, validator, value);
                                }, AsyncDebounceInMs);
                            };
                            for(var _iterator = _this1.getAsyncValidators(field)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true)_this2 = _this1, _loop();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    };
                    for(var _iterator = this.components[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this1 = this, _loop();
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "invokeAsyncValidator",
            value: function invokeAsyncValidator(field, validator, value) {
                return _async_to_generator(function() {
                    var fieldId, isValid, _, _1, _tmp, _tmp1;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                fieldId = field.id;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    validator.fn(value, this.formData)
                                ];
                            case 2:
                                isValid = _state.sent();
                                if (this.isValidatorResultObsolete(fieldId, value)) {
                                    this.updateField({
                                        id: field.id,
                                        isValidationPending: false
                                    });
                                    return [
                                        2
                                    ];
                                }
                                _1 = (_ = this).updateField;
                                _tmp = {
                                    id: field.id,
                                    isValid: isValid,
                                    isValidationPending: false
                                };
                                if (!!isValid) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    this.getValidatorMessage(validator)
                                ];
                            case 3:
                                _tmp1 = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                _tmp1 = undefined;
                                _state.label = 5;
                            case 5:
                                _1.apply(_, [
                                    (_tmp.error = _tmp1, _tmp)
                                ]);
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                _state.sent();
                                this.updateField({
                                    id: field.id,
                                    isValidationPending: false
                                });
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getValidatorMessage",
            value: function getValidatorMessage(validator) {
                if (typeof validator.message === 'function') {
                    return validator.message(this.formData);
                }
                return validator.message || null;
            }
        },
        {
            key: "isValidatorResultObsolete",
            value: function isValidatorResultObsolete(fieldId, value) {
                // if the value of the field has changed while the validation was pending
                // then this validation result is no longer relevant since it refers to the old value
                return this.formData[fieldId].value !== value;
            }
        },
        {
            key: "invokeInitialFieldTriggers",
            value: function invokeInitialFieldTriggers() {
                var _this = this;
                var components = this.components.filter(function(component) {
                    var data = _this.formData[component.id];
                    return data.value == null && !data.touched;
                });
                this.components.forEach(function(component) {
                    var value = _this.formData[component.id].value;
                    if (value !== null) {
                        _this.invokeTriggersForComponents(components, component, value);
                    }
                });
            }
        },
        {
            key: "invokeTriggers",
            value: function invokeTriggers(field, value) {
                this.invokeTriggersForComponents(this.components, field, value);
            }
        },
        {
            key: "invokeTriggersForComponents",
            value: function invokeTriggersForComponents(components, field, value) {
                var _this = this;
                components.forEach(function(component) {
                    var _component_triggers;
                    var trigger = (_component_triggers = component.triggers) == null ? void 0 : _component_triggers[field.id];
                    if (trigger) {
                        trigger(value, _this.formData, function(field) {
                            _this.updateField(field);
                        });
                    }
                });
            }
        },
        {
            /**
   * Given a field value has changed, invoke triggered validators of other fields
   * And update their validation result in the store
   * This will happen at any field value change event.
   *
   * @param field the field changed
   * @param value the value of the field
   */ key: "invokeTriggeredValidators",
            value: function invokeTriggeredValidators(field, value) {
                var _this = this;
                // form data with updated value for the given field
                // used to validate related fields against this value that hasn't been updated to the store yet
                var updatedFormData = this.getFormDataWithFieldValue(field, value);
                this.getFieldsToRevalidateFrom(field.id).forEach(function(triggeredField) {
                    return _async_to_generator(function() {
                        var triggeredFieldValue, _this_getValidationResult, isValid, error, _, _1, _tmp;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    triggeredFieldValue = this.formData[triggeredField.id].value;
                                    _this_getValidationResult = this.getValidationResult(triggeredField, triggeredFieldValue, updatedFormData), isValid = _this_getValidationResult.isValid, error = _this_getValidationResult.error;
                                    this.updateField({
                                        id: triggeredField.id,
                                        isValid: isValid,
                                        isValidationPending: false
                                    });
                                    _1 = (_ = this).updateField;
                                    _tmp = {
                                        id: triggeredField.id
                                    };
                                    return [
                                        4,
                                        error
                                    ];
                                case 1:
                                    _1.apply(_, [
                                        (_tmp.error = _state.sent(), _tmp)
                                    ]);
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(_this);
                });
            }
        },
        {
            key: "getFieldsToRevalidateFrom",
            value: function getFieldsToRevalidateFrom(field) {
                return this.components.filter(function(component) {
                    var _component_validation;
                    return ((_component_validation = component.validation) != null ? _component_validation : []).some(function(validator) {
                        var _validator_triggeringFields;
                        return ((_validator_triggeringFields = validator.triggeringFields) != null ? _validator_triggeringFields : []).includes(field);
                    });
                });
            }
        },
        {
            key: "getFormDataWithFieldValue",
            value: function getFormDataWithFieldValue(field, value) {
                return _extends({}, this.formData, _define_property({}, field.id, _extends({}, this.formData[field.id], {
                    value: value
                })));
            }
        },
        {
            key: "setUpProxies",
            value: function setUpProxies(config) {
                var _this = this;
                config.forEach(function(step) {
                    step.components.forEach(function(_, i) {
                        step.components[i] = _this.getProxy(step.components[i]);
                    });
                });
            }
        },
        {
            key: "getProxy",
            value: function getProxy(config) {
                var _this = this;
                var preloadPromise;
                return new Proxy(config, {
                    get: function(target, prop, receiver) {
                        if (prop === 'preloadProperties') {
                            if (!target.preloadProperties) {
                                return undefined;
                            }
                            return function() {
                                return _async_to_generator(function() {
                                    var props;
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (this.cachedData[target.id]) {
                                                    return [
                                                        2,
                                                        this.cachedData[target.id]
                                                    ];
                                                }
                                                if (preloadPromise) {
                                                    return [
                                                        2,
                                                        preloadPromise
                                                    ];
                                                }
                                                preloadPromise = Promise.resolve(target.preloadProperties());
                                                return [
                                                    4,
                                                    preloadPromise
                                                ];
                                            case 1:
                                                props = _state.sent();
                                                this.cachedData[target.id] = props;
                                                return [
                                                    2,
                                                    props
                                                ];
                                        }
                                    });
                                }).call(_this);
                            };
                        }
                        return Reflect.get(target, prop, receiver);
                    }
                });
            }
        },
        {
            key: "getInitialFormData",
            value: function getInitialFormData(formConfig, initialState) {
                return _async_to_generator(function() {
                    var fields;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(deepFlattenConfig(formConfig).map(function(component) {
                                        return _async_to_generator(function() {
                                            var _component_properties, preloaded, _tmp, _component_properties_value, _ref;
                                            return _ts_generator(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        if (!component.preloadProperties) return [
                                                            3,
                                                            2
                                                        ];
                                                        return [
                                                            4,
                                                            component.preloadProperties()
                                                        ];
                                                    case 1:
                                                        _tmp = _state.sent();
                                                        return [
                                                            3,
                                                            3
                                                        ];
                                                    case 2:
                                                        _tmp = {};
                                                        _state.label = 3;
                                                    case 3:
                                                        preloaded = _tmp;
                                                        return [
                                                            2,
                                                            _extends({
                                                                id: component.id,
                                                                type: component.type,
                                                                value: (_ref = (_component_properties_value = (_component_properties = component.properties) == null ? void 0 : _component_properties['value']) != null ? _component_properties_value : preloaded['value']) != null ? _ref : null,
                                                                touched: false,
                                                                error: null,
                                                                isValid: null,
                                                                isValidationPending: false
                                                            }, initialState == null ? void 0 : initialState[component.id])
                                                        ];
                                                }
                                            });
                                        })();
                                    }))
                                ];
                            case 1:
                                fields = _state.sent();
                                return [
                                    2,
                                    fields.reduce(function(acc, field) {
                                        return _extends({}, acc, _define_property({}, field.id, field));
                                    }, {})
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return FormBuilderService;
}();
var DEFAULT_INITIAL_STEP = '0';
/**
 * Builds and manages dynamic multi-step forms using a declarative configuration.
 *
 * The FormBuilder is a light-weight utility that renders a form based on
 * a list of step configurations and synchronizes the DOM with an internal
 * form state. It supports field validation (sync and async), progressive
 * disclosure through steps, and a submit flow that returns normalized data.
 *
 * Remarks:
 * - This class creates and owns a <form> element and a submit button based on the
 *   current step configuration. Use `createForm` to instantiate and render the
 *   form, and `destroyForm` to clean up.
 * - To change steps programmatically, call `setStep(stepId)`; the DOM will be re-rendered
 *   and state will be preserved/validated accordingly.
 * - Use `setSubmitLoading(true|false)` to toggle loading state on the submit button
 *   during async operations.
 *
 * Example:
 * ```ts
 * import { FormBuilder } from '@gig/magic-form-builder';
 * import type { IFormBuilderStepConfiguration, IFormData } from '@gig/magic-form-builder';
 *
 * const config: IFormBuilderStepConfiguration[] = [
 *   {
 *     id: '0',
 *     elements: [
 *       { id: 'email', type: 'text', label: 'Email', validators: ['required', 'email'] },
 *       { id: 'agree', type: 'checkbox', label: 'I agree to terms' }
 *     ],
 *     nextButton: { text: 'Continue' }
 *   }
 * ];
 *
 * const initialState: IFormData = { email: '', agree: false };
 *
 * const builder = new FormBuilder();
 * const formEl = await builder.createForm({ config, initialState, root: document.body });
 * document.body.appendChild(formEl);
 *
 * // Later, when done
 * builder.destroyForm();
 * ```
 */ var FormBuilder = /*#__PURE__*/ function() {
    function FormBuilder() {
        _class_call_check(this, FormBuilder);
        this.config = [];
        this.initialState = {};
        this.currentStep = '';
        this.formService = new FormBuilderService(this.syncDomWithFormState.bind(this));
        this.components = [];
    }
    _create_class(FormBuilder, [
        {
            key: "createForm",
            value: function createForm(params) {
                return _async_to_generator(function() {
                    var fieldsWrapper, button, buttonConfig;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.saveParams(params);
                                this.form = document.createElement('form');
                                this.form.classList.add('form');
                                fieldsWrapper = document.createElement('div');
                                fieldsWrapper.classList.add('fields-wrapper');
                                this.form.appendChild(fieldsWrapper);
                                button = this.getSubmitButton();
                                if (button) {
                                    this.form.appendChild(button);
                                }
                                return [
                                    4,
                                    this.initializeFormService(params.config, this.initialState)
                                ];
                            case 1:
                                _state.sent();
                                buttonConfig = this.getStepConfig().nextButton;
                                if (buttonConfig && !buttonConfig.alwaysEnabled) {
                                    this.triggerFirstValidation();
                                }
                                return [
                                    2,
                                    this.form
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "destroyForm",
            value: function destroyForm() {
                var _this_observer, _this_form;
                this.formService.destroy();
                (_this_observer = this.observer) == null ? void 0 : _this_observer.disconnect();
                this.observer = undefined;
                (_this_form = this.form) == null ? void 0 : _this_form.remove();
                this.form = undefined;
                this.components = [];
            }
        },
        {
            key: "setSubmitLoading",
            value: function setSubmitLoading(loading) {
                if (!this.form) {
                    return;
                }
                var button = this.form.querySelector('[type="submit"]');
                if (loading) {
                    button.setAttribute('loading', '');
                } else {
                    button.removeAttribute('loading');
                }
            }
        },
        {
            key: "observeForm",
            value: function observeForm() {
                var _this = this;
                this.observer = new MutationObserver(function(mutationsList) {
                    mutationsList.forEach(function(mutation) {
                        if (mutation.type === 'childList') {
                            mutation.removedNodes.forEach(function(removedNode) {
                                if (removedNode === _this.form || removedNode.contains(_this.form)) {
                                    _this.destroyForm();
                                }
                            });
                        }
                    });
                });
                this.observer.observe(this.root || document.body, {
                    subtree: true,
                    childList: true
                });
            }
        },
        {
            key: "setStep",
            value: function setStep(step) {
                return _async_to_generator(function() {
                    var oldButton, button, formData;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                oldButton = this.form.querySelector('.next-button');
                                oldButton == null ? void 0 : oldButton.remove();
                                this.currentStep = step;
                                this.createCurrentStepElements();
                                button = this.getSubmitButton();
                                if (button) {
                                    this.form.appendChild(button);
                                }
                                return [
                                    4,
                                    this.formService.getFormData()
                                ];
                            case 1:
                                formData = _state.sent();
                                this.syncDomWithFormState(formData);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getStep",
            value: function getStep() {
                return this.currentStep;
            }
        },
        {
            key: "saveParams",
            value: function saveParams(params) {
                this.config = params.config;
                var _params_initialState;
                this.initialState = (_params_initialState = params.initialState) != null ? _params_initialState : {};
                this.currentStep = params.currentStep || DEFAULT_INITIAL_STEP;
                this.root = params.root;
                this.components = deepFlattenConfig(this.config);
            }
        },
        {
            key: "getSubmitButton",
            value: function getSubmitButton() {
                var _this = this;
                var step = this.getStepConfig();
                var button = step.nextButton;
                if (!button) {
                    if (step.footer) {
                        var btn = step.footer.querySelector('[type=submit]');
                        step.footer.classList.add('.next-button');
                        btn.addEventListener('click', function(event) {
                            _this.onSubmit(event);
                        });
                        return step.footer;
                    }
                    return null;
                }
                var testId = button.testId || "step".concat(step.path, "-submit");
                var buttonElement = document.createElement('magic-ui-button');
                buttonElement.classList.add('next-button');
                buttonElement.setAttribute('type', 'submit');
                buttonElement.setAttribute('variant', 'primary');
                buttonElement.setAttribute('wide', '');
                buttonElement.setAttribute('data-v-test-id', testId);
                buttonElement.innerHTML = button.text;
                buttonElement.addEventListener('click', function(event) {
                    _this.onSubmit(event);
                });
                return buttonElement;
            }
        },
        {
            key: "createField",
            value: function createField(params) {
                return _async_to_generator(function() {
                    var fieldConfig;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.saveParams({
                                    config: [
                                        {
                                            path: '0',
                                            components: [
                                                params.config
                                            ]
                                        }
                                    ],
                                    root: params.root
                                });
                                this.form = document.createElement('div');
                                this.form.classList.add('field-wrapper');
                                fieldConfig = params.config;
                                return [
                                    4,
                                    this.initializeFormService([
                                        {
                                            path: '0',
                                            components: [
                                                fieldConfig
                                            ]
                                        }
                                    ], {})
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    this.form
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "initializeFormService",
            value: function initializeFormService(config, initialState) {
                return _async_to_generator(function() {
                    var formData;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    this.formService.initialise(config, initialState)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    4,
                                    this.formService.getFormData()
                                ];
                            case 2:
                                formData = _state.sent();
                                this.syncDomWithFormState(formData);
                                this.observeForm();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "createCurrentStepElements",
            value: function createCurrentStepElements() {
                var _this = this;
                if (!this.form) {
                    return;
                }
                var fieldsWrapper = this.form.querySelector('.fields-wrapper');
                fieldsWrapper.innerHTML = '';
                this.getStepConfig().components.forEach(function(fieldConfig, index) {
                    _this.createFormElement(fieldsWrapper, fieldConfig, index);
                });
            }
        },
        {
            key: "updateField",
            value: function updateField(model) {
                this.formService.updateField(model);
            }
        },
        {
            key: "updateServerField",
            value: function updateServerField(serverId, model) {
                var fieldId = findComponentIdByServerId(this.components, serverId) || '';
                if (fieldId) {
                    this.formService.updateField(_extends({}, model, {
                        id: fieldId
                    }));
                }
            }
        },
        {
            key: "hasField",
            value: function hasField(serverId) {
                return !!findComponentIdByServerId(this.components, serverId);
            }
        },
        {
            key: "syncDomWithFormState",
            value: function syncDomWithFormState(formData) {
                var _this = this;
                if (!this.form) {
                    return;
                }
                var components = this.getStepConfig().components;
                components.forEach(function(component, index) {
                    return _this.createFormStructure(component, index);
                });
                components.forEach(function(component) {
                    return _this.syncFormComponent(formData, component);
                });
                this.setSubmitDisabled();
                this.form.dispatchEvent(new CustomEvent('form-change', {
                    detail: {
                        form: formData
                    }
                }));
            }
        },
        {
            key: "setSubmitDisabled",
            value: function setSubmitDisabled() {
                if (!this.form) {
                    return;
                }
                var button = this.form.querySelector('[type="submit"]');
                var buttonConfig = this.getStepConfig().nextButton;
                if (!button || (buttonConfig == null ? void 0 : buttonConfig.alwaysEnabled)) {
                    return;
                }
                var disabled = this.shouldBlockNextStep();
                if (disabled) {
                    button.setAttribute('disabled', '');
                } else {
                    button.removeAttribute('disabled');
                }
            }
        },
        {
            key: "createFormStructure",
            value: function createFormStructure(component, index) {
                var element = this.form.querySelector("#".concat(component.id));
                if (!element) {
                    var fieldsWrapper = this.form.querySelector('.fields-wrapper') || this.form;
                    this.createFormElement(fieldsWrapper, component, index);
                }
            }
        },
        {
            key: "syncFormComponent",
            value: function syncFormComponent(formData, component) {
                return _async_to_generator(function() {
                    var _this, element, data, attributes, hasError, hasWarning, hasSuccess, message, touched;
                    return _ts_generator(this, function(_state) {
                        _this = this;
                        element = this.form.querySelector("#".concat(component.id));
                        data = formData[component.id];
                        if (data.hidden) {
                            element == null ? void 0 : element.remove();
                            return [
                                2
                            ];
                        }
                        if (component.dynamicProperties) {
                            attributes = getDynamicProperties(component, formData);
                            patchElementProperties(element, attributes);
                        }
                        if (component.isStandAlone) {
                            patchElementProperties(element, {
                                valueObject: data.value
                            });
                        } else {
                            setElementAttribute(element, 'value', data.value);
                        }
                        setElementAttribute(element, 'disabled', data.disabled);
                        setElementAttribute(element, 'data-v-test-id', component.testId);
                        if (component.isDataField) {
                            hasError = this.formService.isFormDataInvalid(component.id, true);
                            setElementAttribute(element, 'hasError', hasError);
                            setElementAttribute(element, 'has-error', hasError);
                            hasWarning = this.formService.isFormDataPending(component.id);
                            setElementAttribute(element, 'hasWarning', hasWarning);
                            setElementAttribute(element, 'has-warning', hasWarning);
                            hasSuccess = this.formService.isFormDataValid(component.id, true);
                            setElementAttribute(element, 'hasSuccess', hasSuccess);
                            setElementAttribute(element, 'has-success', hasSuccess);
                            message = this.formService.getFormDataMessage(component.id);
                            setElementAttribute(element, 'message', message);
                            touched = this.formService.isFormDataTouched(component.id);
                            setElementAttribute(element, 'touched', touched);
                        }
                        if (component.children) {
                            component.children.forEach(function(component) {
                                return _this.syncFormComponent(formData, component);
                            });
                        }
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "createFormElement",
            value: function createFormElement(parent, config, index) {
                var element = this.createElement(config, index);
                this.applyProperties(element, config);
                this.addEventListeners(element, config);
                this.handleSlot(element, config);
                this.handleEmitHandlers(element, config);
                parent.appendChild(element);
                if (config.children) {
                    this.createChildElements(element, config.children);
                }
                return element;
            }
        },
        {
            key: "createElement",
            value: function createElement(config, index) {
                var element = document.createElement(config.component);
                element.setAttribute('id', config.id);
                element.style.order = "".concat(index + 1);
                return element;
            }
        },
        {
            key: "applyProperties",
            value: function applyProperties(element, config) {
                if (config.properties) {
                    patchElementProperties(element, config.properties);
                }
                if (config.preloadProperties) {
                    Promise.resolve(config.preloadProperties()).then(function(attributes) {
                        patchElementProperties(element, attributes);
                    });
                }
            }
        },
        {
            key: "addEventListeners",
            value: function addEventListeners(element, config) {
                var _this = this;
                if (!config.isStandAlone) {
                    element.addEventListener('change', function(e) {
                        var event = e;
                        if (event == null ? void 0 : event.detail) {
                            var value = event.detail.value || event.detail[0];
                            _this.formService.updateField({
                                id: config.id,
                                value: value,
                                touched: true
                            });
                        } else {
                            console.error('"change" Event detail is missing', element, event);
                        }
                    });
                    element.addEventListener('blur', function() {
                        _this.formService.updateField({
                            id: config.id,
                            touched: true
                        });
                    });
                } else {
                    element.addEventListener('stand-alone-change', function(e) {
                        var event = e;
                        _this.formService.updateField(_extends({
                            id: config.id,
                            touched: true
                        }, event.detail));
                    });
                }
            }
        },
        {
            key: "handleSlot",
            value: function handleSlot(element, config) {
                if (config.slot) {
                    setElementAttribute(element, 'slot', config.slot);
                }
            }
        },
        {
            key: "handleEmitHandlers",
            value: function handleEmitHandlers(element, config) {
                var _this = this;
                if (config.emitHandlers) {
                    Object.entries(config.emitHandlers).forEach(function(param) {
                        var _param = _sliced_to_array(param, 2), eventName = _param[0], eventHandler = _param[1];
                        element.addEventListener(eventName, function(event) {
                            return _async_to_generator(function() {
                                var result;
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]);
                                            return [
                                                4,
                                                eventHandler(event)
                                            ];
                                        case 1:
                                            result = _state.sent();
                                            if (result) {
                                                this.formService.updateField(result);
                                            } else {
                                                // used to trigger an update of dynamic properties
                                                this.formService.updateField({
                                                    id: config.id
                                                });
                                            }
                                            return [
                                                3,
                                                3
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }).call(_this);
                        });
                    });
                }
            }
        },
        {
            key: "createChildElements",
            value: function createChildElements(parent, children) {
                var _this = this;
                children.forEach(function(child, childIndex) {
                    _this.createFormElement(parent, child, childIndex);
                });
            }
        },
        {
            key: "onSubmit",
            value: function onSubmit(event) {
                return _async_to_generator(function() {
                    var stepIndex, path, formValue;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                event.preventDefault();
                                this.forceValidationsToDisplay();
                                if (this.shouldBlockNextStep()) {
                                    return [
                                        2
                                    ];
                                }
                                stepIndex = this.getCurrentStepIndex();
                                if (!(stepIndex < this.config.length - 1)) return [
                                    3,
                                    2
                                ];
                                path = this.config[stepIndex + 1].path;
                                return [
                                    4,
                                    this.setStep(path)
                                ];
                            case 1:
                                _state.sent();
                                this.dispatchEvent(new CustomEvent('next-step', {
                                    detail: path
                                }));
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                formValue = this.formService.getFormValue();
                                this.currentStep = (+this.currentStep + 1).toString();
                                this.dispatchEvent(new CustomEvent('form-submit', {
                                    detail: formValue
                                }));
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "triggerFirstValidation",
            value: function triggerFirstValidation() {
                var _this = this;
                this.getStepConfig().components.forEach(function(component) {
                    return _this.invokeComponentValidations(component);
                });
            }
        },
        {
            key: "invokeComponentValidations",
            value: function invokeComponentValidations(component) {
                var _this = this;
                if (component.children) {
                    return component.children.forEach(function(component) {
                        return _this.invokeComponentValidations(component);
                    });
                }
                this.formService.invokeValidatorsAndUpdateFormModel({
                    id: component.id
                });
            }
        },
        {
            key: "forceValidationsToDisplay",
            value: function forceValidationsToDisplay() {
                var _this = this;
                this.getStepConfig().components.forEach(function(component) {
                    return _this.updateComponentState(component);
                });
            }
        },
        {
            key: "updateComponentState",
            value: function updateComponentState(component) {
                var _this = this;
                if (component.children) {
                    return component.children.forEach(function(component) {
                        return _this.updateComponentState(component);
                    });
                }
                this.formService.updateField({
                    id: component.id,
                    touched: true
                });
            }
        },
        {
            key: "getCurrentStepIndex",
            value: function getCurrentStepIndex() {
                var configIndex = this.config.indexOf(this.getStepConfig());
                return configIndex !== -1 ? configIndex : 0;
            }
        },
        {
            key: "dispatchEvent",
            value: function dispatchEvent(event) {
                if (!this.form) {
                    return;
                }
                this.form.dispatchEvent(event);
            }
        },
        {
            key: "shouldBlockNextStep",
            value: function shouldBlockNextStep() {
                var _this = this;
                return this.getStepConfig().components.some(function(component) {
                    return _this.isInvalidComponent(component);
                });
            }
        },
        {
            key: "isInvalidComponent",
            value: function isInvalidComponent(component) {
                var _this = this;
                if (component.children) {
                    return component.children.some(function(child) {
                        return _this.isInvalidComponent(child);
                    });
                }
                return this.formService.isFormDataInvalid(component.id, false);
            }
        },
        {
            key: "getStepConfig",
            value: function getStepConfig() {
                var _this = this;
                if (this.currentStep === DEFAULT_INITIAL_STEP) {
                    return this.config[0];
                }
                return this.config.find(function(configStep) {
                    return configStep.path === _this.currentStep;
                }) || this.config[0];
            }
        }
    ]);
    return FormBuilder;
}();

function getDetailsTemplate$1(amount) {
    const isWithdrawView = AppState.wallet.selectedTabName === View.Withdraw;
    const isLockedAmount = AppState.wallet.lockedAmount;
    const showBalanceTemplate = isWithdrawView && !isLockedAmount;
    return `<div class="details">
            ${showBalanceTemplate ? getWithdrawBalanceTemplate() : ''}
            ${getSummarySection(amount)}
            <div class="details_form" part="details_form">
            </div>
        </div>`;
}

async function createFormScreen(config) {
    const { amount, onFormSubmit, formBuilder, formConfig } = config;
    const content = getCurrentTab();
    const form = await formBuilder.createForm({
        config: formConfig,
        root: AppState.shadowRoot
    });
    form.classList.add('form-builder');
    form.setAttribute('part', 'form-builder');
    const detailsTemplate = createElementFromTemplate('div', getDetailsTemplate$1(amount));
    const formDiv = detailsTemplate.querySelector('.details_form');
    formDiv == null ? void 0 : formDiv.appendChild(form);
    content.replaceChildren(detailsTemplate);
    scrollToTop();
    attachCancelListeners(formBuilder);
    if (onFormSubmit) {
        form.addEventListener('form-submit', (event)=>{
            const formData = event.detail;
            onFormSubmit(formData, amount);
        });
        return Promise.resolve({});
    }
    return new Promise((resolve)=>{
        form.addEventListener('form-submit', (event)=>{
            const formData = event.detail;
            resolve(formData);
        });
    });
}
function attachCancelListeners(formBuilder) {
    const content = getCurrentTab();
    const changeButton = content.querySelector('.details__change-button');
    const cancelButton = content.querySelector('.details__cancel-button');
    changeButton == null ? void 0 : changeButton.addEventListener('click', ()=>{
        cancelForm(formBuilder);
    });
    cancelButton == null ? void 0 : cancelButton.addEventListener('click', ()=>{
        cancelForm(formBuilder);
    });
}
function cancelForm(formBuilder) {
    formBuilder.destroyForm();
    const view = AppState.wallet.selectedTabName;
    if (view === View.Withdraw) {
        createWithdrawView();
    } else {
        createDepositView$1();
    }
}

function getDetailsFooter(additionalContent) {
    const currentTab = AppState.wallet.selectedTabName;
    const submitLabel = currentTab === View.Withdraw ? translate('galleon.withdraw.confirm.button') : translate('galleon.deposit.continue');
    return `<div class="details__footer ${additionalContent ? 'with-content' : ''}" part="details__footer">
            ${additionalContent ? additionalContent : ''}
            <div class="details__footer-wrapper" part="details__footer-wrapper">
              <magic-ui-button
                class="button details__cancel-button"
                part="button details__cancel-button"
                variant="primary"
                hollow
              >
                ${translate('wallet.wait-response-cancel.button')}
              </magic-ui-button>
              <magic-ui-button
                class="button details__confirm-button"
                part="button details__confirm-button"
                type="submit"
                variant="primary"
              >
                ${submitLabel}
              </magic-ui-button>
            </div>
          </div>`;
}

var required = function(value) {
    return !!value;
};

var minLength = function(length) {
    return function(value) {
        return "".concat(value).length >= length;
    };
};
var maxLength = function(length) {
    return function(value) {
        return "".concat(value).length <= length;
    };
};
var emailRegex$1 = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;
var isEmail = function(email) {
    return emailRegex$1.test(email);
};

function emailField(email) {
    return {
        id: 'email',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'email',
        validationDisplay: ValidationDisplay.OnTouchShowMessage,
        properties: {
            type: 'email',
            placeholder: translate('galleon.input.placeholder'),
            label: translate('galleon.deposit.email.enter.label'),
            value: email
        },
        validation: [
            {
                name: 'required',
                fn: (value)=>required(value),
                message: translate('galleon.deposit.email.label.error')
            },
            {
                name: 'email',
                fn: (value)=>isEmail(value),
                message: translate('galleon.deposit.email.label.error')
            }
        ]
    };
}

function getSkrillRegisterMessage() {
    return `<div>
            <magic-ui-text
              tag="p"
              class="details__footer-skrill"
              part="details__footer-skrill"
              content='${translate('galleon.skrill.account')}'
              is-markdown
            ></magic-ui-text>
          </div>`;
}
function getEmailFormConfig(email = '') {
    const formFooter = document.createElement('div');
    formFooter.innerHTML = getDetailsFooter(getSkrillRegisterMessage());
    return [
        {
            path: '1',
            components: [
                emailField(email)
            ],
            footer: formFooter
        }
    ];
}

var _formBuilder$5 = /*#__PURE__*/ _class_private_field_loose_key("_formBuilder"), _createForm = /*#__PURE__*/ _class_private_field_loose_key("_createForm");
class PaysafeSkrillMethod extends BaseRedirectCorexMethod {
    get methodLabel() {
        return 'Skrill';
    }
    async processWithdraw(amount) {
        const formResult = await _class_private_field_loose_base(this, _createForm)[_createForm](amount);
        const method = this.paymentMethodExternalId;
        const emailSubject = translate('galleon.withdrawal.success.email.title').replace('{method}', 'Skrill');
        const emailMessage = translate('galleon.withdrawal.success.email.message').replace('{method}', 'Skrill');
        return await super.processWithdraw(amount, undefined, {
            externalUserProfileId: formResult.email,
            emailSubject,
            emailMessage,
            defaultRedirectionUrl: this.getRedirectionUrl(this.redirectBaseUrl, method, ERedirectStatus.Default),
            completeRedirectionUrl: this.getRedirectionUrl(this.redirectBaseUrl, method, ERedirectStatus.Success),
            cancelRedirectionUrl: this.getRedirectionUrl(this.redirectBaseUrl, method, ERedirectStatus.Cancel),
            failRedirectionUrl: this.getRedirectionUrl(this.redirectBaseUrl, method, ERedirectStatus.Fail)
        });
    }
    async processDeposit(result, config) {
        let email = this.corexConfig.userEmail;
        if (!AppState.wallet.features.skipIntermediateRedirectStep) {
            const formResult = await _class_private_field_loose_base(this, _createForm)[_createForm](result.amount);
            email = formResult.email;
        }
        if (AppState.wallet.chosenDepositBonus !== '') {
            config.promoCode = AppState.wallet.chosenDepositBonus;
        }
        if (AppState.wallet.depositExtraData.sweepstakesShopItemId !== '') {
            config.sweepStakesShopItemID = AppState.wallet.depositExtraData.sweepstakesShopItemId;
        }
        return super.processDeposit(result, config, {
            externalUserProfileId: email
        });
    }
    constructor(...args){
        super(...args), Object.defineProperty(this, _createForm, {
            value: createForm
        }), Object.defineProperty(this, _formBuilder$5, {
            writable: true,
            value: void 0
        }), _class_private_field_loose_base(this, _formBuilder$5)[_formBuilder$5] = new FormBuilder();
    }
}
async function createForm(amount) {
    const formResult = await createFormScreen({
        amount,
        formBuilder: _class_private_field_loose_base(this, _formBuilder$5)[_formBuilder$5],
        formConfig: getEmailFormConfig(this.corexConfig.userEmail)
    });
    const content = getCurrentTab();
    const submitBtn = content.querySelector('.details__confirm-button');
    submitBtn == null ? void 0 : submitBtn.setAttribute('loading', 'true');
    return formResult;
}

class PaysafePaysafeCardMethod extends BaseRedirectCorexMethod {
    get methodLabel() {
        return 'Paysafecard';
    }
}

class BaseSavedHandleMethod extends BaseCorexMethod {
    deposit(amount) {
        console.error('deposit is not implemented', amount);
    }
    get disabledByNetPosition() {
        return this.netPosition === 0;
    }
    render(index) {
        const methodDiv = createElementFromTemplate('div', getSavedWithdrawMethodTemplate({
            holderContent: this.getHolderContent(),
            methodContent: this.getMethodContent(),
            lockedAmount: AppState.wallet.lockedAmount,
            netPosition: this.netPosition,
            id: this.id,
            isRemovable: false,
            method: this
        }));
        if (this.netPosition === 0) {
            methodDiv.classList.add('disabled');
        }
        return renderSavedWithdrawMethod(index, this, methodDiv);
    }
    showWithdrawResult(result, successMessage) {
        createWithdrawStatusScreen(result, successMessage);
    }
    constructor(params){
        super(params), this.params = params;
        this.paymentHandleToken = params.paymentHandleToken;
    }
}

class BaseSavedRedirectMethod extends BaseSavedHandleMethod {
    get extraWithdrawSubmit() {
        return {};
    }
    async withdraw(amount, extraData = {}) {
        const currencyCode = AppState.wallet.balanceData.currencyCode;
        const launchResult = await this.corexGateway.launchWithdraw(_extends$1({
            currencyCode: currencyCode,
            externalPaymentMethodId: this.paymentMethodExternalId,
            amount: amount,
            externalUserProfileId: this.redirectEmail
        }, extraData));
        const submitData = _extends$1({
            externalPaymentMethodId: this.paymentMethodExternalId,
            sessionContextId: launchResult.sessionContextId,
            amount: amount,
            currencyCode: currencyCode,
            paymentMethod: this.paymentMethodExternalId
        }, this.extraWithdrawSubmit);
        if (launchResult.paymentHandleToken) {
            submitData.externalPaymentToken = launchResult.paymentHandleToken;
        }
        const submitResult = await this.corexGateway.submitWithdraw(submitData);
        const result = {
            success: submitResult.success,
            transactionID: submitResult.transactionID,
            amount: amount,
            currencyCode: currencyCode,
            paymentMethod: this.paymentMethodExternalId
        };
        this.logPayment(_extends$1({}, result, {
            paymentMethod: submitResult.paymentMethod
        }));
        this.showWithdrawResult(result, this.getSuccessMessage(result));
    }
    getSuccessMessage(data) {
        return translate('galleon.withdrawal.success.pending.description').replace('{method}', this.methodLabel).replace('{amount}', formatCurrency(data.amount, data.currencyCode)).replace('{email}', this.redirectEmail).replace('{transactionID}', data.transactionID);
    }
    getMethodContent() {
        return this.redirectEmail || '';
    }
    getHolderContent() {
        return this.redirectName || '';
    }
    constructor(params){
        super(params);
        this.redirectEmail = params.email;
        this.redirectName = params.name;
    }
}

class SavedPayPalMethod extends BaseSavedRedirectMethod {
    get methodLabel() {
        return 'PayPal';
    }
    get extraWithdrawSubmit() {
        const closedLoopOnly = AppState.wallet.closedLoopOnly;
        const details = {
            externalUserProfileEmail: this.redirectEmail
        };
        const magicPaypalData = {
            paypalDetails: details
        };
        if (closedLoopOnly) {
            // use magic payload
            return magicPaypalData;
        }
        return {};
    }
    constructor(params){
        super(params);
    }
}

class SavedSkrillMethod extends BaseSavedRedirectMethod {
    get methodLabel() {
        return 'Skrill';
    }
    async withdraw(amount) {
        const emailSubject = translate('galleon.withdrawal.success.email.title').replace('{method}', 'Skrill');
        const emailMessage = translate('galleon.withdrawal.success.email.message').replace('{method}', 'Skrill');
        const skrillData = {
            emailSubject,
            emailMessage
        };
        return super.withdraw(amount, skrillData);
    }
    constructor(params){
        super(params);
    }
}

var _card = /*#__PURE__*/ _class_private_field_loose_key("_card");
class SavedCardMethod extends BaseSavedHandleMethod {
    async withdraw(amount) {
        const savedWithdrawMethods = AppState.savedWithdrawMethods;
        const currencyCode = AppState.wallet.balanceData.currencyCode;
        const { externalUserProfileId, sessionContextId } = savedWithdrawMethods;
        let submitData = {
            externalPaymentMethodId: PaysafeMethodId.Card,
            sessionContextId: sessionContextId,
            externalUserProfileId: externalUserProfileId,
            amount: amount,
            currencyCode: currencyCode,
            externalPaymentToken: this.paymentHandleToken,
            paymentMethod: PaysafeMethodId.Card
        };
        const closedLoopOnly = AppState.wallet.closedLoopOnly;
        const cardDetails = {
            holderName: _class_private_field_loose_base(this, _card)[_card].holderName,
            maskedNumber: _class_private_field_loose_base(this, _card)[_card].lastFourDigits,
            type: _class_private_field_loose_base(this, _card)[_card].cardType,
            issuingCountry: _class_private_field_loose_base(this, _card)[_card].issuingCountry,
            category: _class_private_field_loose_base(this, _card)[_card].cardCategory,
            expiryDate: formatCardExpiryDate(_class_private_field_loose_base(this, _card)[_card].expiryMonth, _class_private_field_loose_base(this, _card)[_card].expiryYear)
        };
        const magicCardData = {
            cardDetails
        };
        if (closedLoopOnly) {
            // use magic payload
            submitData = _extends$1({}, submitData, magicCardData);
        }
        const submitResult = await this.corexGateway.submitWithdraw(submitData);
        let errorText;
        if (submitResult.errors) {
            errorText = getSpecificErrorText(submitResult.errors, View.Withdraw);
        }
        const result = {
            success: submitResult.success,
            transactionID: submitResult.transactionID,
            amount: amount,
            currencyCode: currencyCode,
            paymentMethod: _class_private_field_loose_base(this, _card)[_card].lastFourDigits,
            errorText: errorText
        };
        this.logPayment(_extends$1({}, result, {
            paymentMethod: submitResult.paymentMethod
        }));
        this.showWithdrawResult(result, this.getSuccessMessage(result));
    }
    render(index) {
        return super.render(index);
    }
    getSuccessMessage(data) {
        return translate('galleon.withdrawal.success.card.description').replace('{amount}', formatCurrency(data.amount, data.currencyCode)).replace('{lastFourDigits}', _class_private_field_loose_base(this, _card)[_card].lastFourDigits).replace('{transactionID}', data.transactionID);
    }
    getMethodContent() {
        return `**** **** **** ${_class_private_field_loose_base(this, _card)[_card].lastFourDigits}`;
    }
    getHolderContent() {
        return _class_private_field_loose_base(this, _card)[_card].holderName || '';
    }
    constructor(params){
        super(params), Object.defineProperty(this, _card, {
            writable: true,
            value: void 0
        });
        _class_private_field_loose_base(this, _card)[_card] = params.card;
    }
}

var _bankAccount = /*#__PURE__*/ _class_private_field_loose_key("_bankAccount");
class SavedPayByBankMethod extends BaseSavedHandleMethod {
    async withdraw(amount) {
        const currencyCode = AppState.wallet.balanceData.currencyCode;
        const payByBankLaunchConfig = {
            currencyCode,
            externalPaymentMethodId: PaysafeMethodId.PayByBank,
            isNewAccount: false
        };
        const launchResult = await this.corexGateway.launchWithdraw(payByBankLaunchConfig);
        const submitResult = await this.corexGateway.submitWithdraw({
            externalPaymentMethodId: PaysafeMethodId.PayByBank,
            sessionContextId: launchResult.sessionContextId,
            amount: amount,
            currencyCode: currencyCode,
            externalPaymentToken: this.paymentHandleToken,
            paymentMethod: PaysafeMethodId.PayByBank
        });
        const result = {
            success: submitResult.success,
            transactionID: submitResult.transactionID,
            amount: amount,
            currencyCode: currencyCode,
            paymentMethod: _class_private_field_loose_base(this, _bankAccount)[_bankAccount].lastDigits
        };
        this.logPayment(_extends$1({}, result, {
            paymentMethod: submitResult.paymentMethod
        }));
        this.showWithdrawResult(result, this.getSuccessMessage(result));
    }
    getSuccessMessage(data) {
        return translate('galleon.withdrawal.success.paybybank.description').replace('{amount}', formatCurrency(data.amount, data.currencyCode)).replace('{lastDigits}', _class_private_field_loose_base(this, _bankAccount)[_bankAccount].lastDigits).replace('{transactionID}', data.transactionID);
    }
    getMethodContent() {
        return `**** **** **** **${_class_private_field_loose_base(this, _bankAccount)[_bankAccount].lastDigits}`;
    }
    getHolderContent() {
        return _class_private_field_loose_base(this, _bankAccount)[_bankAccount].accountHolderName || '';
    }
    constructor(params){
        super(params), Object.defineProperty(this, _bankAccount, {
            writable: true,
            value: void 0
        });
        _class_private_field_loose_base(this, _bankAccount)[_bankAccount] = params.bankAccount;
    }
}

function getGooglePayPage(amount) {
    return `${getSummarySection(amount)}`;
}

const paysafeGooglePaySourceUrl = 'https://pay.google.com/gp/p/js/pay.js';
const allowedPaymentMethods = {
    type: 'CARD',
    parameters: {
        allowedAuthMethods: [
            'PAN_ONLY',
            'CRYPTOGRAM_3DS'
        ],
        allowedCardNetworks: [
            'AMEX',
            'DISCOVER',
            'INTERAC',
            'JCB',
            'MASTERCARD',
            'VISA'
        ]
    }
};
var _paymentsClient = /*#__PURE__*/ _class_private_field_loose_key("_paymentsClient"), _renderContent = /*#__PURE__*/ _class_private_field_loose_key("_renderContent"), _showDepositResult = /*#__PURE__*/ _class_private_field_loose_key("_showDepositResult"), _onGooglePaymentButtonClicked = /*#__PURE__*/ _class_private_field_loose_key("_onGooglePaymentButtonClicked");
class PaysafeGooglePayMethod extends BaseCorexMethod {
    async deposit(amount) {
        await loadScript(paysafeGooglePaySourceUrl);
        if (!_class_private_field_loose_base(this, _paymentsClient)[_paymentsClient]) {
            var _this_corexGateway_config_paysafe;
            _class_private_field_loose_base(this, _paymentsClient)[_paymentsClient] = new google.payments.api.PaymentsClient({
                environment: (_this_corexGateway_config_paysafe = this.corexGateway.config.paysafe) == null ? void 0 : _this_corexGateway_config_paysafe.environment
            });
        }
        const config = this.getDepositConfig(amount);
        const result = {
            amount,
            currencyCode: this.currencyCode,
            success: false,
            paymentMethod: this.paymentMethodExternalId,
            paymentMethodLabel: 'GooglePay',
            transactionID: ''
        };
        try {
            const { sessionContextId } = await this.corexGateway.launchDeposit(config);
            // Check readiness
            let ready = false;
            try {
                const response = await _class_private_field_loose_base(this, _paymentsClient)[_paymentsClient].isReadyToPay({
                    apiVersion: 2,
                    apiVersionMinor: 0,
                    allowedPaymentMethods: [
                        allowedPaymentMethods
                    ]
                });
                ready = !!(response == null ? void 0 : response.result);
            } catch (err) {
                console.error('Google Pay isReadyToPay error:', err);
                _class_private_field_loose_base(this, _showDepositResult)[_showDepositResult](result);
                return result;
            }
            if (!ready) {
                console.warn('Google Pay is not ready to pay.');
                _class_private_field_loose_base(this, _showDepositResult)[_showDepositResult](result);
                return result;
            }
            // Render and wait for a user click
            await new Promise((resolveClick)=>{
                _class_private_field_loose_base(this, _renderContent)[_renderContent](amount, (clicked)=>{
                    if (clicked) resolveClick();
                });
            });
            await _class_private_field_loose_base(this, _onGooglePaymentButtonClicked)[_onGooglePaymentButtonClicked](amount, sessionContextId, result);
            _class_private_field_loose_base(this, _showDepositResult)[_showDepositResult](result);
            return result;
        } catch (error) {
            console.error('Error during Google Pay deposit init:', error);
            _class_private_field_loose_base(this, _showDepositResult)[_showDepositResult](result);
            return result;
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    withdraw(amount) {}
    constructor(...args){
        super(...args), Object.defineProperty(this, _renderContent, {
            value: renderContent
        }), Object.defineProperty(this, _showDepositResult, {
            value: showDepositResult
        }), Object.defineProperty(this, _onGooglePaymentButtonClicked, {
            value: onGooglePaymentButtonClicked
        }), Object.defineProperty(this, _paymentsClient, {
            writable: true,
            value: void 0
        });
    }
}
function renderContent(amount, onClick) {
    var _content_querySelector;
    const googlePayButton = _class_private_field_loose_base(this, _paymentsClient)[_paymentsClient].createButton({
        onClick: ()=>onClick(true),
        allowedPaymentMethods: [
            allowedPaymentMethods
        ],
        buttonSizeMode: 'fill',
        buttonType: 'pay'
    });
    const content = getCurrentTab();
    content.innerHTML = getGooglePayPage(amount);
    content.appendChild(googlePayButton);
    scrollToTop();
    (_content_querySelector = content.querySelector('.details__change-button')) == null ? void 0 : _content_querySelector.addEventListener('click', ()=>{
        createDepositView$1();
    });
    return content;
}
function showDepositResult(depositResult) {
    emitDepositResult(depositResult);
    this.logPayment(depositResult);
    if (depositResult.success) {
        createDepositPaypalCompleteMessage(depositResult, handleDepositSuccess(depositResult));
    } else {
        createDepositStatusScreen(depositResult);
    }
}
async function onGooglePaymentButtonClicked(amount, sessionContextId, result) {
    var _this_corexGateway_config_paysafe, _AppState_wallet_profile_billingAddress, _AppState_wallet_profile;
    const paymentDataRequest = {
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [
            _extends$1({}, allowedPaymentMethods, {
                tokenizationSpecification: {
                    type: 'PAYMENT_GATEWAY',
                    parameters: {
                        gateway: 'paysafe',
                        gatewayMerchantId: (_this_corexGateway_config_paysafe = this.corexGateway.config.paysafe) == null ? void 0 : _this_corexGateway_config_paysafe.merchantId
                    }
                }
            })
        ],
        transactionInfo: {
            countryCode: (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : (_AppState_wallet_profile_billingAddress = _AppState_wallet_profile.billingAddress) == null ? void 0 : _AppState_wallet_profile_billingAddress.country,
            currencyCode: this.currencyCode,
            totalPriceStatus: 'FINAL',
            totalPrice: amount.toFixed(2)
        }
    };
    try {
        var _AppState_wallet_profile1, _AppState_wallet_profile2, _AppState_wallet_profile3, _AppState_wallet_profile4;
        const googlePayPaymentToken = await _class_private_field_loose_base(this, _paymentsClient)[_paymentsClient].loadPaymentData(paymentDataRequest);
        const method = this.paymentMethodExternalId;
        const customer = (_AppState_wallet_profile1 = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile1.customer;
        const payload = {
            sessionContextId,
            amount,
            currencyCode: this.currencyCode,
            customerDetails: (_AppState_wallet_profile2 = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile2.customer,
            billingDetails: (_AppState_wallet_profile3 = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile3.billingAddress,
            googlePayData: {
                GooglePayPaymentToken: _extends$1({}, googlePayPaymentToken, {
                    shippingAddress: _extends$1({}, (_AppState_wallet_profile4 = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile4.billingAddress, {
                        name: `${customer == null ? void 0 : customer.firstName} ${customer == null ? void 0 : customer.lastName}`
                    })
                })
            },
            defaultRedirectionUrl: this.getRedirectionUrl(this.redirectBaseUrl, method, ERedirectStatus.Default),
            completeRedirectionUrl: this.getRedirectionUrl(this.redirectBaseUrl, method, ERedirectStatus.Success),
            failRedirectionUrl: this.getRedirectionUrl(this.redirectBaseUrl, method, ERedirectStatus.Fail),
            merchantUrl: 'https://api.qa.paysafe.com/checkout/v2/index.html#/desktop'
        };
        const authorizeResult = await this.corexGateway.depositSubmit(googlePayPaymentToken.paymentMethodData.tokenizationData.token, this.paymentMethodExternalId, undefined, payload);
        if ('redirectUrl' in authorizeResult) {
            if (authorizeResult.redirectUrl) {
                const iframeElement = createCloseIframeDialog(authorizeResult.redirectUrl);
                const redirectResult = await ProxyListener.openWindow(authorizeResult.redirectUrl, this.redirectBaseUrl, (iframeElement == null ? void 0 : iframeElement.contentWindow) || null);
                if ((redirectResult == null ? void 0 : redirectResult.status) === ERedirectStatus.Success) {
                    result.success = true;
                }
            } else {
                result.success = true;
            }
        }
    } catch (err) {
        console.error('loadPaymentData error:', err);
    }
}

class PaysafeMethodFactory {
    static createPaymentMethod(method) {
        const baseProps = {
            provider: ProviderType.Paysafe,
            id: method.id,
            title: isMagicPaymentMethod(method) ? getMagicPaymentMethodNameByLanguage(method, AppState.wallet.locale || 'en') : method.name,
            minAmount: method.minAmount,
            maxAmount: method.maxAmount,
            currencyCode: method.currencyCode,
            paymentMethodExternalId: method.paymentMethodExternalId,
            paymentType: method.paymentType,
            externalAccountId: method.externalAccountId,
            position: isMagicPaymentMethod(method) ? method.position : undefined,
            logoUrl: isMagicPaymentMethod(method) ? getMagicPaymentMethodLogoByMarket(method, AppState.wallet.locale || 'en') : ''
        };
        switch(method.paymentMethodExternalId){
            case PaysafeMethodId.Card:
                return new PaysafeCardMethod(baseProps);
            case PaysafeMethodId.Paypal:
                return new PaysafePayPalMethod(baseProps);
            case PaysafeMethodId.PayByBank:
                return new PayByBankMethod(baseProps);
            case PaysafeMethodId.Skrill:
                return new PaysafeSkrillMethod(baseProps);
            case PaysafeMethodId.Paysafecard:
                return new PaysafePaysafeCardMethod(baseProps);
            case PaysafeMethodId.ApplePay:
                return new PaysafeApplePayMethod(baseProps);
            case PaysafeMethodId.GooglePayWith3ds:
            case PaysafeMethodId.GooglePayWithout3ds:
                return new PaysafeGooglePayMethod(baseProps);
            default:
                return new PaysafeCardMethod(baseProps);
        }
    }
    static createSavedPaymentMethod(method) {
        const baseProps = {
            paymentHandleToken: method.paymentHandleToken,
            paymentMethodExternalId: method.paymentMethodExternalId,
            netPosition: method.netPosition,
            id: method.paymentHandleToken,
            provider: ProviderType.Paysafe,
            minAmount: 0,
            maxAmount: 0,
            title: '',
            currencyCode: AppState.wallet.balanceData.currencyCode,
            logoUrl: isMagicPaymentMethod(method) ? getMagicPaymentMethodLogoByMarket(method, AppState.wallet.locale || 'en') : ''
        };
        const { email, name, card } = method;
        switch(method.paymentMethodExternalId){
            case PaysafeMethodId.Paypal:
                return new SavedPayPalMethod(_extends$1({}, baseProps, {
                    email: email,
                    name: name
                }));
            case PaysafeMethodId.Skrill:
                return new SavedSkrillMethod(_extends$1({}, baseProps, {
                    email: email,
                    name: name
                }));
            case PaysafeMethodId.Card:
                return new SavedCardMethod(_extends$1({}, baseProps, {
                    card: card
                }));
            case PaysafeMethodId.PayByBank:
                return new SavedPayByBankMethod(_extends$1({}, baseProps, {
                    bankAccount: method
                }));
            default:
                return new SavedCardMethod(_extends$1({}, baseProps, {
                    card: card
                }));
        }
    }
}

class PaymongoRedirectListenerInstance extends ProxyListenerInstance {
    openWindow(url, redirectUrl, customWindow = null) {
        if (!customWindow) {
            this.currentWindow = window.open(url, 'popupWindow', 'width=1200,height=800,left=200,top=100');
            this.currentWindow.focus();
        } else {
            this.currentWindow = customWindow;
        }
        this.currentUrl = new URL(url);
        this.redirectUrl = new URL(redirectUrl);
        return new Promise((resolve)=>{
            const listener = (event)=>{
                var _this_redirectUrl;
                if (event.origin !== ((_this_redirectUrl = this.redirectUrl) == null ? void 0 : _this_redirectUrl.origin)) {
                    // Security check: Ensure the message is from the expected origin
                    return;
                }
                const data = typeof event.data === 'object' ? event.data : {};
                const hrefParams = getUrlParamsAsObject(data == null ? void 0 : data.href) || {};
                const intentId = hrefParams == null ? void 0 : hrefParams.payment_intent_id;
                data.status = (hrefParams == null ? void 0 : hrefParams.status) === "2" ? ERedirectStatus.Pending : ERedirectStatus.Fail;
                data.transactionID = intentId;
                if (commonSuccessCondition(event.data)) {
                    var // The expected message has been received
                    _this_currentWindow;
                    (_this_currentWindow = this.currentWindow) == null ? void 0 : _this_currentWindow.close();
                    resolve(data);
                    window.removeEventListener('message', listener);
                }
            };
            window.addEventListener('message', listener);
            this.checkIfWindowClosed(listener, resolve);
        });
    }
}
class PayMayaRedirectListenerInstance extends ProxyListenerInstance {
    openWindow(url, redirectUrl, customWindow = null) {
        if (!customWindow) {
            this.currentWindow = window.open(url, 'popupWindow', 'width=1200,height=800,left=200,top=100');
            this.currentWindow.focus();
        } else {
            this.currentWindow = customWindow;
        }
        this.currentUrl = new URL(url);
        this.redirectUrl = new URL(redirectUrl);
        return new Promise((resolve)=>{
            const listener = (event)=>{
                var _this_redirectUrl;
                if (event.origin !== ((_this_redirectUrl = this.redirectUrl) == null ? void 0 : _this_redirectUrl.origin)) {
                    // Security check: Ensure the message is from the expected origin
                    return;
                }
                if (commonSuccessCondition(event.data)) {
                    var _this_currentWindow;
                    const data = typeof event.data === 'object' ? event.data : {};
                    const hrefParams = getUrlParamsAsObject(data == null ? void 0 : data.href) || {};
                    data.status = (hrefParams == null ? void 0 : hrefParams.status) === "2" ? ERedirectStatus.Pending : ERedirectStatus.Fail;
                    (_this_currentWindow = this.currentWindow) == null ? void 0 : _this_currentWindow.close();
                    resolve(data);
                    window.removeEventListener('message', listener);
                }
            };
            window.addEventListener('message', listener);
            this.checkIfWindowClosed(listener, resolve, {
                status: ERedirectStatus.Pending,
                href: '',
                transactionID: '',
                origin: 'paymentsCallback',
                txState: 'pending'
            });
        });
    }
}
const PaymongoListener = new PaymongoRedirectListenerInstance();
const PayMayaListener = new PayMayaRedirectListenerInstance();

const paymongoRedirectMessages = ()=>{
    const messages = {
        [ERedirectStatus.Fail]: {
            specificMessage: translate('galleon.error.description'),
            specificTitle: translate('galleon.error.top-up.title')
        }
    };
    return _extends$1({}, specificRedirectMessages(), messages);
};
class BasePaymongoMethod extends BaseRedirectCorexMethod {
    get corexGateway() {
        var _GatewayRegistry_getCorexAdaptedGateway;
        return (_GatewayRegistry_getCorexAdaptedGateway = GatewayRegistry.getCorexAdaptedGateway(GatewayType.Paymongo)) == null ? void 0 : _GatewayRegistry_getCorexAdaptedGateway.corexService;
    }
    get methodLabel() {
        return capitalize(this.paymentMethodExternalId || '');
    }
    get flowType() {
        return EMethodFlowType.RedirectPopup;
    }
    constructor(...args){
        super(...args), this.specificMessages = paymongoRedirectMessages();
    }
}

class BasePaymongoRedirectMethod extends BasePaymongoMethod {
    async processDeposit(result, config) {
        var _AppState_wallet_profile, _AppState_wallet_profile1;
        const billingAddress = (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile.billingAddress;
        const customer = (_AppState_wallet_profile1 = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile1.customer;
        const specificParams = {
            amount: result.amount,
            returnUrl: this.redirectBaseUrl,
            currencyCode: this.currencyCode,
            externalPaymentMethodId: this.paymentMethodExternalId,
            billingDetails: {
                addressLine1: billingAddress == null ? void 0 : billingAddress.street,
                addressLine2: billingAddress == null ? void 0 : billingAddress.street2,
                city: billingAddress == null ? void 0 : billingAddress.city,
                country: billingAddress == null ? void 0 : billingAddress.country,
                postalCode: billingAddress == null ? void 0 : billingAddress.zip,
                state: billingAddress == null ? void 0 : billingAddress.state
            },
            customerDetails: {
                email: customer == null ? void 0 : customer.email,
                name: customer == null ? void 0 : customer.firstName,
                phone: customer == null ? void 0 : customer.phone
            }
        };
        this.logAttempt(result.amount);
        const launchResult = await this.corexGateway.launchDeposit(config, specificParams);
        if (launchResult.redirectUrl) {
            result.success = true;
            result.buttonUrl = launchResult.redirectUrl;
            result.popupUrl = this.redirectBaseUrl;
        }
        return result;
    }
    createIframeContent(launchDepositResult) {
        const iframeElement = this.flowType === EDevcodeMethodFlowType.NestedIframe ? createCloseIframeDialog(launchDepositResult.buttonUrl, false) : null;
        return iframeElement;
    }
    async getRedirectWindowResult(launchDepositResult, customWindow) {
        const redirectResult = await PaymongoListener.openWindow(launchDepositResult.buttonUrl, launchDepositResult.popupUrl, customWindow);
        if (redirectResult) {
            redirectResult.txState = this.paymentMethodExternalId;
        }
        return redirectResult;
    }
}

var PaymentIntentStatus = /*#__PURE__*/ function(PaymentIntentStatus) {
    PaymentIntentStatus["Succeeded"] = "succeeded";
    PaymentIntentStatus["RequiresPaymentMethod"] = "requires_payment_method";
    PaymentIntentStatus["RequiresConfirmation"] = "requires_confirmation";
    PaymentIntentStatus["RequiresAction"] = "requires_action";
    PaymentIntentStatus["AwaitingNextAction"] = "awaiting_next_action";
    PaymentIntentStatus["AwaitingPaymentMethod"] = "awaiting_payment_method";
    PaymentIntentStatus["Processing"] = "processing";
    PaymentIntentStatus["Canceled"] = "canceled";
    return PaymentIntentStatus;
}({});
var ActionType = /*#__PURE__*/ function(ActionType) {
    ActionType["Redirect"] = "redirect";
    return ActionType;
}({});

// Mapping from PaymentIntentStatus to ERedirectStatus
({
    [PaymentIntentStatus.Succeeded]: ERedirectStatus.Pending,
    [PaymentIntentStatus.RequiresPaymentMethod]: ERedirectStatus.Fail,
    [PaymentIntentStatus.RequiresConfirmation]: ERedirectStatus.Fail,
    [PaymentIntentStatus.RequiresAction]: ERedirectStatus.Fail,
    [PaymentIntentStatus.Processing]: ERedirectStatus.Fail,
    [PaymentIntentStatus.AwaitingPaymentMethod]: ERedirectStatus.Fail,
    [PaymentIntentStatus.AwaitingNextAction]: ERedirectStatus.Fail,
    [PaymentIntentStatus.Canceled]: ERedirectStatus.Fail
});
var InstapayBankCodes = /*#__PURE__*/ function(InstapayBankCodes) {
    InstapayBankCodes["BPI"] = "BOPIPHMMXXX";
    InstapayBankCodes["BDO"] = "BNORPHMMXXX";
    InstapayBankCodes["LANDBANK"] = "TLBPPHMMXXX";
    InstapayBankCodes["METROBANK"] = "MBTCPHMMXXX";
    InstapayBankCodes["UNIONBANK"] = "UBPHPHMMXXX";
    InstapayBankCodes["PAYMAYA"] = "PAPHPHM1XXX";
    InstapayBankCodes["GRABPAY"] = "GHPESGSGXXX";
    InstapayBankCodes["GCASH"] = "GXCHPHM2XXX";
    return InstapayBankCodes;
}({});

const validationGroups = {
    TEN_OR_TWELVE_DIGITS: {
        bankCodes: [
            InstapayBankCodes.BPI,
            InstapayBankCodes.BDO,
            InstapayBankCodes.LANDBANK
        ],
        validator: (value)=>[
                10,
                12
            ].includes(value.length),
        message: ()=>createMessage(translate('galleon.withdraw.account.number.error.length-or'), {
                first: 10,
                second: 12
            })
    },
    TWELVE_DIGITS_ONLY: {
        bankCodes: [
            InstapayBankCodes.METROBANK,
            InstapayBankCodes.UNIONBANK
        ],
        validator: (value)=>value.length === 12,
        message: ()=>createMessage(translate('galleon.withdraw.account.number.error.length-exact'), {
                digits: 12
            })
    },
    MOBILE_WALLET: {
        bankCodes: [
            InstapayBankCodes.PAYMAYA,
            InstapayBankCodes.GRABPAY,
            InstapayBankCodes.GCASH
        ],
        validator: (value)=>value.length === 11 && value.startsWith('09'),
        message: ()=>createMessage(translate('galleon.withdraw.account.number.error.mobile-format'), {
                digits: 11,
                prefix: '09'
            })
    },
    DEFAULT: {
        maxLength: 12,
        validator: (value)=>value.length > 0 && value.length <= 12,
        message: (maxLength)=>createMessage(translate('galleon.withdraw.account.number.error.max-length'), {
                max: maxLength
            })
    }
};
function createMessage(template, replacements) {
    let message = template;
    for(const key in replacements){
        message = message.replace(`{${key}}`, String(replacements[key]));
    }
    return message;
}
function createConditionalValidator(name, group, bankDetailsField) {
    return {
        name,
        fn: (value, formData)=>{
            var _formData_bankDetailsField;
            const bankCode = (_formData_bankDetailsField = formData[bankDetailsField]) == null ? void 0 : _formData_bankDetailsField.value;
            if (!bankCode || !group.bankCodes.includes(bankCode)) {
                return true;
            }
            // If the bank is in the group, run its specific validator.
            return group.validator(String(value || ''));
        },
        message: group.message()
    };
}

const bankDetailsFieldName = 'bankDetails';
function getBankListFormConfig(prealodedData) {
    var _prealodedData_banks_, _prealodedData_banks;
    const formFooter = document.createElement('div');
    formFooter.innerHTML = getDetailsFooter();
    return [
        {
            path: '1',
            components: [
                {
                    id: 'bankDetailsWrapper',
                    component: 'magic-ui-form-field',
                    isDataField: false,
                    properties: {
                        label: translate('galleon.withdraw.bank.name.label')
                    },
                    children: [
                        {
                            id: bankDetailsFieldName,
                            component: 'magic-ui-dropdown',
                            isDataField: true,
                            type: 'text',
                            testId: bankDetailsFieldName,
                            validationDisplay: ValidationDisplay.OnTouchShowMessage,
                            properties: {
                                placeholder: translate('galleon.input.placeholder'),
                                value: prealodedData == null ? void 0 : (_prealodedData_banks = prealodedData.banks) == null ? void 0 : (_prealodedData_banks_ = _prealodedData_banks[0]) == null ? void 0 : _prealodedData_banks_.bankCode
                            },
                            validation: [
                                {
                                    name: 'required',
                                    fn: (value)=>required(value),
                                    message: translate('galleon.withdraw.bank.name.required')
                                }
                            ],
                            preloadProperties: function() {
                                const bankList = (prealodedData == null ? void 0 : prealodedData.banks) || [];
                                const dropdownOptions = bankList.map(({ bankAccountName, bankCode })=>({
                                        name: bankAccountName,
                                        value: bankCode
                                    }));
                                return {
                                    options: dropdownOptions
                                };
                            },
                            converter: (formValue)=>{
                                var _bankList_find;
                                const bankList = (prealodedData == null ? void 0 : prealodedData.banks) || [];
                                const codeValue = formValue[bankDetailsFieldName].value;
                                return {
                                    accountName: (_bankList_find = bankList.find((value)=>value.bankCode === codeValue)) == null ? void 0 : _bankList_find.bankAccountName,
                                    code: codeValue
                                };
                            }
                        }
                    ]
                },
                {
                    id: 'accountNumber',
                    component: 'magic-ui-form-field',
                    isDataField: true,
                    type: 'text',
                    testId: 'accountNumber',
                    validationDisplay: ValidationDisplay.OnTouchShowMessage,
                    properties: {
                        placeholder: translate('galleon.input.placeholder'),
                        label: translate('galleon.withdraw.account.number.label'),
                        type: 'number'
                    },
                    validation: [
                        {
                            name: 'required',
                            fn: (value)=>required(value),
                            message: translate('galleon.withdraw.account.number.required')
                        },
                        createConditionalValidator('is-valid-ten-or-twelve-digits', validationGroups.TEN_OR_TWELVE_DIGITS, bankDetailsFieldName),
                        createConditionalValidator('is-valid-twelve-digits', validationGroups.TWELVE_DIGITS_ONLY, bankDetailsFieldName),
                        createConditionalValidator('is-valid-mobile-wallet', validationGroups.MOBILE_WALLET, bankDetailsFieldName),
                        {
                            name: 'is-valid-accountNumber',
                            fn: (value)=>maxLength(12)(value),
                            message: validationGroups.DEFAULT.message(12)
                        }
                    ]
                }
            ],
            footer: formFooter
        }
    ];
}

var _formBuilder$4 = /*#__PURE__*/ _class_private_field_loose_key("_formBuilder");
class PaymongoBankTransferMethod extends BasePaymongoRedirectMethod {
    get methodLabel() {
        return capitalize(this.paymentMethodExternalId);
    }
    async withdraw(amount) {
        var _preLaunchData_banks;
        this.logAttempt(amount);
        const preLaunchData = await this.corexGateway.payment.preLaunch({
            currencyCode: this.currencyCode,
            externalPaymentMethodId: this.paymentMethodExternalId
        }, this.corexGateway.providerType);
        if (!((_preLaunchData_banks = preLaunchData.banks) == null ? void 0 : _preLaunchData_banks.length)) {
            console.error(`There are no any banks available for paymongo withdrawal ${this.paymentMethodExternalId} payment method`);
            const result = {
                success: false,
                transactionID: '',
                amount: amount,
                currencyCode: this.currencyCode,
                paymentMethod: this.paymentMethodExternalId
            };
            this.logPayment(result);
            createWithdrawStatusScreen(result);
            return result;
        }
        const formResult = await createFormScreen({
            amount,
            formBuilder: _class_private_field_loose_base(this, _formBuilder$4)[_formBuilder$4],
            formConfig: getBankListFormConfig(preLaunchData)
        });
        const content = getCurrentTab();
        const submitBtn = content.querySelector('.details__confirm-button');
        submitBtn == null ? void 0 : submitBtn.setAttribute('loading', 'true');
        this.logAttempt(amount);
        const launchResult = await this.corexGateway.launchWithdraw({
            currencyCode: this.currencyCode,
            externalPaymentMethodId: this.paymentMethodExternalId,
            amount: amount,
            bankDetails: {
                accountName: formResult == null ? void 0 : formResult.accountName,
                accountNumber: formResult == null ? void 0 : formResult.accountNumber,
                code: formResult == null ? void 0 : formResult.code
            }
        });
        const result = {
            success: !!(launchResult == null ? void 0 : launchResult.transactionId),
            transactionID: launchResult == null ? void 0 : launchResult.transactionId,
            amount: amount,
            currencyCode: this.currencyCode,
            paymentMethod: this.paymentMethodExternalId
        };
        const { message, title } = this.getWaitingForApprovalStatusMessage();
        this.logPayment(result);
        createWithdrawStatusScreen(result, message, result.success ? title : undefined);
        return result;
    }
    constructor(...args){
        super(...args), Object.defineProperty(this, _formBuilder$4, {
            writable: true,
            value: void 0
        }), _class_private_field_loose_base(this, _formBuilder$4)[_formBuilder$4] = new FormBuilder();
    }
}

class BasePaymongoIntentStatusMethod extends BasePaymongoRedirectMethod {
    get paymongoGateway() {
        return GatewayRegistry.getCorexAdaptedGateway(GatewayType.Paymongo);
    }
    async processDeposit(result, config) {
        var _AppState_wallet_profile, _AppState_wallet_profile1;
        this.intentData = null;
        const billingAddress = (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile.billingAddress;
        const customer = (_AppState_wallet_profile1 = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile1.customer;
        const specificParams = {
            amount: result.amount,
            returnUrl: this.redirectBaseUrl,
            currencyCode: this.currencyCode,
            externalPaymentMethodId: this.paymentMethodExternalId,
            billingDetails: {
                addressLine1: billingAddress == null ? void 0 : billingAddress.street,
                addressLine2: billingAddress == null ? void 0 : billingAddress.street2,
                city: billingAddress == null ? void 0 : billingAddress.city,
                country: billingAddress == null ? void 0 : billingAddress.country,
                postalCode: billingAddress == null ? void 0 : billingAddress.zip,
                state: billingAddress == null ? void 0 : billingAddress.state
            },
            customerDetails: {
                email: customer == null ? void 0 : customer.email,
                name: customer == null ? void 0 : customer.firstName,
                phone: customer == null ? void 0 : customer.phone
            }
        };
        this.logAttempt(result.amount);
        const launchResult = await this.corexGateway.launchDeposit(config, specificParams);
        if (launchResult.redirectUrl) {
            result.success = true;
            result.buttonUrl = launchResult.redirectUrl;
            result.popupUrl = this.redirectBaseUrl;
        }
        this.intentData = launchResult;
        return result;
    }
    async getRedirectWindowResult(launchDepositResult, customWindow) {
        const redirectResult = await PaymongoListener.openWindow(launchDepositResult.buttonUrl, launchDepositResult.popupUrl, customWindow);
        if (redirectResult) {
            var _this_paymongoGateway_config_corex_paymongo, _this_paymongoGateway_config_corex, _this_paymongoGateway_config;
            redirectResult.txState = this.paymentMethodExternalId;
            // call paymongo directly to know the transaction status
            if (this.intentData && ((_this_paymongoGateway_config = this.paymongoGateway.config) == null ? void 0 : (_this_paymongoGateway_config_corex = _this_paymongoGateway_config.corex) == null ? void 0 : (_this_paymongoGateway_config_corex_paymongo = _this_paymongoGateway_config_corex.paymongo) == null ? void 0 : _this_paymongoGateway_config_corex_paymongo.publicKey)) {
                var _paymongoIntentData_data, _paymentIntentAttributes_next_action;
                setLoading(true);
                const paymongoIntentData = await this.getPaymongoIntentData();
                setLoading(false);
                const paymentIntentAttributes = paymongoIntentData == null ? void 0 : (_paymongoIntentData_data = paymongoIntentData.data) == null ? void 0 : _paymongoIntentData_data.attributes;
                if (!((paymentIntentAttributes == null ? void 0 : paymentIntentAttributes.status) === PaymentIntentStatus.AwaitingNextAction && (paymentIntentAttributes == null ? void 0 : (_paymentIntentAttributes_next_action = paymentIntentAttributes.next_action) == null ? void 0 : _paymentIntentAttributes_next_action.type) === ActionType.Redirect)) {
                    redirectResult.status = (paymentIntentAttributes == null ? void 0 : paymentIntentAttributes.status) === PaymentIntentStatus.Succeeded ? ERedirectStatus.Pending : ERedirectStatus.Fail;
                }
            } else {
                console.error('the paymongo intent data or public key is missing');
            }
        }
        return redirectResult;
    }
    async getPaymongoIntentData() {
        return await this.paymongoGateway.getPaymentIntent({
            intentId: this.intentData.externalPaymentIntentId,
            clientKey: this.intentData.externalPaymentClientKey,
            publicKey: this.paymongoGateway.config.corex.paymongo.publicKey
        });
    }
    constructor(...args){
        super(...args), this.intentData = null;
    }
}

class PaymongoQRCodeMethod extends BasePaymongoIntentStatusMethod {
    get methodLabel() {
        return capitalize(this.paymentMethodExternalId);
    }
    async processDeposit(result, config) {
        var _AppState_wallet_profile, _AppState_wallet_profile1;
        const billingAddress = (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile.billingAddress;
        const customer = (_AppState_wallet_profile1 = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile1.customer;
        const specificParams = {
            amount: result.amount,
            returnUrl: this.redirectBaseUrl,
            currencyCode: this.currencyCode,
            externalPaymentMethodId: this.paymentMethodExternalId,
            billingDetails: {
                addressLine1: billingAddress == null ? void 0 : billingAddress.street,
                addressLine2: billingAddress == null ? void 0 : billingAddress.street2,
                city: billingAddress == null ? void 0 : billingAddress.city,
                country: billingAddress == null ? void 0 : billingAddress.country,
                postalCode: billingAddress == null ? void 0 : billingAddress.zip,
                state: billingAddress == null ? void 0 : billingAddress.state
            },
            customerDetails: {
                email: customer == null ? void 0 : customer.email,
                name: customer == null ? void 0 : customer.firstName,
                phone: customer == null ? void 0 : customer.phone
            }
        };
        const prevBalance = AppState.wallet.balanceData.balance;
        this.logAttempt(result.amount);
        const launchResult = await this.corexGateway.launchDeposit(config, specificParams);
        if (launchResult.imageUrl) {
            result.buttonUrl = launchResult.imageUrl;
            result.popupUrl = this.redirectBaseUrl;
            createClosedQRPHCodeImageDialog(result.buttonUrl);
        }
        this.intentData = launchResult;
        var _getCurrentTab;
        const content = (_getCurrentTab = getCurrentTab()) != null ? _getCurrentTab : document.createElement('div');
        const iframeContainer = content.querySelector(`.status-screen__container`);
        // Return a promise that resolves when either the interval condition is met or timeout occurs
        return new Promise((resolve)=>{
            const interval = setInterval(()=>{
                if (AppState.wallet.balanceData.balance === prevBalance) {
                    return;
                }
                if (!iframeContainer) {
                    clearInterval(interval);
                }
                this.getPaymongoIntentData().then((intentData)=>{
                    if (intentData) {
                        const status = intentData.data.attributes.status;
                        if (status === PaymentIntentStatus.AwaitingNextAction || status === PaymentIntentStatus.Processing) {
                            return;
                        }
                        if (status === PaymentIntentStatus.Succeeded) {
                            result.success = true;
                            result.transactionID = intentData.data.id;
                            this.showDepositResult(result);
                        } else if (status === PaymentIntentStatus.Canceled) {
                            result.success = false;
                            createDepositStatusScreen(result);
                            this.logPayment(result);
                        }
                        clearInterval(interval);
                        // Resolve the promise with the updated result
                        resolve(result);
                    }
                }).catch((error)=>{
                    console.error('Error fetching intent data:', error);
                });
            }, 5000);
            // Set a timeout to clear the interval after 30 minutes
            const mins30 = 30 * 60 * 1000;
            setTimeout(()=>{
                if (iframeContainer) {
                    clearInterval(interval);
                    result.success = false;
                    createDepositStatusScreen(result);
                    this.logPayment(result);
                }
                // Always resolve the promise after timeout, even if the interval condition wasn't met
                resolve(result);
            }, mins30);
        });
    }
    async showDepositResult(launchDepositResult) {
        const depositResultData = {
            amount: launchDepositResult.amount,
            currencyCode: this.currencyCode,
            success: launchDepositResult.success,
            paymentMethod: this.paymentMethodExternalId,
            paymentMethodLabel: this.methodLabel
        };
        if (!launchDepositResult.success) {
            this.logPayment(depositResultData);
            createDepositStatusScreen(depositResultData);
            return;
        }
        createDepositStatusScreen(depositResultData);
    }
}

/**
 * @packageDocumentation
 * Paymongo Dob Direct Method
 */ class PaymongoDobDirectMethod extends BasePaymongoIntentStatusMethod {
    async getRedirectWindowResult(launchDepositResult, customWindow) {
        const redirectResult = await PaymongoListener.openWindow(launchDepositResult.buttonUrl, launchDepositResult.popupUrl, customWindow);
        if (redirectResult) {
            redirectResult.txState = this.paymentMethodExternalId;
            redirectResult.status = ERedirectStatus.Pending;
        }
        return redirectResult;
    }
    async intentCall() {
        let paymongoIntentData;
        setLoading(true);
        try {
            paymongoIntentData = await this.paymongoGateway.getPaymentIntent({
                intentId: this.intentData.externalPaymentIntentId,
                clientKey: this.intentData.externalPaymentClientKey,
                publicKey: this.paymongoGateway.config.corex.paymongo.publicKey
            });
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
        return paymongoIntentData;
    }
}

class PaymongoUbpMethod extends PaymongoDobDirectMethod {
    get flowType() {
        return EMethodFlowType.RedirectPopup;
    }
}

class PaymayaMethod extends BasePaymongoIntentStatusMethod {
    get flowType() {
        return EMethodFlowType.RedirectPopup;
    }
    async getRedirectWindowResult(launchDepositResult, customWindow) {
        const redirectResult = await PayMayaListener.openWindow(launchDepositResult.buttonUrl, launchDepositResult.popupUrl, customWindow);
        if (redirectResult) {
            var _this_paymongoGateway_config_corex_paymongo, _this_paymongoGateway_config_corex, _this_paymongoGateway_config;
            redirectResult.txState = this.paymentMethodExternalId;
            // call paymongo directly to know the transaction status
            if (this.intentData && ((_this_paymongoGateway_config = this.paymongoGateway.config) == null ? void 0 : (_this_paymongoGateway_config_corex = _this_paymongoGateway_config.corex) == null ? void 0 : (_this_paymongoGateway_config_corex_paymongo = _this_paymongoGateway_config_corex.paymongo) == null ? void 0 : _this_paymongoGateway_config_corex_paymongo.publicKey)) {
                var _paymongoIntentData_data, _paymentIntentAttributes_next_action;
                setLoading(true);
                const paymongoIntentData = await this.getPaymongoIntentData();
                setLoading(false);
                const paymentIntentAttributes = paymongoIntentData == null ? void 0 : (_paymongoIntentData_data = paymongoIntentData.data) == null ? void 0 : _paymongoIntentData_data.attributes;
                if (!((paymentIntentAttributes == null ? void 0 : paymentIntentAttributes.status) === PaymentIntentStatus.AwaitingNextAction && (paymentIntentAttributes == null ? void 0 : (_paymentIntentAttributes_next_action = paymentIntentAttributes.next_action) == null ? void 0 : _paymentIntentAttributes_next_action.type) === ActionType.Redirect)) {
                    redirectResult.status = (paymentIntentAttributes == null ? void 0 : paymentIntentAttributes.status) === PaymentIntentStatus.Succeeded ? ERedirectStatus.Pending : ERedirectStatus.Pending; // workaround to fix PROD issue for mobile (GWP-9055)
                }
            } else {
                console.error('the paymongo intent data or public key is missing');
            }
        }
        return redirectResult;
    }
}

/**
 * @packageDocumentation
 * Paymongo Factory Instance
 */ class PaymongoFactoryInstance {
    createPaymentMethod(method) {
        const baseProps = {
            provider: ProviderType.Paymongo,
            id: method.id,
            title: isMagicPaymentMethod(method) ? getMagicPaymentMethodNameByLanguage(method, AppState.wallet.locale || 'en') : method.name,
            minAmount: method.minAmount,
            maxAmount: method.maxAmount,
            currencyCode: method.currencyCode,
            paymentMethodExternalId: method.paymentMethodExternalId,
            paymentType: method.paymentType,
            position: isMagicPaymentMethod(method) ? method.position : undefined,
            logoUrl: isMagicPaymentMethod(method) ? getMagicPaymentMethodLogoByMarket(method, AppState.wallet.locale || 'en') : ''
        };
        switch(method.paymentMethodExternalId){
            case PaymongoMethodId.Metrobank:
            case PaymongoMethodId.Landbank:
                return new PaymongoBankTransferMethod(baseProps);
            case PaymongoMethodId.BDO:
                return new BasePaymongoIntentStatusMethod(baseProps);
            case PaymongoMethodId.Grabpay:
                return new BasePaymongoIntentStatusMethod(baseProps);
            case PaymongoMethodId.Paymaya:
                return new PaymayaMethod(baseProps);
            case PaymongoMethodId.Instapay:
                return new PaymongoBankTransferMethod(baseProps);
            case PaymongoMethodId.Pesonet:
                return new PaymongoBankTransferMethod(baseProps);
            case PaymongoMethodId.Qrph:
                return new PaymongoQRCodeMethod(baseProps);
            case PaymongoMethodId.Bpi:
            case PaymongoMethodId.TestBpi:
                return new PaymongoDobDirectMethod(baseProps);
            case PaymongoMethodId.TestUbp:
            case PaymongoMethodId.Ubp:
                return new PaymongoUbpMethod(baseProps);
            default:
                return new BasePaymongoIntentStatusMethod(baseProps);
        }
    }
}
const PaymongoFactory = new PaymongoFactoryInstance();

class SolairepayRedirectListenerInstance extends ProxyListenerInstance {
    openWindow(url, redirectUrl, customWindow = null) {
        if (!customWindow) {
            this.currentWindow = window.open(url, 'popupWindow', 'width=1200,height=800,left=200,top=100');
            this.currentWindow.focus();
        } else {
            this.currentWindow = customWindow;
        }
        this.currentUrl = new URL(url);
        this.redirectUrl = new URL(redirectUrl);
        return new Promise((resolve)=>{
            const listener = (event)=>{
                var _this_redirectUrl;
                if (event.origin !== ((_this_redirectUrl = this.redirectUrl) == null ? void 0 : _this_redirectUrl.origin)) {
                    // Security check: Ensure the message is from the expected origin
                    return;
                }
                const data = typeof event.data === 'object' ? event.data : {};
                data.status = ERedirectStatus.Pending;
                if (commonSuccessCondition(event.data)) {
                    var // The expected message has been received
                    _this_currentWindow;
                    (_this_currentWindow = this.currentWindow) == null ? void 0 : _this_currentWindow.close();
                    resolve(_extends$1({}, data, {
                        status: ERedirectStatus.Pending
                    }));
                    window.removeEventListener('message', listener);
                }
            };
            window.addEventListener('message', listener);
            this.checkIfWindowClosed(listener, resolve, {
                status: ERedirectStatus.Pending,
                href: '',
                transactionID: '',
                origin: 'paymentsCallback',
                txState: 'pending'
            });
        });
    }
}
const SolairepayListener = new SolairepayRedirectListenerInstance();

const SuccessSolairePayStatuses = [
    "PENDING",
    "SUCCESS"
];

const customRedirectMessages = ()=>{
    const messages = {};
    return _extends$1({}, specificRedirectMessages(), messages);
};
class BaseSolairepayMethod extends BaseRedirectCorexMethod {
    get corexGateway() {
        var _GatewayRegistry_getCorexAdaptedGateway;
        return (_GatewayRegistry_getCorexAdaptedGateway = GatewayRegistry.getCorexAdaptedGateway(GatewayType.Solairepay)) == null ? void 0 : _GatewayRegistry_getCorexAdaptedGateway.corexService;
    }
    get methodLabel() {
        return capitalize(this.paymentMethodExternalId || '');
    }
    get mainGateway() {
        return GatewayRegistry.getCorexAdaptedGateway(GatewayType.Solairepay);
    }
    constructor(...args){
        super(...args), this.specificMessages = customRedirectMessages();
    }
}

class BaseSolairepayRedirectMethod extends BaseSolairepayMethod {
    async processDeposit(result, config) {
        var _AppState_wallet_profile;
        this.statusData = null;
        const customer = (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile.customer;
        const specificParams = {
            amount: result.amount,
            currencyCode: this.currencyCode,
            externalPaymentMethodId: this.paymentMethodExternalId,
            context: 'deposit',
            redirectUrl: this.redirectFallBackUrl,
            phoneNumber: (customer == null ? void 0 : customer.phone) || '',
            email: (customer == null ? void 0 : customer.email) || '',
            firstName: customer == null ? void 0 : customer.firstName,
            lastName: customer == null ? void 0 : customer.lastName
        };
        if (customer == null ? void 0 : customer.middleName) {
            specificParams.middleName = customer == null ? void 0 : customer.middleName;
        }
        this.logAttempt(result.amount);
        const launchResult = await this.corexGateway.launchDeposit(config, specificParams);
        if (launchResult.redirectUrl) {
            result.success = true;
            result.buttonUrl = launchResult.redirectUrl;
            result.popupUrl = this.redirectFallBackUrl;
        }
        this.statusData = launchResult;
        return result;
    }
    createIframeContent(launchDepositResult) {
        const iframeElement = this.flowType === EDevcodeMethodFlowType.NestedIframe ? createCloseIframeDialog(launchDepositResult.buttonUrl, false) : null;
        return iframeElement;
    }
    async getRedirectWindowResult(launchDepositResult, customWindow) {
        const redirectResult = await SolairepayListener.openWindow(launchDepositResult.buttonUrl, launchDepositResult.popupUrl, customWindow);
        if (redirectResult) {
            var _this_corexGateway_config_solairepay, _this_corexGateway_config;
            redirectResult.txState = this.paymentMethodExternalId;
            if (this.statusData && ((_this_corexGateway_config = this.corexGateway.config) == null ? void 0 : (_this_corexGateway_config_solairepay = _this_corexGateway_config.solairepay) == null ? void 0 : _this_corexGateway_config_solairepay.apiKey)) {
                setLoading(true);
                const statusData = await this.getSolairepayStatusData();
                setLoading(false);
                redirectResult.status = SuccessSolairePayStatuses.includes(statusData == null ? void 0 : statusData.status) ? ERedirectStatus.Pending : ERedirectStatus.Pending; // workaround to fix the PROD issue for mobile GCash (GWP-9055)
            } else {
                console.error('the Solairepay intent data or public key is missing');
            }
        }
        return redirectResult;
    }
    get flowType() {
        return EMethodFlowType.RedirectPopup;
    }
    async getSolairepayStatusData() {
        return await this.mainGateway.getTransactionStatusData({
            correlationId: this.statusData.correlationId || ''
        });
    }
    get redirectFallBackUrl() {
        const fallBackButtonText = translate('galleon.redirect.fall-back.button.label');
        return `${this.redirectBaseUrl}?back-button-text=${fallBackButtonText}`;
    }
    constructor(...args){
        super(...args), this.statusData = null;
    }
}

function isPhoneNumber(value) {
    if (value === null || value === undefined) {
        return false;
    }
    const trimmedValue = value.trim();
    if (trimmedValue === '') {
        return false;
    }
    const cleaned = trimmedValue.replace(/[\s\-().]/g, '');
    const phoneRegex = /^\+?\d+$/;
    if (!phoneRegex.test(cleaned)) {
        return false; // Contains invalid characters (letters, multiple '+', etc.)
    }
    const digits = cleaned.startsWith('+') ? cleaned.substring(1) : cleaned;
    const minLength = 6; // Very permissive minimum length
    const maxLength = 15; // Common upper limit for international numbers (E.164)
    if (digits.length < minLength || digits.length > maxLength) {
        return false;
    }
    return true;
}

/**
 * Generates the form configuration for GCash payment details.
 *
 * @param params - Pre-filled customer data (phone, email, name).
 * @returns An array of form builder step configurations for GCash.
 */ function gcashFormConfig(params) {
    const formFooter = document.createElement('div');
    formFooter.innerHTML = getDetailsFooter();
    return [
        {
            path: '1',
            components: [
                emailField(params.email),
                {
                    id: 'phoneNumber',
                    component: 'magic-ui-form-field',
                    isDataField: true,
                    type: 'text',
                    testId: 'phoneNumber',
                    validationDisplay: ValidationDisplay.OnTouchShowMessage,
                    properties: {
                        type: 'text',
                        placeholder: translate('galleon.input.placeholder'),
                        label: translate('galleon.customer.phone.number.label'),
                        value: params.phoneNumber || '',
                        readonly: true
                    },
                    validation: [
                        {
                            name: 'is-valid-phone',
                            fn: (value)=>isPhoneNumber(value),
                            message: translate('galleon.customer.phone.number.error')
                        }
                    ]
                },
                {
                    id: 'firstName',
                    component: 'magic-ui-form-field',
                    isDataField: true,
                    type: 'text',
                    testId: 'firstName',
                    validationDisplay: ValidationDisplay.OnTouchShowMessage,
                    properties: {
                        placeholder: translate('galleon.input.placeholder'),
                        label: translate('galleon.customer.first-name.label'),
                        value: params.firstName || ''
                    },
                    validation: [
                        {
                            name: 'required',
                            fn: (value)=>required(value),
                            message: translate('galleon.customer.first-name.required')
                        }
                    ]
                },
                {
                    id: 'lastName',
                    component: 'magic-ui-form-field',
                    isDataField: true,
                    type: 'text',
                    testId: 'lastName',
                    validationDisplay: ValidationDisplay.OnTouchShowMessage,
                    properties: {
                        placeholder: translate('galleon.input.placeholder'),
                        label: translate('galleon.customer.last-name.label'),
                        value: params.lastName || ''
                    },
                    validation: [
                        {
                            name: 'required',
                            fn: (value)=>required(value),
                            message: translate('galleon.customer.last-name.required')
                        }
                    ]
                },
                {
                    id: 'accountNumber',
                    component: 'magic-ui-form-field',
                    isDataField: true,
                    testId: 'accountNumber',
                    validationDisplay: ValidationDisplay.OnTouchShowMessage,
                    properties: {
                        placeholder: translate('galleon.input.placeholder'),
                        label: translate('galleon.withdraw.account.number.label'),
                        value: '',
                        maxLength: 11,
                        type: 'number'
                    },
                    validation: [
                        {
                            name: 'required',
                            fn: (value)=>required(value),
                            message: translate('galleon.withdraw.account.number.required')
                        },
                        {
                            name: 'pattern',
                            fn: (value)=>{
                                const str = value;
                                return /^09\d{9}$/.test(str);
                            },
                            message: translate('galleon.withdraw.gcash.account.number.invalid')
                        }
                    ]
                }
            ],
            footer: formFooter
        }
    ];
}

var _formBuilder$3 = /*#__PURE__*/ _class_private_field_loose_key("_formBuilder");
class GcashMethod extends BaseSolairepayRedirectMethod {
    async withdraw(amount) {
        var _AppState_wallet_profile;
        const customer = (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile.customer;
        const formResult = await createFormScreen({
            amount,
            formBuilder: _class_private_field_loose_base(this, _formBuilder$3)[_formBuilder$3],
            formConfig: gcashFormConfig({
                phoneNumber: (customer == null ? void 0 : customer.phone) || '',
                email: (customer == null ? void 0 : customer.email) || '',
                firstName: (customer == null ? void 0 : customer.firstName) || '',
                lastName: (customer == null ? void 0 : customer.lastName) || ''
            })
        });
        const content = getCurrentTab();
        const submitBtn = content.querySelector('.details__confirm-button');
        submitBtn == null ? void 0 : submitBtn.setAttribute('loading', 'true');
        const specificParams = {
            amount: amount,
            currencyCode: this.currencyCode,
            externalPaymentMethodId: this.paymentMethodExternalId,
            context: 'withdrawal',
            phoneNumber: (formResult == null ? void 0 : formResult.phoneNumber) || '',
            email: (formResult == null ? void 0 : formResult.email) || '',
            firstName: (formResult == null ? void 0 : formResult.firstName) || '',
            lastName: (formResult == null ? void 0 : formResult.lastName) || '',
            accountNumber: (formResult == null ? void 0 : formResult.accountNumber) || ''
        };
        this.logAttempt(amount);
        const launchResult = await this.corexGateway.launchWithdraw(specificParams);
        const result = {
            success: !!(launchResult == null ? void 0 : launchResult.transactionId),
            transactionID: launchResult == null ? void 0 : launchResult.transactionId,
            amount: amount,
            currencyCode: this.currencyCode,
            paymentMethod: this.paymentMethodExternalId
        };
        const { message, title } = this.getWaitingForApprovalStatusMessage();
        this.logPayment(result);
        createWithdrawStatusScreen(result, message, result.success ? title : undefined);
        void PendingBalanceCheck.checkWithdrawalBalance(result);
        return result;
    }
    constructor(...args){
        super(...args), Object.defineProperty(this, _formBuilder$3, {
            writable: true,
            value: void 0
        }), _class_private_field_loose_base(this, _formBuilder$3)[_formBuilder$3] = new FormBuilder();
    }
}

/**
 * @packageDocumentation
 * Solairepay Factory Instance
 */ class SolairepayFactoryInstance {
    createPaymentMethod(method) {
        const baseProps = {
            provider: ProviderType.Paymongo,
            id: method.id,
            title: isMagicPaymentMethod(method) ? getMagicPaymentMethodNameByLanguage(method, AppState.wallet.locale || 'en') : method.name,
            minAmount: method.minAmount,
            maxAmount: method.maxAmount,
            currencyCode: method.currencyCode,
            paymentMethodExternalId: method.paymentMethodExternalId,
            paymentType: method.paymentType,
            position: isMagicPaymentMethod(method) ? method.position : undefined,
            logoUrl: isMagicPaymentMethod(method) ? getMagicPaymentMethodLogoByMarket(method, AppState.wallet.locale || 'en') : ''
        };
        switch(method.paymentMethodExternalId){
            case SolairepayMethodId.GCash:
                return new GcashMethod(baseProps);
            default:
                return new GcashMethod(baseProps);
        }
    }
}
const SolairepayFactory = new SolairepayFactoryInstance();

function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

class BaseApiService {
    get config() {
        return this._config;
    }
    set config(value) {
        this._config = value;
    }
    init(config) {
        this.config = config;
    }
    update(config) {
        this.config = mergeDeep(this.config, config);
        if (config == null ? void 0 : config.token) {
            this.config.token = config.token;
        }
    }
    constructor(){
        this._config = {
            token: ''
        };
    }
}

class BaseGatewayService extends BaseApiService {
    addService(serviceName, service) {
        this.services[serviceName] = service;
    }
    getService(serviceName) {
        return this.services[serviceName];
    }
    get config() {
        return this._config;
    }
    set config(value) {
        this._config = value;
    }
    init(config) {
        this.config = config;
        this.initServices(config);
    // Initialize other services...
    }
    update(config) {
        super.update(config);
        // Update config in other services
        this.updateServices(config);
    }
    initServices(config) {
        for(const serviceName in this.services){
            const service = this.getService(serviceName);
            if (service) {
                service.init(config);
            }
        }
    }
    updateServices(config) {
        for(const serviceName in this.services){
            const service = this.getService(serviceName);
            if (service) {
                service.update(config);
            }
        }
    }
    constructor(){
        super(), this.services = {} // Use a Record
        ;
        this.services = {};
    }
}

class BaseCorexService extends BaseGatewayService {
    getDepositHeaders() {
        const accessToken = `Bearer ${this.config.token}`;
        return {
            'X-tenant-ID': this.config.tenant,
            baggage: `login_session_id=${this.config.userProfileId}`,
            Authorization: accessToken
        };
    }
    getMagicWithdrawHeaders() {
        if (!this.config.magicApiToken) {
            throw new Error('magicApiToken is not provided');
        }
        const accessToken = `Bearer ${this.config.token}`;
        return {
            Authorization: accessToken,
            'x-api-key': this.config.magicApiToken
        };
    }
    async fetchMagicApi(url, method, data, headers) {
        const response = await this.fetchApi(url, method, data, headers);
        const magicRes = response;
        if (magicRes.res) {
            return magicRes.res;
        }
        return response;
    }
    async fetchApi(url, method, bodyData, overrideHeaders) {
        const headers = overrideHeaders ? overrideHeaders : this.getDepositHeaders();
        return await httpUtils.fetchApi(url, method, headers, bodyData);
    }
    getUserProfileId() {
        var _this_config;
        return (_this_config = this.config) == null ? void 0 : _this_config.userProfileId;
    }
    methodSupportsCurrency(currencyCode, method) {
        var _method_currencyCode;
        return !currencyCode || (currencyCode == null ? void 0 : currencyCode.toUpperCase()) === (method == null ? void 0 : (_method_currencyCode = method.currencyCode) == null ? void 0 : _method_currencyCode.toUpperCase());
    }
    isProvidersMethod(method, providerName = CorexProviderType.Paysafe) {
        return method.isActive && (method.mediatorId || '').toLowerCase().includes(providerName);
    }
    get providerType() {
        return this._providerType;
    }
    set providerType(value) {
        this._providerType = value;
    }
    constructor(...args){
        super(...args), this._providerType = CorexProviderType.Paysafe, this.addPaymentMethodExternalId = (method, paymentMethodExternalId, provider)=>{
            return _extends$1({}, method, {
                paymentMethodExternalId: paymentMethodExternalId,
                provider,
                methodProviderId: makeProviderMethodId(provider, paymentMethodExternalId)
            });
        };
    }
}

class CorexWithdrawalService extends BaseCorexService {
    async launchOpenLoopWithdraw(data, providerType = this.providerType) {
        if (!this.config) {
            throw new Error('Corex config not found');
        }
        const userProfileId = this.getUserProfileId();
        const { apiUrl, brand, magicApiUrl } = this.config;
        const closedLoopOnly = AppState.wallet.closedLoopOnly;
        const corexUrl = `${apiUrl}/${providerType}/v1/user-profiles/${userProfileId}/launch/withdraw`;
        const magicUrl = `${magicApiUrl}/corex/${brand}/corex/cashier-launch-withdraw`;
        const url = closedLoopOnly ? magicUrl : corexUrl;
        const headers = closedLoopOnly ? this.getMagicWithdrawHeaders() : undefined;
        return await this.fetchMagicApi(url, 'POST', data, headers);
    }
    async submitWithdraw(data, providerType = this.providerType) {
        if (!this.config) {
            throw new Error('Corex config not found');
        }
        const userProfileId = this.getUserProfileId();
        const { apiUrl, brand, magicApiUrl } = this.config;
        const closedLoopOnly = AppState.wallet.closedLoopOnly;
        const { amount, currencyCode, paymentMethod } = data;
        const requestData = _extends$1({}, data, {
            userProfileId
        });
        const corexUrl = `${apiUrl}/${providerType}/v1/user-profiles/${userProfileId}/submit`;
        const magicUrl = `${magicApiUrl}/corex/${brand}/corex/cashier-submit`;
        const { externalPaymentMethodId, sessionContextId } = requestData, restRequestFields = _object_without_properties_loose(requestData, [
            "externalPaymentMethodId",
            "sessionContextId"
        ]);
        const magicRequestData = _extends$1({
            externalPaymentMethodId: externalPaymentMethodId,
            sessionContextId: sessionContextId
        }, restRequestFields);
        const submitUrl = closedLoopOnly ? magicUrl : corexUrl;
        const resultRequestData = closedLoopOnly ? magicRequestData : requestData;
        LogEventService.logEvent({
            type: LogActionEventName.WithdrawalAttempt,
            params: {
                amount: amount,
                currency: currencyCode,
                method: paymentMethod
            }
        });
        const headers = closedLoopOnly ? this.getMagicWithdrawHeaders() : undefined;
        const response = await this.fetchApi(submitUrl, 'POST', resultRequestData, headers);
        let submitResult = response;
        const magicRes = response;
        if (magicRes.res) {
            submitResult = magicRes.res;
        }
        return {
            amount: amount,
            currencyCode: currencyCode,
            success: !!(submitResult.transactionId || submitResult.transactionID),
            transactionID: submitResult.transactionId || submitResult.transactionID || '',
            paymentMethod: paymentMethod
        };
    }
    async preLaunch(data, providerType = this.providerType) {
        const { apiUrl, brand, magicApiUrl } = this.config;
        const closedLoopOnly = AppState.wallet.closedLoopOnly;
        const userProfileId = this.getUserProfileId();
        const corexUrl = `${apiUrl}/${providerType}/v1/user-profiles/${userProfileId}/launch`;
        const magicUrl = `${magicApiUrl}/corex/${brand}/corex/cashier-launch`;
        const url = closedLoopOnly ? magicUrl : corexUrl;
        const currencyCode = AppState.wallet.balanceData.currencyCode;
        const resultData = _extends$1({
            currencyCode
        }, data);
        const headers = closedLoopOnly ? this.getMagicWithdrawHeaders() : undefined;
        const response = await this.fetchApi(url, 'POST', resultData, headers);
        const magicRes = response;
        if (magicRes.res) {
            return magicRes.res;
        }
        return response;
    }
}

class CorexDepositService extends BaseCorexService {
    async launchDeposit(data, specificData) {
        if (!this.config) {
            throw new Error('Corex config not found');
        }
        const { serviceName } = data.depositConfig;
        this.launchDepositConfig = data;
        const userProfileId = this.getUserProfileId();
        const { apiUrl } = this.config;
        const url = `${data.apiUrl || apiUrl}/${serviceName}/v1/user-profiles/${userProfileId}/launch/deposit`;
        const payloadData = this.buildLaunchDepositRequestPayload(data, specificData);
        this.launchDepositResult = await this.fetchApi(url, 'POST', payloadData);
        return this.launchDepositResult;
    }
    async depositSubmit(externalPaymentToken, externalPaymentMethodId, providerType, payload) {
        var _this_launchDepositResult, _this_launchDepositResult1;
        if (!this.config || !this.launchDepositConfig || !this.launchDepositResult) {
            throw new Error('Corex some configs not found');
        }
        const { serviceName } = this.launchDepositConfig.depositConfig;
        const provider = providerType || serviceName || this.providerType;
        const userProfileId = this.getUserProfileId() || 'userProfileId';
        const { apiUrl } = this.config;
        const config = this.launchDepositConfig;
        const bodyData = _extends$1({
            externalPaymentMethodId,
            userProfileId: userProfileId,
            sessionContextId: (_this_launchDepositResult = this.launchDepositResult) == null ? void 0 : _this_launchDepositResult.sessionContextId,
            externalUserProfileId: (_this_launchDepositResult1 = this.launchDepositResult) == null ? void 0 : _this_launchDepositResult1.externalUserProfileId,
            amount: config.paysafeConfig.amount,
            currencyCode: config.depositConfig.paymentDetails.currencyCode,
            paymentMethodExternalId: config.depositConfig.paymentDetails.externalPaymentMethodId,
            externalPaymentToken: externalPaymentToken
        }, payload);
        const url = `${config.apiUrl || apiUrl}/${provider}/v1/user-profiles/${userProfileId}/submit`;
        return await this.fetchApi(url, 'POST', bodyData);
    }
    buildLaunchDepositRequestPayload(data, specificData) {
        let payloadData = _extends$1({}, data.depositConfig.paymentDetails);
        const promoData = {};
        if (!(data == null ? void 0 : data.sweepStakesShopItemID) && AppState.wallet.depositExtraData.sweepstakesShopItemId !== '' && AppState.wallet.depositExtraData.sweepstakesShopItemId) {
            data.sweepStakesShopItemID = AppState.wallet.depositExtraData.sweepstakesShopItemId;
        }
        if (!(data == null ? void 0 : data.promoCode) && AppState.wallet.chosenDepositBonus !== '' && AppState.wallet.chosenDepositBonus) {
            data.promoCode = AppState.wallet.chosenDepositBonus;
        }
        // Collect specific promo code data
        promoData.depositBonusID = data.promoCode;
        promoData.sweepStakesShopItemID = data.sweepStakesShopItemID;
        const cleanedPromoData = Object.fromEntries(Object.entries(promoData).filter(([_, v])=>!!v));
        if (Object.keys(cleanedPromoData).length > 0) {
            payloadData.promoCode = JSON.stringify(cleanedPromoData);
        }
        if (specificData) {
            payloadData = _extends$1({}, payloadData, specificData);
        }
        return payloadData;
    }
    getUserProfileId() {
        var _this_config, _this_launchDepositConfig_depositConfig, _this_launchDepositConfig;
        return ((_this_config = this.config) == null ? void 0 : _this_config.userProfileId) || ((_this_launchDepositConfig = this.launchDepositConfig) == null ? void 0 : (_this_launchDepositConfig_depositConfig = _this_launchDepositConfig.depositConfig) == null ? void 0 : _this_launchDepositConfig_depositConfig.userProfileId);
    }
    constructor(...args){
        super(...args), this.launchDepositResult = null, this.launchDepositConfig = null;
    }
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var cardTypes$1 = {
    visa: {
        niceType: "Visa",
        type: "visa",
        patterns: [
            4
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            18,
            19
        ],
        code: {
            name: "CVV",
            size: 3
        }
    },
    mastercard: {
        niceType: "Mastercard",
        type: "mastercard",
        patterns: [
            [
                51,
                55
            ],
            [
                2221,
                2229
            ],
            [
                223,
                229
            ],
            [
                23,
                26
            ],
            [
                270,
                271
            ],
            2720
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVC",
            size: 3
        }
    },
    "american-express": {
        niceType: "American Express",
        type: "american-express",
        patterns: [
            34,
            37
        ],
        gaps: [
            4,
            10
        ],
        lengths: [
            15
        ],
        code: {
            name: "CID",
            size: 4
        }
    },
    "diners-club": {
        niceType: "Diners Club",
        type: "diners-club",
        patterns: [
            [
                300,
                305
            ],
            36,
            38,
            39
        ],
        gaps: [
            4,
            10
        ],
        lengths: [
            14,
            16,
            19
        ],
        code: {
            name: "CVV",
            size: 3
        }
    },
    discover: {
        niceType: "Discover",
        type: "discover",
        patterns: [
            6011,
            [
                644,
                649
            ],
            65
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            19
        ],
        code: {
            name: "CID",
            size: 3
        }
    },
    jcb: {
        niceType: "JCB",
        type: "jcb",
        patterns: [
            2131,
            1800,
            [
                3528,
                3589
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVV",
            size: 3
        }
    },
    unionpay: {
        niceType: "UnionPay",
        type: "unionpay",
        patterns: [
            620,
            [
                624,
                626
            ],
            [
                62100,
                62182
            ],
            [
                62184,
                62187
            ],
            [
                62185,
                62197
            ],
            [
                62200,
                62205
            ],
            [
                622010,
                622999
            ],
            622018,
            [
                622019,
                622999
            ],
            [
                62207,
                62209
            ],
            [
                622126,
                622925
            ],
            [
                623,
                626
            ],
            6270,
            6272,
            6276,
            [
                627700,
                627779
            ],
            [
                627781,
                627799
            ],
            [
                6282,
                6289
            ],
            6291,
            6292,
            810,
            [
                8110,
                8131
            ],
            [
                8132,
                8151
            ],
            [
                8152,
                8163
            ],
            [
                8164,
                8171
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            14,
            15,
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVN",
            size: 3
        }
    },
    maestro: {
        niceType: "Maestro",
        type: "maestro",
        patterns: [
            493698,
            [
                500000,
                504174
            ],
            [
                504176,
                506698
            ],
            [
                506779,
                508999
            ],
            [
                56,
                59
            ],
            63,
            67,
            6
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVC",
            size: 3
        }
    },
    elo: {
        niceType: "Elo",
        type: "elo",
        patterns: [
            401178,
            401179,
            438935,
            457631,
            457632,
            431274,
            451416,
            457393,
            504175,
            [
                506699,
                506778
            ],
            [
                509000,
                509999
            ],
            627780,
            636297,
            636368,
            [
                650031,
                650033
            ],
            [
                650035,
                650051
            ],
            [
                650405,
                650439
            ],
            [
                650485,
                650538
            ],
            [
                650541,
                650598
            ],
            [
                650700,
                650718
            ],
            [
                650720,
                650727
            ],
            [
                650901,
                650978
            ],
            [
                651652,
                651679
            ],
            [
                655000,
                655019
            ],
            [
                655021,
                655058
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVE",
            size: 3
        }
    },
    mir: {
        niceType: "Mir",
        type: "mir",
        patterns: [
            [
                2200,
                2204
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVP2",
            size: 3
        }
    },
    hiper: {
        niceType: "Hiper",
        type: "hiper",
        patterns: [
            637095,
            63737423,
            63743358,
            637568,
            637599,
            637609,
            637612
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVC",
            size: 3
        }
    },
    hipercard: {
        niceType: "Hipercard",
        type: "hipercard",
        patterns: [
            606282
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVC",
            size: 3
        }
    }
};
var cardTypes_1 = cardTypes$1;

var addMatchingCardsToResults$1 = {};

var clone$1 = {};

Object.defineProperty(clone$1, "__esModule", {
    value: true
});
clone$1.clone = void 0;
function clone(originalObject) {
    if (!originalObject) {
        return null;
    }
    return JSON.parse(JSON.stringify(originalObject));
}
clone$1.clone = clone;

var matches$1 = {};

/*
 * Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
 * */ Object.defineProperty(matches$1, "__esModule", {
    value: true
});
matches$1.matches = void 0;
function matchesRange(cardNumber, min, max) {
    var maxLengthToCheck = String(min).length;
    var substr = cardNumber.substr(0, maxLengthToCheck);
    var integerRepresentationOfCardNumber = parseInt(substr, 10);
    min = parseInt(String(min).substr(0, substr.length), 10);
    max = parseInt(String(max).substr(0, substr.length), 10);
    return integerRepresentationOfCardNumber >= min && integerRepresentationOfCardNumber <= max;
}
function matchesPattern(cardNumber, pattern) {
    pattern = String(pattern);
    return pattern.substring(0, cardNumber.length) === cardNumber.substring(0, pattern.length);
}
function matches(cardNumber, pattern) {
    if (Array.isArray(pattern)) {
        return matchesRange(cardNumber, pattern[0], pattern[1]);
    }
    return matchesPattern(cardNumber, pattern);
}
matches$1.matches = matches;

Object.defineProperty(addMatchingCardsToResults$1, "__esModule", {
    value: true
});
addMatchingCardsToResults$1.addMatchingCardsToResults = void 0;
var clone_1$1 = clone$1;
var matches_1 = matches$1;
function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
    var i, patternLength;
    for(i = 0; i < cardConfiguration.patterns.length; i++){
        var pattern = cardConfiguration.patterns[i];
        if (!matches_1.matches(cardNumber, pattern)) {
            continue;
        }
        var clonedCardConfiguration = clone_1$1.clone(cardConfiguration);
        if (Array.isArray(pattern)) {
            patternLength = String(pattern[0]).length;
        } else {
            patternLength = String(pattern).length;
        }
        if (cardNumber.length >= patternLength) {
            clonedCardConfiguration.matchStrength = patternLength;
        }
        results.push(clonedCardConfiguration);
        break;
    }
}
addMatchingCardsToResults$1.addMatchingCardsToResults = addMatchingCardsToResults;

var isValidInputType$1 = {};

function _instanceof$2(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
Object.defineProperty(isValidInputType$1, "__esModule", {
    value: true
});
isValidInputType$1.isValidInputType = void 0;
function isValidInputType(cardNumber) {
    return typeof cardNumber === "string" || _instanceof$2(cardNumber, String);
}
isValidInputType$1.isValidInputType = isValidInputType;

var findBestMatch$1 = {};

Object.defineProperty(findBestMatch$1, "__esModule", {
    value: true
});
findBestMatch$1.findBestMatch = void 0;
function hasEnoughResultsToDetermineBestMatch(results) {
    var numberOfResultsWithMaxStrengthProperty = results.filter(function(result) {
        return result.matchStrength;
    }).length;
    /*
     * if all possible results have a maxStrength property that means the card
     * number is sufficiently long enough to determine conclusively what the card
     * type is
     * */ return numberOfResultsWithMaxStrengthProperty > 0 && numberOfResultsWithMaxStrengthProperty === results.length;
}
function findBestMatch(results) {
    if (!hasEnoughResultsToDetermineBestMatch(results)) {
        return null;
    }
    return results.reduce(function(bestMatch, result) {
        if (!bestMatch) {
            return result;
        }
        /*
         * If the current best match pattern is less specific than this result, set
         * the result as the new best match
         * */ if (Number(bestMatch.matchStrength) < Number(result.matchStrength)) {
            return result;
        }
        return bestMatch;
    });
}
findBestMatch$1.findBestMatch = findBestMatch;

var __assign$1 = commonjsGlobal && commonjsGlobal.__assign || function() {
    __assign$1 = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
var cardTypes = cardTypes_1;
var add_matching_cards_to_results_1 = addMatchingCardsToResults$1;
var is_valid_input_type_1 = isValidInputType$1;
var find_best_match_1 = findBestMatch$1;
var clone_1 = clone$1;
var customCards = {};
var cardNames = {
    VISA: "visa",
    MASTERCARD: "mastercard",
    AMERICAN_EXPRESS: "american-express",
    DINERS_CLUB: "diners-club",
    DISCOVER: "discover",
    JCB: "jcb",
    UNIONPAY: "unionpay",
    MAESTRO: "maestro",
    ELO: "elo",
    MIR: "mir",
    HIPER: "hiper",
    HIPERCARD: "hipercard"
};
var ORIGINAL_TEST_ORDER = [
    cardNames.VISA,
    cardNames.MASTERCARD,
    cardNames.AMERICAN_EXPRESS,
    cardNames.DINERS_CLUB,
    cardNames.DISCOVER,
    cardNames.JCB,
    cardNames.UNIONPAY,
    cardNames.MAESTRO,
    cardNames.ELO,
    cardNames.MIR,
    cardNames.HIPER,
    cardNames.HIPERCARD
];
var testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
function findType(cardType) {
    return customCards[cardType] || cardTypes[cardType];
}
function getAllCardTypes() {
    return testOrder.map(function(cardType) {
        return clone_1.clone(findType(cardType));
    });
}
function getCardPosition(name, ignoreErrorForNotExisting) {
    if (ignoreErrorForNotExisting === void 0) {
        ignoreErrorForNotExisting = false;
    }
    var position = testOrder.indexOf(name);
    if (!ignoreErrorForNotExisting && position === -1) {
        throw new Error('"' + name + '" is not a supported card type.');
    }
    return position;
}
function creditCardType$1(cardNumber) {
    var results = [];
    if (!is_valid_input_type_1.isValidInputType(cardNumber)) {
        return results;
    }
    if (cardNumber.length === 0) {
        return getAllCardTypes();
    }
    testOrder.forEach(function(cardType) {
        var cardConfiguration = findType(cardType);
        add_matching_cards_to_results_1.addMatchingCardsToResults(cardNumber, cardConfiguration, results);
    });
    var bestMatch = find_best_match_1.findBestMatch(results);
    if (bestMatch) {
        return [
            bestMatch
        ];
    }
    return results;
}
creditCardType$1.getTypeInfo = function(cardType) {
    return clone_1.clone(findType(cardType));
};
creditCardType$1.removeCard = function(name) {
    var position = getCardPosition(name);
    testOrder.splice(position, 1);
};
creditCardType$1.addCard = function(config) {
    var existingCardPosition = getCardPosition(config.type, true);
    customCards[config.type] = config;
    if (existingCardPosition === -1) {
        testOrder.push(config.type);
    }
};
creditCardType$1.updateCard = function(cardType, updates) {
    var originalObject = customCards[cardType] || cardTypes[cardType];
    if (!originalObject) {
        throw new Error("\"" + cardType + "\" is not a recognized type. Use `addCard` instead.'");
    }
    if (updates.type && originalObject.type !== updates.type) {
        throw new Error("Cannot overwrite type parameter.");
    }
    var clonedCard = clone_1.clone(originalObject);
    clonedCard = __assign$1(__assign$1({}, clonedCard), updates);
    customCards[clonedCard.type] = clonedCard;
};
creditCardType$1.changeOrder = function(name, position) {
    var currentPosition = getCardPosition(name);
    testOrder.splice(currentPosition, 1);
    testOrder.splice(position, 0, name);
};
creditCardType$1.resetModifications = function() {
    testOrder = clone_1.clone(ORIGINAL_TEST_ORDER);
    customCards = {};
};
creditCardType$1.types = cardNames;
var dist$1 = creditCardType$1;

var cardholderName$1 = {};

Object.defineProperty(cardholderName$1, "__esModule", {
    value: true
});
cardholderName$1.cardholderName = void 0;
var CARD_NUMBER_REGEX = /^[\d\s-]*$/;
var MAX_LENGTH = 255;
function verification$6(isValid, isPotentiallyValid) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid
    };
}
function cardholderName(value) {
    if (typeof value !== "string") {
        return verification$6(false, false);
    }
    if (value.length === 0) {
        return verification$6(false, true);
    }
    if (value.length > MAX_LENGTH) {
        return verification$6(false, false);
    }
    if (CARD_NUMBER_REGEX.test(value)) {
        return verification$6(false, true);
    }
    return verification$6(true, true);
}
cardholderName$1.cardholderName = cardholderName;

var cardNumber$1 = {};

/* eslint-disable */
function luhn10$1(identifier) {
    var sum = 0;
    var alt = false;
    var i = identifier.length - 1;
    var num;
    while(i >= 0){
        num = parseInt(identifier.charAt(i), 10);
        if (alt) {
            num *= 2;
            if (num > 9) {
                num = num % 10 + 1; // eslint-disable-line no-extra-parens
            }
        }
        alt = !alt;
        sum += num;
        i--;
    }
    return sum % 10 === 0;
}
var luhn10_1 = luhn10$1;

Object.defineProperty(cardNumber$1, "__esModule", {
    value: true
});
cardNumber$1.cardNumber = void 0;
var luhn10 = luhn10_1;
var getCardTypes = dist$1;
function verification$5(card, isPotentiallyValid, isValid) {
    return {
        card: card,
        isPotentiallyValid: isPotentiallyValid,
        isValid: isValid
    };
}
function cardNumber(value, options) {
    if (options === void 0) {
        options = {};
    }
    var isPotentiallyValid, isValid, maxLength;
    if (typeof value !== "string" && typeof value !== "number") {
        return verification$5(null, false, false);
    }
    var testCardValue = String(value).replace(/-|\s/g, "");
    if (!/^\d*$/.test(testCardValue)) {
        return verification$5(null, false, false);
    }
    var potentialTypes = getCardTypes(testCardValue);
    if (potentialTypes.length === 0) {
        return verification$5(null, false, false);
    } else if (potentialTypes.length !== 1) {
        return verification$5(null, true, false);
    }
    var cardType = potentialTypes[0];
    if (options.maxLength && testCardValue.length > options.maxLength) {
        return verification$5(cardType, false, false);
    }
    if (options.skipLuhnValidation === true || cardType.type === getCardTypes.types.UNIONPAY && options.luhnValidateUnionPay !== true) {
        isValid = true;
    } else {
        isValid = luhn10(testCardValue);
    }
    maxLength = Math.max.apply(null, cardType.lengths);
    if (options.maxLength) {
        maxLength = Math.min(options.maxLength, maxLength);
    }
    for(var i = 0; i < cardType.lengths.length; i++){
        if (cardType.lengths[i] === testCardValue.length) {
            isPotentiallyValid = testCardValue.length < maxLength || isValid;
            return verification$5(cardType, isPotentiallyValid, isValid);
        }
    }
    return verification$5(cardType, testCardValue.length < maxLength, false);
}
cardNumber$1.cardNumber = cardNumber;

var expirationDate$1 = {};

var parseDate$1 = {};

var expirationYear$1 = {};

Object.defineProperty(expirationYear$1, "__esModule", {
    value: true
});
expirationYear$1.expirationYear = void 0;
var DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE = 19;
function verification$4(isValid, isPotentiallyValid, isCurrentYear) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid,
        isCurrentYear: isCurrentYear || false
    };
}
function expirationYear(value, maxElapsedYear) {
    if (maxElapsedYear === void 0) {
        maxElapsedYear = DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE;
    }
    var isCurrentYear;
    if (typeof value !== "string") {
        return verification$4(false, false);
    }
    if (value.replace(/\s/g, "") === "") {
        return verification$4(false, true);
    }
    if (!/^\d*$/.test(value)) {
        return verification$4(false, false);
    }
    var len = value.length;
    if (len < 2) {
        return verification$4(false, true);
    }
    var currentYear = new Date().getFullYear();
    if (len === 3) {
        // 20x === 20x
        var firstTwo = value.slice(0, 2);
        var currentFirstTwo = String(currentYear).slice(0, 2);
        return verification$4(false, firstTwo === currentFirstTwo);
    }
    if (len > 4) {
        return verification$4(false, false);
    }
    var numericValue = parseInt(value, 10);
    var twoDigitYear = Number(String(currentYear).substr(2, 2));
    var valid = false;
    if (len === 2) {
        if (String(currentYear).substr(0, 2) === value) {
            return verification$4(false, true);
        }
        isCurrentYear = twoDigitYear === numericValue;
        valid = numericValue >= twoDigitYear && numericValue <= twoDigitYear + maxElapsedYear;
    } else if (len === 4) {
        isCurrentYear = currentYear === numericValue;
        valid = numericValue >= currentYear && numericValue <= currentYear + maxElapsedYear;
    }
    return verification$4(valid, valid, isCurrentYear);
}
expirationYear$1.expirationYear = expirationYear;

var isArray = {};

// Polyfill taken from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray#Polyfill>.
Object.defineProperty(isArray, "__esModule", {
    value: true
});
isArray.isArray = void 0;
isArray.isArray = Array.isArray || function(arg) {
    return Object.prototype.toString.call(arg) === "[object Array]";
};

Object.defineProperty(parseDate$1, "__esModule", {
    value: true
});
parseDate$1.parseDate = void 0;
var expiration_year_1$2 = expirationYear$1;
var is_array_1 = isArray;
function getNumberOfMonthDigitsInDateString(dateString) {
    var firstCharacter = Number(dateString[0]);
    var assumedYear;
    /*
      if the first character in the string starts with `0`,
      we know that the month will be 2 digits.
  
      '0122' => {month: '01', year: '22'}
    */ if (firstCharacter === 0) {
        return 2;
    }
    /*
      if the first character in the string starts with
      number greater than 1, it must be a 1 digit month
  
      '322' => {month: '3', year: '22'}
    */ if (firstCharacter > 1) {
        return 1;
    }
    /*
      if the first 2 characters make up a number between
      13-19, we know that the month portion must be 1
  
      '139' => {month: '1', year: '39'}
    */ if (firstCharacter === 1 && Number(dateString[1]) > 2) {
        return 1;
    }
    /*
      if the first 2 characters make up a number between
      10-12, we check if the year portion would be considered
      valid if we assumed that the month was 1. If it is
      not potentially valid, we assume the month must have
      2 digits.
  
      '109' => {month: '10', year: '9'}
      '120' => {month: '1', year: '20'} // when checked in the year 2019
      '120' => {month: '12', year: '0'} // when checked in the year 2021
    */ if (firstCharacter === 1) {
        assumedYear = dateString.substr(1);
        return (0, expiration_year_1$2.expirationYear)(assumedYear).isPotentiallyValid ? 1 : 2;
    }
    /*
      If the length of the value is exactly 5 characters,
      we assume a full year was passed in, meaning the remaining
      single leading digit must be the month value.
  
      '12202' => {month: '1', year: '2202'}
    */ if (dateString.length === 5) {
        return 1;
    }
    /*
      If the length of the value is more than five characters,
      we assume a full year was passed in addition to the month
      and therefore the month portion must be 2 digits.
  
      '112020' => {month: '11', year: '2020'}
    */ if (dateString.length > 5) {
        return 2;
    }
    /*
      By default, the month value is the first value
    */ return 1;
}
function parseDate(datestring) {
    var date;
    if (/^\d{4}-\d{1,2}$/.test(datestring)) {
        date = datestring.split("-").reverse();
    } else if (/\//.test(datestring)) {
        date = datestring.split(/\s*\/\s*/g);
    } else if (/\s/.test(datestring)) {
        date = datestring.split(/ +/g);
    }
    if ((0, is_array_1.isArray)(date)) {
        return {
            month: date[0] || "",
            year: date.slice(1).join()
        };
    }
    var numberOfDigitsInMonth = getNumberOfMonthDigitsInDateString(datestring);
    var month = datestring.substr(0, numberOfDigitsInMonth);
    return {
        month: month,
        year: datestring.substr(month.length)
    };
}
parseDate$1.parseDate = parseDate;

var expirationMonth$1 = {};

Object.defineProperty(expirationMonth$1, "__esModule", {
    value: true
});
expirationMonth$1.expirationMonth = void 0;
function verification$3(isValid, isPotentiallyValid, isValidForThisYear) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid,
        isValidForThisYear: isValidForThisYear || false
    };
}
function expirationMonth(value) {
    var currentMonth = new Date().getMonth() + 1;
    if (typeof value !== "string") {
        return verification$3(false, false);
    }
    if (value.replace(/\s/g, "") === "" || value === "0") {
        return verification$3(false, true);
    }
    if (!/^\d*$/.test(value)) {
        return verification$3(false, false);
    }
    var month = parseInt(value, 10);
    if (isNaN(Number(value))) {
        return verification$3(false, false);
    }
    var result = month > 0 && month < 13;
    return verification$3(result, result, result && month >= currentMonth);
}
expirationMonth$1.expirationMonth = expirationMonth;

function _type_of$1(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(expirationDate$1, "__esModule", {
    value: true
});
expirationDate$1.expirationDate = void 0;
var parse_date_1 = parseDate$1;
var expiration_month_1$1 = expirationMonth$1;
var expiration_year_1$1 = expirationYear$1;
function verification$2(isValid, isPotentiallyValid, month, year) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid,
        month: month,
        year: year
    };
}
function expirationDate(value, maxElapsedYear) {
    var date;
    if (typeof value === "string") {
        value = value.replace(/^(\d\d) (\d\d(\d\d)?)$/, "$1/$2");
        date = (0, parse_date_1.parseDate)(String(value));
    } else if (value !== null && (typeof value === "undefined" ? "undefined" : _type_of$1(value)) === "object") {
        var fullDate = __assign({}, value);
        date = {
            month: String(fullDate.month),
            year: String(fullDate.year)
        };
    } else {
        return verification$2(false, false, null, null);
    }
    var monthValid = (0, expiration_month_1$1.expirationMonth)(date.month);
    var yearValid = (0, expiration_year_1$1.expirationYear)(date.year, maxElapsedYear);
    if (monthValid.isValid) {
        if (yearValid.isCurrentYear) {
            var isValidForThisYear = monthValid.isValidForThisYear;
            return verification$2(isValidForThisYear, isValidForThisYear, date.month, date.year);
        }
        if (yearValid.isValid) {
            return verification$2(true, true, date.month, date.year);
        }
    }
    if (monthValid.isPotentiallyValid && yearValid.isPotentiallyValid) {
        return verification$2(false, true, null, null);
    }
    return verification$2(false, false, null, null);
}
expirationDate$1.expirationDate = expirationDate;

var cvv$1 = {};

function _instanceof$1(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
Object.defineProperty(cvv$1, "__esModule", {
    value: true
});
cvv$1.cvv = void 0;
var DEFAULT_LENGTH = 3;
function includes(array, thing) {
    for(var i = 0; i < array.length; i++){
        if (thing === array[i]) {
            return true;
        }
    }
    return false;
}
function max(array) {
    var maximum = DEFAULT_LENGTH;
    var i = 0;
    for(; i < array.length; i++){
        maximum = array[i] > maximum ? array[i] : maximum;
    }
    return maximum;
}
function verification$1(isValid, isPotentiallyValid) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid
    };
}
function cvv(value, maxLength) {
    if (maxLength === void 0) {
        maxLength = DEFAULT_LENGTH;
    }
    maxLength = _instanceof$1(maxLength, Array) ? maxLength : [
        maxLength
    ];
    if (typeof value !== "string") {
        return verification$1(false, false);
    }
    if (!/^\d*$/.test(value)) {
        return verification$1(false, false);
    }
    if (includes(maxLength, value.length)) {
        return verification$1(true, true);
    }
    if (value.length < Math.min.apply(null, maxLength)) {
        return verification$1(false, true);
    }
    if (value.length > max(maxLength)) {
        return verification$1(false, false);
    }
    return verification$1(true, true);
}
cvv$1.cvv = cvv;

var postalCode$1 = {};

Object.defineProperty(postalCode$1, "__esModule", {
    value: true
});
postalCode$1.postalCode = void 0;
var DEFAULT_MIN_POSTAL_CODE_LENGTH = 3;
var ALPHANUM = new RegExp(/^[a-z0-9]+$/i);
function verification(isValid, isPotentiallyValid) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid
    };
}
function postalCode(value, options) {
    if (options === void 0) {
        options = {};
    }
    var minLength = options.minLength || DEFAULT_MIN_POSTAL_CODE_LENGTH;
    if (typeof value !== "string") {
        return verification(false, false);
    } else if (value.length < minLength) {
        return verification(false, true);
    } else if (!ALPHANUM.test(value.trim().slice(0, minLength))) {
        return verification(false, true);
    }
    return verification(true, true);
}
postalCode$1.postalCode = postalCode;

var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = {
            enumerable: true,
            get: function get() {
                return m[k];
            }
        };
    }
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
};
var creditCardType = __importStar(dist$1);
var cardholder_name_1 = cardholderName$1;
var card_number_1 = cardNumber$1;
var expiration_date_1 = expirationDate$1;
var expiration_month_1 = expirationMonth$1;
var expiration_year_1 = expirationYear$1;
var cvv_1 = cvv$1;
var postal_code_1 = postalCode$1;
var cardValidator = {
    creditCardType: creditCardType,
    cardholderName: cardholder_name_1.cardholderName,
    number: card_number_1.cardNumber,
    expirationDate: expiration_date_1.expirationDate,
    expirationMonth: expiration_month_1.expirationMonth,
    expirationYear: expiration_year_1.expirationYear,
    cvv: cvv_1.cvv,
    postalCode: postal_code_1.postalCode
};
var dist = cardValidator;

class CorexPaymentMethodService extends BaseCorexService {
    async launchWithdraw(data, serviceName = this.providerType) {
        if (!this.config) {
            throw new Error('Corex config not found');
        }
        const userProfileId = this.getUserProfileId();
        const { apiUrl, brand, magicApiUrl } = this.config;
        const closedLoopOnly = AppState.wallet.closedLoopOnly;
        const corexUrl = `${apiUrl}/${serviceName}/v1/user-profiles/${userProfileId}/launch/withdraw`;
        const magicUrl = `${magicApiUrl}/corex/${brand}/corex/cashier-launch-withdraw`;
        const url = closedLoopOnly ? magicUrl : corexUrl;
        const headers = closedLoopOnly ? this.getMagicWithdrawHeaders() : undefined;
        return await this.fetchMagicApi(url, 'POST', data, headers);
    }
    async getCardMethods(providerType = this.providerType) {
        var _launchResult_paymentHandles_filter, _launchResult_paymentHandles;
        const currencyCode = AppState.wallet.balanceData.currencyCode;
        const cardLaunchConfig = {
            currencyCode,
            externalPaymentMethodId: PaysafeMethodId.Card
        };
        const launchResult = await this.launchWithdraw(cardLaunchConfig, providerType);
        const filteredExpiredCardItems = (_launchResult_paymentHandles = launchResult.paymentHandles) == null ? void 0 : (_launchResult_paymentHandles_filter = _launchResult_paymentHandles.filter) == null ? void 0 : _launchResult_paymentHandles_filter.call(_launchResult_paymentHandles, (value)=>{
            const card = value.card;
            if (card) {
                const expirationResult = dist.expirationDate({
                    month: card.expiryMonth,
                    year: card.expiryYear
                });
                return expirationResult.isValid;
            }
            return true;
        });
        const mappedItems = filteredExpiredCardItems == null ? void 0 : filteredExpiredCardItems.map((method)=>this.addPaymentMethodExternalId(method, PaysafeMethodId.Card, ProviderType.Paysafe));
        const result = _extends$1({}, launchResult, {
            paymentHandles: mappedItems
        });
        return result;
    }
    /**
   * Retrieves PayByBank methods.  This method is specific to Paysafe.
   */ async getPayByBankMethods() {
        var _payByBankPreLaunch_bankAccounts;
        const currencyCode = AppState.wallet.balanceData.currencyCode;
        const payByBankPreLaunchConfig = {
            externalPaymentMethodId: PaysafeMethodId.PayByBank,
            currencyCode
        };
        const payByBankPreLaunch = await this.preLaunch(payByBankPreLaunchConfig);
        const emptyResult = {
            sessionContextId: '',
            bankAccounts: []
        };
        let result = _extends$1({}, emptyResult);
        const mappedItems = (_payByBankPreLaunch_bankAccounts = payByBankPreLaunch.bankAccounts) == null ? void 0 : _payByBankPreLaunch_bankAccounts.map((method)=>this.addPaymentMethodExternalId(method, PaysafeMethodId.PayByBank, ProviderType.Paysafe));
        result = _extends$1({}, emptyResult, {
            bankAccounts: mappedItems
        });
        return result;
    }
    async getPayPalMethods() {
        var _savedPayPalEmails_externalUserProfileEmails;
        const payPalPreLaunchConfig = {
            externalPaymentMethodId: PaysafeMethodId.Paypal
        };
        const savedPayPalEmails = await this.preLaunch(payPalPreLaunchConfig);
        const paypalModel = {
            paymentMethodExternalId: PaysafeMethodId.Paypal,
            provider: ProviderType.Paysafe,
            methodProviderId: makeProviderMethodId(ProviderType.Paysafe, PaysafeMethodId.Paypal)
        };
        if (Array.isArray(savedPayPalEmails)) {
            return savedPayPalEmails.map((item)=>_extends$1({
                    paymentHandleToken: item.externalUserProfileEmail,
                    email: item.externalUserProfileEmail,
                    name: 'PayPal',
                    netPosition: item.netPosition
                }, paypalModel)) || [];
        }
        return ((_savedPayPalEmails_externalUserProfileEmails = savedPayPalEmails.externalUserProfileEmails) == null ? void 0 : _savedPayPalEmails_externalUserProfileEmails.map((email)=>_extends$1({
                paymentHandleToken: email,
                email,
                name: 'PayPal'
            }, paypalModel))) || [];
    }
    async getSkrillMethods() {
        var _savedEmails_externalUserProfileEmails;
        const skrillPreLaunchConfig = {
            externalPaymentMethodId: PaysafeMethodId.Skrill
        };
        const savedEmails = await this.preLaunch(skrillPreLaunchConfig);
        return ((_savedEmails_externalUserProfileEmails = savedEmails.externalUserProfileEmails) == null ? void 0 : _savedEmails_externalUserProfileEmails.map((email)=>({
                paymentHandleToken: email,
                email,
                name: 'Skrill',
                paymentMethodExternalId: PaysafeMethodId.Skrill,
                methodProviderId: 'Paysafe:SKRILL',
                provider: ProviderType.Paysafe
            }))) || [];
    }
    async preLaunch(data, providerType = this.providerType) {
        const { apiUrl, brand, magicApiUrl } = this.config;
        const closedLoopOnly = AppState.wallet.closedLoopOnly;
        const userProfileId = this.getUserProfileId();
        const corexUrl = `${apiUrl}/${providerType}/v1/user-profiles/${userProfileId}/launch`;
        const magicUrl = `${magicApiUrl}/corex/${brand}/corex/cashier-launch`;
        const url = closedLoopOnly ? magicUrl : corexUrl;
        const currencyCode = AppState.wallet.balanceData.currencyCode;
        const resultData = _extends$1({
            currencyCode
        }, data);
        const headers = closedLoopOnly ? this.getMagicWithdrawHeaders() : undefined;
        const response = await this.fetchApi(url, 'POST', resultData, headers);
        const magicRes = response;
        if (magicRes.res) {
            return magicRes.res;
        }
        return response;
    }
}

var ServiceName = /*#__PURE__*/ function(ServiceName) {
    ServiceName["Withdrawal"] = "withdrawal";
    ServiceName["Deposit"] = "deposit";
    ServiceName["Payment"] = "payment";
    return ServiceName;
}({});

var _getMethodsByType = /*#__PURE__*/ _class_private_field_loose_key("_getMethodsByType"), _getAllMagicMethods = /*#__PURE__*/ _class_private_field_loose_key("_getAllMagicMethods");
class CorexGateway extends BaseCorexService {
    get payment() {
        return this.paymentService;
    }
    init(config) {
        super.init(config);
    }
    update(config) {
        super.update(config);
    }
    async getDepositMethods(currencyCode = AppState.wallet.balanceData.currencyCode, providerType = this.providerType, filterByCurrency = true) {
        return _class_private_field_loose_base(this, _getMethodsByType)[_getMethodsByType]('Deposit', currencyCode, providerType, filterByCurrency);
    }
    async getWithdrawMethods(currencyCode = AppState.wallet.balanceData.currencyCode, providerType = this.providerType) {
        return _class_private_field_loose_base(this, _getMethodsByType)[_getMethodsByType]('Withdraw', currencyCode, providerType, true);
    }
    launchDeposit(data, specificData) {
        return this.depositService.launchDeposit(data, specificData);
    }
    preLaunch(data, providerType = this.providerType) {
        return this.withdrawalService.preLaunch(data, providerType);
    }
    async getBonuses() {
        if (!this.config) {
            throw new Error('Corex config not found');
        }
        const userProfileId = this.getUserProfileId();
        const { apiUrl } = this.config;
        const url = `${apiUrl}/endeavour-bonuses/v1/user-profiles/${userProfileId}/bonuses`;
        return (await this.fetchApi(url, 'GET')).data;
    }
    async updateBonus(bonusId, type) {
        if (!this.config) {
            throw new Error('Corex config not found');
        }
        const userProfileId = this.getUserProfileId();
        const { apiUrl } = this.config;
        const url = `${apiUrl}/endeavour-bonuses/v1/user-profiles/${userProfileId}/bonuses/${bonusId}/${type}`;
        return await this.fetchApi(url, 'POST');
    }
    async launchWithdraw(data, serviceName = this.providerType) {
        return await this.paymentService.launchWithdraw(data, serviceName);
    }
    async launchOpenLoopWithdraw(data, providerType = this.providerType) {
        return await this.withdrawalService.launchOpenLoopWithdraw(data, providerType);
    }
    async submitWithdraw(data, providerType = this.providerType) {
        return await this.withdrawalService.submitWithdraw(data, providerType);
    }
    async depositSubmit(externalPaymentToken, externalPaymentMethodId, providerType, payload) {
        return await this.depositService.depositSubmit(externalPaymentToken, externalPaymentMethodId, providerType, payload);
    }
    initServices(config) {
        super.initServices(config);
    }
    async getCoreXMethods(paymentFilter = this.providerType) {
        const queryFilter = paymentFilter ? `?filter=mediatorId eq '${paymentFilter}'` : ''; // Conditional query
        // ... rest of the method (unchanged)
        if (!this.config) {
            throw new Error('Corex config not found');
        }
        if (this.cachedMethods) {
            return Promise.resolve(this.cachedMethods);
        }
        const { apiUrl } = this.config;
        const url = `${apiUrl}/endeavour-payments-configuration/v1/payment-method-configs${queryFilter}`; // Use queryFilter
        this.cachedMethods = (await this.fetchApi(url, 'GET')).data;
        var _this_cachedMethods;
        return (_this_cachedMethods = this.cachedMethods) != null ? _this_cachedMethods : [];
    }
    constructor(){
        super(), Object.defineProperty(this, _getMethodsByType, {
            value: getMethodsByType
        }), Object.defineProperty(this, _getAllMagicMethods, {
            value: getAllMagicMethods
        }), this.cachedMethods = null, this.createViewModel = (method)=>{
            switch(method.mediatorId){
                case CorexProviderType.Paysafe:
                    return PaysafeMethodFactory.createPaymentMethod(method);
                case CorexProviderType.Paymongo:
                    return PaymongoFactory.createPaymentMethod(method);
                case CorexProviderType.Solairepay:
                    return SolairepayFactory.createPaymentMethod(method);
                default:
                    return PaysafeMethodFactory.createPaymentMethod(method);
            }
        };
        this.withdrawalService = new CorexWithdrawalService();
        this.depositService = new CorexDepositService();
        this.paymentService = new CorexPaymentMethodService();
        this.addService(ServiceName.Withdrawal, this.withdrawalService);
        this.addService(ServiceName.Deposit, this.depositService);
        this.addService(ServiceName.Payment, this.paymentService);
    }
}
async function getMethodsByType(type, currencyCode = AppState.wallet.balanceData.currencyCode, providerType = this.providerType, filterByCurrency = true) {
    const methods = await this.getCoreXMethods();
    const filteredMethods = methods.filter((method)=>{
        const matchesType = method.paymentType === type || method.paymentType === 'Both';
        const supportsCurrency = !filterByCurrency || this.methodSupportsCurrency(currencyCode, method);
        return this.isProvidersMethod(method, providerType) && matchesType && supportsCurrency;
    });
    return mapMagicMethods(filteredMethods, _class_private_field_loose_base(this, _getAllMagicMethods)[_getAllMagicMethods](), (corexMethod, magicMethod)=>magicMethod.paymentMethodExternalId === corexMethod.paymentMethodExternalId && magicMethod.currency === corexMethod.currencyCode).map(this.createViewModel);
}
function getAllMagicMethods() {
    return [
        ...AppState.methods.magicPaymentMethodsByProvider.Paysafe,
        ...AppState.methods.magicPaymentMethodsByProvider.SolairePay,
        ...AppState.methods.magicPaymentMethodsByProvider.Paymongo
    ];
}

class BaseCorexAdaptedGateway extends BaseGatewayService {
    get providerType() {
        return this.corexService.providerType;
    }
    async init(config) {
        super.init(config);
        this.corexService.init(config.corex);
    }
    update(config) {
        super.update(config);
        if (config.corex) {
            this.corexService.update(config.corex);
        }
    }
    constructor(){
        super();
        this.corexService = new CorexGateway();
    }
}

function getCreditCardDetailsPage(amount) {
    return `
    <div class="card-details" part="card-details">
        ${getSummarySection(amount)}
        <div class="card-details__divider" part="card-details__divider"></div>
        ${getCardDetails()}
    </div>
  `;
}
function getCardDetails() {
    return `
    <div class="card-details__fields" part="card-details__fields">
        ${getCardDetailsTitle()}
        ${getCardNumberField()}
        ${getCardHolderField()}
        <div class="card-details__fields-data" part="card-details__fields-data">
            ${getExpiryField()}
            ${getCVCField()}
        </div>
        ${getSubmitButtons()}
    </div>
  `;
}
function getCardDetailsTitle() {
    return `
    <magic-ui-text
        tag="b"
        class="card-details__fields-title"
        part="card-details__fields-title"
        content='${translate('galleon.deposit.card.details.title')}'
    ></magic-ui-text>
  `;
}
function getCardNumberField() {
    return `
    <div class="card-details__fields-field" part="card-details__fields-field">
        <magic-ui-text
            tag="b"
            class="card-details__fields-subtitle"
            part="card-details__fields-subtitle"
            content='${translate('galleon.deposit.card.details.number.label')}'
        ></magic-ui-text>
        <magic-ui-form-field
            class="card-details__fields-input card-details__fields-card"
            part="card-details__fields-input card-details__fields-card"
            placeholder="${translate('galleon.input.placeholder')}"
            type="text"
            maxlength="22"
        ></magic-ui-form-field>
        <magic-ui-text
            tag="p"
            class="card-details__errors-card"
            part="card-details__errors-card"
            content='${translate('galleon.deposit.card.details.number.error')}'
        ></magic-ui-text>
    </div>
  `;
}
function getCardHolderField() {
    var _AppState_wallet_profile, _AppState_wallet_profile1;
    const firstName = ((_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile.customer.firstName) || '';
    const lastName = ((_AppState_wallet_profile1 = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile1.customer.lastName) || '';
    const holderName = `${firstName} ${lastName}`;
    return `
    <div class="card-details__fields-field" part="card-details__fields-field">
        <magic-ui-text
            tag="b"
            class="card-details__fields-subtitle"
            part="card-details__fields-subtitle"
            content='${translate('galleon.deposit.card.details.holder.label')}'
        ></magic-ui-text>
        <magic-ui-form-field
            class="card-details__fields-input card-details__fields-holder"
            part="card-details__fields-holder"
            placeholder="${translate('galleon.input.placeholder')}"
            initialValue="${holderName}"
            type="text"
        ></magic-ui-form-field>
        <magic-ui-text
            tag="p"
            class="card-details__errors-holder"
            part="card-details__errors-holder"
            content='${translate('galleon.deposit.card.details.holder.error')}'
        ></magic-ui-text>
    </div>
  `;
}
function getExpiryField() {
    return `
    <div class="card-details__fields-field card-details__fields-grow" part="card-details__fields-field">
        <magic-ui-text
            tag="b"
            class="card-details__fields-subtitle"
            part="card-details__fields-subtitle"
            content='${translate('galleon.deposit.card.details.expiry.label')}'
        ></magic-ui-text>
        <magic-ui-form-field
            class="card-details__fields-input card-details__fields-expiry"
            part="card-details__fields-input card-details__fields-expiry"
            placeholder="${translate('galleon.input.placeholder')}"
            type="text"
        ></magic-ui-form-field>
        <magic-ui-text
            tag="p"
            class="card-details__errors-expiry"
            part="card-details__errors-expiry"
            content='${translate('galleon.deposit.card.details.expiry.error')}'
        ></magic-ui-text>
    </div>
  `;
}
function getCVCField() {
    return `
    <div class="card-details__fields-field card-details__fields-grow" part="card-details__fields-field">
        <div class="card-details__fields-descr" part="card-details__fields-descr">
            <div class="tooltip" part="tooltip">
                ${getTooltipTemplate('CVC', translate('galleon.deposit.tooltip.cvc.subtitle'))}
            </div>
            <magic-ui-text
                tag="b"
                class="card-details__fields-subtitle"
                part="card-details__fields-subtitle"
                content='CVC'
            ></magic-ui-text>
        </div>
        <magic-ui-form-field
            class="card-details__fields-input card-details__fields-cvc"
            part="card-details__fields-input card-details__fields-cvc"
            placeholder="${translate('galleon.input.placeholder')}"
            type="text"
            maxLength="4"
        ></magic-ui-form-field>
        <magic-ui-text
            tag="p"
            class="card-details__errors-cvc"
            part="card-details__errors-cvc"
            content='${translate('galleon.deposit.card.details.cvc.error')}'
        ></magic-ui-text>
    </div>
  `;
}
function getSubmitButtons() {
    return `
    <div class="card-details__submit" part="card-details__submit">
        <div class="card-details__submit-container">
            <div class="card-details__cancel-wrapper" part="card-details__cancel-wrapper">
              <magic-ui-button
                  class="button card-details__cancel-btn"
                  part="button card-details__cancel-btn"
                  variant="primary"
                  hollow
                  >
                  ${translate('galleon.deposit.card.details.cancel')}
              </magic-ui-button>
            </div>
            <magic-ui-button
                class="button card-details__submit-confirm"
                part="button card-details__submit-confirm"
                variant="primary"
                disabled
                >
                ${translate('galleon.deposit.card.details.confirm')}
            </magic-ui-button>
        </div>
    </div>
  `;
}

class CardDefaultField {
}
CardDefaultField.MIN_LENGTH = 16;
CardDefaultField.MAX_LENGTH = 19;
CardDefaultField.CODE_NAME = 'CVC';
CardDefaultField.CODE_MIN = 3;
CardDefaultField.CODE_MAX = 4;

function handleCardNumberInput(value, formField, submitButton, errorConfig) {
    const cleanInput = value.replace(/\s+/g, ''); // Remove all spaces
    const validResult = dist.number(cleanInput);
    const { card } = validResult;
    const formattedNumber = formatCardNumber(validResult, cleanInput);
    refreshFieldValue(formField, formattedNumber);
    if (card == null ? void 0 : card.lengths) {
        var _card_gaps;
        const maxInputLen = +(Math.max(...card.lengths) || 0) + +((card == null ? void 0 : (_card_gaps = card.gaps) == null ? void 0 : _card_gaps.length) || 0);
        formField.setAttribute('maxlength', '' + maxInputLen);
    } else {
        formField.removeAttribute('maxlength');
    }
    const errorElement = errorConfig.invalid;
    const { isValid } = validResult;
    if (!isValid) {
        var _errorElement_setAttribute;
        let resultContent = translate('galleon.deposit.card.details.number.error');
        if (card) {
            const minNumber = Math.min(...card.lengths) || CardDefaultField.MIN_LENGTH;
            const maxNumber = Math.max(...card.lengths) || CardDefaultField.MAX_LENGTH;
            resultContent = translate('galleon.deposit.card.details.number.range.error').replace('{cardType}', card.niceType || '').replace('{min}', '' + minNumber).replace('{max}', '' + maxNumber);
            if (minNumber === maxNumber) {
                resultContent = translate('galleon.deposit.card.details.number.single.error').replace('{cardType}', card.niceType || '').replace('{value}', '' + maxNumber);
            }
            if ((cleanInput == null ? void 0 : cleanInput.length) >= minNumber && (cleanInput == null ? void 0 : cleanInput.length) <= maxNumber) {
                resultContent = translate('galleon.deposit.card.details.number.common.error').replace('{cardType}', card.niceType || '');
            }
        }
        if (!value) {
            resultContent = translate('galleon.deposit.card.details.number.empty.error');
        }
        errorElement == null ? void 0 : (_errorElement_setAttribute = errorElement.setAttribute) == null ? void 0 : _errorElement_setAttribute.call(errorElement, 'content', resultContent);
    }
    checkErrorMessage(isValid, formField, submitButton, errorConfig);
}
function formatCardNumber(validResult, cleanInput) {
    var _validResult_card;
    const gaps = (validResult == null ? void 0 : (_validResult_card = validResult.card) == null ? void 0 : _validResult_card.gaps) || []; // Default gaps if no card type is detected
    let formattedNumber = '';
    let start = 0;
    gaps.forEach((gap)=>{
        if (start < cleanInput.length) {
            formattedNumber += cleanInput.substring(start, gap) + ' ';
            start = gap;
        }
    });
    // Add remaining characters after the last gap
    formattedNumber += cleanInput.substring(start);
    return formattedNumber.trim(); // Remove trailing space
}
function refreshFieldValue(formField, value) {
    setTimeout(()=>{
        formField.setAttribute('value', value);
    }, 0);
}
function handleCardHolderInput(value = '', formField, submitButton, errorConfig) {
    const trimedValue = value.trim();
    refreshFieldValue(formField, value);
    const validResult = dist.cardholderName(trimedValue);
    const { isValid } = validResult;
    checkErrorMessage(isValid, formField, submitButton, errorConfig);
}
function handleCVCInput(value = '', formField, submitButton, errorConfig, cardValue) {
    var _errorElement_setAttribute;
    let resultMinCodeLength = CardDefaultField.CODE_MIN;
    let resultMaxCodeLength = CardDefaultField.CODE_MAX;
    let cardCode = CardDefaultField.CODE_NAME;
    const numericValue = value.replace(/[^0-9]/g, '');
    const trimmedValue = numericValue.substring(0, CardDefaultField.CODE_MAX);
    refreshFieldValue(formField, trimmedValue);
    if (cardValue) {
        var _validResult_card_code, _validResult_card, _validResult_card_code1, _validResult_card1;
        const validResult = dist.number(cardValue);
        const maxCardCodeLength = validResult == null ? void 0 : (_validResult_card = validResult.card) == null ? void 0 : (_validResult_card_code = _validResult_card.code) == null ? void 0 : _validResult_card_code.size;
        cardCode = (validResult == null ? void 0 : (_validResult_card1 = validResult.card) == null ? void 0 : (_validResult_card_code1 = _validResult_card1.code) == null ? void 0 : _validResult_card_code1.name) || CardDefaultField.CODE_NAME;
        resultMaxCodeLength = maxCardCodeLength || CardDefaultField.CODE_MAX;
        resultMinCodeLength = maxCardCodeLength || CardDefaultField.CODE_MIN;
    }
    const errorElement = errorConfig.invalid;
    let resultContent = translate('galleon.deposit.card.details.code.range.error').replace('{code}', cardCode).replace('{min}', '' + resultMinCodeLength).replace('{max}', '' + resultMaxCodeLength);
    if (resultMaxCodeLength === resultMinCodeLength) {
        resultContent = translate('galleon.deposit.card.details.code.single.error').replace('{code}', cardCode).replace('{value}', String(resultMaxCodeLength));
    }
    errorElement == null ? void 0 : (_errorElement_setAttribute = errorElement.setAttribute) == null ? void 0 : _errorElement_setAttribute.call(errorElement, 'content', resultContent);
    const resultValid = trimmedValue.length <= resultMaxCodeLength && trimmedValue.length >= resultMinCodeLength;
    checkErrorMessage(resultValid, formField, submitButton, errorConfig);
    return trimmedValue;
}
function handleExpiryInput(value = '', formField, submitButton, errorConfig) {
    const validResult = dist.expirationDate(value);
    const { isValid } = validResult;
    refreshFieldValue(formField, value);
    checkErrorMessage(isValid, formField, submitButton, errorConfig);
}

function getEventValue(event) {
    var _customEvent_detail, _customEvent_detail1;
    const customEvent = event;
    return (customEvent == null ? void 0 : (_customEvent_detail = customEvent.detail) == null ? void 0 : _customEvent_detail.value) || ((_customEvent_detail1 = customEvent.detail) == null ? void 0 : _customEvent_detail1[0]) || '';
}

const expiryFormatter = (value)=>{
    // Remove all non-numeric characters immediately
    const numericOnly = value.replace(/[^0-9]/g, '');
    if (!numericOnly) {
        return '';
    }
    const truncated = numericOnly.slice(0, 4);
    const month = truncated.substring(0, 2);
    const year = truncated.substring(2, 4);
    if (truncated.length >= 1) {
        if (month.length === 2 && parseInt(month) > 12) {
            return '12' + (year ? '/' + year : '');
        }
        return month + (truncated.length > 2 ? '/' + year : '');
    }
    return truncated;
};

var _submitBtn = /*#__PURE__*/ _class_private_field_loose_key("_submitBtn"), _changeBtn = /*#__PURE__*/ _class_private_field_loose_key("_changeBtn"), _cancelBtn = /*#__PURE__*/ _class_private_field_loose_key("_cancelBtn"), _expiryField = /*#__PURE__*/ _class_private_field_loose_key("_expiryField"), _cvcField = /*#__PURE__*/ _class_private_field_loose_key("_cvcField"), _holderField = /*#__PURE__*/ _class_private_field_loose_key("_holderField"), _cardNumberField = /*#__PURE__*/ _class_private_field_loose_key("_cardNumberField"), _errorConfigs = /*#__PURE__*/ _class_private_field_loose_key("_errorConfigs"), _onDeposit = /*#__PURE__*/ _class_private_field_loose_key("_onDeposit"), _attachListeners$2 = /*#__PURE__*/ _class_private_field_loose_key("_attachListeners"), _updateFormStatus$1 = /*#__PURE__*/ _class_private_field_loose_key("_updateFormStatus");
class CardFormManager {
    constructor(onDeposit){
        Object.defineProperty(this, _attachListeners$2, {
            value: attachListeners$2
        });
        Object.defineProperty(this, _updateFormStatus$1, {
            value: updateFormStatus$1
        });
        Object.defineProperty(this, _submitBtn, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _changeBtn, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _cancelBtn, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _expiryField, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _cvcField, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _holderField, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _cardNumberField, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _errorConfigs, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _onDeposit, {
            writable: true,
            value: void 0
        });
        const shadowRoot = AppState.shadowRoot;
        _class_private_field_loose_base(this, _submitBtn)[_submitBtn] = shadowRoot.querySelector('.card-details__submit-confirm');
        _class_private_field_loose_base(this, _changeBtn)[_changeBtn] = shadowRoot.querySelector('.card-details__summary-button');
        _class_private_field_loose_base(this, _cancelBtn)[_cancelBtn] = shadowRoot.querySelector('.card-details__cancel-btn');
        _class_private_field_loose_base(this, _expiryField)[_expiryField] = shadowRoot.querySelector('.card-details__fields-expiry');
        _class_private_field_loose_base(this, _cvcField)[_cvcField] = shadowRoot.querySelector('.card-details__fields-cvc');
        _class_private_field_loose_base(this, _holderField)[_holderField] = shadowRoot.querySelector('.card-details__fields-holder');
        _class_private_field_loose_base(this, _cardNumberField)[_cardNumberField] = shadowRoot.querySelector('.card-details__fields-card');
        _class_private_field_loose_base(this, _onDeposit)[_onDeposit] = onDeposit;
        _class_private_field_loose_base(this, _errorConfigs)[_errorConfigs] = {
            card: {
                invalid: shadowRoot.querySelector('.card-details__errors-card')
            },
            holder: {
                invalid: shadowRoot.querySelector('.card-details__errors-holder')
            },
            cvc: {
                invalid: shadowRoot.querySelector('.card-details__errors-cvc')
            },
            expiry: {
                invalid: shadowRoot.querySelector('.card-details__errors-expiry')
            }
        };
        _class_private_field_loose_base(this, _attachListeners$2)[_attachListeners$2]();
    }
}
function attachListeners$2() {
    var _class_private_field_loose_base__cardNumberField, _class_private_field_loose_base__holderField, _class_private_field_loose_base__cvcField, _class_private_field_loose_base__expiryField, _class_private_field_loose_base__cancelBtn, _class_private_field_loose_base__changeBtn, _class_private_field_loose_base__submitBtn;
    // Card Number Listener
    (_class_private_field_loose_base__cardNumberField = _class_private_field_loose_base(this, _cardNumberField)[_cardNumberField]) == null ? void 0 : _class_private_field_loose_base__cardNumberField.addEventListener('input', (event)=>{
        const value = getEventValue(event);
        _class_private_field_loose_base(this, _cardNumberField)[_cardNumberField].setAttribute('value', value);
        const numericValue = value.replace(/[^0-9\s]/g, ''); // Remove non-numeric and non-space characters
        const cvvCode = _class_private_field_loose_base(this, _cvcField)[_cvcField].getAttribute('value');
        handleCardNumberInput(numericValue, _class_private_field_loose_base(this, _cardNumberField)[_cardNumberField], _class_private_field_loose_base(this, _submitBtn)[_submitBtn], _class_private_field_loose_base(this, _errorConfigs)[_errorConfigs]['card']);
        if (cvvCode) {
            handleCVCInput(cvvCode, _class_private_field_loose_base(this, _cvcField)[_cvcField], _class_private_field_loose_base(this, _submitBtn)[_submitBtn], _class_private_field_loose_base(this, _errorConfigs)[_errorConfigs]['cvc'], numericValue || '');
        }
        _class_private_field_loose_base(this, _updateFormStatus$1)[_updateFormStatus$1]();
    });
    // Card Holder Listener
    (_class_private_field_loose_base__holderField = _class_private_field_loose_base(this, _holderField)[_holderField]) == null ? void 0 : _class_private_field_loose_base__holderField.addEventListener('input', (event)=>{
        const value = getEventValue(event);
        _class_private_field_loose_base(this, _holderField)[_holderField].setAttribute('value', value);
        handleCardHolderInput(value, _class_private_field_loose_base(this, _holderField)[_holderField], _class_private_field_loose_base(this, _submitBtn)[_submitBtn], _class_private_field_loose_base(this, _errorConfigs)[_errorConfigs]['holder']);
        _class_private_field_loose_base(this, _updateFormStatus$1)[_updateFormStatus$1]();
    });
    // CVC Listener
    (_class_private_field_loose_base__cvcField = _class_private_field_loose_base(this, _cvcField)[_cvcField]) == null ? void 0 : _class_private_field_loose_base__cvcField.addEventListener('input', (event)=>{
        const value = getEventValue(event);
        _class_private_field_loose_base(this, _cvcField)[_cvcField].setAttribute('value', value);
        const cardValue = _class_private_field_loose_base(this, _cardNumberField)[_cardNumberField].getAttribute('value');
        handleCVCInput(value, _class_private_field_loose_base(this, _cvcField)[_cvcField], _class_private_field_loose_base(this, _submitBtn)[_submitBtn], _class_private_field_loose_base(this, _errorConfigs)[_errorConfigs]['cvc'], cardValue || '');
        _class_private_field_loose_base(this, _updateFormStatus$1)[_updateFormStatus$1]();
    });
    // Expiry Date Listener
    (_class_private_field_loose_base__expiryField = _class_private_field_loose_base(this, _expiryField)[_expiryField]) == null ? void 0 : _class_private_field_loose_base__expiryField.addEventListener('input', (event)=>{
        const value = getEventValue(event);
        const numValue = value.replace(/[^0-9/]/g, '');
        _class_private_field_loose_base(this, _expiryField)[_expiryField].setAttribute('value', value);
        const formattedValue = expiryFormatter(numValue);
        handleExpiryInput(formattedValue, _class_private_field_loose_base(this, _expiryField)[_expiryField], _class_private_field_loose_base(this, _submitBtn)[_submitBtn], _class_private_field_loose_base(this, _errorConfigs)[_errorConfigs]['expiry']);
        _class_private_field_loose_base(this, _updateFormStatus$1)[_updateFormStatus$1]();
    });
    (_class_private_field_loose_base__cancelBtn = _class_private_field_loose_base(this, _cancelBtn)[_cancelBtn]) == null ? void 0 : _class_private_field_loose_base__cancelBtn.addEventListener('click', ()=>{
        AppState.wallet.deposit.selectedMethod = null;
        createDepositView$1();
    });
    (_class_private_field_loose_base__changeBtn = _class_private_field_loose_base(this, _changeBtn)[_changeBtn]) == null ? void 0 : _class_private_field_loose_base__changeBtn.addEventListener('click', ()=>{
        AppState.wallet.deposit.selectedMethod = null;
        createDepositView$1();
    });
    (_class_private_field_loose_base__submitBtn = _class_private_field_loose_base(this, _submitBtn)[_submitBtn]) == null ? void 0 : _class_private_field_loose_base__submitBtn.addEventListener('click', ()=>{
        _class_private_field_loose_base(this, _onDeposit)[_onDeposit]({
            cvc: _class_private_field_loose_base(this, _cvcField)[_cvcField].getAttribute('value'),
            expiry: _class_private_field_loose_base(this, _expiryField)[_expiryField].getAttribute('value'),
            holder: _class_private_field_loose_base(this, _holderField)[_holderField].getAttribute('value'),
            number: _class_private_field_loose_base(this, _cardNumberField)[_cardNumberField].getAttribute('value')
        });
        _class_private_field_loose_base(this, _submitBtn)[_submitBtn].setAttribute('loading', 'true');
        _class_private_field_loose_base(this, _submitBtn)[_submitBtn].setAttribute('disabled', 'true');
    });
}
function updateFormStatus$1() {
    const expirySuccess = _class_private_field_loose_base(this, _expiryField)[_expiryField].getAttribute('hasSuccess');
    const cvcFieldSuccess = _class_private_field_loose_base(this, _cvcField)[_cvcField].getAttribute('hasSuccess');
    const holderFieldSuccess = _class_private_field_loose_base(this, _holderField)[_holderField].getAttribute('hasSuccess');
    const cardNumberFieldSuccess = _class_private_field_loose_base(this, _cardNumberField)[_cardNumberField].getAttribute('hasSuccess');
    if (expirySuccess && cvcFieldSuccess && holderFieldSuccess && cardNumberFieldSuccess) {
        _class_private_field_loose_base(this, _submitBtn)[_submitBtn].removeAttribute('disabled');
    } else {
        _class_private_field_loose_base(this, _submitBtn)[_submitBtn].setAttribute('disabled', '');
    }
}
function initializeCardForm(onDeposit) {
    new CardFormManager(onDeposit);
}

const loadedScripts = [];
const injectScript = (src)=>{
    if (loadedScripts.includes(src)) {
        return Promise.reject('Script is already loaded');
    }
    return new Promise((resolve, reject)=>{
        const script = document.createElement('script');
        script.src = src;
        script.addEventListener('load', resolve);
        script.addEventListener('error', (e)=>reject(e.error));
        document.head.appendChild(script);
        loadedScripts.push(src);
    });
};
/**
 * Loads the encryption script from PaymentIQ
 *
 * @returns A promise that resolves when the script loads
 */ const injectEncryptionScript = (env, merchanId)=>{
    const prefix = env.indexOf('prod') >= 0 ? '' : 'test-';
    return injectScript(`https://${prefix}api.paymentiq.io/paymentiq/api/viq/jscardencrypter/${merchanId}`).then(()=>{
    // Script is successfully loaded!
    }).catch((error)=>{
        console.error(error);
    });
};
/**
 * The encrypted value per brand
 *
 * @returns The encrypted value
 */ const getEncryptedValue = (value)=>{
    try {
        const enValue = window.encryptData(value);
        return enValue.toString();
    } catch (e) {
        throw Error('[CCEE] Processing credit card failed.');
    }
};

// Generated ESM version of ua-parser-js
// DO NOT EDIT THIS FILE!
// Source: /src/main/ua-parser.js
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v2.0.0
   Copyright © 2012-2024 Faisal Salman <f@faisalman.com>
   AGPLv3 License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://uaparser.dev
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
/* jshint esversion: 6 */ /* globals window */ //////////////
// Constants
/////////////
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var LIBVERSION = '2.0.0', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', STR_TYPE = 'string', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv', WEARABLE = 'wearable', XR = 'xr', EMBEDDED = 'embedded', INAPP = 'inapp', USER_AGENT = 'user-agent', UA_MAX_LENGTH = 500, BRANDS = 'brands', FORMFACTORS = 'formFactors', FULLVERLIST = 'fullVersionList', PLATFORM = 'platform', PLATFORMVER = 'platformVersion', BITNESS = 'bitness', CH_HEADER = 'sec-ch-ua', CH_HEADER_FULL_VER_LIST = CH_HEADER + '-full-version-list', CH_HEADER_ARCH = CH_HEADER + '-arch', CH_HEADER_BITNESS = CH_HEADER + '-' + BITNESS, CH_HEADER_FORM_FACTORS = CH_HEADER + '-form-factors', CH_HEADER_MOBILE = CH_HEADER + '-' + MOBILE, CH_HEADER_MODEL = CH_HEADER + '-' + MODEL, CH_HEADER_PLATFORM = CH_HEADER + '-' + PLATFORM, CH_HEADER_PLATFORM_VER = CH_HEADER_PLATFORM + '-version', CH_ALL_VALUES = [
    BRANDS,
    FULLVERLIST,
    MOBILE,
    MODEL,
    PLATFORM,
    PLATFORMVER,
    ARCHITECTURE,
    FORMFACTORS,
    BITNESS
], UA_BROWSER = 'browser', UA_CPU = 'cpu', UA_DEVICE = 'device', UA_ENGINE = 'engine', UA_OS = 'os', UA_RESULT = 'result', AMAZON = 'Amazon', APPLE = 'Apple', ASUS = 'ASUS', BLACKBERRY = 'BlackBerry', GOOGLE = 'Google', HUAWEI = 'Huawei', LENOVO = 'Lenovo', HONOR = 'Honor', LG = 'LG', MICROSOFT = 'Microsoft', MOTOROLA = 'Motorola', SAMSUNG = 'Samsung', SHARP = 'Sharp', SONY = 'Sony', XIAOMI = 'Xiaomi', ZEBRA = 'Zebra', PREFIX_MOBILE = 'Mobile ', SUFFIX_BROWSER = ' Browser', CHROME = 'Chrome', CHROMECAST = 'Chromecast', EDGE = 'Edge', FIREFOX = 'Firefox', OPERA = 'Opera', FACEBOOK = 'Facebook', SOGOU = 'Sogou', WINDOWS = 'Windows';
var isWindow = (typeof window === "undefined" ? "undefined" : _type_of(window)) !== UNDEF_TYPE, NAVIGATOR = isWindow && window.navigator ? window.navigator : undefined, NAVIGATOR_UADATA = NAVIGATOR && NAVIGATOR.userAgentData ? NAVIGATOR.userAgentData : undefined;
///////////
// Helper
//////////
var extend = function extend(defaultRgx, extensions) {
    var mergedRgx = {};
    var extraRgx = extensions;
    if (!isExtensions(extensions)) {
        extraRgx = {};
        for(var i in extensions){
            for(var j in extensions[i]){
                extraRgx[j] = extensions[i][j].concat(extraRgx[j] ? extraRgx[j] : []);
            }
        }
    }
    for(var k in defaultRgx){
        mergedRgx[k] = extraRgx[k] && extraRgx[k].length % 2 === 0 ? extraRgx[k].concat(defaultRgx[k]) : defaultRgx[k];
    }
    return mergedRgx;
}, enumerize = function enumerize(arr) {
    var enums = {};
    for(var i = 0; i < arr.length; i++){
        enums[arr[i].toUpperCase()] = arr[i];
    }
    return enums;
}, has = function has(str1, str2) {
    if ((typeof str1 === "undefined" ? "undefined" : _type_of(str1)) === OBJ_TYPE && str1.length > 0) {
        for(var i in str1){
            if (lowerize(str1[i]) == lowerize(str2)) return true;
        }
        return false;
    }
    return isString(str1) ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
}, isExtensions = function isExtensions1(obj, deep) {
    for(var prop in obj){
        return /^(browser|cpu|device|engine|os)$/.test(prop) || (deep ? isExtensions(obj[prop]) : false);
    }
}, isString = function isString(val) {
    return (typeof val === "undefined" ? "undefined" : _type_of(val)) === STR_TYPE;
}, itemListToArray = function itemListToArray(header) {
    if (!header) return undefined;
    var arr = [];
    var tokens = strip(/\\?\"/g, header).split(',');
    for(var i = 0; i < tokens.length; i++){
        if (tokens[i].indexOf(';') > -1) {
            var token = trim(tokens[i]).split(';v=');
            arr[i] = {
                brand: token[0],
                version: token[1]
            };
        } else {
            arr[i] = trim(tokens[i]);
        }
    }
    return arr;
}, lowerize = function lowerize(str) {
    return isString(str) ? str.toLowerCase() : str;
}, majorize = function majorize(version) {
    return isString(version) ? strip(/[^\d\.]/g, version).split('.')[0] : undefined;
}, setProps = function setProps(arr) {
    for(var i in arr){
        var propName = arr[i];
        if ((typeof propName === "undefined" ? "undefined" : _type_of(propName)) == OBJ_TYPE && propName.length == 2) {
            this[propName[0]] = propName[1];
        } else {
            this[propName] = undefined;
        }
    }
    return this;
}, strip = function strip(pattern, str) {
    return isString(str) ? str.replace(pattern, EMPTY) : str;
}, stripQuotes = function stripQuotes(str) {
    return strip(/\\?\"/g, str);
}, trim = function trim(str, len) {
    if (isString(str)) {
        str = strip(/^\s\s*/, str);
        return (typeof len === "undefined" ? "undefined" : _type_of(len)) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
    }
};
///////////////
// Map helper
//////////////
var rgxMapper = function rgxMapper(ua, arrays) {
    if (!ua || !arrays) return;
    var i = 0, j, k, p, q, matches, match;
    // loop through all regexes maps
    while(i < arrays.length && !matches){
        var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
        j = k = 0;
        // try matching uastring with regexes
        while(j < regex.length && !matches){
            if (!regex[j]) {
                break;
            }
            matches = regex[j++].exec(ua);
            if (!!matches) {
                for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if ((typeof q === "undefined" ? "undefined" : _type_of(q)) === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (_type_of(q[1]) == FUNC_TYPE) {
                                // assign modified match
                                this[q[0]] = q[1].call(this, match);
                            } else {
                                // assign given value, ignore regex match
                                this[q[0]] = q[1];
                            }
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (_type_of(q[1]) === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                // call function (usually string mapper)
                                this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            } else {
                                // sanitize match using given regex
                                this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                            }
                        } else if (q.length === 4) {
                            this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                        }
                    } else {
                        this[q] = match ? match : undefined;
                    }
                }
            }
        }
        i += 2;
    }
}, strMapper = function strMapper(str, map) {
    for(var i in map){
        // check if current value is array
        if (_type_of(map[i]) === OBJ_TYPE && map[i].length > 0) {
            for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) {
                    return i === UNKNOWN ? undefined : i;
                }
            }
        } else if (has(map[i], str)) {
            return i === UNKNOWN ? undefined : i;
        }
    }
    return map.hasOwnProperty('*') ? map['*'] : str;
};
///////////////
// String map
//////////////
var windowsVersionMap = {
    'ME': '4.90',
    'NT 3.11': 'NT3.51',
    'NT 4.0': 'NT4.0',
    '2000': 'NT 5.0',
    'XP': [
        'NT 5.1',
        'NT 5.2'
    ],
    'Vista': 'NT 6.0',
    '7': 'NT 6.1',
    '8': 'NT 6.2',
    '8.1': 'NT 6.3',
    '10': [
        'NT 6.4',
        'NT 10.0'
    ],
    'RT': 'ARM'
}, formFactorsMap = {
    'embedded': 'Automotive',
    'mobile': 'Mobile',
    'tablet': [
        'Tablet',
        'EInk'
    ],
    'smarttv': 'TV',
    'wearable': 'Watch',
    'xr': [
        'VR',
        'XR'
    ],
    '?': [
        'Desktop',
        'Unknown'
    ],
    '*': undefined
};
//////////////
// Regex map
/////////////
var defaultRegexes = {
    browser: [
        [
            // Most common regardless engine
            /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
        ],
        [
            VERSION,
            [
                NAME,
                PREFIX_MOBILE + 'Chrome'
            ]
        ],
        [
            /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
        ],
        [
            VERSION,
            [
                NAME,
                'Edge'
            ]
        ],
        [
            // Presto based
            /(opera mini)\/([-\w\.]+)/i,
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
        ],
        [
            NAME,
            VERSION
        ],
        [
            /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
        ],
        [
            VERSION,
            [
                NAME,
                OPERA + ' Mini'
            ]
        ],
        [
            /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
        ],
        [
            VERSION,
            [
                NAME,
                OPERA + ' GX'
            ]
        ],
        [
            /\bopr\/([\w\.]+)/i // Opera Webkit
        ],
        [
            VERSION,
            [
                NAME,
                OPERA
            ]
        ],
        [
            // Mixed
            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
        ],
        [
            VERSION,
            [
                NAME,
                'Baidu'
            ]
        ],
        [
            /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i // Maxthon
        ],
        [
            VERSION,
            [
                NAME,
                'Maxthon'
            ]
        ],
        [
            /(kindle)\/([\w\.]+)/i,
            /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
            // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
            // Trident based
            /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
            /(?:ms|\()(ie) ([\w\.]+)/i,
            // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
            // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
            /(heytap|ovi|115)browser\/([\d\.]+)/i,
            /(weibo)__([\d\.]+)/i // Weibo
        ],
        [
            NAME,
            VERSION
        ],
        [
            /quark(?:pc)?\/([-\w\.]+)/i // Quark
        ],
        [
            VERSION,
            [
                NAME,
                'Quark'
            ]
        ],
        [
            /\bddg\/([\w\.]+)/i // DuckDuckGo
        ],
        [
            VERSION,
            [
                NAME,
                'DuckDuckGo'
            ]
        ],
        [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
        ],
        [
            VERSION,
            [
                NAME,
                'UCBrowser'
            ]
        ],
        [
            /microm.+\bqbcore\/([\w\.]+)/i,
            /\bqbcore\/([\w\.]+).+microm/i,
            /micromessenger\/([\w\.]+)/i // WeChat
        ],
        [
            VERSION,
            [
                NAME,
                'WeChat'
            ]
        ],
        [
            /konqueror\/([\w\.]+)/i // Konqueror
        ],
        [
            VERSION,
            [
                NAME,
                'Konqueror'
            ]
        ],
        [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
        ],
        [
            VERSION,
            [
                NAME,
                'IE'
            ]
        ],
        [
            /ya(?:search)?browser\/([\w\.]+)/i // Yandex
        ],
        [
            VERSION,
            [
                NAME,
                'Yandex'
            ]
        ],
        [
            /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
        ],
        [
            VERSION,
            [
                NAME,
                'Smart ' + LENOVO + SUFFIX_BROWSER
            ]
        ],
        [
            /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
        ],
        [
            [
                NAME,
                /(.+)/,
                '$1 Secure' + SUFFIX_BROWSER
            ],
            VERSION
        ],
        [
            /\bfocus\/([\w\.]+)/i // Firefox Focus
        ],
        [
            VERSION,
            [
                NAME,
                FIREFOX + ' Focus'
            ]
        ],
        [
            /\bopt\/([\w\.]+)/i // Opera Touch
        ],
        [
            VERSION,
            [
                NAME,
                OPERA + ' Touch'
            ]
        ],
        [
            /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
        ],
        [
            VERSION,
            [
                NAME,
                'Coc Coc'
            ]
        ],
        [
            /dolfin\/([\w\.]+)/i // Dolphin
        ],
        [
            VERSION,
            [
                NAME,
                'Dolphin'
            ]
        ],
        [
            /coast\/([\w\.]+)/i // Opera Coast
        ],
        [
            VERSION,
            [
                NAME,
                OPERA + ' Coast'
            ]
        ],
        [
            /miuibrowser\/([\w\.]+)/i // MIUI Browser
        ],
        [
            VERSION,
            [
                NAME,
                'MIUI' + SUFFIX_BROWSER
            ]
        ],
        [
            /fxios\/([\w\.-]+)/i // Firefox for iOS
        ],
        [
            VERSION,
            [
                NAME,
                PREFIX_MOBILE + FIREFOX
            ]
        ],
        [
            /\bqihoobrowser\/?([\w\.]*)/i // 360
        ],
        [
            VERSION,
            [
                NAME,
                '360'
            ]
        ],
        [
            /\b(qq)\/([\w\.]+)/i // QQ
        ],
        [
            [
                NAME,
                /(.+)/,
                '$1Browser'
            ],
            VERSION
        ],
        [
            /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
        ],
        [
            [
                NAME,
                /(.+)/,
                '$1' + SUFFIX_BROWSER
            ],
            VERSION
        ],
        [
            /samsungbrowser\/([\w\.]+)/i // Samsung Internet
        ],
        [
            VERSION,
            [
                NAME,
                SAMSUNG + ' Internet'
            ]
        ],
        [
            /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
        ],
        [
            VERSION,
            [
                NAME,
                SOGOU + ' Explorer'
            ]
        ],
        [
            /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
        ],
        [
            [
                NAME,
                SOGOU + ' Mobile'
            ],
            VERSION
        ],
        [
            /(electron)\/([\w\.]+) safari/i,
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
            /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i // QQ/2345
        ],
        [
            NAME,
            VERSION
        ],
        [
            /(lbbrowser|rekonq)/i // LieBao Browser/Rekonq
        ],
        [
            NAME
        ],
        [
            /ome\/([\w\.]+) \w* ?(iron) saf/i,
            /ome\/([\w\.]+).+qihu (360)[es]e/i // 360
        ],
        [
            VERSION,
            NAME
        ],
        [
            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
        ],
        [
            [
                NAME,
                FACEBOOK
            ],
            VERSION,
            [
                TYPE,
                INAPP
            ]
        ],
        [
            /(Klarna)\/([\w\.]+)/i,
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
            /safari (line)\/([\w\.]+)/i,
            /\b(line)\/([\w\.]+)\/iab/i,
            /(alipay)client\/([\w\.]+)/i,
            /(twitter)(?:and| f.+e\/([\w\.]+))/i,
            /(instagram|snapchat)[\/ ]([-\w\.]+)/i // Instagram/Snapchat
        ],
        [
            NAME,
            VERSION,
            [
                TYPE,
                INAPP
            ]
        ],
        [
            /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
        ],
        [
            VERSION,
            [
                NAME,
                'GSA'
            ],
            [
                TYPE,
                INAPP
            ]
        ],
        [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
        ],
        [
            VERSION,
            [
                NAME,
                'TikTok'
            ],
            [
                TYPE,
                INAPP
            ]
        ],
        [
            /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
        ],
        [
            NAME,
            [
                TYPE,
                INAPP
            ]
        ],
        [
            /(chromium)[\/ ]([-\w\.]+)/i // Chromium
        ],
        [
            NAME,
            VERSION
        ],
        [
            /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
        ],
        [
            VERSION,
            [
                NAME,
                CHROME + ' Headless'
            ]
        ],
        [
            / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
        ],
        [
            [
                NAME,
                CHROME + ' WebView'
            ],
            VERSION
        ],
        [
            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
        ],
        [
            VERSION,
            [
                NAME,
                'Android' + SUFFIX_BROWSER
            ]
        ],
        [
            /chrome\/([\w\.]+) mobile/i // Chrome Mobile
        ],
        [
            VERSION,
            [
                NAME,
                PREFIX_MOBILE + 'Chrome'
            ]
        ],
        [
            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [
            NAME,
            VERSION
        ],
        [
            /version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i // Safari Mobile
        ],
        [
            VERSION,
            [
                NAME,
                PREFIX_MOBILE + 'Safari'
            ]
        ],
        [
            /iphone .*mobile(?:\/\w+ | ?)safari/i
        ],
        [
            [
                NAME,
                PREFIX_MOBILE + 'Safari'
            ]
        ],
        [
            /version\/([\w\.\,]+) .*(safari)/i // Safari
        ],
        [
            VERSION,
            NAME
        ],
        [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
        ],
        [
            NAME,
            [
                VERSION,
                '1'
            ]
        ],
        [
            /(webkit|khtml)\/([\w\.]+)/i
        ],
        [
            NAME,
            VERSION
        ],
        [
            // Gecko based
            /(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i // Firefox Mobile
        ],
        [
            [
                NAME,
                PREFIX_MOBILE + FIREFOX
            ],
            VERSION
        ],
        [
            /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
        ],
        [
            [
                NAME,
                'Netscape'
            ],
            VERSION
        ],
        [
            /(wolvic|librewolf)\/([\w\.]+)/i // Wolvic/LibreWolf
        ],
        [
            NAME,
            VERSION
        ],
        [
            /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
        ],
        [
            VERSION,
            [
                NAME,
                FIREFOX + ' Reality'
            ]
        ],
        [
            /ekiohf.+(flow)\/([\w\.]+)/i,
            /(swiftfox)/i,
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
            // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
            // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
            // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser
            /\b(links) \(([\w\.]+)/i // Links
        ],
        [
            NAME,
            [
                VERSION,
                /_/g,
                '.'
            ]
        ],
        [
            /(cobalt)\/([\w\.]+)/i // Cobalt
        ],
        [
            NAME,
            [
                VERSION,
                /[^\d\.]+./,
                EMPTY
            ]
        ]
    ],
    cpu: [
        [
            /\b(?:(amd|x|x86[-_]?|wow|win)64)\b/i // AMD64 (x64)
        ],
        [
            [
                ARCHITECTURE,
                'amd64'
            ]
        ],
        [
            /(ia32(?=;))/i,
            /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
        ],
        [
            [
                ARCHITECTURE,
                'ia32'
            ]
        ],
        [
            /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
        ],
        [
            [
                ARCHITECTURE,
                'arm64'
            ]
        ],
        [
            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
        ],
        [
            [
                ARCHITECTURE,
                'armhf'
            ]
        ],
        [
            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
        ],
        [
            [
                ARCHITECTURE,
                'arm'
            ]
        ],
        [
            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
        ],
        [
            [
                ARCHITECTURE,
                /ower/,
                EMPTY,
                lowerize
            ]
        ],
        [
            /(sun4\w)[;\)]/i // SPARC
        ],
        [
            [
                ARCHITECTURE,
                'sparc'
            ]
        ],
        [
            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
        ],
        [
            [
                ARCHITECTURE,
                lowerize
            ]
        ]
    ],
    device: [
        [
            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////
            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [
            MODEL,
            [
                VENDOR,
                SAMSUNG
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]((?!sm-[lr])[-\w]+)/i,
            /sec-(sgh\w+)/i
        ],
        [
            MODEL,
            [
                VENDOR,
                SAMSUNG
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
        ],
        [
            MODEL,
            [
                VENDOR,
                APPLE
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            /\((ipad);[-\w\),; ]+apple/i,
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [
            MODEL,
            [
                VENDOR,
                APPLE
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            /(macintosh);/i
        ],
        [
            MODEL,
            [
                VENDOR,
                APPLE
            ]
        ],
        [
            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [
            MODEL,
            [
                VENDOR,
                SHARP
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Honor
            /(?:honor)([-\w ]+)[;\)]/i
        ],
        [
            MODEL,
            [
                VENDOR,
                HONOR
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [
            MODEL,
            [
                VENDOR,
                HUAWEI
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            /(?:huawei)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [
            MODEL,
            [
                VENDOR,
                HUAWEI
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Xiaomi
            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
            /\b; (\w+) build\/hm\1/i,
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i // Xiaomi Mi
        ],
        [
            [
                MODEL,
                /_/g,
                ' '
            ],
            [
                VENDOR,
                XIAOMI
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
        ],
        [
            [
                MODEL,
                /_/g,
                ' '
            ],
            [
                VENDOR,
                XIAOMI
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [
            MODEL,
            [
                VENDOR,
                'OPPO'
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            /\b(opd2\d{3}a?) bui/i
        ],
        [
            MODEL,
            [
                VENDOR,
                'OPPO'
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [
            MODEL,
            [
                VENDOR,
                'Vivo'
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Realme
            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
        ],
        [
            MODEL,
            [
                VENDOR,
                'Realme'
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [
            MODEL,
            [
                VENDOR,
                MOTOROLA
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [
            MODEL,
            [
                VENDOR,
                MOTOROLA
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [
            MODEL,
            [
                VENDOR,
                LG
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
        ],
        [
            MODEL,
            [
                VENDOR,
                LG
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [
            MODEL,
            [
                VENDOR,
                LENOVO
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
        ],
        [
            [
                MODEL,
                /_/g,
                ' '
            ],
            [
                VENDOR,
                'Nokia'
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Google
            /(pixel c)\b/i // Google Pixel C
        ],
        [
            MODEL,
            [
                VENDOR,
                GOOGLE
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
        ],
        [
            MODEL,
            [
                VENDOR,
                GOOGLE
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Sony
            /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [
            MODEL,
            [
                VENDOR,
                SONY
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [
            [
                MODEL,
                'Xperia Tablet'
            ],
            [
                VENDOR,
                SONY
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [
            MODEL,
            [
                VENDOR,
                'OnePlus'
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
            /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
        ],
        [
            MODEL,
            [
                VENDOR,
                AMAZON
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
        ],
        [
            [
                MODEL,
                /(.+)/g,
                'Fire Phone $1'
            ],
            [
                VENDOR,
                AMAZON
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
        ],
        [
            MODEL,
            VENDOR,
            [
                TYPE,
                TABLET
            ]
        ],
        [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i // BlackBerry 10
        ],
        [
            MODEL,
            [
                VENDOR,
                BLACKBERRY
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [
            MODEL,
            [
                VENDOR,
                ASUS
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [
            MODEL,
            [
                VENDOR,
                ASUS
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // HTC
            /(nexus 9)/i // HTC Nexus 9
        ],
        [
            MODEL,
            [
                VENDOR,
                'HTC'
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [
            VENDOR,
            [
                MODEL,
                /_/g,
                ' '
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // TCL
            /tcl (xess p17aa)/i,
            /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])(_\w(\w|\w\w))?(\)| bui)/i
        ],
        [
            MODEL,
            [
                VENDOR,
                'TCL'
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            /droid [\w\.]+; (418(?:7d|8v)|5087z|5102l|61(?:02[dh]|25[adfh]|27[ai]|56[dh]|59k|65[ah])|a509dl|t(?:43(?:0w|1[adepqu])|50(?:6d|7[adju])|6(?:09dl|10k|12b|71[efho]|76[hjk])|7(?:66[ahju]|67[hw]|7[045][bh]|71[hk]|73o|76[ho]|79w|81[hks]?|82h|90[bhsy]|99b)|810[hs]))(_\w(\w|\w\w))?(\)| bui)/i
        ],
        [
            MODEL,
            [
                VENDOR,
                'TCL'
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // itel
            /(itel) ((\w+))/i
        ],
        [
            [
                VENDOR,
                lowerize
            ],
            MODEL,
            [
                TYPE,
                strMapper,
                {
                    'tablet': [
                        'p10001l',
                        'w7001'
                    ],
                    '*': 'mobile'
                }
            ]
        ],
        [
            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [
            MODEL,
            [
                VENDOR,
                'Acer'
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
        ],
        [
            MODEL,
            [
                VENDOR,
                'Meizu'
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Ulefone
            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
        ],
        [
            MODEL,
            [
                VENDOR,
                'Ulefone'
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Energizer
            /; (energy ?\w+)(?: bui|\))/i,
            /; energizer ([\w ]+)(?: bui|\))/i
        ],
        [
            MODEL,
            [
                VENDOR,
                'Energizer'
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Cat
            /; cat (b35);/i,
            /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
        ],
        [
            MODEL,
            [
                VENDOR,
                'Cat'
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Smartfren
            /((?:new )?andromax[\w- ]+)(?: bui|\))/i
        ],
        [
            MODEL,
            [
                VENDOR,
                'Smartfren'
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // Nothing
            /droid.+; (a(?:015|06[35]|142p?))/i
        ],
        [
            MODEL,
            [
                VENDOR,
                'Nothing'
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
            // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
            /; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i,
            /(hp) ([\w ]+\w)/i,
            /(asus)-?(\w+)/i,
            /(microsoft); (lumia[\w ]+)/i,
            /(lenovo)[-_ ]?([-\w]+)/i,
            /(jolla)/i,
            /(oppo) ?([\w ]+) bui/i // OPPO
        ],
        [
            VENDOR,
            MODEL,
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            /(imo) (tab \w+)/i,
            /(kobo)\s(ereader|touch)/i,
            /(archos) (gamepad2?)/i,
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
            /(kindle)\/([\w\.]+)/i // Kindle
        ],
        [
            VENDOR,
            MODEL,
            [
                TYPE,
                TABLET
            ]
        ],
        [
            /(surface duo)/i // Surface Duo
        ],
        [
            MODEL,
            [
                VENDOR,
                MICROSOFT
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
        ],
        [
            MODEL,
            [
                VENDOR,
                'Fairphone'
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            /(shield[\w ]+) b/i // Nvidia Shield Tablets
        ],
        [
            MODEL,
            [
                VENDOR,
                'Nvidia'
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            /(sprint) (\w+)/i // Sprint Phones
        ],
        [
            VENDOR,
            MODEL,
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            /(kin\.[onetw]{3})/i // Microsoft Kin
        ],
        [
            [
                MODEL,
                /\./g,
                ' '
            ],
            [
                VENDOR,
                MICROSOFT
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            /droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
        ],
        [
            MODEL,
            [
                VENDOR,
                ZEBRA
            ],
            [
                TYPE,
                TABLET
            ]
        ],
        [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [
            MODEL,
            [
                VENDOR,
                ZEBRA
            ],
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            ///////////////////
            // SMARTTVS
            ///////////////////
            /smart-tv.+(samsung)/i // Samsung
        ],
        [
            VENDOR,
            [
                TYPE,
                SMARTTV
            ]
        ],
        [
            /hbbtv.+maple;(\d+)/i
        ],
        [
            [
                MODEL,
                /^/,
                'SmartTV'
            ],
            [
                VENDOR,
                SAMSUNG
            ],
            [
                TYPE,
                SMARTTV
            ]
        ],
        [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
        ],
        [
            [
                VENDOR,
                LG
            ],
            [
                TYPE,
                SMARTTV
            ]
        ],
        [
            /(apple) ?tv/i // Apple TV
        ],
        [
            VENDOR,
            [
                MODEL,
                APPLE + ' TV'
            ],
            [
                TYPE,
                SMARTTV
            ]
        ],
        [
            /crkey.*devicetype\/chromecast/i // Google Chromecast Third Generation
        ],
        [
            [
                MODEL,
                CHROMECAST + ' Third Generation'
            ],
            [
                VENDOR,
                GOOGLE
            ],
            [
                TYPE,
                SMARTTV
            ]
        ],
        [
            /crkey.*devicetype\/([^/]*)/i // Google Chromecast with specific device type
        ],
        [
            [
                MODEL,
                /^/,
                'Chromecast '
            ],
            [
                VENDOR,
                GOOGLE
            ],
            [
                TYPE,
                SMARTTV
            ]
        ],
        [
            /fuchsia.*crkey/i // Google Chromecast Nest Hub
        ],
        [
            [
                MODEL,
                CHROMECAST + ' Nest Hub'
            ],
            [
                VENDOR,
                GOOGLE
            ],
            [
                TYPE,
                SMARTTV
            ]
        ],
        [
            /crkey/i // Google Chromecast, Linux-based or unknown
        ],
        [
            [
                MODEL,
                CHROMECAST
            ],
            [
                VENDOR,
                GOOGLE
            ],
            [
                TYPE,
                SMARTTV
            ]
        ],
        [
            /droid.+aft(\w+)( bui|\))/i // Fire TV
        ],
        [
            MODEL,
            [
                VENDOR,
                AMAZON
            ],
            [
                TYPE,
                SMARTTV
            ]
        ],
        [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i // Sharp
        ],
        [
            MODEL,
            [
                VENDOR,
                SHARP
            ],
            [
                TYPE,
                SMARTTV
            ]
        ],
        [
            /(bravia[\w ]+)( bui|\))/i // Sony
        ],
        [
            MODEL,
            [
                VENDOR,
                SONY
            ],
            [
                TYPE,
                SMARTTV
            ]
        ],
        [
            /(mitv-\w{5}) bui/i // Xiaomi
        ],
        [
            MODEL,
            [
                VENDOR,
                XIAOMI
            ],
            [
                TYPE,
                SMARTTV
            ]
        ],
        [
            /Hbbtv.*(technisat) (.*);/i // TechniSAT
        ],
        [
            VENDOR,
            MODEL,
            [
                TYPE,
                SMARTTV
            ]
        ],
        [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
        ],
        [
            [
                VENDOR,
                trim
            ],
            [
                MODEL,
                trim
            ],
            [
                TYPE,
                SMARTTV
            ]
        ],
        [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
        ],
        [
            [
                TYPE,
                SMARTTV
            ]
        ],
        [
            ///////////////////
            // CONSOLES
            ///////////////////
            /(ouya)/i,
            /(nintendo) (\w+)/i // Nintendo
        ],
        [
            VENDOR,
            MODEL,
            [
                TYPE,
                CONSOLE
            ]
        ],
        [
            /droid.+; (shield) bui/i // Nvidia
        ],
        [
            MODEL,
            [
                VENDOR,
                'Nvidia'
            ],
            [
                TYPE,
                CONSOLE
            ]
        ],
        [
            /(playstation \w+)/i // Playstation
        ],
        [
            MODEL,
            [
                VENDOR,
                SONY
            ],
            [
                TYPE,
                CONSOLE
            ]
        ],
        [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
        ],
        [
            MODEL,
            [
                VENDOR,
                MICROSOFT
            ],
            [
                TYPE,
                CONSOLE
            ]
        ],
        [
            ///////////////////
            // WEARABLES
            ///////////////////
            /\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i // Samsung Galaxy Watch
        ],
        [
            MODEL,
            [
                VENDOR,
                SAMSUNG
            ],
            [
                TYPE,
                WEARABLE
            ]
        ],
        [
            /((pebble))app/i // Pebble
        ],
        [
            VENDOR,
            MODEL,
            [
                TYPE,
                WEARABLE
            ]
        ],
        [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
        ],
        [
            MODEL,
            [
                VENDOR,
                APPLE
            ],
            [
                TYPE,
                WEARABLE
            ]
        ],
        [
            /droid.+; (wt63?0{2,3})\)/i
        ],
        [
            MODEL,
            [
                VENDOR,
                ZEBRA
            ],
            [
                TYPE,
                WEARABLE
            ]
        ],
        [
            ///////////////////
            // XR
            ///////////////////
            /droid.+; (glass) \d/i // Google Glass
        ],
        [
            MODEL,
            [
                VENDOR,
                GOOGLE
            ],
            [
                TYPE,
                XR
            ]
        ],
        [
            /(pico) (4|neo3(?: link|pro)?)/i // Pico
        ],
        [
            VENDOR,
            MODEL,
            [
                TYPE,
                XR
            ]
        ],
        [
            /; (quest( \d| pro)?)/i // Oculus Quest
        ],
        [
            MODEL,
            [
                VENDOR,
                FACEBOOK
            ],
            [
                TYPE,
                XR
            ]
        ],
        [
            ///////////////////
            // EMBEDDED
            ///////////////////
            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
        ],
        [
            VENDOR,
            [
                TYPE,
                EMBEDDED
            ]
        ],
        [
            /(aeobc)\b/i // Echo Dot
        ],
        [
            MODEL,
            [
                VENDOR,
                AMAZON
            ],
            [
                TYPE,
                EMBEDDED
            ]
        ],
        [
            ////////////////////
            // MIXED (GENERIC)
            ///////////////////
            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
        ],
        [
            MODEL,
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
        ],
        [
            MODEL,
            [
                TYPE,
                TABLET
            ]
        ],
        [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
        ],
        [
            [
                TYPE,
                TABLET
            ]
        ],
        [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
        ],
        [
            [
                TYPE,
                MOBILE
            ]
        ],
        [
            /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
        ],
        [
            MODEL,
            [
                VENDOR,
                'Generic'
            ]
        ]
    ],
    engine: [
        [
            /windows.+ edge\/([\w\.]+)/i // EdgeHTML
        ],
        [
            VERSION,
            [
                NAME,
                EDGE + 'HTML'
            ]
        ],
        [
            /(arkweb)\/([\w\.]+)/i // ArkWeb
        ],
        [
            NAME,
            VERSION
        ],
        [
            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
        ],
        [
            VERSION,
            [
                NAME,
                'Blink'
            ]
        ],
        [
            /(presto)\/([\w\.]+)/i,
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
            /ekioh(flow)\/([\w\.]+)/i,
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
            /(icab)[\/ ]([23]\.[\d\.]+)/i,
            /\b(libweb)/i
        ],
        [
            NAME,
            VERSION
        ],
        [
            /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
        ],
        [
            VERSION,
            NAME
        ]
    ],
    os: [
        [
            // Windows
            /microsoft (windows) (vista|xp)/i // Windows (iTunes)
        ],
        [
            NAME,
            VERSION
        ],
        [
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i // Windows Phone
        ],
        [
            NAME,
            [
                VERSION,
                strMapper,
                windowsVersionMap
            ]
        ],
        [
            /windows nt 6\.2; (arm)/i,
            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [
            [
                VERSION,
                strMapper,
                windowsVersionMap
            ],
            [
                NAME,
                WINDOWS
            ]
        ],
        [
            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
        ],
        [
            [
                VERSION,
                /_/g,
                '.'
            ],
            [
                NAME,
                'iOS'
            ]
        ],
        [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
        ],
        [
            [
                NAME,
                'macOS'
            ],
            [
                VERSION,
                /_/g,
                '.'
            ]
        ],
        [
            // Google Chromecast
            /android ([\d\.]+).*crkey/i // Google Chromecast, Android-based
        ],
        [
            VERSION,
            [
                NAME,
                CHROMECAST + ' Android'
            ]
        ],
        [
            /fuchsia.*crkey\/([\d\.]+)/i // Google Chromecast, Fuchsia-based
        ],
        [
            VERSION,
            [
                NAME,
                CHROMECAST + ' Fuchsia'
            ]
        ],
        [
            /crkey\/([\d\.]+).*devicetype\/smartspeaker/i // Google Chromecast, Linux-based Smart Speaker
        ],
        [
            VERSION,
            [
                NAME,
                CHROMECAST + ' SmartSpeaker'
            ]
        ],
        [
            /linux.*crkey\/([\d\.]+)/i // Google Chromecast, Legacy Linux-based
        ],
        [
            VERSION,
            [
                NAME,
                CHROMECAST + ' Linux'
            ]
        ],
        [
            /crkey\/([\d\.]+)/i // Google Chromecast, unknown
        ],
        [
            VERSION,
            [
                NAME,
                CHROMECAST
            ]
        ],
        [
            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
        ],
        [
            VERSION,
            NAME
        ],
        [
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,
            /(tizen|kaios)[\/ ]([\w\.]+)/i,
            /\((series40);/i // Series 40
        ],
        [
            NAME,
            VERSION
        ],
        [
            /\(bb(10);/i // BlackBerry 10
        ],
        [
            VERSION,
            [
                NAME,
                BLACKBERRY
            ]
        ],
        [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
        ],
        [
            VERSION,
            [
                NAME,
                'Symbian'
            ]
        ],
        [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
        ],
        [
            VERSION,
            [
                NAME,
                FIREFOX + ' OS'
            ]
        ],
        [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
        ],
        [
            VERSION,
            [
                NAME,
                'webOS'
            ]
        ],
        [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
        ],
        [
            VERSION,
            [
                NAME,
                'watchOS'
            ]
        ],
        [
            // Google ChromeOS
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
        ],
        [
            [
                NAME,
                "Chrome OS"
            ],
            VERSION
        ],
        [
            // Smart TVs
            /panasonic;(viera)/i,
            /(netrange)mmh/i,
            /(nettv)\/(\d+\.[\w\.]+)/i,
            // Console
            /(nintendo|playstation) (\w+)/i,
            /(xbox); +xbox ([^\);]+)/i,
            /(pico) .+os([\w\.]+)/i,
            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
            /(mint)[\/\(\) ]?(\w*)/i,
            /(mageia|vectorlinux)[; ]/i,
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
            // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,
            /(gnu) ?([\w\.]*)/i,
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
            /(haiku) (\w+)/i // Haiku
        ],
        [
            NAME,
            VERSION
        ],
        [
            /(sunos) ?([\w\.\d]*)/i // Solaris
        ],
        [
            [
                NAME,
                'Solaris'
            ],
            VERSION
        ],
        [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
            /(unix) ?([\w\.]*)/i // UNIX
        ],
        [
            NAME,
            VERSION
        ]
    ]
};
/////////////////
// Factories
////////////////
var defaultProps = function() {
    var props = {
        init: {},
        isIgnore: {},
        isIgnoreRgx: {},
        toString: {}
    };
    setProps.call(props.init, [
        [
            UA_BROWSER,
            [
                NAME,
                VERSION,
                MAJOR,
                TYPE
            ]
        ],
        [
            UA_CPU,
            [
                ARCHITECTURE
            ]
        ],
        [
            UA_DEVICE,
            [
                TYPE,
                MODEL,
                VENDOR
            ]
        ],
        [
            UA_ENGINE,
            [
                NAME,
                VERSION
            ]
        ],
        [
            UA_OS,
            [
                NAME,
                VERSION
            ]
        ]
    ]);
    setProps.call(props.isIgnore, [
        [
            UA_BROWSER,
            [
                VERSION,
                MAJOR
            ]
        ],
        [
            UA_ENGINE,
            [
                VERSION
            ]
        ],
        [
            UA_OS,
            [
                VERSION
            ]
        ]
    ]);
    setProps.call(props.isIgnoreRgx, [
        [
            UA_BROWSER,
            / ?browser$/i
        ],
        [
            UA_OS,
            / ?os$/i
        ]
    ]);
    setProps.call(props.toString, [
        [
            UA_BROWSER,
            [
                NAME,
                VERSION
            ]
        ],
        [
            UA_CPU,
            [
                ARCHITECTURE
            ]
        ],
        [
            UA_DEVICE,
            [
                VENDOR,
                MODEL
            ]
        ],
        [
            UA_ENGINE,
            [
                NAME,
                VERSION
            ]
        ],
        [
            UA_OS,
            [
                NAME,
                VERSION
            ]
        ]
    ]);
    return props;
}();
var createIData = function createIData(item, itemType) {
    var init_props = defaultProps.init[itemType], is_ignoreProps = defaultProps.isIgnore[itemType] || 0, is_ignoreRgx = defaultProps.isIgnoreRgx[itemType] || 0, toString_props = defaultProps.toString[itemType] || 0;
    function IData() {
        setProps.call(this, init_props);
    }
    IData.prototype.getItem = function() {
        return item;
    };
    IData.prototype.withClientHints = function() {
        // nodejs / non-client-hints browsers
        if (!NAVIGATOR_UADATA) {
            return item.parseCH().get();
        }
        // browsers based on chromium 85+
        return NAVIGATOR_UADATA.getHighEntropyValues(CH_ALL_VALUES).then(function(res) {
            return item.setCH(new UACHData(res, false)).parseCH().get();
        });
    };
    IData.prototype.withFeatureCheck = function() {
        return item.detectFeature().get();
    };
    if (itemType != UA_RESULT) {
        IData.prototype.is = function(strToCheck) {
            var is = false;
            for(var i in this){
                if (this.hasOwnProperty(i) && !has(is_ignoreProps, i) && lowerize(is_ignoreRgx ? strip(is_ignoreRgx, this[i]) : this[i]) == lowerize(is_ignoreRgx ? strip(is_ignoreRgx, strToCheck) : strToCheck)) {
                    is = true;
                    if (strToCheck != UNDEF_TYPE) break;
                } else if (strToCheck == UNDEF_TYPE && is) {
                    is = !is;
                    break;
                }
            }
            return is;
        };
        IData.prototype.toString = function() {
            var str = EMPTY;
            for(var i in toString_props){
                if (_type_of(this[toString_props[i]]) !== UNDEF_TYPE) {
                    str += (str ? ' ' : EMPTY) + this[toString_props[i]];
                }
            }
            return str || UNDEF_TYPE;
        };
    }
    if (!NAVIGATOR_UADATA) {
        IData.prototype.then = function(cb) {
            var that = this;
            var IDataResolve = function IDataResolve() {
                for(var prop in that){
                    if (that.hasOwnProperty(prop)) {
                        this[prop] = that[prop];
                    }
                }
            };
            IDataResolve.prototype = {
                is: IData.prototype.is,
                toString: IData.prototype.toString
            };
            var resolveData = new IDataResolve();
            cb(resolveData);
            return resolveData;
        };
    }
    return new IData();
};
/////////////////
// Constructor
////////////////
function UACHData(uach, isHttpUACH) {
    uach = uach || {};
    setProps.call(this, CH_ALL_VALUES);
    if (isHttpUACH) {
        setProps.call(this, [
            [
                BRANDS,
                itemListToArray(uach[CH_HEADER])
            ],
            [
                FULLVERLIST,
                itemListToArray(uach[CH_HEADER_FULL_VER_LIST])
            ],
            [
                MOBILE,
                /\?1/.test(uach[CH_HEADER_MOBILE])
            ],
            [
                MODEL,
                stripQuotes(uach[CH_HEADER_MODEL])
            ],
            [
                PLATFORM,
                stripQuotes(uach[CH_HEADER_PLATFORM])
            ],
            [
                PLATFORMVER,
                stripQuotes(uach[CH_HEADER_PLATFORM_VER])
            ],
            [
                ARCHITECTURE,
                stripQuotes(uach[CH_HEADER_ARCH])
            ],
            [
                FORMFACTORS,
                itemListToArray(uach[CH_HEADER_FORM_FACTORS])
            ],
            [
                BITNESS,
                stripQuotes(uach[CH_HEADER_BITNESS])
            ]
        ]);
    } else {
        for(var prop in uach){
            if (this.hasOwnProperty(prop) && _type_of(uach[prop]) !== UNDEF_TYPE) this[prop] = uach[prop];
        }
    }
}
function UAItem(itemType, ua, rgxMap, uaCH) {
    this.get = function(prop) {
        if (!prop) return this.data;
        return this.data.hasOwnProperty(prop) ? this.data[prop] : undefined;
    };
    this.set = function(prop, val) {
        this.data[prop] = val;
        return this;
    };
    this.setCH = function(ch) {
        this.uaCH = ch;
        return this;
    };
    this.detectFeature = function() {
        if (NAVIGATOR && NAVIGATOR.userAgent == this.ua) {
            switch(this.itemType){
                case UA_BROWSER:
                    // Brave-specific detection
                    if (NAVIGATOR.brave && _type_of(NAVIGATOR.brave.isBrave) == FUNC_TYPE) {
                        this.set(NAME, 'Brave');
                    }
                    break;
                case UA_DEVICE:
                    // Chrome-specific detection: check for 'mobile' value of navigator.userAgentData
                    if (!this.get(TYPE) && NAVIGATOR_UADATA && NAVIGATOR_UADATA[MOBILE]) {
                        this.set(TYPE, MOBILE);
                    }
                    // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
                    if (this.get(MODEL) == 'Macintosh' && NAVIGATOR && _type_of(NAVIGATOR.standalone) !== UNDEF_TYPE && NAVIGATOR.maxTouchPoints && NAVIGATOR.maxTouchPoints > 2) {
                        this.set(MODEL, 'iPad').set(TYPE, TABLET);
                    }
                    break;
                case UA_OS:
                    // Chrome-specific detection: check for 'platform' value of navigator.userAgentData
                    if (!this.get(NAME) && NAVIGATOR_UADATA && NAVIGATOR_UADATA[PLATFORM]) {
                        this.set(NAME, NAVIGATOR_UADATA[PLATFORM]);
                    }
                    break;
                case UA_RESULT:
                    var data = this.data;
                    var detect = function detect(itemType) {
                        return data[itemType].getItem().detectFeature().get();
                    };
                    this.set(UA_BROWSER, detect(UA_BROWSER)).set(UA_CPU, detect(UA_CPU)).set(UA_DEVICE, detect(UA_DEVICE)).set(UA_ENGINE, detect(UA_ENGINE)).set(UA_OS, detect(UA_OS));
            }
        }
        return this;
    };
    this.parseUA = function() {
        if (this.itemType != UA_RESULT) {
            rgxMapper.call(this.data, this.ua, this.rgxMap);
        }
        if (this.itemType == UA_BROWSER) {
            this.set(MAJOR, majorize(this.get(VERSION)));
        }
        return this;
    };
    this.parseCH = function() {
        var _$uaCH = this.uaCH, _$rgxMap = this.rgxMap;
        switch(this.itemType){
            case UA_BROWSER:
                var brands = _$uaCH[FULLVERLIST] || _$uaCH[BRANDS], prevName;
                if (brands) {
                    for(var i in brands){
                        var brandName = strip(/(Google|Microsoft) /, brands[i].brand || brands[i]), brandVersion = brands[i].version;
                        if (!/not.a.brand/i.test(brandName) && (!prevName || /chrom/i.test(prevName) && !/chromi/i.test(brandName))) {
                            this.set(NAME, brandName).set(VERSION, brandVersion).set(MAJOR, majorize(brandVersion));
                            prevName = brandName;
                        }
                    }
                }
                break;
            case UA_CPU:
                var archName = _$uaCH[ARCHITECTURE];
                if (archName) {
                    if (archName && _$uaCH[BITNESS] == '64') archName += '64';
                    rgxMapper.call(this.data, archName + ';', _$rgxMap);
                }
                break;
            case UA_DEVICE:
                if (_$uaCH[MOBILE]) {
                    this.set(TYPE, MOBILE);
                }
                if (_$uaCH[MODEL]) {
                    this.set(MODEL, _$uaCH[MODEL]);
                }
                // Xbox-Specific Detection
                if (_$uaCH[MODEL] == 'Xbox') {
                    this.set(TYPE, CONSOLE).set(VENDOR, MICROSOFT);
                }
                if (_$uaCH[FORMFACTORS]) {
                    var ff;
                    if (typeof _$uaCH[FORMFACTORS] !== 'string') {
                        var idx = 0;
                        while(!ff && idx < _$uaCH[FORMFACTORS].length){
                            ff = strMapper(_$uaCH[FORMFACTORS][idx++], formFactorsMap);
                        }
                    } else {
                        ff = strMapper(_$uaCH[FORMFACTORS], formFactorsMap);
                    }
                    this.set(TYPE, ff);
                }
                break;
            case UA_OS:
                var osName = _$uaCH[PLATFORM];
                if (osName) {
                    var osVersion = _$uaCH[PLATFORMVER];
                    if (osName == WINDOWS) osVersion = parseInt(majorize(osVersion), 10) >= 13 ? '11' : '10';
                    this.set(NAME, osName).set(VERSION, osVersion);
                }
                // Xbox-Specific Detection
                if (this.get(NAME) == WINDOWS && _$uaCH[MODEL] == 'Xbox') {
                    this.set(NAME, 'Xbox').set(VERSION, undefined);
                }
                break;
            case UA_RESULT:
                var data = this.data;
                var parse = function parse(itemType) {
                    return data[itemType].getItem().setCH(_$uaCH).parseCH().get();
                };
                this.set(UA_BROWSER, parse(UA_BROWSER)).set(UA_CPU, parse(UA_CPU)).set(UA_DEVICE, parse(UA_DEVICE)).set(UA_ENGINE, parse(UA_ENGINE)).set(UA_OS, parse(UA_OS));
        }
        return this;
    };
    setProps.call(this, [
        [
            'itemType',
            itemType
        ],
        [
            'ua',
            ua
        ],
        [
            'uaCH',
            uaCH
        ],
        [
            'rgxMap',
            rgxMap
        ],
        [
            'data',
            createIData(this, itemType)
        ]
    ]);
    return this;
}
function UAParser(ua, extensions, headers) {
    if ((typeof ua === "undefined" ? "undefined" : _type_of(ua)) === OBJ_TYPE) {
        if (isExtensions(ua, true)) {
            if ((typeof extensions === "undefined" ? "undefined" : _type_of(extensions)) === OBJ_TYPE) {
                headers = extensions; // case UAParser(extensions, headers)           
            }
            extensions = ua; // case UAParser(extensions)
        } else {
            headers = ua; // case UAParser(headers)
            extensions = undefined;
        }
        ua = undefined;
    } else if ((typeof ua === "undefined" ? "undefined" : _type_of(ua)) === STR_TYPE && !isExtensions(extensions, true)) {
        headers = extensions; // case UAParser(ua, headers)
        extensions = undefined;
    }
    // Convert Headers object into a plain object
    if (headers && _type_of(headers.append) === FUNC_TYPE) {
        var kv = {};
        headers.forEach(function(v, k) {
            kv[k] = v;
        });
        headers = kv;
    }
    if (!_instanceof(this, UAParser)) {
        return new UAParser(ua, extensions, headers).getResult();
    }
    var userAgent = (typeof ua === "undefined" ? "undefined" : _type_of(ua)) === STR_TYPE ? ua : headers && headers[USER_AGENT] ? headers[USER_AGENT] : NAVIGATOR && NAVIGATOR.userAgent ? NAVIGATOR.userAgent : EMPTY, httpUACH = new UACHData(headers, true), regexMap = extensions ? extend(defaultRegexes, extensions) : defaultRegexes, createItemFunc = function createItemFunc(itemType) {
        if (itemType == UA_RESULT) {
            return function() {
                return new UAItem(itemType, userAgent, regexMap, httpUACH).set('ua', userAgent).set(UA_BROWSER, this.getBrowser()).set(UA_CPU, this.getCPU()).set(UA_DEVICE, this.getDevice()).set(UA_ENGINE, this.getEngine()).set(UA_OS, this.getOS()).get();
            };
        } else {
            return function() {
                return new UAItem(itemType, userAgent, regexMap[itemType], httpUACH).parseUA().get();
            };
        }
    };
    // public methods
    setProps.call(this, [
        [
            'getBrowser',
            createItemFunc(UA_BROWSER)
        ],
        [
            'getCPU',
            createItemFunc(UA_CPU)
        ],
        [
            'getDevice',
            createItemFunc(UA_DEVICE)
        ],
        [
            'getEngine',
            createItemFunc(UA_ENGINE)
        ],
        [
            'getOS',
            createItemFunc(UA_OS)
        ],
        [
            'getResult',
            createItemFunc(UA_RESULT)
        ],
        [
            'getUA',
            function() {
                return userAgent;
            }
        ],
        [
            'setUA',
            function(ua) {
                if (isString(ua)) userAgent = ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
                return this;
            }
        ]
    ]).setUA(userAgent);
    return this;
}
UAParser.VERSION = LIBVERSION;
UAParser.BROWSER = enumerize([
    NAME,
    VERSION,
    MAJOR,
    TYPE
]);
UAParser.CPU = enumerize([
    ARCHITECTURE
]);
UAParser.DEVICE = enumerize([
    MODEL,
    VENDOR,
    TYPE,
    CONSOLE,
    MOBILE,
    SMARTTV,
    TABLET,
    WEARABLE,
    EMBEDDED
]);
UAParser.ENGINE = UAParser.OS = enumerize([
    NAME,
    VERSION
]);

function getPlatformInfo(userAgent) {
    const parser = new UAParser(userAgent);
    const result = parser.getResult();
    return {
        browser: result.browser.name || '',
        browserVersion: result.browser.version || '',
        manufacturer: result.device.vendor || '',
        os: result.os.name || '',
        osVersion: result.os.version || '',
        product: result.device.model || '',
        userAgent: parser.getUA()
    };
}

const convertExpiryDate = (dateStr)=>{
    if (!dateStr) return;
    const [month, shortYear] = dateStr.split('/');
    const expiryMonth = month.padStart(2, '0');
    const expiryYear = `20${shortYear}`;
    return {
        expiryMonth,
        expiryYear
    };
};

class BaseDevcodeMethod extends BasePaymentMethod {
    get redirectBaseUrl() {
        return AppState.wallet.redirectBaseUrl;
    // TODO: investigate how the old cashier uses the default redirect urls and handle them
    // return 'https://casino-citizen.eks-stage01.gigndvr.com/cashier/redirect.html';
    }
    get service() {
        return this.params.service;
    }
    // TODO: check the some methods as Devcode could have a few services for some payment methods
    // BANK has Pay_BY_BANK and more services
    get providerServiceId() {
        return this.params.paymentMethodExternalId + (this.service ? '::' + this.service : '');
    }
    get devcodeGateway() {
        return GatewayRegistry.getGateway(GatewayType.Devcode);
    }
    get flowType() {
        var _this_params;
        return ((_this_params = this.params) == null ? void 0 : _this_params.flowType) || EDevcodeMethodFlowType.Custom;
    }
    getProfileDetails() {
        const profile = AppState.wallet.profile;
        if (!profile) {
            throw new Error('User profile is missing');
        }
        const { customer } = profile;
        const phone = extractUSAPhone(customer.phone);
        const payByBankLaunchConfig = {
            customerDetails: _extends$1({}, customer, {
                phone
            }),
            billingDetails: profile.billingAddress,
            phone
        };
        return payByBankLaunchConfig;
    }
}

class BaseDevcodeRedirectMethod extends BaseDevcodeMethod {
    get methodLabel() {
        return capitalize(this.paymentMethodExternalId);
    }
    get getPopupUrl() {
        return this.redirectBaseUrl;
    }
    async withdraw(amount, _savedMethod) {
        var _AppState_wallet_profile_customer, _AppState_wallet_profile, _response_redirectOutput;
        const options = {
            data: _extends$1({
                amount,
                attributes: {
                    channelId: getScreenType(),
                    iovationBlackbox: '',
                    type: 'Standard',
                    successUrl: this.getStatusRedirectUrl(ERedirectStatus.Success),
                    failureUrl: this.getStatusRedirectUrl(ERedirectStatus.Fail),
                    pendingUrl: this.getStatusRedirectUrl(ERedirectStatus.Pending),
                    cancelUrl: this.getStatusRedirectUrl(ERedirectStatus.Cancel),
                    userPlatform: JSON.stringify(getPlatformInfo(navigator.userAgent))
                },
                email: (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : (_AppState_wallet_profile_customer = _AppState_wallet_profile.customer) == null ? void 0 : _AppState_wallet_profile_customer.email
            }, this.getSpecificWithdrawData()),
            type: this.paymentMethodExternalId.toLowerCase()
        };
        if (this.service) {
            options.data.service = this.service;
        }
        this.logAttempt(amount);
        const response = await this.devcodeGateway.withdrawal(options);
        const launchWithdrawResult = {
            currencyCode: this.currencyCode,
            success: response.success,
            transactionID: response.txRefId,
            amount,
            popupUrl: this.redirectBaseUrl,
            paymentMethod: this.methodLabel,
            promoCode: AppState.wallet.chosenDepositBonus || ''
        };
        if (((_response_redirectOutput = response.redirectOutput) == null ? void 0 : _response_redirectOutput.container) === ERedirectContainer.Iframe) {
            const formattedUrl = formatRedirectURL(response.redirectOutput.url, response.redirectOutput.parameters);
            launchWithdrawResult.buttonUrl = formattedUrl;
        }
        void this.showWithdrawResult(launchWithdrawResult, response);
    }
    async deposit(amount) {
        await this.showUIDepositForm(amount);
        const { response, launchDepositResult } = await this.processDeposit(amount);
        void this.showDepositResult(launchDepositResult, response);
    }
    async processDeposit(amount) {
        var _AppState_wallet_profile_customer, _AppState_wallet_profile, _response_redirectOutput;
        this.amount = amount;
        const options = {
            data: _extends$1({
                amount: this.amount,
                attributes: {
                    bonusCode: AppState.wallet.chosenDepositBonus || '',
                    channelId: getScreenType(),
                    iovationBlackbox: '',
                    type: 'Standard',
                    // TODO: check old cashier implementation of redirection
                    successUrl: this.getStatusRedirectUrl(ERedirectStatus.Success),
                    failureUrl: this.getStatusRedirectUrl(ERedirectStatus.Fail),
                    pendingUrl: this.getStatusRedirectUrl(ERedirectStatus.Pending),
                    cancelUrl: this.getStatusRedirectUrl(ERedirectStatus.Cancel),
                    //FYI: Devcode API returns error when userPlatform is not stringified
                    userPlatform: JSON.stringify(getPlatformInfo(navigator.userAgent))
                },
                email: (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : (_AppState_wallet_profile_customer = _AppState_wallet_profile.customer) == null ? void 0 : _AppState_wallet_profile_customer.email
            }, this.getSpecificDepositData()),
            type: this.paymentMethodExternalId.toLowerCase()
        };
        if (this.service) {
            options.data.service = this.service;
        }
        this.logAttempt(amount);
        const response = await this.devcodeGateway.deposit(options);
        const launchDepositResult = {
            currencyCode: this.currencyCode,
            success: response.success,
            transactionID: response.txRefId,
            amount,
            popupUrl: this.getPopupUrl,
            paymentMethod: this.paymentMethodExternalId,
            paymentMethodLabel: this.methodLabel,
            promoCode: AppState.wallet.chosenDepositBonus || ''
        };
        if (((_response_redirectOutput = response.redirectOutput) == null ? void 0 : _response_redirectOutput.container) === ERedirectContainer.Iframe) {
            const formattedUrl = formatRedirectURL(response.redirectOutput.url, response.redirectOutput.parameters);
            launchDepositResult.buttonUrl = formattedUrl;
        }
        return {
            response,
            launchDepositResult
        };
    }
    async showWithdrawResult(launchWithdrawResult, response) {
        const launchWithdrawData = {
            amount: launchWithdrawResult.amount,
            currencyCode: this.currencyCode,
            success: false,
            paymentMethod: this.paymentMethodExternalId,
            paymentMethodLabel: this.methodLabel,
            transactionID: response.txId
        };
        if (response.txState === 'WAITING_APPROVAL') {
            const { message, title } = this.getWaitingForApprovalStatusMessage();
            this.logPayment(_extends$1({}, launchWithdrawData, {
                success: true
            }));
            createWithdrawStatusScreen(launchWithdrawResult, message, title);
            void PendingBalanceCheck.checkWithdrawalBalance(launchWithdrawResult);
            return;
        }
        if (!launchWithdrawResult.success) {
            this.logPayment(launchWithdrawData);
            createWithdrawStatusScreen(launchWithdrawResult);
            return;
        }
        const iframeElement = this.flowType === EDevcodeMethodFlowType.NestedIframe ? createCloseIframeDialog(response.redirectOutput) : null;
        const redirectResult = await ProxyListener.openWindow(launchWithdrawResult.buttonUrl, launchWithdrawResult.popupUrl, (iframeElement == null ? void 0 : iframeElement.contentWindow) || null);
        const status = (redirectResult == null ? void 0 : redirectResult.status) || ERedirectStatus.PopupClosed;
        const customResult = specificRedirectMessages(true)[status];
        if (status === ERedirectStatus.PopupClosed) {
            this.logPayment(_extends$1({}, launchWithdrawData, {
                success: false
            }));
            return;
        }
        if (status === ERedirectStatus.Cancel) {
            this.logPayment(_extends$1({}, launchWithdrawData, {
                success: false
            }));
            createWithdrawView();
            return;
        }
        launchWithdrawData.errorText = this.prepareMessage(launchWithdrawData, customResult == null ? void 0 : customResult.specificMessage);
        launchWithdrawData.specificTitle = customResult == null ? void 0 : customResult.specificTitle;
        if ((redirectResult == null ? void 0 : redirectResult.txState) === this.paymentMethodExternalId) {
            if (redirectResult.status === ERedirectStatus.Success) {
                launchWithdrawData.success = true;
                createWithdrawStatusScreen(launchWithdrawData);
            } else if (redirectResult.status === ERedirectStatus.Pending) {
                launchWithdrawData.success = true;
                const { message, title } = this.getWaitingForApprovalStatusMessage();
                createWithdrawStatusScreen(launchWithdrawResult, message, title);
                void PendingBalanceCheck.checkWithdrawalBalance(launchWithdrawResult);
            } else {
                createWithdrawStatusScreen(launchWithdrawData);
            }
        } else {
            createWithdrawStatusScreen(launchWithdrawData);
        }
        this.logPayment(launchWithdrawData);
    }
    async showDepositResult(launchDepositResult, response) {
        const depositResultData = {
            amount: launchDepositResult.amount,
            currencyCode: this.currencyCode,
            success: false,
            paymentMethod: this.paymentMethodExternalId,
            paymentMethodLabel: this.methodLabel,
            transactionID: response.txId
        };
        const quickPayment = document.querySelector('magic-quick-payment-content');
        if (!launchDepositResult.success) {
            if (quickPayment) {
                quickDepositCompleted('popupClosed');
            }
            this.logPayment(depositResultData);
            emitDepositResult(depositResultData);
            createDepositStatusScreen(depositResultData);
            scrollToTop();
            return;
        }
        // add condition when NO any redirectOutput value, so we're just need to show simple success screen
        if (!(response == null ? void 0 : response.redirectOutput) && response.success) {
            depositResultData.success = true;
            if (quickPayment) {
                quickDepositCompleted('success');
            }
            this.logPayment(depositResultData);
            emitDepositResult(depositResultData);
            createDepositStatusScreen(depositResultData);
            scrollToTop();
            return;
        }
        scrollToTop();
        const iframeElement = this.flowType === EDevcodeMethodFlowType.NestedIframe ? createCloseIframeDialog(response.redirectOutput) : null;
        const redirectResult = await ProxyListener.openWindow(launchDepositResult.buttonUrl, launchDepositResult.popupUrl, (iframeElement == null ? void 0 : iframeElement.contentWindow) || null);
        const status = (redirectResult == null ? void 0 : redirectResult.status) || ERedirectStatus.PopupClosed;
        const customResult = specificRedirectMessages()[status];
        if (quickPayment) {
            quickDepositCompleted(status);
        }
        if (status === ERedirectStatus.PopupClosed) {
            this.logPayment(_extends$1({}, depositResultData, {
                success: false
            }));
            return;
        }
        if (status === ERedirectStatus.Cancel) {
            this.logPayment(_extends$1({}, depositResultData, {
                success: false
            }));
            createDepositView$1();
            return;
        }
        // try to get specific translations for different statuses
        depositResultData.errorText = this.prepareMessage(depositResultData, customResult == null ? void 0 : customResult.specificMessage);
        depositResultData.specificTitle = customResult == null ? void 0 : customResult.specificTitle;
        if ((redirectResult == null ? void 0 : redirectResult.txState) === this.paymentMethodExternalId) {
            if (redirectResult.status === ERedirectStatus.Pending) {
                depositResultData.success = true;
                createDepositPaypalCompleteMessage(depositResultData, handleDepositSuccess(depositResultData));
            } else if (redirectResult.status === ERedirectStatus.Success) {
                depositResultData.success = true;
                createDepositStatusScreen(depositResultData);
            } else {
                createDepositStatusScreen(depositResultData);
            }
        } else {
            createDepositStatusScreen(depositResultData);
        }
        emitDepositResult(depositResultData);
        this.logPayment(depositResultData);
    }
    prepareMessage(data, message) {
        if (!message) {
            return '';
        }
        return message.replace('{method}', this.methodLabel).replace('{amount}', formatCurrency(data.amount, data.currencyCode)).replace('{transactionID}', data.transactionID);
    }
    getStatusRedirectUrl(status) {
        return this.getRedirectionUrl(this.redirectBaseUrl, this.paymentMethodExternalId, status);
    }
    getSpecificDepositData() {
        return {};
    }
    getSpecificWithdrawData() {
        return {};
    }
    async showUIDepositForm(_amount, _inputParams) {
        return Promise.resolve({});
    }
}

class BaseDevcodeNestedIframeMethod extends BaseDevcodeRedirectMethod {
    get flowType() {
        return EDevcodeMethodFlowType.NestedIframe;
    }
}

var _amount = /*#__PURE__*/ _class_private_field_loose_key("_amount"), _proceedDeposit = /*#__PURE__*/ _class_private_field_loose_key("_proceedDeposit");
class BaseDevcodeCardMethod extends BaseDevcodeNestedIframeMethod {
    async deposit(amount) {
        _class_private_field_loose_base(this, _amount)[_amount] = amount;
        this.createCardDetailsScreen();
    }
    createCardDetailsScreen() {
        const content = getCurrentTab();
        content.innerHTML = getCreditCardDetailsPage(_class_private_field_loose_base(this, _amount)[_amount]);
        scrollToTop();
        initializeCardForm(_class_private_field_loose_base(this, _proceedDeposit)[_proceedDeposit].bind(this));
        const { environment, merchantId } = this.devcodeGateway.config;
        void injectEncryptionScript(environment, merchantId);
    }
    constructor(...args){
        super(...args), Object.defineProperty(this, _proceedDeposit, {
            value: proceedDeposit
        }), Object.defineProperty(this, _amount, {
            writable: true,
            value: void 0
        }), _class_private_field_loose_base(this, _amount)[_amount] = 0;
    }
}
async function proceedDeposit(data) {
    var _convertExpiryDate, _convertExpiryDate1, _response_redirectOutput;
    const options = {
        data: {
            amount: _class_private_field_loose_base(this, _amount)[_amount],
            attributes: {
                bonusCode: AppState.wallet.chosenDepositBonus || '',
                channelId: getScreenType(),
                iovationBlackbox: '',
                type: 'Standard',
                successUrl: this.getStatusRedirectUrl(ERedirectStatus.Success),
                failureUrl: this.getStatusRedirectUrl(ERedirectStatus.Fail),
                pendingUrl: this.getStatusRedirectUrl(ERedirectStatus.Pending),
                cancelUrl: this.getStatusRedirectUrl(ERedirectStatus.Cancel),
                //FYI: Devcode API returns error when userPlatform is not stringified
                userPlatform: JSON.stringify(getPlatformInfo(navigator.userAgent))
            },
            cardHolder: data.holder,
            encCvv: getEncryptedValue(data.cvc),
            encCreditcardNumber: getEncryptedValue(data.number),
            expiryMonth: (_convertExpiryDate = convertExpiryDate(data.expiry)) == null ? void 0 : _convertExpiryDate.expiryMonth,
            expiryYear: (_convertExpiryDate1 = convertExpiryDate(data.expiry)) == null ? void 0 : _convertExpiryDate1.expiryYear
        },
        type: this.paymentMethodExternalId.toLowerCase()
    };
    this.logAttempt(_class_private_field_loose_base(this, _amount)[_amount]);
    const response = await this.devcodeGateway.deposit(options);
    const launchDepositResult = {
        success: response.success,
        amount: _class_private_field_loose_base(this, _amount)[_amount],
        popupUrl: this.redirectBaseUrl,
        currencyCode: AppState.wallet.balanceData.currencyCode,
        transactionID: response.txId,
        creditCard: response == null ? void 0 : response.maskedAccount,
        paymentMethodLabel: 'card'
    };
    if (((_response_redirectOutput = response.redirectOutput) == null ? void 0 : _response_redirectOutput.container) === ERedirectContainer.Iframe) {
        const formattedUrl = formatRedirectURL(response.redirectOutput.url, response.redirectOutput.parameters);
        launchDepositResult.buttonUrl = formattedUrl;
        void this.showDepositResult(launchDepositResult, response);
    } else {
        this.logPayment(launchDepositResult);
        emitDepositResult(launchDepositResult);
        createDepositStatusScreen(launchDepositResult);
    }
}

/**
 * Validate IBAN
 * ```
 * // returns true
 * ibantools.isValidIBAN("NL91ABNA0417164300");
 * ```
 * ```
 * // returns false
 * ibantools.isValidIBAN("NL92ABNA0517164300");
 * ```
 * ```
 * // returns true
 * ibantools.isValidIBAN('CH4431999123000889012');
 * ```
 * ```
 * // returns false
 * ibantools.isValidIBAN('CH4431999123000889012', { allowQRIBAN: false });
 * ```
 */ function isValidIBAN(iban, validationOptions) {
    if (validationOptions === void 0) {
        validationOptions = {
            allowQRIBAN: true
        };
    }
    if (iban === undefined || iban === null) return false;
    var reg = new RegExp('^[0-9]{2}$', '');
    var countryCode = iban.slice(0, 2);
    var spec = countrySpecs[countryCode];
    if (spec === undefined || spec.bban_regexp === undefined || spec.bban_regexp === null || spec.chars === undefined) return false;
    return spec.chars === iban.length && reg.test(iban.slice(2, 4)) && isValidBBAN(iban.slice(4), countryCode) && isValidIBANChecksum(iban) && (validationOptions.allowQRIBAN || !isQRIBAN(iban));
}
/**
 * IBAM validation errors
 */ var ValidationErrorsIBAN;
(function(ValidationErrorsIBAN) {
    ValidationErrorsIBAN[ValidationErrorsIBAN["NoIBANProvided"] = 0] = "NoIBANProvided";
    ValidationErrorsIBAN[ValidationErrorsIBAN["NoIBANCountry"] = 1] = "NoIBANCountry";
    ValidationErrorsIBAN[ValidationErrorsIBAN["WrongBBANLength"] = 2] = "WrongBBANLength";
    ValidationErrorsIBAN[ValidationErrorsIBAN["WrongBBANFormat"] = 3] = "WrongBBANFormat";
    ValidationErrorsIBAN[ValidationErrorsIBAN["ChecksumNotNumber"] = 4] = "ChecksumNotNumber";
    ValidationErrorsIBAN[ValidationErrorsIBAN["WrongIBANChecksum"] = 5] = "WrongIBANChecksum";
    ValidationErrorsIBAN[ValidationErrorsIBAN["WrongAccountBankBranchChecksum"] = 6] = "WrongAccountBankBranchChecksum";
    ValidationErrorsIBAN[ValidationErrorsIBAN["QRIBANNotAllowed"] = 7] = "QRIBANNotAllowed";
})(ValidationErrorsIBAN || (ValidationErrorsIBAN = {}));
/**
 * Validate BBAN
 *
 * ```
 * // returns true
 * ibantools.isValidBBAN("ABNA0417164300", "NL");
 * ```
 * ```
 * // returns false
 * ibantools.isValidBBAN("A7NA0517164300", "NL");
 * ```
 */ function isValidBBAN(bban, countryCode) {
    if (bban === undefined || bban === null || countryCode === undefined || countryCode === null) return false;
    var spec = countrySpecs[countryCode];
    if (spec === undefined || spec === null || spec.bban_regexp === undefined || spec.bban_regexp === null || spec.chars === undefined || spec.chars === null) return false;
    if (spec.chars - 4 === bban.length && checkFormatBBAN(bban, spec.bban_regexp)) {
        if (spec.bban_validation_func) {
            return spec.bban_validation_func(bban.replace(/[\s.]+/g, ''));
        }
        return true;
    }
    return false;
}
/**
 * Check if IBAN is QR-IBAN
 * ```
 * // returns true
 * ibantools.isQRIBAN("CH4431999123000889012");
 * ```
 * ```
 * // returns false
 * ibantools.isQRIBAN("NL92ABNA0517164300");
 * ```
 */ function isQRIBAN(iban) {
    if (iban === undefined || iban === null) return false;
    var countryCode = iban.slice(0, 2);
    var QRIBANCountries = [
        'LI',
        'CH'
    ];
    if (!QRIBANCountries.includes(countryCode)) return false;
    var reg = new RegExp('^3[0-1]{1}[0-9]{3}$', '');
    return reg.test(iban.slice(4, 9));
}
/**
 * Check BBAN format
 *
 * @ignore
 */ function checkFormatBBAN(bban, bformat) {
    var reg = new RegExp(bformat, '');
    return reg.test(bban);
}
/**
 * Calculate checksum of IBAN and compares it with checksum provided in IBAN Registry
 *
 * @ignore
 */ function isValidIBANChecksum(iban) {
    var countryCode = iban.slice(0, 2);
    var providedChecksum = parseInt(iban.slice(2, 4), 10);
    var bban = iban.slice(4);
    // Wikipedia[validating_iban] says there are a specif way to check if a IBAN is valid but
    // it. It says 'If the remainder is 1, the check digit test is passed and the
    // IBAN might be valid.'. might, MIGHT!
    // We don't want might but want yes or no. Since every BBAN is IBAN from the fifth
    // (slice(4)) we can generate the IBAN from BBAN and country code(two first characters)
    // from in the IBAN.
    // To generate the (generate the iban check digits)[generating-iban-check]
    //   Move the country code to the end
    //   remove the checksum from the begging
    //   Add "00" to the end
    //   modulo 97 on the amount
    //   subtract remainder from 98, (98 - remainder)
    //   Add a leading 0 if the remainder is less then 10 (padStart(2, "0")) (we skip this
    //     since we compare int, not string)
    //
    // [validating_iban][https://en.wikipedia.org/wiki/International_Bank_Account_Number#Validating_the_IBAN]
    // [generating-iban-check][https://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits]
    var validationString = replaceCharaterWithCode("".concat(bban).concat(countryCode, "00"));
    var rest = mod9710(validationString);
    return 98 - rest === providedChecksum;
}
/**
 * Iban contain characters and should be converted to intereger by 55 substracted
 * from there ascii value
 *
 * @ignore
 */ function replaceCharaterWithCode(str) {
    // It is slower but alot more readable
    // https://jsbench.me/ttkzgsekae/1
    return str.split('').map(function(c) {
        var code = c.charCodeAt(0);
        return code >= 65 ? (code - 55).toString() : c;
    }).join('');
}
/**
 * Validate BIC/SWIFT
 *
 * ```
 * // returns true
 * ibantools.isValidBIC("ABNANL2A");
 *
 * // returns true
 * ibantools.isValidBIC("NEDSZAJJXXX");
 *
 * // returns false
 * ibantools.isValidBIC("ABN4NL2A");
 *
 * // returns false
 * ibantools.isValidBIC("ABNA NL 2A");
 * ```
 */ function isValidBIC(bic) {
    if (!bic) {
        return false;
    }
    var reg = new RegExp('^[a-zA-Z]{6}[a-zA-Z0-9]{2}([a-zA-Z0-9]{3})?$', '');
    var spec = countrySpecs[bic.toUpperCase().slice(4, 6)];
    return reg.test(bic) && spec !== undefined;
}
/**
 * BIC validation errors
 */ var ValidationErrorsBIC;
(function(ValidationErrorsBIC) {
    ValidationErrorsBIC[ValidationErrorsBIC["NoBICProvided"] = 0] = "NoBICProvided";
    ValidationErrorsBIC[ValidationErrorsBIC["NoBICCountry"] = 1] = "NoBICCountry";
    ValidationErrorsBIC[ValidationErrorsBIC["WrongBICFormat"] = 2] = "WrongBICFormat";
})(ValidationErrorsBIC || (ValidationErrorsBIC = {}));
/**
 * Used for Norway BBAN check
 *
 * @ignore
 */ var checkNorwayBBAN = function checkNorwayBBAN(bban) {
    var weights = [
        5,
        4,
        3,
        2,
        7,
        6,
        5,
        4,
        3,
        2
    ];
    var bbanWithoutSpacesAndPeriods = bban.replace(/[\s.]+/g, '');
    var controlDigit = parseInt(bbanWithoutSpacesAndPeriods.charAt(10), 10);
    var bbanWithoutControlDigit = bbanWithoutSpacesAndPeriods.substring(0, 10);
    var sum = 0;
    for(var index = 0; index < 10; index++){
        sum += parseInt(bbanWithoutControlDigit.charAt(index), 10) * weights[index];
    }
    var remainder = sum % 11;
    return controlDigit === (remainder === 0 ? 0 : 11 - remainder);
};
/**
 * Used for Belgian BBAN check
 *
 * @ignore
 */ var checkBelgianBBAN = function checkBelgianBBAN(bban) {
    var stripped = bban.replace(/[\s.]+/g, '');
    var checkingPart = parseInt(stripped.substring(0, stripped.length - 2), 10);
    var checksum = parseInt(stripped.substring(stripped.length - 2, stripped.length), 10);
    var remainder = checkingPart % 97 === 0 ? 97 : checkingPart % 97;
    return remainder === checksum;
};
/**
 * Mod 97/10 calculation
 *
 * @ignore
 */ var mod9710 = function mod9710(validationString) {
    while(validationString.length > 2){
        // > Any computer programming language or software package that is used to compute D
        // > mod 97 directly must have the ability to handle integers of more than 30 digits.
        // > In practice, this can only be done by software that either supports
        // > arbitrary-precision arithmetic or that can handle 219-bit (unsigned) integers
        // https://en.wikipedia.org/wiki/International_Bank_Account_Number#Modulo_operation_on_IBAN
        var part = validationString.slice(0, 6);
        var partInt = parseInt(part, 10);
        if (isNaN(partInt)) {
            return NaN;
        }
        validationString = partInt % 97 + validationString.slice(part.length);
    }
    return parseInt(validationString, 10) % 97;
};
/**
 * Check BBAN based on Mod97/10 calculation for countries that support it:
 * BA, ME, MK, PT, RS, SI
 *
 * @ignore
 */ var checkMod9710BBAN = function checkMod9710BBAN(bban) {
    var stripped = bban.replace(/[\s.]+/g, '');
    var reminder = mod9710(stripped);
    return reminder === 1;
};
/**
 * Used for Poland BBAN check
 *
 * @ignore
 */ var checkPolandBBAN = function checkPolandBBAN(bban) {
    var weights = [
        3,
        9,
        7,
        1,
        3,
        9,
        7
    ];
    var controlDigit = parseInt(bban.charAt(7), 10);
    var toCheck = bban.substring(0, 7);
    var sum = 0;
    for(var index = 0; index < 7; index++){
        sum += parseInt(toCheck.charAt(index), 10) * weights[index];
    }
    var remainder = sum % 10;
    return controlDigit === (remainder === 0 ? 0 : 10 - remainder);
};
/**
 * Spain (ES) BBAN check
 *
 * @ignore
 */ var checkSpainBBAN = function checkSpainBBAN(bban) {
    var weightsBankBranch = [
        4,
        8,
        5,
        10,
        9,
        7,
        3,
        6
    ];
    var weightsAccount = [
        1,
        2,
        4,
        8,
        5,
        10,
        9,
        7,
        3,
        6
    ];
    var controlBankBranch = parseInt(bban.charAt(8), 10);
    var controlAccount = parseInt(bban.charAt(9), 10);
    var bankBranch = bban.substring(0, 8);
    var account = bban.substring(10, 20);
    var sum = 0;
    for(var index = 0; index < 8; index++){
        sum += parseInt(bankBranch.charAt(index), 10) * weightsBankBranch[index];
    }
    var remainder = sum % 11;
    if (controlBankBranch !== (remainder === 0 ? 0 : remainder === 1 ? 1 : 11 - remainder)) {
        return false;
    }
    sum = 0;
    for(var index = 0; index < 10; index++){
        sum += parseInt(account.charAt(index), 10) * weightsAccount[index];
    }
    remainder = sum % 11;
    return controlAccount === (remainder === 0 ? 0 : remainder === 1 ? 1 : 11 - remainder);
};
/**
 * Mod 11/10 check
 *
 * @ignore
 */ var checkMod1110 = function checkMod1110(toCheck, control) {
    var nr = 10;
    for(var index = 0; index < toCheck.length; index++){
        nr += parseInt(toCheck.charAt(index), 10);
        if (nr % 10 !== 0) {
            nr = nr % 10;
        }
        nr = nr * 2;
        nr = nr % 11;
    }
    return control === (11 - nr === 10 ? 0 : 11 - nr);
};
/**
 * Croatian (HR) BBAN check
 *
 * @ignore
 */ var checkCroatianBBAN = function checkCroatianBBAN(bban) {
    var controlBankBranch = parseInt(bban.charAt(6), 10);
    var controlAccount = parseInt(bban.charAt(16), 10);
    var bankBranch = bban.substring(0, 6);
    var account = bban.substring(7, 16);
    return checkMod1110(bankBranch, controlBankBranch) && checkMod1110(account, controlAccount);
};
/**
 * Czech (CZ) and Slowak (SK) BBAN check
 *
 * @ignore
 */ var checkCzechAndSlovakBBAN = function checkCzechAndSlovakBBAN(bban) {
    var weightsPrefix = [
        10,
        5,
        8,
        4,
        2,
        1
    ];
    var weightsSuffix = [
        6,
        3,
        7,
        9,
        10,
        5,
        8,
        4,
        2,
        1
    ];
    var controlPrefix = parseInt(bban.charAt(9), 10);
    var controlSuffix = parseInt(bban.charAt(19), 10);
    var prefix = bban.substring(4, 9);
    var suffix = bban.substring(10, 19);
    var sum = 0;
    for(var index = 0; index < prefix.length; index++){
        sum += parseInt(prefix.charAt(index), 10) * weightsPrefix[index];
    }
    var remainder = sum % 11;
    if (controlPrefix !== (remainder === 0 ? 0 : remainder === 1 ? 1 : 11 - remainder)) {
        return false;
    }
    sum = 0;
    for(var index = 0; index < suffix.length; index++){
        sum += parseInt(suffix.charAt(index), 10) * weightsSuffix[index];
    }
    remainder = sum % 11;
    return controlSuffix === (remainder === 0 ? 0 : remainder === 1 ? 1 : 11 - remainder);
};
/**
 * Estonian (EE) BBAN check
 *
 * @ignore
 */ var checkEstonianBBAN = function checkEstonianBBAN(bban) {
    var weights = [
        7,
        1,
        3,
        7,
        1,
        3,
        7,
        1,
        3,
        7,
        1,
        3,
        7
    ];
    var controlDigit = parseInt(bban.charAt(15), 10);
    var toCheck = bban.substring(2, 15);
    var sum = 0;
    for(var index = 0; index < toCheck.length; index++){
        sum += parseInt(toCheck.charAt(index), 10) * weights[index];
    }
    var remainder = sum % 10;
    return controlDigit === (remainder === 0 ? 0 : 10 - remainder);
};
/**
 * Check French (FR) BBAN
 * Also for Monaco (MC)
 *
 * @ignore
 */ var checkFrenchBBAN = function checkFrenchBBAN(bban) {
    var stripped = bban.replace(/[\s.]+/g, '');
    var normalized = Array.from(stripped);
    for(var index = 0; index < stripped.length; index++){
        var c = normalized[index].charCodeAt(0);
        if (c >= 65) {
            switch(c){
                case 65:
                case 74:
                    normalized[index] = '1';
                    break;
                case 66:
                case 75:
                case 83:
                    normalized[index] = '2';
                    break;
                case 67:
                case 76:
                case 84:
                    normalized[index] = '3';
                    break;
                case 68:
                case 77:
                case 85:
                    normalized[index] = '4';
                    break;
                case 69:
                case 78:
                case 86:
                    normalized[index] = '5';
                    break;
                case 70:
                case 79:
                case 87:
                    normalized[index] = '6';
                    break;
                case 71:
                case 80:
                case 88:
                    normalized[index] = '7';
                    break;
                case 72:
                case 81:
                case 89:
                    normalized[index] = '8';
                    break;
                case 73:
                case 82:
                case 90:
                    normalized[index] = '9';
                    break;
            }
        }
    }
    var remainder = mod9710(normalized.join(''));
    return remainder === 0;
};
/**
 * Hungarian (HU) BBAN check
 *
 * @ignore
 */ var checkHungarianBBAN = function checkHungarianBBAN(bban) {
    var weights = [
        9,
        7,
        3,
        1,
        9,
        7,
        3,
        1,
        9,
        7,
        3,
        1,
        9,
        7,
        3
    ];
    var controlDigitBankBranch = parseInt(bban.charAt(7), 10);
    var toCheckBankBranch = bban.substring(0, 7);
    var sum = 0;
    for(var index = 0; index < toCheckBankBranch.length; index++){
        sum += parseInt(toCheckBankBranch.charAt(index), 10) * weights[index];
    }
    var remainder = sum % 10;
    if (controlDigitBankBranch !== (remainder === 0 ? 0 : 10 - remainder)) {
        return false;
    }
    sum = 0;
    if (bban.endsWith('00000000')) {
        var toCheckAccount = bban.substring(8, 15);
        var controlDigitAccount = parseInt(bban.charAt(15), 10);
        for(var index = 0; index < toCheckAccount.length; index++){
            sum += parseInt(toCheckAccount.charAt(index), 10) * weights[index];
        }
        var remainder_1 = sum % 10;
        return controlDigitAccount === (remainder_1 === 0 ? 0 : 10 - remainder_1);
    } else {
        var toCheckAccount = bban.substring(8, 23);
        var controlDigitAccount = parseInt(bban.charAt(23), 10);
        for(var index = 0; index < toCheckAccount.length; index++){
            sum += parseInt(toCheckAccount.charAt(index), 10) * weights[index];
        }
        var remainder_2 = sum % 10;
        return controlDigitAccount === (remainder_2 === 0 ? 0 : 10 - remainder_2);
    }
};
/**
 * Country specifications
 */ var countrySpecs = {
    AD: {
        chars: 24,
        bban_regexp: '^[0-9]{8}[A-Z0-9]{12}$',
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: '4-7',
        bank_identifier: '0-3',
        account_indentifier: '8-24'
    },
    AE: {
        chars: 23,
        bban_regexp: '^[0-9]{3}[0-9]{16}$',
        IBANRegistry: true,
        bank_identifier: '0-2',
        account_indentifier: '7-23'
    },
    AF: {},
    AG: {},
    AI: {},
    AL: {
        chars: 28,
        bban_regexp: '^[0-9]{8}[A-Z0-9]{16}$',
        IBANRegistry: true,
        branch_indentifier: '3-7',
        bank_identifier: '0-2',
        account_indentifier: '12-28'
    },
    AM: {},
    AO: {
        chars: 25,
        bban_regexp: '^[0-9]{21}$'
    },
    AQ: {},
    AR: {},
    AS: {},
    AT: {
        chars: 20,
        bban_regexp: '^[0-9]{16}$',
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-4'
    },
    AU: {},
    AW: {},
    AX: {
        chars: 18,
        bban_regexp: '^[0-9]{14}$',
        IBANRegistry: true
    },
    AZ: {
        chars: 28,
        bban_regexp: '^[A-Z]{4}[A-Z0-9]{20}$',
        IBANRegistry: true,
        bank_identifier: '0-3',
        account_indentifier: '4-28'
    },
    BA: {
        chars: 20,
        bban_regexp: '^[0-9]{16}$',
        bban_validation_func: checkMod9710BBAN,
        IBANRegistry: true,
        branch_indentifier: '3-5',
        bank_identifier: '0-2'
    },
    BB: {},
    BD: {},
    BE: {
        chars: 16,
        bban_regexp: '^[0-9]{12}$',
        bban_validation_func: checkBelgianBBAN,
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-2',
        account_indentifier: '0-16'
    },
    BF: {
        chars: 28,
        bban_regexp: '^[A-Z0-9]{2}[0-9]{22}$'
    },
    BG: {
        chars: 22,
        bban_regexp: '^[A-Z]{4}[0-9]{6}[A-Z0-9]{8}$',
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: '4-7',
        bank_identifier: '0-3'
    },
    BH: {
        chars: 22,
        bban_regexp: '^[A-Z]{4}[A-Z0-9]{14}$',
        IBANRegistry: true,
        bank_identifier: '0-3',
        account_indentifier: '8-22'
    },
    BI: {
        chars: 27,
        bban_regexp: '^[0-9]{23}$',
        branch_indentifier: '5-9',
        bank_identifier: '0-4',
        account_indentifier: '14-27'
    },
    BJ: {
        chars: 28,
        bban_regexp: '^[A-Z0-9]{2}[0-9]{22}$'
    },
    BL: {
        chars: 27,
        bban_regexp: '^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$'
    },
    BM: {},
    BN: {},
    BO: {},
    BQ: {},
    BR: {
        chars: 29,
        bban_regexp: '^[0-9]{23}[A-Z]{1}[A-Z0-9]{1}$',
        IBANRegistry: true,
        branch_indentifier: '8-12',
        bank_identifier: '0-7',
        account_indentifier: '17-29'
    },
    BS: {},
    BT: {},
    BV: {},
    BW: {},
    BY: {
        chars: 28,
        bban_regexp: '^[A-Z]{4}[0-9]{4}[A-Z0-9]{16}$',
        IBANRegistry: true,
        bank_identifier: '0-3'
    },
    BZ: {},
    CA: {},
    CC: {},
    CD: {},
    CF: {
        chars: 27,
        bban_regexp: '^[0-9]{23}$'
    },
    CG: {
        chars: 27,
        bban_regexp: '^[0-9]{23}$'
    },
    CH: {
        chars: 21,
        bban_regexp: '^[0-9]{5}[A-Z0-9]{12}$',
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-4'
    },
    CI: {
        chars: 28,
        bban_regexp: '^[A-Z]{1}[0-9]{23}$'
    },
    CK: {},
    CL: {},
    CM: {
        chars: 27,
        bban_regexp: '^[0-9]{23}$'
    },
    CN: {},
    CO: {},
    CR: {
        chars: 22,
        bban_regexp: '^[0-9]{18}$',
        IBANRegistry: true,
        bank_identifier: '0-3',
        account_indentifier: '8-22'
    },
    CU: {},
    CV: {
        chars: 25,
        bban_regexp: '^[0-9]{21}$'
    },
    CW: {},
    CX: {},
    CY: {
        chars: 28,
        bban_regexp: '^[0-9]{8}[A-Z0-9]{16}$',
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: '3-7',
        bank_identifier: '0-2',
        account_indentifier: '12-28'
    },
    CZ: {
        chars: 24,
        bban_regexp: '^[0-9]{20}$',
        bban_validation_func: checkCzechAndSlovakBBAN,
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-3'
    },
    DE: {
        chars: 22,
        bban_regexp: '^[0-9]{18}$',
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-7',
        account_indentifier: '13-22'
    },
    DJ: {
        chars: 27,
        bban_regexp: '^[0-9]{23}$',
        branch_indentifier: '5-9',
        bank_identifier: '0-4',
        account_indentifier: '14-27'
    },
    DK: {
        chars: 18,
        bban_regexp: '^[0-9]{14}$',
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-3',
        account_indentifier: '4-18'
    },
    DM: {},
    DO: {
        chars: 28,
        bban_regexp: '^[A-Z]{4}[0-9]{20}$',
        IBANRegistry: true,
        bank_identifier: '0-3',
        account_indentifier: '8-28'
    },
    DZ: {
        chars: 26,
        bban_regexp: '^[0-9]{22}$'
    },
    EC: {},
    EE: {
        chars: 20,
        bban_regexp: '^[0-9]{16}$',
        bban_validation_func: checkEstonianBBAN,
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-1',
        account_indentifier: '8-20'
    },
    EG: {
        chars: 29,
        bban_regexp: '^[0-9]{25}',
        IBANRegistry: true,
        branch_indentifier: '4-7',
        bank_identifier: '0-3',
        account_indentifier: '17-29'
    },
    EH: {},
    ER: {},
    ES: {
        chars: 24,
        bban_validation_func: checkSpainBBAN,
        bban_regexp: '^[0-9]{20}$',
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: '4-7',
        bank_identifier: '0-3',
        account_indentifier: '14-24'
    },
    ET: {},
    FI: {
        chars: 18,
        bban_regexp: '^[0-9]{14}$',
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-2',
        account_indentifier: '0-0'
    },
    FJ: {},
    FK: {
        chars: 18,
        bban_regexp: '^[A-Z]{2}[0-9]{12}$',
        bank_identifier: '0-1',
        account_indentifier: '6-18'
    },
    FM: {},
    FO: {
        chars: 18,
        bban_regexp: '^[0-9]{14}$',
        IBANRegistry: true,
        bank_identifier: '0-3',
        account_indentifier: '4-18'
    },
    FR: {
        chars: 27,
        bban_regexp: '^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$',
        bban_validation_func: checkFrenchBBAN,
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-4',
        branch_indentifier: '5-9',
        account_indentifier: '14-24'
    },
    GA: {
        chars: 27,
        bban_regexp: '^[0-9]{23}$'
    },
    GB: {
        chars: 22,
        bban_regexp: '^[A-Z]{4}[0-9]{14}$',
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: '4-9',
        bank_identifier: '0-3'
    },
    GD: {},
    GE: {
        chars: 22,
        bban_regexp: '^[A-Z0-9]{2}[0-9]{16}$',
        IBANRegistry: true,
        bank_identifier: '0-1',
        account_indentifier: '6-22'
    },
    GF: {
        chars: 27,
        bban_regexp: '^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$',
        IBANRegistry: true
    },
    GG: {},
    GH: {},
    GI: {
        chars: 23,
        bban_regexp: '^[A-Z]{4}[A-Z0-9]{15}$',
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-3',
        account_indentifier: '8-23'
    },
    GL: {
        chars: 18,
        bban_regexp: '^[0-9]{14}$',
        IBANRegistry: true,
        bank_identifier: '0-3',
        account_indentifier: '4-18'
    },
    GM: {},
    GN: {},
    GP: {
        chars: 27,
        bban_regexp: '^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$',
        IBANRegistry: true
    },
    GQ: {
        chars: 27,
        bban_regexp: '^[0-9]{23}$'
    },
    GR: {
        chars: 27,
        bban_regexp: '^[0-9]{7}[A-Z0-9]{16}$',
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: '3-6',
        bank_identifier: '0-2',
        account_indentifier: '7-27'
    },
    GS: {},
    GT: {
        chars: 28,
        bban_regexp: '^[A-Z0-9]{24}$',
        IBANRegistry: true,
        bank_identifier: '0-3',
        account_indentifier: '8-28'
    },
    GU: {},
    GW: {
        chars: 25,
        bban_regexp: '^[A-Z]{2}[0-9]{19}$'
    },
    GY: {},
    HK: {},
    HM: {},
    HN: {
        chars: 28,
        bban_regexp: '^[A-Z]{4}[0-9]{20}$'
    },
    HR: {
        chars: 21,
        bban_regexp: '^[0-9]{17}$',
        bban_validation_func: checkCroatianBBAN,
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-6'
    },
    HT: {},
    HU: {
        chars: 28,
        bban_regexp: '^[0-9]{24}$',
        bban_validation_func: checkHungarianBBAN,
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: '3-6',
        bank_identifier: '0-2'
    },
    ID: {},
    IE: {
        chars: 22,
        bban_regexp: '^[A-Z0-9]{4}[0-9]{14}$',
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: '4-9',
        bank_identifier: '0-3'
    },
    IL: {
        chars: 23,
        bban_regexp: '^[0-9]{19}$',
        IBANRegistry: true,
        branch_indentifier: '3-5',
        bank_identifier: '0-2'
    },
    IM: {},
    IN: {},
    IO: {},
    IQ: {
        chars: 23,
        bban_regexp: '^[A-Z]{4}[0-9]{15}$',
        IBANRegistry: true,
        branch_indentifier: '4-6',
        bank_identifier: '0-3',
        account_indentifier: '11-23'
    },
    IR: {
        chars: 26,
        bban_regexp: '^[0-9]{22}$'
    },
    IS: {
        chars: 26,
        bban_regexp: '^[0-9]{22}$',
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: '2-3',
        bank_identifier: '0-1'
    },
    IT: {
        chars: 27,
        bban_regexp: '^[A-Z]{1}[0-9]{10}[A-Z0-9]{12}$',
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: '6-10',
        bank_identifier: '1-5',
        account_indentifier: '4-27'
    },
    JE: {},
    JM: {},
    JO: {
        chars: 30,
        bban_regexp: '^[A-Z]{4}[0-9]{4}[A-Z0-9]{18}$',
        IBANRegistry: true,
        branch_indentifier: '4-7',
        bank_identifier: '4-7'
    },
    JP: {},
    KE: {},
    KG: {},
    KH: {},
    KI: {},
    KM: {
        chars: 27,
        bban_regexp: '^[0-9]{23}$'
    },
    KN: {},
    KP: {},
    KR: {},
    KW: {
        chars: 30,
        bban_regexp: '^[A-Z]{4}[A-Z0-9]{22}$',
        IBANRegistry: true,
        bank_identifier: '0-3',
        account_indentifier: '20-30'
    },
    KY: {},
    KZ: {
        chars: 20,
        bban_regexp: '^[0-9]{3}[A-Z0-9]{13}$',
        IBANRegistry: true,
        bank_identifier: '0-2',
        account_indentifier: '0-20'
    },
    LA: {},
    LB: {
        chars: 28,
        bban_regexp: '^[0-9]{4}[A-Z0-9]{20}$',
        IBANRegistry: true,
        bank_identifier: '0-3',
        account_indentifier: '14-28'
    },
    LC: {
        chars: 32,
        bban_regexp: '^[A-Z]{4}[A-Z0-9]{24}$',
        IBANRegistry: true,
        bank_identifier: '0-3',
        account_indentifier: '8-32'
    },
    LI: {
        chars: 21,
        bban_regexp: '^[0-9]{5}[A-Z0-9]{12}$',
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-4'
    },
    LK: {},
    LR: {},
    LS: {},
    LT: {
        chars: 20,
        bban_regexp: '^[0-9]{16}$',
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-4'
    },
    LU: {
        chars: 20,
        bban_regexp: '^[0-9]{3}[A-Z0-9]{13}$',
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-2'
    },
    LV: {
        chars: 21,
        bban_regexp: '^[A-Z]{4}[A-Z0-9]{13}$',
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-3',
        account_indentifier: '0-21'
    },
    LY: {
        chars: 25,
        bban_regexp: '^[0-9]{21}$',
        IBANRegistry: true,
        branch_indentifier: '3-5',
        bank_identifier: '0-2',
        account_indentifier: '10-25'
    },
    MA: {
        chars: 28,
        bban_regexp: '^[0-9]{24}$'
    },
    MC: {
        chars: 27,
        bban_regexp: '^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$',
        bban_validation_func: checkFrenchBBAN,
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: '5-9',
        bank_identifier: '0-4'
    },
    MD: {
        chars: 24,
        bban_regexp: '^[A-Z0-9]{2}[A-Z0-9]{18}$',
        IBANRegistry: true,
        bank_identifier: '0-1',
        account_indentifier: '6-24'
    },
    ME: {
        chars: 22,
        bban_regexp: '^[0-9]{18}$',
        bban_validation_func: checkMod9710BBAN,
        IBANRegistry: true,
        bank_identifier: '0-2',
        account_indentifier: '4-22'
    },
    MF: {
        chars: 27,
        bban_regexp: '^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$',
        IBANRegistry: true
    },
    MG: {
        chars: 27,
        bban_regexp: '^[0-9]{23}$'
    },
    MH: {},
    MK: {
        chars: 19,
        bban_regexp: '^[0-9]{3}[A-Z0-9]{10}[0-9]{2}$',
        bban_validation_func: checkMod9710BBAN,
        IBANRegistry: true,
        bank_identifier: '0-2'
    },
    ML: {
        chars: 28,
        bban_regexp: '^[A-Z0-9]{2}[0-9]{22}$'
    },
    MM: {},
    MN: {
        chars: 20,
        bban_regexp: '^[0-9]{16}$',
        IBANRegistry: true,
        bank_identifier: '0-3',
        account_indentifier: '8-20'
    },
    MO: {},
    MP: {},
    MQ: {
        chars: 27,
        bban_regexp: '^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$',
        IBANRegistry: true
    },
    MR: {
        chars: 27,
        bban_regexp: '^[0-9]{23}$',
        IBANRegistry: true,
        branch_indentifier: '5-9',
        bank_identifier: '0-4',
        account_indentifier: '4-27'
    },
    MS: {},
    MT: {
        chars: 31,
        bban_regexp: '^[A-Z]{4}[0-9]{5}[A-Z0-9]{18}$',
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: '4-8',
        bank_identifier: '0-3',
        account_indentifier: '15-31'
    },
    MU: {
        chars: 30,
        bban_regexp: '^[A-Z]{4}[0-9]{19}[A-Z]{3}$',
        IBANRegistry: true,
        branch_indentifier: '6-7',
        bank_identifier: '0-5',
        account_indentifier: '0-30'
    },
    MV: {},
    MW: {},
    MX: {},
    MY: {},
    MZ: {
        chars: 25,
        bban_regexp: '^[0-9]{21}$'
    },
    NA: {},
    NC: {
        chars: 27,
        bban_regexp: '^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$',
        IBANRegistry: true
    },
    NE: {
        chars: 28,
        bban_regexp: '^[A-Z]{2}[0-9]{22}$'
    },
    NF: {},
    NG: {},
    NI: {
        chars: 28,
        bban_regexp: '^[A-Z]{4}[0-9]{20}$',
        bank_identifier: '0-3',
        IBANRegistry: true,
        account_indentifier: '8-28'
    },
    NL: {
        chars: 18,
        bban_regexp: '^[A-Z]{4}[0-9]{10}$',
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-3',
        account_indentifier: '8-18'
    },
    NO: {
        chars: 15,
        bban_regexp: '^[0-9]{11}$',
        bban_validation_func: checkNorwayBBAN,
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-3',
        account_indentifier: '4-15'
    },
    NP: {},
    NR: {},
    NU: {},
    NZ: {},
    OM: {
        chars: 23,
        bban_regexp: '^[0-9]{3}[A-Z0-9]{16}$',
        IBANRegistry: true,
        SEPA: false,
        bank_identifier: '0-2'
    },
    PA: {},
    PE: {},
    PF: {
        chars: 27,
        bban_regexp: '^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$',
        IBANRegistry: true
    },
    PG: {},
    PH: {},
    PK: {
        chars: 24,
        bban_regexp: '^[A-Z0-9]{4}[0-9]{16}$',
        IBANRegistry: true,
        bank_identifier: '0-3'
    },
    PL: {
        chars: 28,
        bban_validation_func: checkPolandBBAN,
        bban_regexp: '^[0-9]{24}$',
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: '0-7',
        account_indentifier: '2-28'
    },
    PM: {
        chars: 27,
        bban_regexp: '^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$',
        IBANRegistry: true
    },
    PN: {},
    PR: {},
    PS: {
        chars: 29,
        bban_regexp: '^[A-Z0-9]{4}[0-9]{21}$',
        IBANRegistry: true,
        bank_identifier: '0-3',
        account_indentifier: '17-29'
    },
    PT: {
        chars: 25,
        bban_regexp: '^[0-9]{21}$',
        bban_validation_func: checkMod9710BBAN,
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-3'
    },
    PW: {},
    PY: {},
    QA: {
        chars: 29,
        bban_regexp: '^[A-Z]{4}[A-Z0-9]{21}$',
        IBANRegistry: true,
        bank_identifier: '0-3',
        account_indentifier: '8-29'
    },
    RE: {
        chars: 27,
        bban_regexp: '^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$',
        IBANRegistry: true
    },
    RO: {
        chars: 24,
        bban_regexp: '^[A-Z]{4}[A-Z0-9]{16}$',
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-3',
        account_indentifier: '0-24'
    },
    RS: {
        chars: 22,
        bban_regexp: '^[0-9]{18}$',
        bban_validation_func: checkMod9710BBAN,
        IBANRegistry: true,
        bank_identifier: '0-2'
    },
    RU: {
        chars: 33,
        bban_regexp: '^[0-9]{14}[A-Z0-9]{15}$',
        IBANRegistry: true,
        branch_indentifier: '9-13',
        bank_identifier: '0-8',
        account_indentifier: '13-33'
    },
    RW: {},
    SA: {
        chars: 24,
        bban_regexp: '^[0-9]{2}[A-Z0-9]{18}$',
        IBANRegistry: true,
        bank_identifier: '0-1',
        account_indentifier: '12-24'
    },
    SB: {},
    SC: {
        chars: 31,
        bban_regexp: '^[A-Z]{4}[0-9]{20}[A-Z]{3}$',
        IBANRegistry: true,
        branch_indentifier: '6-7',
        bank_identifier: '0-5',
        account_indentifier: '12-28'
    },
    SD: {
        chars: 18,
        bban_regexp: '^[0-9]{14}$',
        IBANRegistry: true,
        bank_identifier: '0-1',
        account_indentifier: '6-18'
    },
    SE: {
        chars: 24,
        bban_regexp: '^[0-9]{20}$',
        IBANRegistry: true,
        SEPA: true,
        bank_identifier: '0-2'
    },
    SG: {},
    SH: {},
    SI: {
        chars: 19,
        bban_regexp: '^[0-9]{15}$',
        bban_validation_func: checkMod9710BBAN,
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: '2-4',
        bank_identifier: '0-1',
        account_indentifier: '9-16'
    },
    SJ: {},
    SK: {
        chars: 24,
        bban_regexp: '^[0-9]{20}$',
        bban_validation_func: checkCzechAndSlovakBBAN,
        IBANRegistry: true,
        SEPA: true
    },
    SL: {},
    SM: {
        chars: 27,
        bban_regexp: '^[A-Z]{1}[0-9]{10}[A-Z0-9]{12}$',
        IBANRegistry: true,
        SEPA: true,
        branch_indentifier: '6-10'
    },
    SN: {
        chars: 28,
        bban_regexp: '^[A-Z]{2}[0-9]{22}$'
    },
    SO: {
        chars: 23,
        bban_regexp: '^[0-9]{19}$',
        IBANRegistry: true,
        branch_indentifier: '4-6',
        account_indentifier: '11-23'
    },
    SR: {},
    SS: {},
    ST: {
        chars: 25,
        bban_regexp: '^[0-9]{21}$',
        IBANRegistry: true,
        branch_indentifier: '4-7'
    },
    SV: {
        chars: 28,
        bban_regexp: '^[A-Z]{4}[0-9]{20}$',
        IBANRegistry: true,
        account_indentifier: '8-28'
    },
    SX: {},
    SY: {},
    SZ: {},
    TC: {},
    TD: {
        chars: 27,
        bban_regexp: '^[0-9]{23}$'
    },
    TF: {
        chars: 27,
        bban_regexp: '^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$',
        IBANRegistry: true
    },
    TG: {
        chars: 28,
        bban_regexp: '^[A-Z]{2}[0-9]{22}$'
    },
    TH: {},
    TJ: {},
    TK: {},
    TL: {
        chars: 23,
        bban_regexp: '^[0-9]{19}$',
        IBANRegistry: true,
        account_indentifier: '4-23'
    },
    TM: {},
    TN: {
        chars: 24,
        bban_regexp: '^[0-9]{20}$',
        IBANRegistry: true,
        branch_indentifier: '2-4',
        account_indentifier: '4-24'
    },
    TO: {},
    TR: {
        chars: 26,
        bban_regexp: '^[0-9]{5}[A-Z0-9]{17}$',
        IBANRegistry: true
    },
    TT: {},
    TV: {},
    TW: {},
    TZ: {},
    UA: {
        chars: 29,
        bban_regexp: '^[0-9]{6}[A-Z0-9]{19}$',
        IBANRegistry: true,
        account_indentifier: '15-29'
    },
    UG: {},
    UM: {},
    US: {},
    UY: {},
    UZ: {},
    VA: {
        chars: 22,
        bban_regexp: '^[0-9]{18}',
        IBANRegistry: true,
        SEPA: true,
        account_indentifier: '7-22'
    },
    VC: {},
    VE: {},
    VG: {
        chars: 24,
        bban_regexp: '^[A-Z0-9]{4}[0-9]{16}$',
        IBANRegistry: true,
        account_indentifier: '8-24'
    },
    VI: {},
    VN: {},
    VU: {},
    WF: {
        chars: 27,
        bban_regexp: '^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$',
        IBANRegistry: true
    },
    WS: {},
    XK: {
        chars: 20,
        bban_regexp: '^[0-9]{16}$',
        IBANRegistry: true,
        branch_indentifier: '2-3',
        account_indentifier: '4-20'
    },
    YE: {},
    YT: {
        chars: 27,
        bban_regexp: '^[0-9]{10}[A-Z0-9]{11}[0-9]{2}$',
        IBANRegistry: true
    },
    ZA: {},
    ZM: {},
    ZW: {}
};

const devcodeBankIBAN = makeProviderMethodId(ProviderType.Devcode, DevcodeMethodId.BankIBAN);
function getDetailsTemplate(amount) {
    const { maxAmount, currencyCode, minAmount, netPosition } = getMethodByProviderId(devcodeBankIBAN, AppState.methods.withdraw);
    const resultMaxAmount = Math.min(maxAmount, netPosition || maxAmount);
    return `
    <div class="details">
      ${getWithdrawBalanceTemplate()}
      ${getSummarySection(amount)}
      <magic-ui-text
        tag="b"
        class="details__heading"
        part="details__heading"
        is-markdown
        content="${translate('galleon.withdraw.iban.details.title')}"
      ></magic-ui-text>
      <div class="details__field">
        <magic-ui-text
          tag="b"
          class="details__label"
          part="details__label"
          content="${translate('input.amount.hint')}"
        ></magic-ui-text>
        <magic-ui-input
          class="details__amount"
          part="details__amount"
          value="${amount}"
        ></magic-ui-input>
        <magic-ui-text
          tag="p"
          class="amount-screen__error amount-error"
          part="amount-screen__error amount-error"
          content='${translate('galleon.withdrawal.amount.error').replace('{minAmount}', formatCurrency(minAmount, currencyCode)).replace('{maxAmount}', formatCurrency(resultMaxAmount, currencyCode))}'
       ></magic-ui-text>
      </div>
      <div class="details__field">
        <div
          class="details__label"
          part="details__label">
          <div class="tooltip" part="tooltip">
              ${getTooltipTemplate(translate('galleon.withdraw.tooltip.iban.title'), translate('galleon.withdraw.tooltip.iban.subtitle'))}
          </div>
          <magic-ui-text tag="b" content="${translate('wallet.bank-iban.hint')}"></magic-ui-text>
        </div>
        <magic-ui-input
          class="details__iban"
          part="details__iban"
          placeholder="${translate('galleon.bank-iban.placeholder')}"
          value="">
        </magic-ui-input>
        <magic-ui-text tag="p" class="amount-screen__error iban-error" part="amount-screen__error iban-error"></magic-ui-text>
      </div>
      <div class="details__field">
        <div class="details__label" part="details__label">
          <div class="tooltip" part="tooltip">${getTooltipTemplate(translate('galleon.bank-iban.bic.label'), translate('galleon.withdraw.tooltip.bic.subtitle'))}</div>
          <magic-ui-text tag="b" content="${translate('galleon.bank-iban.bic.label')}"></magic-ui-text>
        </div>
        <magic-ui-input
        class="details__bic" part="details__bic"
        placeholder="${translate('galleon.bank-iban.bic.placeholder')}"
        value=""></magic-ui-input>
        <magic-ui-text tag="p" class="amount-screen__error bic-error" part="amount-screen__error bic-error"></magic-ui-text>
      </div>
      ${getDetailsFooter()}
    </div>`;
}
const registerListeners = (element, callback)=>{
    const amountInput = element.querySelector('.details__amount');
    const amountErrorElement = element.querySelector('.amount-error');
    const ibanInput = element.querySelector('.details__iban');
    const ibanErrorElement = element.querySelector('.iban-error');
    const bicInput = element.querySelector('.details__bic');
    const bicErrorElement = element.querySelector('.bic-error');
    const cancelButton = element.querySelector('.details__cancel-button');
    const changeButton = element.querySelector('.details__change-button');
    const confirmButton = element.querySelector('.details__confirm-button');
    const { maxAmount, minAmount, netPosition } = getMethodByProviderId(devcodeBankIBAN, AppState.methods.withdraw);
    const resultMaxAmount = Math.min(maxAmount, netPosition || maxAmount);
    const state = new Proxy({
        amount: 0,
        iban: '',
        bic: ''
    }, {
        set (target, property, value) {
            target[property] = value;
            const isAmountValid = target['amount'] >= minAmount && target['amount'] <= resultMaxAmount;
            const isIBANValid = isValidIBAN(target.iban);
            const isBICValid = isValidBIC(target.bic);
            if (property === 'amount') {
                const method = isAmountValid ? 'remove' : 'add';
                amountErrorElement.classList[method]('active');
            } else if (property === 'iban') {
                if (isIBANValid) {
                    ibanErrorElement.classList.remove('active');
                } else {
                    const error = !value ? translate('galleon.withdrawal.bankiban.error.iban-required') : translate('galleon.withdrawal.bankiban.error.iban-format');
                    ibanErrorElement.setAttribute('content', error);
                    ibanErrorElement.classList.add('active');
                }
            } else if (property === 'bic') {
                if (isBICValid) {
                    bicErrorElement.classList.remove('active');
                } else {
                    const error = !value ? translate('galleon.withdrawal.bankiban.error.bic-required') : translate('galleon.withdrawal.bankiban.error.bic-format');
                    bicErrorElement.setAttribute('content', error);
                    bicErrorElement.classList.add('active');
                }
            }
            const isFormValid = isAmountValid && isIBANValid && isBICValid;
            if (isFormValid) {
                confirmButton.removeAttribute('disabled');
            } else {
                confirmButton.setAttribute('disabled', `true`);
            }
            return true;
        }
    });
    var _amountInput_getAttribute;
    state.amount = Number((_amountInput_getAttribute = amountInput == null ? void 0 : amountInput.getAttribute('value')) != null ? _amountInput_getAttribute : 0);
    amountInput == null ? void 0 : amountInput.addEventListener('input', (event)=>state.amount = +getEventValue(event));
    ibanInput == null ? void 0 : ibanInput.addEventListener('input', (event)=>state.iban = getEventValue(event));
    bicInput == null ? void 0 : bicInput.addEventListener('input', (event)=>state.bic = getEventValue(event));
    cancelButton == null ? void 0 : cancelButton.addEventListener('click', ()=>{
        AppState.wallet.withdraw.selectedMethod = null;
        createWithdrawView();
    });
    changeButton == null ? void 0 : changeButton.addEventListener('click', ()=>{
        AppState.wallet.withdraw.selectedMethod = null;
        createWithdrawView();
    });
    confirmButton == null ? void 0 : confirmButton.addEventListener('click', ()=>{
        if (!confirmButton.getAttribute('disabled')) {
            confirmButton == null ? void 0 : confirmButton.setAttribute('disabled', 'true');
            void callback(state.amount, state.iban, state.bic);
        }
    });
};
const bankIBANDetailsUI = {
    registerListeners,
    template: getDetailsTemplate
};

class DevcodeBankIBANMethod extends BaseDevcodeNestedIframeMethod {
    async withdraw(amount) {
        const detailsTemplate = createElementFromTemplate('div', bankIBANDetailsUI.template(amount));
        const container = AppState.shadowRoot.querySelector('.tab-content');
        bankIBANDetailsUI.registerListeners(detailsTemplate, this.withdrawCallback.bind(this));
        container.replaceChildren(detailsTemplate);
    }
    async withdrawCallback(amount, iban, bic) {
        var _AppState_wallet_profile_customer, _AppState_wallet_profile;
        const { merchantId } = this.devcodeGateway.config;
        const options = {
            data: {
                amount,
                iban,
                bic,
                merchantId,
                attributes: {
                    channelId: getScreenType(),
                    iovationBlackbox: '',
                    type: 'Standard',
                    userPlatform: JSON.stringify(getPlatformInfo(navigator.userAgent))
                },
                email: (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : (_AppState_wallet_profile_customer = _AppState_wallet_profile.customer) == null ? void 0 : _AppState_wallet_profile_customer.email
            },
            type: this.paymentMethodExternalId.toLowerCase()
        };
        this.logAttempt(amount);
        const response = await this.devcodeGateway.withdrawal(options);
        const launchWithdrawResult = {
            currencyCode: this.currencyCode,
            success: response.success,
            transactionID: response.txRefId,
            amount,
            popupUrl: this.redirectBaseUrl,
            paymentMethod: this.paymentMethodExternalId,
            promoCode: AppState.wallet.chosenDepositBonus || ''
        };
        this.logPayment(launchWithdrawResult);
        const successTemplate = createElementFromTemplate('div', getWithdrawalStatusScreenTemplate(launchWithdrawResult));
        const content = AppState.shadowRoot.querySelector('.tab-content');
        content.replaceChildren(successTemplate);
        statusButtonsHandler(content, ()=>{
            if (launchWithdrawResult.success) {
                emitWithdrawCompleted();
            } else {
                createWithdrawView();
            }
        });
    }
}

function getBankLocalFormConfig() {
    const formFooter = document.createElement('div');
    formFooter.innerHTML = getDetailsFooter();
    return [
        {
            path: '1',
            components: [
                {
                    id: 'clearingNumber',
                    component: 'magic-ui-form-field',
                    isDataField: true,
                    type: 'text',
                    testId: 'clearingNumber',
                    validationDisplay: ValidationDisplay.OnTouchShowMessage,
                    properties: {
                        placeholder: translate('galleon.input.placeholder'),
                        label: translate('galleon.withdraw.clearing.number.label')
                    },
                    validation: [
                        {
                            name: 'required',
                            fn: (value)=>required(value),
                            message: translate('galleon.withdraw.clearing.number.required')
                        },
                        {
                            name: 'is-valid-clearingNumber',
                            fn: (value)=>maxLength(60)(value),
                            message: translate('galleon.withdraw.clearing.number.invalid')
                        }
                    ]
                },
                {
                    id: 'accountNumber',
                    component: 'magic-ui-form-field',
                    isDataField: true,
                    type: 'text',
                    testId: 'accountNumber',
                    validationDisplay: ValidationDisplay.OnTouchShowMessage,
                    properties: {
                        placeholder: translate('galleon.input.placeholder'),
                        label: translate('galleon.withdraw.account.number.label')
                    },
                    validation: [
                        {
                            name: 'required',
                            fn: (value)=>required(value),
                            message: translate('galleon.withdraw.account.number.required')
                        },
                        {
                            name: 'is-valid-accountNumber',
                            fn: (value)=>maxLength(120)(value),
                            message: translate('galleon.withdraw.account.number.invalid')
                        }
                    ]
                },
                {
                    id: 'beneficiaryName',
                    component: 'magic-ui-form-field',
                    isDataField: true,
                    type: 'text',
                    testId: 'beneficiaryName',
                    validationDisplay: ValidationDisplay.OnTouchShowMessage,
                    properties: {
                        placeholder: translate('galleon.input.placeholder'),
                        label: translate('galleon.withdraw.beneficiary.name.label')
                    },
                    validation: [
                        {
                            name: 'required',
                            fn: (value)=>required(value),
                            message: translate('galleon.withdraw.beneficiary.name.required')
                        },
                        {
                            name: 'is-valid-beneficiaryName',
                            fn: (value)=>maxLength(50)(value),
                            message: translate('galleon.withdraw.beneficiary.name.invalid')
                        }
                    ]
                }
            ],
            footer: formFooter
        }
    ];
}

var _formBuilder$2 = /*#__PURE__*/ _class_private_field_loose_key("_formBuilder"), _onFormSubmit$2 = /*#__PURE__*/ _class_private_field_loose_key("_onFormSubmit");
class DevcodeBankLocalMethod extends BaseDevcodeMethod {
    withdraw(amount) {
        void createFormScreen({
            amount,
            formBuilder: _class_private_field_loose_base(this, _formBuilder$2)[_formBuilder$2],
            formConfig: getBankLocalFormConfig(),
            onFormSubmit: _class_private_field_loose_base(this, _onFormSubmit$2)[_onFormSubmit$2].bind(this)
        });
    }
    deposit(amount) {
        console.log(amount);
    }
    constructor(...args){
        super(...args), Object.defineProperty(this, _onFormSubmit$2, {
            value: onFormSubmit$2
        }), Object.defineProperty(this, _formBuilder$2, {
            writable: true,
            value: void 0
        }), _class_private_field_loose_base(this, _formBuilder$2)[_formBuilder$2] = new FormBuilder();
    }
}
async function onFormSubmit$2(formData, amount) {
    var _AppState_wallet_profile_customer, _AppState_wallet_profile;
    const content = getCurrentTab();
    const submitBtn = content.querySelector('.details__confirm-button');
    submitBtn == null ? void 0 : submitBtn.setAttribute('loading', 'true');
    const { merchantId } = this.devcodeGateway.config;
    const { accountNumber, beneficiaryName, clearingNumber } = formData;
    const options = {
        data: {
            amount,
            accountNumber,
            beneficiaryName,
            clearingNumber,
            merchantId,
            attributes: {
                channelId: getScreenType(),
                iovationBlackbox: '',
                type: 'Standard',
                userPlatform: JSON.stringify(getPlatformInfo(navigator.userAgent))
            },
            email: (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : (_AppState_wallet_profile_customer = _AppState_wallet_profile.customer) == null ? void 0 : _AppState_wallet_profile_customer.email
        },
        type: this.paymentMethodExternalId.toLowerCase()
    };
    this.logAttempt(amount);
    const response = await this.devcodeGateway.withdrawal(options);
    const launchWithdrawResult = {
        currencyCode: this.currencyCode,
        success: response.success,
        transactionID: response.txRefId,
        amount,
        popupUrl: this.redirectBaseUrl,
        paymentMethod: this.paymentMethodExternalId,
        promoCode: AppState.wallet.chosenDepositBonus || ''
    };
    this.logPayment(launchWithdrawResult);
    if (response.txState === 'WAITING_APPROVAL') {
        const { message, title } = this.getWaitingForApprovalStatusMessage();
        createWithdrawStatusScreen(launchWithdrawResult, message, title);
        void PendingBalanceCheck.checkWithdrawalBalance(launchWithdrawResult);
        return;
    }
    createWithdrawStatusScreen(launchWithdrawResult);
}

class BaseDevcodeSavedMethod extends BaseDevcodeNestedIframeMethod {
    render(index) {
        return super.render(index);
    }
    getSpecificWithdrawData() {
        return {
            accountId: this.accountId
        };
    }
    getSpecificDepositTemplate() {
        return {
            specificSubtitle: this.maskedAccount,
            isRemovable: AppState.wallet.features.isMethodRemovalEnabled,
            id: this.id
        };
    }
    getSpecificDepositData() {
        return {
            email: this.maskedAccount
        };
    }
    getHolderContent() {
        return this.methodLabel;
    }
    getMethodContent() {
        return this.maskedAccount;
    }
    renderWithdrawElement(index) {
        var _AppState_wallet_features, _AppState_wallet;
        const methodDiv = createElementFromTemplate('div', getSavedWithdrawMethodTemplate({
            holderContent: this.getHolderContent(),
            methodContent: this.getMethodContent(),
            lockedAmount: AppState.wallet.lockedAmount,
            id: this.id,
            isRemovable: ((_AppState_wallet = AppState.wallet) == null ? void 0 : (_AppState_wallet_features = _AppState_wallet.features) == null ? void 0 : _AppState_wallet_features.isMethodRemovalEnabled) || false,
            method: this
        }));
        const methodId = this.id;
        this.methodDiv = methodDiv;
        initBaseMethodControls(methodDiv, methodId, (result)=>{
            if (result) {
                void this.proceedRemoveMethod();
            }
        });
        return renderSavedWithdrawMethod(index, this, methodDiv);
    }
    async callRemoveMethod() {
        return this.devcodeGateway.remove({
            accountId: this.accountId
        }).then((result)=>{
            return result.success;
        }).catch((error)=>{
            console.error('Devcode remove method error', error);
            return false;
        });
    }
    constructor(params){
        super(params);
        this.maskedAccount = params.maskedAccount;
        this.isSavedMethod = params.isSavedMethod;
        this.accountId = params.accountId;
    }
}

function getCVCConfig() {
    const formFooter = document.createElement('div');
    formFooter.innerHTML = getDetailsFooter();
    return [
        {
            path: '1',
            components: [
                {
                    id: 'cvc',
                    component: 'magic-ui-form-field',
                    isDataField: true,
                    type: 'text',
                    testId: 'cvc',
                    validationDisplay: ValidationDisplay.OnTouchShowMessage,
                    properties: {
                        placeholder: translate('galleon.input.placeholder'),
                        label: 'CVC',
                        type: 'number',
                        inputmode: 'numeric'
                    },
                    validation: [
                        {
                            name: 'required',
                            fn: (value)=>required(value),
                            message: translate('galleon.deposit.card.details.cvc.error')
                        },
                        {
                            name: 'is-valid-cvc',
                            fn: (value)=>!isNaN(Number(value)) && maxLength(4)(value) && minLength(3)(value),
                            message: translate('galleon.deposit.card.details.cvc.error')
                        }
                    ]
                }
            ],
            footer: formFooter
        }
    ];
}

var _cardType = /*#__PURE__*/ _class_private_field_loose_key("_cardType"), _cvv = /*#__PURE__*/ _class_private_field_loose_key("_cvv"), _accountId = /*#__PURE__*/ _class_private_field_loose_key("_accountId"), _formBuilder$1 = /*#__PURE__*/ _class_private_field_loose_key("_formBuilder"), _handleAccordionToggle = /*#__PURE__*/ _class_private_field_loose_key("_handleAccordionToggle"), _attachCVCListener = /*#__PURE__*/ _class_private_field_loose_key("_attachCVCListener"), _attachInputListener = /*#__PURE__*/ _class_private_field_loose_key("_attachInputListener"), _updateFormStatus = /*#__PURE__*/ _class_private_field_loose_key("_updateFormStatus");
class DevcodeSavedCardMethod extends BaseDevcodeSavedMethod {
    setCVV(cvv) {
        if (!isNaN(Number(cvv)) && cvv.length > 2 && cvv.length < 5) {
            _class_private_field_loose_base(this, _cvv)[_cvv] = cvv;
        }
    }
    render(index) {
        return super.render(index);
    }
    async injectEncryption() {
        const { config } = this.devcodeGateway;
        await injectEncryptionScript(config.environment, config.merchantId);
    }
    getSpecificDepositData() {
        return {
            accountId: _class_private_field_loose_base(this, _accountId)[_accountId],
            encCvv: getEncryptedValue(_class_private_field_loose_base(this, _cvv)[_cvv])
        };
    }
    getSpecificDepositTemplate() {
        return {
            specificSubtitle: this.maskedAccount,
            specificTitle: _class_private_field_loose_base(this, _cardType)[_cardType]
        };
    }
    renderDepositElement() {
        const methodDiv = createElementFromTemplate('div', getDepositMethodTemplate(this, _extends$1({
            lockedAmount: AppState.wallet.lockedAmount
        }, this.getSpecificDepositTemplate())));
        methodDiv.classList.add('method-container', 'deposit-method-container', `method-${this.id}`);
        if (AppState.wallet.lockedAmount) {
            methodDiv.classList.add('payment-method--locked-amount');
            attachLockedAmountListener(methodDiv, async ()=>{
                const selectedTabState = AppState.selectedTabState;
                selectedTabState.selectedSavedMethod = this;
                void this.injectEncryption();
                void createFormScreen({
                    amount: AppState.wallet.lockedAmount,
                    formBuilder: _class_private_field_loose_base(this, _formBuilder$1)[_formBuilder$1],
                    formConfig: getCVCConfig(),
                    onFormSubmit: (formResult)=>{
                        _class_private_field_loose_base(this, _cvv)[_cvv] = formResult.cvc;
                        const content = getCurrentTab();
                        const submitBtn = content.querySelector('.details__confirm-button');
                        submitBtn == null ? void 0 : submitBtn.setAttribute('loading', 'true');
                        selectedTabState.selectedSavedMethod = null;
                        void handleLockedDepositClick(this);
                    }
                });
            });
        } else {
            attachAccordionListener(methodDiv, (methodDiv)=>_class_private_field_loose_base(this, _handleAccordionToggle)[_handleAccordionToggle](methodDiv));
        }
        return methodDiv;
    }
    constructor(params){
        super(params), Object.defineProperty(this, _handleAccordionToggle, {
            value: handleAccordionToggle
        }), Object.defineProperty(this, _attachCVCListener, {
            value: attachCVCListener
        }), Object.defineProperty(this, _attachInputListener, {
            value: attachInputListener
        }), Object.defineProperty(this, _updateFormStatus, {
            value: updateFormStatus
        }), Object.defineProperty(this, _cardType, {
            writable: true,
            value: void 0
        }), Object.defineProperty(this, _cvv, {
            writable: true,
            value: void 0
        }), Object.defineProperty(this, _accountId, {
            writable: true,
            value: void 0
        }), Object.defineProperty(this, _formBuilder$1, {
            writable: true,
            value: void 0
        }), _class_private_field_loose_base(this, _formBuilder$1)[_formBuilder$1] = new FormBuilder();
        _class_private_field_loose_base(this, _cardType)[_cardType] = params.cardType;
        _class_private_field_loose_base(this, _cvv)[_cvv] = '';
        _class_private_field_loose_base(this, _accountId)[_accountId] = params.accountId;
    }
}
function handleAccordionToggle(methodDiv) {
    var _this;
    const selectedTabState = AppState.selectedTabState;
    const stateSelectedMethod = selectedTabState == null ? void 0 : selectedTabState.selectedSavedMethod;
    if (stateSelectedMethod == null ? void 0 : stateSelectedMethod.id) {
        const prevMethodDiv = getMethodDivById(stateSelectedMethod.id);
        if (prevMethodDiv) {
            removeAmountScreen(prevMethodDiv);
            toggleAccordionByMethod(prevMethodDiv, true);
        }
    }
    const isTheSameMethod = (stateSelectedMethod == null ? void 0 : stateSelectedMethod.id) === ((_this = this) == null ? void 0 : _this.id);
    toggleAccordionByMethod(methodDiv, isTheSameMethod);
    if (isTheSameMethod) {
        AppState.wallet.deposit.selectedSavedMethod = null;
        removeAmountScreen(methodDiv);
    } else {
        AppState.wallet.deposit.selectedSavedMethod = this;
        addAmountScreen(methodDiv, this, true);
        void this.injectEncryption();
        _class_private_field_loose_base(this, _attachCVCListener)[_attachCVCListener](methodDiv, this);
        _class_private_field_loose_base(this, _attachInputListener)[_attachInputListener](methodDiv, this);
        attachButtonListener(methodDiv, {
            isSavedMethod: this.isSavedMethod,
            shouldEnableBtn: false,
            onInputChange: ()=>_class_private_field_loose_base(this, _updateFormStatus)[_updateFormStatus](methodDiv)
        });
    }
}
function attachCVCListener(methodDiv, depositMethod) {
    const formField = methodDiv.querySelector('.cvc-form-field');
    const submitButton = methodDiv.querySelector('.amount-screen__submit');
    const errorText = methodDiv.querySelector('.amount-screen__error-cvc');
    if (formField) {
        formField.addEventListener('input', function(event) {
            var _customEvent_detail, _customEvent_detail1;
            const customEvent = event;
            const value = (customEvent == null ? void 0 : (_customEvent_detail = customEvent.detail) == null ? void 0 : _customEvent_detail.value) || ((_customEvent_detail1 = customEvent.detail) == null ? void 0 : _customEvent_detail1[0]);
            _class_private_field_loose_base(depositMethod, _cvv)[_cvv] = handleCVCInput(value, formField, submitButton, {
                invalid: errorText
            });
            _class_private_field_loose_base(depositMethod, _updateFormStatus)[_updateFormStatus](methodDiv);
        });
    }
}
function attachInputListener(methodDiv, depositMethod) {
    const formField = methodDiv.querySelector('.input-form-field');
    if (formField) {
        formField.addEventListener('input', function(event) {
            var _customEvent_detail, _customEvent_detail1;
            const customEvent = event;
            const value = (customEvent == null ? void 0 : (_customEvent_detail = customEvent.detail) == null ? void 0 : _customEvent_detail.value) || ((_customEvent_detail1 = customEvent.detail) == null ? void 0 : _customEvent_detail1[0]);
            handleInput(value, methodDiv, depositMethod, false);
            _class_private_field_loose_base(depositMethod, _updateFormStatus)[_updateFormStatus](methodDiv);
        });
    }
}
function updateFormStatus(methodDiv) {
    const cvcField = methodDiv.querySelector('.cvc-form-field');
    const amountField = methodDiv.querySelector('.input-form-field');
    const submitButton = methodDiv.querySelector('.amount-screen__submit');
    if (cvcField.getAttribute('hasSuccess') && amountField.getAttribute('hasSuccess')) {
        submitButton.removeAttribute('disabled');
    } else {
        submitButton.setAttribute('disabled', '');
    }
}

class DevCodeAppleMethod extends BaseDevcodeNestedIframeMethod {
    get getPopupUrl() {
        return window.location.origin;
    }
}

class DevcodeMuchBetterMethod extends BaseDevcodeNestedIframeMethod {
    getSpecificDepositData() {
        var _AppState_wallet_profile;
        return {
            phoneNumber: (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile.customer.phone
        };
    }
}

const MIN_ACCOUNT_NUMBER_LENGHT = 15;
const MAX_ACCOUNT_NUMNBER_LENGTH = 16;
const MIN_SWIFT_LENGHT = 8;
const MAX_SWIFT_LENGTH = 11;
function devcodeBankTransferFormConfig(input) {
    const formFooter = document.createElement('div');
    formFooter.innerHTML = getDetailsFooter();
    function bankInvalidMessage(text, min, max) {
        return text.replace('{min}', String(min)).replace('{max}', String(max));
    }
    return [
        {
            path: '1',
            components: [
                {
                    id: 'branchName',
                    component: 'magic-ui-form-field',
                    isDataField: true,
                    type: 'text',
                    testId: 'branchName',
                    validationDisplay: ValidationDisplay.OnTouchShowMessage,
                    properties: {
                        placeholder: translate('galleon.input.placeholder'),
                        label: translate('galleon.bank.input.branch-name.label'),
                        value: (input == null ? void 0 : input.branchName) || ''
                    },
                    validation: [
                        {
                            name: 'required',
                            fn: (value)=>required(value),
                            message: translate('galleon.bank.input.branch-name.required')
                        }
                    ]
                },
                {
                    id: 'accountNumber',
                    component: 'magic-ui-form-field',
                    isDataField: true,
                    type: 'text',
                    testId: 'accountNumber',
                    validationDisplay: ValidationDisplay.OnTouchShowMessage,
                    properties: {
                        placeholder: translate('galleon.bank.input.account-number.placeholder'),
                        label: translate('galleon.bank.input.account-number.label'),
                        value: (input == null ? void 0 : input.accountNumber) || ''
                    },
                    validation: [
                        {
                            name: 'required',
                            fn: (value)=>required(value),
                            message: translate('galleon.withdraw.account.number.required')
                        },
                        {
                            name: 'is-valid-accountNumber',
                            fn: (value)=>maxLength(MAX_ACCOUNT_NUMNBER_LENGTH)(value) && minLength(MIN_ACCOUNT_NUMBER_LENGHT)(value),
                            message: bankInvalidMessage(translate('galleon.withdraw.bank-transfer.account-number.invalid'), MIN_ACCOUNT_NUMBER_LENGHT, MAX_ACCOUNT_NUMNBER_LENGTH)
                        }
                    ]
                },
                {
                    id: 'bicSwift',
                    component: 'magic-ui-form-field',
                    isDataField: true,
                    type: 'text',
                    testId: 'bicSwift',
                    validationDisplay: ValidationDisplay.OnTouchShowMessage,
                    properties: {
                        placeholder: translate('galleon.bank.input.bic-swift.placeholder'),
                        label: translate('galleon.bank.input.bic-swift.label'),
                        value: ''
                    },
                    validation: [
                        {
                            name: 'is-valid-bicSwift',
                            fn: (value)=>maxLength(MAX_SWIFT_LENGTH)(value) && minLength(MIN_SWIFT_LENGHT)(value),
                            message: bankInvalidMessage(translate('galleon.withdraw.bank-transfer.swift.invalid'), MIN_SWIFT_LENGHT, MAX_SWIFT_LENGTH)
                        }
                    ]
                }
            ],
            footer: formFooter
        }
    ];
}

var _formBuilder = /*#__PURE__*/ _class_private_field_loose_key("_formBuilder");
class DevcodeBankTransferMethod extends BaseDevcodeNestedIframeMethod {
    async withdraw(amount) {
        var _AppState_wallet_profile;
        const customer = (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : _AppState_wallet_profile.customer;
        const name = (customer == null ? void 0 : customer.firstName) || (customer == null ? void 0 : customer.lastName) ? `${(customer == null ? void 0 : customer.firstName) || ''} ${(customer == null ? void 0 : customer.lastName) || ''}` : '';
        const formResult = await createFormScreen({
            amount,
            formBuilder: _class_private_field_loose_base(this, _formBuilder)[_formBuilder],
            formConfig: devcodeBankTransferFormConfig({
                branchName: name
            })
        });
        const content = getCurrentTab();
        const submitBtn = content.querySelector('.details__confirm-button');
        submitBtn == null ? void 0 : submitBtn.setAttribute('loading', 'true');
        await this.proceedWithdrawal(amount, formResult);
    }
    async proceedWithdrawal(amount, formData) {
        const { merchantId } = this.devcodeGateway.config;
        const payloadData = {
            amount,
            accountNumber: formData.accountNumber,
            bic: formData.bicSwift,
            branchName: formData.branchName,
            merchantId,
            attributes: {
                channelId: getScreenType(),
                iovationBlackbox: '',
                type: 'Standard',
                userPlatform: JSON.stringify(getPlatformInfo(navigator.userAgent))
            }
        };
        const options = {
            data: payloadData,
            type: this.paymentMethodExternalId.toLowerCase()
        };
        this.logAttempt(amount);
        const response = await this.devcodeGateway.withdrawal(options);
        const launchWithdrawResult = {
            currencyCode: this.currencyCode,
            success: response.success,
            transactionID: response.txRefId,
            amount,
            popupUrl: this.redirectBaseUrl,
            paymentMethod: this.paymentMethodExternalId,
            promoCode: AppState.wallet.chosenDepositBonus || ''
        };
        this.logPayment(launchWithdrawResult);
        if (response.txState === 'WAITING_APPROVAL') {
            const { message, title } = this.getWaitingForApprovalStatusMessage();
            createWithdrawStatusScreen(launchWithdrawResult, message, title);
            void PendingBalanceCheck.checkWithdrawalBalance(launchWithdrawResult);
            return;
        }
        createWithdrawStatusScreen(launchWithdrawResult);
    }
    constructor(...args){
        super(...args), Object.defineProperty(this, _formBuilder, {
            writable: true,
            value: void 0
        }), _class_private_field_loose_base(this, _formBuilder)[_formBuilder] = new FormBuilder();
    }
}

class DevcodePayByBankMethod extends BaseDevcodeNestedIframeMethod {
    get paymentMethodExternalId() {
        return this.providerServiceId;
    }
    get flowType() {
        return EDevcodeMethodFlowType.NestedIframe;
    }
    async withdraw(amount) {
        await this.proceedWithdrawal(amount);
    }
    async showUIDepositForm(_amount, _inputParams) {
        return Promise.resolve({});
    }
    async processDeposit(amount) {
        var _AppState_wallet_profile_customer, _AppState_wallet_profile, _response_redirectOutput;
        this.amount = amount;
        const options = {
            data: _extends$1({
                amount: this.amount,
                attributes: {
                    bonusCode: AppState.wallet.chosenDepositBonus || '',
                    channelId: getScreenType(),
                    iovationBlackbox: '',
                    type: 'Standard',
                    // TODO: check old cashier implementation of redirection
                    successUrl: this.getStatusRedirectUrl(ERedirectStatus.Success),
                    failureUrl: this.getStatusRedirectUrl(ERedirectStatus.Fail),
                    pendingUrl: this.getStatusRedirectUrl(ERedirectStatus.Pending),
                    cancelUrl: this.getStatusRedirectUrl(ERedirectStatus.Cancel),
                    //FYI: Devcode API returns error when userPlatform is not stringified
                    userPlatform: JSON.stringify(getPlatformInfo(navigator.userAgent))
                },
                email: (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : (_AppState_wallet_profile_customer = _AppState_wallet_profile.customer) == null ? void 0 : _AppState_wallet_profile_customer.email
            }, this.getSpecificDepositData()),
            type: this.params.paymentMethodExternalId.toLowerCase()
        };
        if (this.service) {
            options.data.service = this.service;
        }
        this.logAttempt(amount);
        const response = await this.devcodeGateway.deposit(options);
        const launchDepositResult = {
            currencyCode: this.currencyCode,
            success: response.success,
            transactionID: response.txRefId,
            amount,
            popupUrl: this.getPopupUrl,
            paymentMethod: this.paymentMethodExternalId,
            paymentMethodLabel: this.methodLabel,
            promoCode: AppState.wallet.chosenDepositBonus || ''
        };
        if (((_response_redirectOutput = response.redirectOutput) == null ? void 0 : _response_redirectOutput.container) === ERedirectContainer.Iframe) {
            const formattedUrl = formatRedirectURL(response.redirectOutput.url, response.redirectOutput.parameters);
            launchDepositResult.buttonUrl = formattedUrl;
        }
        return {
            response,
            launchDepositResult
        };
    }
    getSpecificDepositData() {
        return this.getProfileDetails();
    }
    getStatusRedirectUrl(status) {
        return this.getRedirectionUrl(this.redirectBaseUrl, this.paymentMethodExternalId, status);
    }
    async proceedWithdrawal(amount, formData = {}) {
        var _AppState_wallet_profile_customer, _AppState_wallet_profile, _response_redirectOutput;
        const { merchantId } = this.devcodeGateway.config;
        const payByBankLaunchConfig = this.getProfileDetails();
        const payloadData = _extends$1({
            amount,
            service: this.service,
            merchantId,
            attributes: {
                channelId: getScreenType(),
                iovationBlackbox: '',
                type: 'Standard',
                successUrl: this.getStatusRedirectUrl(ERedirectStatus.Success),
                failureUrl: this.getStatusRedirectUrl(ERedirectStatus.Fail),
                pendingUrl: this.getStatusRedirectUrl(ERedirectStatus.Pending),
                cancelUrl: this.getStatusRedirectUrl(ERedirectStatus.Cancel),
                userPlatform: JSON.stringify(getPlatformInfo(navigator.userAgent))
            }
        }, payByBankLaunchConfig, formData, {
            email: (_AppState_wallet_profile = AppState.wallet.profile) == null ? void 0 : (_AppState_wallet_profile_customer = _AppState_wallet_profile.customer) == null ? void 0 : _AppState_wallet_profile_customer.email
        });
        const options = {
            data: payloadData,
            type: this.params.paymentMethodExternalId.toLowerCase()
        };
        this.logAttempt(amount);
        const response = await this.devcodeGateway.withdrawal(options);
        const launchWithdrawResult = {
            currencyCode: this.currencyCode,
            success: response.success,
            transactionID: response.txRefId,
            amount,
            popupUrl: this.redirectBaseUrl,
            paymentMethod: this.params.paymentMethodExternalId,
            promoCode: AppState.wallet.chosenDepositBonus || ''
        };
        this.logPayment(launchWithdrawResult);
        if (((_response_redirectOutput = response.redirectOutput) == null ? void 0 : _response_redirectOutput.container) === ERedirectContainer.Iframe) {
            const formattedUrl = formatRedirectURL(response.redirectOutput.url, response.redirectOutput.parameters);
            launchWithdrawResult.buttonUrl = formattedUrl;
        }
        void this.showWithdrawResult(launchWithdrawResult, response);
    }
}

class DevcodeSavedPBBMethod extends BaseDevcodeSavedMethod {
    getSpecificWithdrawData() {
        return _extends$1({
            service: this.service
        }, super.getSpecificWithdrawData(), this.getProfileDetails());
    }
    getSpecificDepositData() {
        return {
            maskedAccount: this.maskedAccount,
            service: this.service,
            accountId: this.accountId
        };
    }
}

class DevcodeMethodFactory {
    static createPaymentMethod(method, isDeposit = true) {
        const { totalFixedFee, totalPercentageFee, minAmount, maxAmount } = this.calculateLimits(method, isDeposit);
        const baseProps = {
            provider: ProviderType.Devcode,
            id: method.txType,
            title: isMagicPaymentMethod(method) ? getMagicPaymentMethodNameByLanguage(method, AppState.wallet.locale || 'en') : method.providerType,
            fixedFee: Number(totalFixedFee),
            percentageFee: Number(totalPercentageFee),
            minAmount: minAmount,
            maxAmount: maxAmount,
            currencyCode: AppState.wallet.balanceData.currencyCode,
            paymentMethodExternalId: method.providerType,
            logoUrl: isMagicPaymentMethod(method) ? getMagicPaymentMethodLogoByMarket(method, AppState.wallet.locale || 'en') : method.logoUrl,
            position: isMagicPaymentMethod(method) ? method.position : undefined
        };
        if (method.service) {
            baseProps.service = method.service;
        }
        // TODO: we need to check the service type along with the provider type for devcode methods
        // const providerServiceType = method.providerType + (method.service ? '+' + method.service : '');
        switch(method.providerType){
            case DevcodeMethodId.CreditCard:
                return new BaseDevcodeCardMethod(baseProps);
            case DevcodeMethodId.Skrill:
            case DevcodeMethodId.Trustly:
            case DevcodeMethodId.Paypal:
                // TODO: we can specify flowtype for basic or redirect methods
                // baseProps.flowType = EDevcodeMethodFlowType.NestedIframe;
                return new BaseDevcodeNestedIframeMethod(baseProps);
            case DevcodeMethodId.MuchBetter:
                return new DevcodeMuchBetterMethod(baseProps);
            case DevcodeMethodId.BankIBAN:
                return new DevcodeBankIBANMethod(baseProps);
            case DevcodeMethodId.Bank:
                switch(method.service){
                    case DevcodeServiceId.PayByBank:
                        return new DevcodePayByBankMethod(baseProps);
                }
                return new DevcodeBankTransferMethod(baseProps);
            case DevcodeMethodId.BankLocal:
                return new DevcodeBankLocalMethod(baseProps);
            case DevcodeMethodId.ApplePay:
                return new DevCodeAppleMethod(baseProps);
            default:
                return new BaseDevcodeNestedIframeMethod(baseProps);
        }
    }
    static calculateLimits(method, isDeposit) {
        var _method_fees_, _method_fees, _method_fees_1, _method_fees1;
        // TODO: check if could we have the few different method.fees[0] method.fees[1]...
        //  objects in one time for one method as it was implemented as on the old cashier
        const totalFixedFee = ((_method_fees = method.fees) == null ? void 0 : (_method_fees_ = _method_fees[0]) == null ? void 0 : _method_fees_.fixedFee) || 0;
        const totalPercentageFee = ((_method_fees1 = method.fees) == null ? void 0 : (_method_fees_1 = _method_fees1[0]) == null ? void 0 : _method_fees_1.percentageFee) || 0;
        const resultPricePartFee = 1 + Number(totalPercentageFee);
        const feeDirection = isDeposit ? 1 : -1;
        const minAmount = resultPricePartFee * Number(method.limit.min) + Number(totalFixedFee) * feeDirection;
        const maxAmount = resultPricePartFee * Number(method.limit.max) + Number(totalFixedFee) * feeDirection;
        return {
            totalFixedFee,
            totalPercentageFee,
            minAmount,
            maxAmount
        };
    }
    static createSavedMethod(method, isDeposit = true) {
        var _method_accounts;
        if (!((_method_accounts = method.accounts) == null ? void 0 : _method_accounts.length)) return [];
        const savedMethods = [];
        const { totalFixedFee, totalPercentageFee, minAmount, maxAmount } = this.calculateLimits(method, isDeposit);
        for(let i = 0; i < method.accounts.length; i++){
            var _method_accounts_i, _method_accounts1, _method_accounts_i1, _method_accounts2;
            const baseProps = {
                fixedFee: Number(totalFixedFee),
                percentageFee: Number(totalPercentageFee),
                maxAmount: maxAmount,
                minAmount: minAmount,
                paymentMethodExternalId: method.providerType,
                id: (_method_accounts1 = method.accounts) == null ? void 0 : (_method_accounts_i = _method_accounts1[i]) == null ? void 0 : _method_accounts_i.accountId,
                maskedAccount: (_method_accounts2 = method.accounts) == null ? void 0 : (_method_accounts_i1 = _method_accounts2[i]) == null ? void 0 : _method_accounts_i1.maskedAccount,
                title: method.providerType,
                isSavedMethod: true,
                provider: ProviderType.Devcode,
                currencyCode: AppState.wallet.balanceData.currencyCode,
                accountId: method.accounts[i].accountId,
                logoUrl: isMagicPaymentMethod(method) ? getMagicPaymentMethodLogoByMarket(method, AppState.wallet.locale || 'en') : method.logoUrl
            };
            if (method.service) {
                baseProps.service = method.service;
            }
            switch(method.providerType){
                case DevcodeMethodId.CreditCard:
                    savedMethods.push(new DevcodeSavedCardMethod(_extends$1({}, baseProps, {
                        cardType: method.accounts[i].cardType
                    })));
                    break;
                case DevcodeMethodId.Bank:
                    switch(method.service){
                        case DevcodeServiceId.PayByBank:
                            savedMethods.push(new DevcodeSavedPBBMethod(_extends$1({}, baseProps)));
                            break;
                    }
                    break;
                default:
                    savedMethods.push(new BaseDevcodeSavedMethod(_extends$1({}, baseProps)));
            }
        }
        return savedMethods;
    }
}

var _host = /*#__PURE__*/ _class_private_field_loose_key("_host"), _fetchApi = /*#__PURE__*/ _class_private_field_loose_key("_fetchApi"), _transformToPaymentViewModel$1 = /*#__PURE__*/ _class_private_field_loose_key("_transformToPaymentViewModel");
class DevcodeGateway extends BaseCorexAdaptedGateway {
    async init(config) {
        this.config = config;
        const HOST_ENDPOINT = config.environment === 'test' ? 'test-' : '';
        _class_private_field_loose_base(this, _host)[_host] = 'https://' + HOST_ENDPOINT + 'api.paymentiq.io/paymentiq';
        if (this.config.isMockEnv) {
            _class_private_field_loose_base(this, _host)[_host] = this.config.corex.apiUrl;
        }
        super.init(config);
    }
    update(config) {
        super.update(config);
    }
    async launchDeposit() {
        const launchDepositConfig = {
            depositConfig: {
                apiUrl: this.config.corex.apiUrl,
                tenant: this.config.corex.tenant,
                paymentDetails: {
                    currencyCode: AppState.wallet.balanceData.currencyCode
                },
                serviceName: CorexProviderType.Devcode
            }
        };
        return await this.corexService.launchDeposit(launchDepositConfig);
    }
    async getWithdrawalMethods() {
        const { sessionContextId } = await this.launchWithdraw();
        this.update({
            sessionId: sessionContextId
        });
        this.fetchPendingWithdrawals(); // Call fetchPendingWithdrawals here
        return this.getLibWithdrawalMethods();
    }
    async getDepositMethods() {
        const { sessionContextId } = await this.launchDeposit();
        this.update({
            sessionId: sessionContextId
        });
        const { methods, savedMethods } = await this.getLibDepositMethods();
        return {
            methods,
            savedMethods
        };
    }
    async getLibWithdrawalMethods() {
        return await this.getPaymentMethods(false);
    }
    async getPaymentMethods(isDeposit) {
        const request = {};
        const channel = getScreenType();
        const requestUrlMethod = isDeposit ? 'Deposit' : 'Withdrawal';
        request.method = 'GET';
        request.url = `${_class_private_field_loose_base(this, _host)[_host]}/api/user/payment/method/${this.config.merchantId}/${this.config.userProfileId}` + `?sessionId=${this.config.sessionId}&channelId=${channel}&method=${requestUrlMethod}`;
        const response = await _class_private_field_loose_base(this, _fetchApi)[_fetchApi](request);
        const mappedMethods = mapMagicMethods(response.methods, AppState.methods.magicPaymentMethodsByProvider.Devcode, /*
      TODO: we need to review the way to substitute data from CMS and align it with the PIQ,
      as we use txType as unique key and magicMethod.name - we can specify on CMS for Devcode
      and the magicMethod.method - it is going from CoreX BO, but we need to recreat the method one the name is changed pon CreX BO
       */ (devcodeMethod, magicMethod)=>magicMethod.name === devcodeMethod.txType, (devcodeMethod, magicMethod)=>_extends$1({}, devcodeMethod, magicMethod, {
                providerType: devcodeMethod.providerType
            }));
        return _class_private_field_loose_base(this, _transformToPaymentViewModel$1)[_transformToPaymentViewModel$1](mappedMethods, isDeposit);
    }
    async deposit(depositOptions) {
        const request = {};
        depositOptions.data.merchantId = this.config.merchantId;
        depositOptions.data.sessionId = this.config.sessionId;
        depositOptions.data.userId = this.config.userProfileId;
        request.method = 'POST';
        request.url = `${_class_private_field_loose_base(this, _host)[_host]}/api/${depositOptions.type}/deposit/process?locale=${this.config.locale}`;
        request.data = depositOptions.data;
        return _class_private_field_loose_base(this, _fetchApi)[_fetchApi](request);
    }
    async withdrawal(withdrawalOptions) {
        const request = {};
        withdrawalOptions.data.merchantId = this.config.merchantId;
        withdrawalOptions.data.sessionId = this.config.sessionId;
        withdrawalOptions.data.userId = this.config.userProfileId;
        request.method = 'POST';
        request.url = `${_class_private_field_loose_base(this, _host)[_host]}/api/${withdrawalOptions.type}/withdrawal/process?locale=${this.config.locale}`;
        request.data = withdrawalOptions.data;
        return _class_private_field_loose_base(this, _fetchApi)[_fetchApi](request);
    }
    async remove(options) {
        var _options_data;
        const request = {};
        request.method = 'DELETE';
        const merchantId = this.config.merchantId || options.merchantId; //`100049002`;
        const usedId = options.userId || this.config.userProfileId;
        const accountId = options.accountId;
        const sessionId = (options == null ? void 0 : (_options_data = options.data) == null ? void 0 : _options_data.sessionId) || this.config.sessionId;
        request.url = `${_class_private_field_loose_base(this, _host)[_host]}/api/user/account/${merchantId}/${usedId}/${accountId}?sessionId=${sessionId}`;
        request.data = {
            sessionId: this.config.sessionId
        };
        return _class_private_field_loose_base(this, _fetchApi)[_fetchApi](request);
    }
    async fetchPendingWithdrawals() {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(new Date().getFullYear() - 1);
        const oneYearAgoTimestamp = formatDate(oneYearAgo);
        const request = {};
        request.method = 'GET';
        request.url = `${_class_private_field_loose_base(this, _host)[_host]}/api/user/transaction/${this.config.merchantId}/${this.config.userProfileId}?sessionId=${this.config.sessionId}&method=Withdrawal&states=WAITING_APPROVAL&minDate=${oneYearAgoTimestamp}`;
        const data = await _class_private_field_loose_base(this, _fetchApi)[_fetchApi](request);
        if (data == null ? void 0 : data.transactions) {
            const existingWithdrawalIds = new Set(AppState.wallet.pendingWithdrawals.map((w)=>w.id));
            const newWithdrawals = data.transactions.filter((w)=>!existingWithdrawalIds.has(w.id));
            AppState.wallet.pendingWithdrawals = [
                ...AppState.wallet.pendingWithdrawals,
                ...newWithdrawals
            ]; // Add only new withdrawals.
        }
    }
    async getLibDepositMethods() {
        return await this.getPaymentMethods(true);
    }
    async launchWithdraw() {
        const config = {
            currencyCode: AppState.wallet.balanceData.currencyCode
        };
        return await this.corexService.launchWithdraw(config, CorexProviderType.Devcode);
    }
    constructor(){
        super(), Object.defineProperty(this, _fetchApi, {
            value: fetchApi
        }), Object.defineProperty(this, _transformToPaymentViewModel$1, {
            value: transformToPaymentViewModel$1
        }), Object.defineProperty(this, _host, {
            writable: true,
            value: void 0
        });
        this.corexService.providerType = CorexProviderType.Devcode;
    }
}
async function fetchApi(request, mockResult) {
    return httpUtils.fetchApi(request.url, request.method, request.headers, request.data, mockResult);
}
function transformToPaymentViewModel$1(methods, isDeposit = true) {
    return {
        savedMethods: methods.map((method)=>DevcodeMethodFactory.createSavedMethod(method, isDeposit)).flat(),
        methods: methods.map((method)=>DevcodeMethodFactory.createPaymentMethod(method, isDeposit))
    };
}

function buildNuveiFormConfig(fields) {
    const formFooter = document.createElement('div');
    formFooter.innerHTML = getDetailsFooter();
    return [
        {
            path: '1',
            components: fields.map((field)=>{
                var _field_caption_, _field_caption, _field_validationmessage_, _field_validationmessage, _field_validationmessage_1, _field_validationmessage1;
                return {
                    id: field.name,
                    component: 'magic-ui-form-field',
                    isDataField: true,
                    type: 'text',
                    testId: field.name,
                    validationDisplay: ValidationDisplay.OnTouchShowMessage,
                    properties: {
                        placeholder: translate('galleon.input.placeholder'),
                        label: (_field_caption = field.caption) == null ? void 0 : (_field_caption_ = _field_caption[0]) == null ? void 0 : _field_caption_.message
                    },
                    validation: [
                        {
                            name: 'required',
                            fn: (value)=>{
                                return required(value);
                            },
                            message: (_field_validationmessage = field.validationmessage) == null ? void 0 : (_field_validationmessage_ = _field_validationmessage[0]) == null ? void 0 : _field_validationmessage_.message
                        },
                        {
                            name: field.name,
                            fn: (value)=>{
                                if (field.validationFn && typeof field.validationFn === 'function') {
                                    return field.validationFn(value);
                                }
                                if (field.regex) {
                                    const regex = new RegExp(field.regex);
                                    return !!regex.test(value);
                                }
                                return true;
                            },
                            message: (_field_validationmessage1 = field.validationmessage) == null ? void 0 : (_field_validationmessage_1 = _field_validationmessage1[0]) == null ? void 0 : _field_validationmessage_1.message
                        }
                    ]
                };
            }),
            footer: formFooter
        }
    ];
}

var _shouldCreateForm = /*#__PURE__*/ _class_private_field_loose_key("_shouldCreateForm"), _onFormSubmit$1 = /*#__PURE__*/ _class_private_field_loose_key("_onFormSubmit");
class BaseNuveiMethod extends BasePaymentMethod {
    deposit(amount) {
        if (_class_private_field_loose_base(this, _shouldCreateForm)[_shouldCreateForm]()) {
            const fields = this.updateFieldsValues(this.params.fields);
            void createFormScreen({
                amount,
                formBuilder: this.formBuilder,
                formConfig: buildNuveiFormConfig(fields),
                onFormSubmit: _class_private_field_loose_base(this, _onFormSubmit$1)[_onFormSubmit$1].bind(this)
            });
        } else {
            // implement later
            console.log('deposited', amount);
        }
    }
    withdraw(amount) {
        console.log(amount);
    }
    updateFieldsValues(fields) {
        return fields;
    }
    constructor(...args){
        super(...args), Object.defineProperty(this, _shouldCreateForm, {
            value: shouldCreateForm
        }), Object.defineProperty(this, _onFormSubmit$1, {
            value: onFormSubmit$1
        }), this.formBuilder = new FormBuilder();
    }
}
function shouldCreateForm() {
    return this.params.fields.length;
}
async function onFormSubmit$1(formData, amount) {
    var _GatewayRegistry_getGateway;
    this.logAttempt(amount);
    (_GatewayRegistry_getGateway = GatewayRegistry.getGateway(GatewayType.Nuvei)) == null ? void 0 : _GatewayRegistry_getGateway.createPayment(amount, this.params.paymentMethodExternalId, {
        alternativePaymentMethod: _extends$1({
            paymentMethod: this.params.paymentMethodExternalId
        }, formData)
    });
}

var _fields = /*#__PURE__*/ _class_private_field_loose_key("_fields"), _onFormSubmit = /*#__PURE__*/ _class_private_field_loose_key("_onFormSubmit"), _addEventHandlers = /*#__PURE__*/ _class_private_field_loose_key("_addEventHandlers");
class CardNuveiMethod extends BaseNuveiMethod {
    async deposit(amount) {
        await createFormScreen({
            amount,
            formBuilder: this.formBuilder,
            formConfig: buildNuveiFormConfig(_class_private_field_loose_base(this, _fields)[_fields]),
            onFormSubmit: _class_private_field_loose_base(this, _onFormSubmit)[_onFormSubmit].bind(this)
        });
        _class_private_field_loose_base(this, _addEventHandlers)[_addEventHandlers]();
    }
    constructor(...args){
        super(...args), Object.defineProperty(this, _onFormSubmit, {
            value: onFormSubmit
        }), Object.defineProperty(this, _addEventHandlers, {
            value: addEventHandlers
        }), Object.defineProperty(this, _fields, {
            writable: true,
            value: void 0
        }), _class_private_field_loose_base(this, _fields)[_fields] = [
            {
                name: 'cardHolderName',
                type: 'text',
                caption: [
                    {
                        message: translate('galleon.deposit.card.details.holder.label')
                    }
                ]
            },
            {
                name: 'cardNumber',
                type: 'text',
                caption: [
                    {
                        message: translate('galleon.deposit.card.details.number.label')
                    }
                ],
                validationFn: (value)=>dist.number(value).isValid,
                validationmessage: [
                    {
                        message: translate('galleon.deposit.card.details.number.error')
                    }
                ]
            },
            {
                name: 'expirationTime',
                type: 'text',
                caption: [
                    {
                        message: translate('galleon.deposit.card.details.expiry.label')
                    }
                ],
                validationFn: (value)=>dist.expirationDate(value).isValid,
                validationmessage: [
                    {
                        message: translate('galleon.deposit.card.details.expiry.error')
                    }
                ]
            },
            {
                name: 'CVV',
                type: 'text',
                caption: [
                    {
                        message: 'CVC'
                    }
                ],
                regex: '^[0-9]{3,4}$',
                validationmessage: [
                    {
                        message: translate('galleon.deposit.card.details.cvc.error')
                    }
                ]
            }
        ];
    }
}
async function onFormSubmit(formData, amount) {
    const { expirationTime } = formData, card = _object_without_properties_loose(formData, [
        "expirationTime"
    ]);
    const [month, shortYear] = expirationTime.split('/');
    const content = getCurrentTab();
    const submitBtn = content.querySelector('.details__confirm-button');
    submitBtn == null ? void 0 : submitBtn.setAttribute('loading', 'true');
    const nuveiGateway = GatewayRegistry.getGateway(GatewayType.Nuvei);
    this.logAttempt(amount);
    const depositData = await nuveiGateway.createPayment(amount, this.params.paymentMethodExternalId, {
        card: _extends$1({}, card, {
            expirationMonth: month,
            expirationYear: `20${shortYear}`
        })
    });
    this.logPayment(depositData);
    createDepositStatusScreen(depositData);
}
function addEventHandlers() {
    const content = getCurrentTab();
    const form = content.querySelector('.form-builder');
    const expirationTime$ = form.querySelector('#expirationTime');
    expirationTime$ == null ? void 0 : expirationTime$.addEventListener('input', (event)=>{
        const value = getEventValue(event);
        const numValue = value.replace(/[^0-9/]/g, '');
        expirationTime$.setAttribute('value', value);
        refreshFieldValue(expirationTime$, expiryFormatter(numValue));
    });
}

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
class NuveiExpressCheckoutMethod extends BaseNuveiMethod {
    updateFieldsValues(fields) {
        const updatedFields = [
            ...fields
        ];
        const emailField = updatedFields.find((field)=>field.name === 'email');
        emailField.regex = emailRegex;
        emailField.caption.push({
            message: translate('galleon.deposit.email.label')
        });
        if (emailField.validationmessage) {
            var _emailField_validationmessage;
            (_emailField_validationmessage = emailField.validationmessage) == null ? void 0 : _emailField_validationmessage.push({
                message: translate('galleon.deposit.email.label.error')
            });
        } else {
            emailField.validationmessage = [
                {
                    message: translate('galleon.deposit.email.label.error')
                }
            ];
        }
        return updatedFields;
    }
}

class NuveiMethodFactory {
    static createPaymentMethod(method) {
        var _method_paymentMethodDisplayName_, _method_paymentMethodDisplayName;
        const baseProps = {
            id: method.paymentMethod,
            paymentMethodExternalId: method.paymentMethod,
            title: isMagicPaymentMethod(method) ? getMagicPaymentMethodNameByLanguage(method, AppState.wallet.locale || 'en') : (_method_paymentMethodDisplayName = method.paymentMethodDisplayName) == null ? void 0 : (_method_paymentMethodDisplayName_ = _method_paymentMethodDisplayName[0]) == null ? void 0 : _method_paymentMethodDisplayName_.message,
            currencyCode: method.currencies[0],
            logoUrl: isMagicPaymentMethod(method) ? getMagicPaymentMethodLogoByMarket(method, AppState.wallet.locale || 'en') : method.logoURL,
            provider: ProviderType.Nuvei,
            fields: method.fields,
            maxAmount: 10000,
            minAmount: 10,
            position: isMagicPaymentMethod(method) ? method.position : undefined
        };
        switch(method.paymentMethod){
            case NuveiMethodId.Card:
                return new CardNuveiMethod(baseProps);
            case NuveiMethodId.ExpressCheckout:
                return new NuveiExpressCheckoutMethod(baseProps);
            default:
                return new BaseNuveiMethod(baseProps);
        }
    }
}

const NUVEI_URLS = {
    backUrl: 'https://docs.nuvei.com/',
    deepLinkUrl: 'https://docs.nuvei.com/',
    successUrl: 'https://docs.nuvei.com/',
    errorUrl: 'https://docs.nuvei.com/'
};

const nuveiSourceUrl = 'https://cdn.safecharge.com/safecharge_resources/v1/websdk/safecharge.js';
var _instance = /*#__PURE__*/ _class_private_field_loose_key("_instance"), _config = /*#__PURE__*/ _class_private_field_loose_key("_config"), _initialised$1 = /*#__PURE__*/ _class_private_field_loose_key("_initialised"), _isScriptLoaded = /*#__PURE__*/ _class_private_field_loose_key("_isScriptLoaded");
class NuveiCashier {
    static get instance() {
        if (!_class_private_field_loose_base(this, _instance)[_instance]) {
            _class_private_field_loose_base(this, _instance)[_instance] = new NuveiCashier();
        }
        return _class_private_field_loose_base(this, _instance)[_instance];
    }
    async init(config) {
        if (_class_private_field_loose_base(this, _initialised$1)[_initialised$1]) {
            return Promise.resolve();
        }
        if (!_class_private_field_loose_base(this, _isScriptLoaded)[_isScriptLoaded]) {
            _class_private_field_loose_base(this, _isScriptLoaded)[_isScriptLoaded] = await loadScript(nuveiSourceUrl);
        }
        _class_private_field_loose_base(this, _initialised$1)[_initialised$1] = true;
        _class_private_field_loose_base(this, _config)[_config] = config;
        return Promise.resolve();
    }
    async update(config) {
        if (!_class_private_field_loose_base(this, _initialised$1)[_initialised$1]) {
            return Promise.resolve();
        }
        if (config) {
            _class_private_field_loose_base(this, _config)[_config] = _extends$1({}, _class_private_field_loose_base(this, _config)[_config], config);
        }
    }
    constructor(){
        Object.defineProperty(this, _config, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _initialised$1, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _isScriptLoaded, {
            writable: true,
            value: void 0
        });
        _class_private_field_loose_base(this, _initialised$1)[_initialised$1] = false;
        _class_private_field_loose_base(this, _isScriptLoaded)[_isScriptLoaded] = false;
    }
}
Object.defineProperty(NuveiCashier, _instance, {
    writable: true,
    value: void 0
});

var _sfc = /*#__PURE__*/ _class_private_field_loose_key("_sfc"), _getMethodLabelByMethodId = /*#__PURE__*/ _class_private_field_loose_key("_getMethodLabelByMethodId"), _transformToPaymentViewModel = /*#__PURE__*/ _class_private_field_loose_key("_transformToPaymentViewModel");
class NuveiGateway extends BaseCorexAdaptedGateway {
    async init(config) {
        await super.init(config);
        await NuveiCashier.instance.init(config.libConfig);
    }
    async update(config) {
        super.update(config);
    }
    async getDepositMethods() {
        const { sessionContextExternalId, sessionContextId } = await this.preLaunch();
        void this.update({
            sessionContextExternalId,
            sessionContextId
        });
        return await this.getPaymentMethods('deposit');
    }
    async getWithdrawalMethods() {
        const { sessionContextExternalId, sessionContextId } = await this.preLaunch();
        this.update({
            sessionContextExternalId,
            sessionContextId
        });
        return await this.getPaymentMethods('withdrawal');
    }
    async launchDeposit(paymentMethodExternalId) {
        const launchDepositConfig = {
            depositConfig: {
                apiUrl: this.config.corex.apiUrl,
                tenant: this.config.corex.tenant,
                paymentDetails: _extends$1({
                    currencyCode: AppState.wallet.balanceData.currencyCode,
                    paymentMethodExternalId,
                    sessionContextId: this.config.sessionContextId
                }, NUVEI_URLS),
                serviceName: CorexProviderType.Nuvei
            }
        };
        return await this.corexService.launchDeposit(launchDepositConfig);
    }
    async preLaunch() {
        const config = {
            externalPaymentMethodId: this.config.corex.nuvei.paymentMethodExternalId,
            currencyCode: AppState.wallet.balanceData.currencyCode
        };
        return await this.corexService.preLaunch(config);
    }
    async launchWithdraw(sessionContextId) {
        var _this_config_corex_nuvei;
        const launchWithdrawConfig = _extends$1({
            apiUrl: this.config.corex.apiUrl,
            tenant: this.config.corex.tenant,
            paymentMethodExternalId: (_this_config_corex_nuvei = this.config.corex.nuvei) == null ? void 0 : _this_config_corex_nuvei.paymentMethodExternalId
        }, NUVEI_URLS, {
            sessionContextId,
            currencyCode: AppState.wallet.balanceData.currencyCode
        });
        return await this.corexService.launchWithdraw(launchWithdrawConfig, CorexProviderType.Nuvei);
    }
    async getPaymentMethods(type) {
        const options = {
            sessionToken: this.config.sessionContextExternalId,
            env: 'int',
            merchantId: this.config.merchantId,
            merchantSiteId: this.config.siteMerchantId,
            blockCards: [
                [
                    'visa',
                    'credit',
                    'corporate'
                ],
                [
                    'amex',
                    'GB',
                    'prepaid'
                ]
            ],
            blockPasteCard: true,
            disableNuveiAnalytics: true,
            showAccountCapture: true,
            onPaymentEvent: function(result) {
                console.log('onPaymentEvent =>', result);
            },
            logLevel: '4',
            support19Digits: true
        };
        _class_private_field_loose_base(this, _sfc)[_sfc] = window.SafeCharge(options);
        const response = await new Promise((resolve)=>{
            _class_private_field_loose_base(this, _sfc)[_sfc].getApms({
                type,
                currencyCode: AppState.wallet.balanceData.currencyCode,
                countryCode: 'MT',
                languageCode: 'en'
            }, function(res) {
                resolve(res);
            });
        });
        const methods = mapMagicMethods(response.paymentMethods, AppState.methods.magicPaymentMethodsByProvider.Nuvei, (nuveiMethod, magicMethod)=>magicMethod.paymentMethodExternalId === nuveiMethod.paymentMethod);
        return _class_private_field_loose_base(this, _transformToPaymentViewModel)[_transformToPaymentViewModel](methods);
    }
    async createPayment(amount, paymentMethodExternalId, paymentOption) {
        const { sessionContextExternalId } = await this.launchDeposit(paymentMethodExternalId);
        const paymentMethodLabel = _class_private_field_loose_base(this, _getMethodLabelByMethodId)[_getMethodLabelByMethodId](paymentMethodExternalId);
        await _class_private_field_loose_base(this, _sfc)[_sfc].setOpenAmount({
            sessionToken: sessionContextExternalId,
            amount
        });
        return new Promise((resolve)=>{
            _class_private_field_loose_base(this, _sfc)[_sfc].createPayment({
                sessionToken: sessionContextExternalId,
                paymentOption
            }, function({ ccCardNumber, transactionId, result }) {
                resolve({
                    success: result === 'APPROVED',
                    amount,
                    currencyCode: AppState.wallet.balanceData.currencyCode,
                    transactionID: transactionId,
                    creditCard: ccCardNumber,
                    paymentMethodLabel
                });
            });
        });
    }
    constructor(){
        super(), Object.defineProperty(this, _getMethodLabelByMethodId, {
            value: getMethodLabelByMethodId
        }), Object.defineProperty(this, _transformToPaymentViewModel, {
            value: transformToPaymentViewModel
        }), Object.defineProperty(this, _sfc, {
            writable: true,
            value: void 0
        });
        this.corexService.providerType = CorexProviderType.Nuvei;
    }
}
function getMethodLabelByMethodId(paymentMethodExternalId) {
    switch(paymentMethodExternalId){
        case NuveiMethodId.Card:
            return 'card';
        case NuveiMethodId.ExpressCheckout:
            return 'Paypal';
        default:
            return '';
    }
}
function transformToPaymentViewModel(methods) {
    return methods.map((method)=>NuveiMethodFactory.createPaymentMethod(method));
}

class PaysafeGateway extends BaseCorexAdaptedGateway {
    async init(config) {
        await PaysafeCashier.instance.init(config.libConfig);
        return super.init(config);
    }
    async getSavedWithdrawMethods(providerType = this.providerType) {
        const currencyCode = AppState.wallet.balanceData.currencyCode;
        const methods = [];
        const depositMethods = await this.corexService.getDepositMethods(currencyCode, providerType);
        const withdrawMethods = await this.corexService.getWithdrawMethods(currencyCode, providerType);
        const allMethods = [
            ...depositMethods,
            ...withdrawMethods
        ];
        methods.push(this.shouldFetchWithdrawSavedMethod(allMethods, PaysafeMethodId.Card) ? this.corexService.payment.getCardMethods() : Promise.resolve(null));
        methods.push(this.shouldFetchWithdrawSavedMethod(allMethods, PaysafeMethodId.Paypal) ? this.corexService.payment.getPayPalMethods() : Promise.resolve(null));
        if (currencyCode === 'USD') {
            methods.push(this.corexService.payment.getPayByBankMethods());
        } else {
            methods.push(Promise.resolve(null));
        }
        methods.push(this.shouldFetchWithdrawSavedMethod(allMethods, PaysafeMethodId.Skrill) ? this.corexService.payment.getSkrillMethods() : Promise.resolve(null));
        const [cardLaunchResult, paypalMethods, payByBankMethods, skrillMethods] = await Promise.all(methods);
        let session = '', payByBankSession = '';
        const paymentHandles = [];
        if (cardLaunchResult) {
            const { paymentHandles: cardMethods, sessionContextId } = cardLaunchResult;
            session = sessionContextId;
            paymentHandles.push(...cardMethods);
        }
        if (paypalMethods) {
            paymentHandles.push(...paypalMethods);
        }
        if (payByBankMethods) {
            const { bankAccounts, sessionContextId: payByBankSessionContextId } = payByBankMethods;
            payByBankSession = payByBankSessionContextId;
            if (bankAccounts) {
                paymentHandles.push(...bankAccounts);
            }
        }
        if (skrillMethods) {
            paymentHandles.push(...skrillMethods);
        }
        const mappedItems = paymentHandles.map(this.createSavedPaymentHandleItem);
        return {
            sessionContextId: session,
            paymentHandles: mappedItems,
            payByBankSessionContextId: payByBankSession
        };
    }
    shouldFetchWithdrawSavedMethod(allMethods, paymentMethodExternalId) {
        return allMethods.some((method)=>this.isWithdrawSavedMethod(method.params, paymentMethodExternalId));
    }
    isWithdrawSavedMethod(method, paymentMethodExternalId) {
        return method.paymentMethodExternalId === paymentMethodExternalId && method.paymentType !== 'Deposit';
    }
    constructor(){
        super(), this.createSavedPaymentHandleItem = (method)=>{
            return PaysafeMethodFactory.createSavedPaymentMethod(method);
        };
        this.corexService.providerType = CorexProviderType.Paysafe;
    }
}

const PAYMONGO_DEFAULT_URL = 'https://api.paymongo.com';
class PaymongoGateway extends BaseCorexAdaptedGateway {
    get paymongoConfig() {
        return this.config.corex.paymongo;
    }
    async getPaymentIntent(data) {
        const url = `${this.getApiUrl()}/v1/payment_intents/${data.intentId}?client_key=${data.clientKey}`;
        return httpUtils.fetchApi(url, 'GET', _extends$1({}, this.headers, {
            authorization: 'Basic ' + btoa(`${data.publicKey}`)
        }));
    }
    getApiUrl() {
        var _this_paymongoConfig;
        return ((_this_paymongoConfig = this.paymongoConfig) == null ? void 0 : _this_paymongoConfig.apiUrl) || PAYMONGO_DEFAULT_URL;
    }
    get headers() {
        return {
            accept: 'application/json'
        };
    }
    constructor(){
        super();
        this.corexService.providerType = CorexProviderType.Paymongo;
    }
}

const SOLAIREPAY_API_URL = 'https://stgbepay-v2.solaireaccess.net';
class SolairepayGateway extends BaseCorexAdaptedGateway {
    async getTransactionStatusData(payload) {
        try {
            const url = `${this.getApiUrl()}/payments-gateway/v1/transaction/${payload.correlationId}/status`;
            const result = await httpUtils.fetchApi(url, 'GET', _extends$1({}, this.headers));
            return result;
        } catch (e) {
            console.error('CORS error:', e);
            return Promise.resolve(null);
        }
    }
    get gatewayConfig() {
        return this.config.corex.solairepay;
    }
    getApiUrl() {
        var _this_gatewayConfig;
        return ((_this_gatewayConfig = this.gatewayConfig) == null ? void 0 : _this_gatewayConfig.apiUrl) || SOLAIREPAY_API_URL;
    }
    get headers() {
        return {
            accept: 'application/json',
            'X-PAYMENTS-GATEWAY-API-KEY': this.gatewayConfig.apiKey
        };
    }
    constructor(){
        super();
        this.corexService.providerType = CorexProviderType.Solairepay;
    }
}

var _initialised = /*#__PURE__*/ _class_private_field_loose_key("_initialised"), _devcodeConfigProvided = /*#__PURE__*/ _class_private_field_loose_key("_devcodeConfigProvided"), _paysafeConfigProvided = /*#__PURE__*/ _class_private_field_loose_key("_paysafeConfigProvided"), _nuveiConfigProvided = /*#__PURE__*/ _class_private_field_loose_key("_nuveiConfigProvided"), _paymongoConfigProvided = /*#__PURE__*/ _class_private_field_loose_key("_paymongoConfigProvided"), _solairepayConfigProvided = /*#__PURE__*/ _class_private_field_loose_key("_solairepayConfigProvided"), _corexGateway = /*#__PURE__*/ _class_private_field_loose_key("_corexGateway"), _paysafeGateway = /*#__PURE__*/ _class_private_field_loose_key("_paysafeGateway"), _devcodeGateway = /*#__PURE__*/ _class_private_field_loose_key("_devcodeGateway"), _nuveiGateway = /*#__PURE__*/ _class_private_field_loose_key("_nuveiGateway"), _paymongoGateway = /*#__PURE__*/ _class_private_field_loose_key("_paymongoGateway"), _solairepayGateway = /*#__PURE__*/ _class_private_field_loose_key("_solairepayGateway"), _sortMethodsByPosition = /*#__PURE__*/ _class_private_field_loose_key("_sortMethodsByPosition"), _getGatewayMethod = /*#__PURE__*/ _class_private_field_loose_key("_getGatewayMethod"), _getMethods = /*#__PURE__*/ _class_private_field_loose_key("_getMethods");
/**
 * A facade over multiple payment provider gateways used by the wallet UI.
 *
 * WalletGateway initializes and orchestrates provider-specific gateways and
 * exposes a unified interface to retrieve deposit/withdraw methods and bonuses.
 * It is a singleton; use WalletGateway.instance to access the shared instance.
 *
 * @remarks
 * The gateway uses the AppState to read runtime data such as locale, balance and
 * redirect base URL. It registers underlying gateways in GatewayRegistry.
 *
 * @public
 */ class WalletGateway {
    static get instance() {
        if (!this._instance) {
            this._instance = new WalletGateway();
        }
        return this._instance;
    }
    async init(config) {
        var _config_corex, _config_corex_nuvei, _config_corex_paymongo, _config_corex_solairepay;
        if (_class_private_field_loose_base(this, _initialised)[_initialised]) {
            this.update(config);
            return Promise.resolve();
        }
        AppState.wallet.imageUrl = config.corex.imageUrl;
        AppState.wallet.redirectBaseUrl = config.corex.redirectBaseUrl;
        var _config_corex_firstDepositLimits;
        AppState.wallet.firstDepositLimits = (_config_corex_firstDepositLimits = (_config_corex = config.corex) == null ? void 0 : _config_corex.firstDepositLimits) != null ? _config_corex_firstDepositLimits : {};
        _class_private_field_loose_base(this, _paysafeConfigProvided)[_paysafeConfigProvided] = !!config.corex.paysafeApiKey;
        _class_private_field_loose_base(this, _devcodeConfigProvided)[_devcodeConfigProvided] = !!config.corex.devcodeMerchantId;
        _class_private_field_loose_base(this, _nuveiConfigProvided)[_nuveiConfigProvided] = !!((_config_corex_nuvei = config.corex.nuvei) == null ? void 0 : _config_corex_nuvei.merchantId);
        _class_private_field_loose_base(this, _paymongoConfigProvided)[_paymongoConfigProvided] = !!((_config_corex_paymongo = config.corex.paymongo) == null ? void 0 : _config_corex_paymongo.publicKey);
        _class_private_field_loose_base(this, _solairepayConfigProvided)[_solairepayConfigProvided] = !!((_config_corex_solairepay = config.corex.solairepay) == null ? void 0 : _config_corex_solairepay.apiKey);
        if (_class_private_field_loose_base(this, _paysafeConfigProvided)[_paysafeConfigProvided]) {
            const paysafeInitConfig = {
                apiKey: config.corex.paysafeApiKey,
                environment: config.corex.paysafeEnvironment,
                userProfileId: config.corex.userProfileId,
                accountIds: config.corex.cardAccounts,
                bankAccountIds: config.corex.bankAccounts
            };
            _class_private_field_loose_base(this, _paysafeGateway)[_paysafeGateway].init({
                corex: config.corex,
                libConfig: paysafeInitConfig
            });
        }
        if (_class_private_field_loose_base(this, _paymongoConfigProvided)[_paymongoConfigProvided]) {
            _class_private_field_loose_base(this, _paymongoGateway)[_paymongoGateway].init({
                corex: config.corex,
                libConfig: {}
            });
        }
        if (_class_private_field_loose_base(this, _solairepayConfigProvided)[_solairepayConfigProvided]) {
            _class_private_field_loose_base(this, _solairepayGateway)[_solairepayGateway].init({
                corex: config.corex,
                libConfig: {}
            });
        }
        // TODO: we need to rid of that initialisation as the corex gateway should be used inside of each provider's gateway
        _class_private_field_loose_base(this, _corexGateway)[_corexGateway].init(config.corex);
        if (_class_private_field_loose_base(this, _devcodeConfigProvided)[_devcodeConfigProvided]) {
            var _config_corex1;
            _class_private_field_loose_base(this, _devcodeGateway)[_devcodeGateway].init({
                merchantId: config.corex.devcodeMerchantId,
                userProfileId: config.corex.userProfileId,
                locale: AppState.wallet.locale || 'en_US',
                environment: config.corex.devcodeEnvironment || 'test',
                isMockEnv: (_config_corex1 = config.corex) == null ? void 0 : _config_corex1.isMockEnv,
                corex: config.corex
            });
        }
        if (_class_private_field_loose_base(this, _nuveiConfigProvided)[_nuveiConfigProvided] && config.corex.nuvei) {
            const nuveiLibConfig = {
                apiKey: config.corex.nuvei.apiKey,
                merchantId: config.corex.nuvei.merchantId,
                currency: AppState.wallet.balanceData.currencyCode,
                baseUrl: config.corex.apiUrl,
                siteMerchantId: config.corex.nuvei.siteMerchantId,
                token: config.corex.token,
                tenant: config.corex.tenant,
                environment: config.corex.paysafeEnvironment,
                userProfileId: config.corex.userProfileId
            };
            void _class_private_field_loose_base(this, _nuveiGateway)[_nuveiGateway].init({
                merchantId: config.corex.nuvei.merchantId,
                siteMerchantId: config.corex.nuvei.siteMerchantId,
                corex: config.corex,
                libConfig: nuveiLibConfig
            });
        }
        _class_private_field_loose_base(this, _initialised)[_initialised] = true;
    }
    async update(config) {
        if (!_class_private_field_loose_base(this, _initialised)[_initialised]) {
            return Promise.resolve();
        }
        if (config.corex) {
            const corexAdaptedConfig = {
                corex: config.corex
            };
            _class_private_field_loose_base(this, _corexGateway)[_corexGateway].update(config.corex);
            if (_class_private_field_loose_base(this, _paysafeConfigProvided)[_paysafeConfigProvided]) {
                _class_private_field_loose_base(this, _paysafeGateway)[_paysafeGateway].update(corexAdaptedConfig);
            }
            if (_class_private_field_loose_base(this, _devcodeConfigProvided)[_devcodeConfigProvided]) {
                _class_private_field_loose_base(this, _devcodeGateway)[_devcodeGateway].update(corexAdaptedConfig);
            }
            if (_class_private_field_loose_base(this, _nuveiConfigProvided)[_nuveiConfigProvided]) {
                _class_private_field_loose_base(this, _nuveiGateway)[_nuveiGateway].update(corexAdaptedConfig);
            }
            if (_class_private_field_loose_base(this, _paymongoConfigProvided)[_paymongoConfigProvided]) {
                _class_private_field_loose_base(this, _paymongoGateway)[_paymongoGateway].update(corexAdaptedConfig);
            }
            if (_class_private_field_loose_base(this, _solairepayConfigProvided)[_solairepayConfigProvided]) {
                _class_private_field_loose_base(this, _solairepayGateway)[_solairepayGateway].update(corexAdaptedConfig);
            }
        }
    }
    async getBonuses() {
        return await _class_private_field_loose_base(this, _corexGateway)[_corexGateway].getBonuses();
    }
    async updateBonus(bonusId, type) {
        return await _class_private_field_loose_base(this, _corexGateway)[_corexGateway].updateBonus(bonusId, type);
    }
    async getDepositMethods() {
        const result = await _class_private_field_loose_base(this, _getMethods)[_getMethods]([
            _class_private_field_loose_base(this, _getGatewayMethod)[_getGatewayMethod](_class_private_field_loose_base(this, _paysafeConfigProvided)[_paysafeConfigProvided], ()=>_class_private_field_loose_base(this, _paysafeGateway)[_paysafeGateway].corexService.getDepositMethods()),
            _class_private_field_loose_base(this, _getGatewayMethod)[_getGatewayMethod](_class_private_field_loose_base(this, _devcodeConfigProvided)[_devcodeConfigProvided], ()=>_class_private_field_loose_base(this, _devcodeGateway)[_devcodeGateway].getDepositMethods()),
            _class_private_field_loose_base(this, _getGatewayMethod)[_getGatewayMethod](_class_private_field_loose_base(this, _nuveiConfigProvided)[_nuveiConfigProvided], ()=>_class_private_field_loose_base(this, _nuveiGateway)[_nuveiGateway].getDepositMethods()),
            _class_private_field_loose_base(this, _getGatewayMethod)[_getGatewayMethod](_class_private_field_loose_base(this, _solairepayConfigProvided)[_solairepayConfigProvided], ()=>_class_private_field_loose_base(this, _solairepayGateway)[_solairepayGateway].corexService.getDepositMethods()),
            _class_private_field_loose_base(this, _getGatewayMethod)[_getGatewayMethod](_class_private_field_loose_base(this, _paymongoConfigProvided)[_paymongoConfigProvided], ()=>_class_private_field_loose_base(this, _paymongoGateway)[_paymongoGateway].corexService.getDepositMethods())
        ]);
        if (AppState.wallet.features.enhancedGalleonCashierConfiguration) {
            const sortedByPosition = _class_private_field_loose_base(this, _sortMethodsByPosition)[_sortMethodsByPosition](result.methods);
            return {
                methods: sortedByPosition,
                savedMethods: result.savedMethods
            };
        }
        return result;
    }
    async getWithdrawMethods() {
        const result = await _class_private_field_loose_base(this, _getMethods)[_getMethods]([
            _class_private_field_loose_base(this, _getGatewayMethod)[_getGatewayMethod](_class_private_field_loose_base(this, _paysafeConfigProvided)[_paysafeConfigProvided], ()=>_class_private_field_loose_base(this, _paysafeGateway)[_paysafeGateway].corexService.getWithdrawMethods()),
            _class_private_field_loose_base(this, _getGatewayMethod)[_getGatewayMethod](_class_private_field_loose_base(this, _devcodeConfigProvided)[_devcodeConfigProvided], ()=>_class_private_field_loose_base(this, _devcodeGateway)[_devcodeGateway].getWithdrawalMethods()),
            _class_private_field_loose_base(this, _getGatewayMethod)[_getGatewayMethod](_class_private_field_loose_base(this, _nuveiConfigProvided)[_nuveiConfigProvided], ()=>_class_private_field_loose_base(this, _nuveiGateway)[_nuveiGateway].getWithdrawalMethods()),
            _class_private_field_loose_base(this, _getGatewayMethod)[_getGatewayMethod](_class_private_field_loose_base(this, _solairepayConfigProvided)[_solairepayConfigProvided], ()=>_class_private_field_loose_base(this, _solairepayGateway)[_solairepayGateway].corexService.getWithdrawMethods()),
            _class_private_field_loose_base(this, _getGatewayMethod)[_getGatewayMethod](_class_private_field_loose_base(this, _paymongoConfigProvided)[_paymongoConfigProvided], ()=>_class_private_field_loose_base(this, _paymongoGateway)[_paymongoGateway].corexService.getWithdrawMethods())
        ]);
        if (AppState.wallet.features.enhancedGalleonCashierConfiguration) {
            const sortedByPosition = _class_private_field_loose_base(this, _sortMethodsByPosition)[_sortMethodsByPosition](result.methods);
            return {
                methods: sortedByPosition,
                savedMethods: result.savedMethods
            };
        }
        return result;
    }
    async getPaysafeSavedWithdrawMethods() {
        return _class_private_field_loose_base(this, _paysafeConfigProvided)[_paysafeConfigProvided] ? _class_private_field_loose_base(this, _paysafeGateway)[_paysafeGateway].getSavedWithdrawMethods() : Promise.resolve({
            sessionContextId: '',
            paymentHandles: []
        });
    }
    isInitialized() {
        return _class_private_field_loose_base(this, _initialised)[_initialised];
    }
    constructor(){
        Object.defineProperty(this, _sortMethodsByPosition, {
            value: sortMethodsByPosition
        });
        Object.defineProperty(this, _getGatewayMethod, {
            value: getGatewayMethod
        });
        Object.defineProperty(this, _getMethods, {
            value: getMethods
        });
        Object.defineProperty(this, _initialised, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _devcodeConfigProvided, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _paysafeConfigProvided, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _nuveiConfigProvided, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _paymongoConfigProvided, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _solairepayConfigProvided, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _corexGateway, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _paysafeGateway, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _devcodeGateway, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _nuveiGateway, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _paymongoGateway, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, _solairepayGateway, {
            writable: true,
            value: void 0
        });
        _class_private_field_loose_base(this, _initialised)[_initialised] = false;
        _class_private_field_loose_base(this, _devcodeConfigProvided)[_devcodeConfigProvided] = false;
        _class_private_field_loose_base(this, _paysafeConfigProvided)[_paysafeConfigProvided] = false;
        _class_private_field_loose_base(this, _nuveiConfigProvided)[_nuveiConfigProvided] = false;
        _class_private_field_loose_base(this, _paymongoConfigProvided)[_paymongoConfigProvided] = false;
        _class_private_field_loose_base(this, _solairepayConfigProvided)[_solairepayConfigProvided] = false;
        _class_private_field_loose_base(this, _corexGateway)[_corexGateway] = new CorexGateway();
        _class_private_field_loose_base(this, _paysafeGateway)[_paysafeGateway] = new PaysafeGateway();
        _class_private_field_loose_base(this, _devcodeGateway)[_devcodeGateway] = new DevcodeGateway();
        _class_private_field_loose_base(this, _nuveiGateway)[_nuveiGateway] = new NuveiGateway();
        _class_private_field_loose_base(this, _paymongoGateway)[_paymongoGateway] = new PaymongoGateway();
        _class_private_field_loose_base(this, _solairepayGateway)[_solairepayGateway] = new SolairepayGateway();
        GatewayRegistry.clear();
        GatewayRegistry.registerGateway(GatewayType.Paysafe, _class_private_field_loose_base(this, _paysafeGateway)[_paysafeGateway]);
        GatewayRegistry.registerGateway(GatewayType.Devcode, _class_private_field_loose_base(this, _devcodeGateway)[_devcodeGateway]);
        GatewayRegistry.registerGateway(GatewayType.Nuvei, _class_private_field_loose_base(this, _nuveiGateway)[_nuveiGateway]);
        GatewayRegistry.registerGateway(GatewayType.Corex, _class_private_field_loose_base(this, _corexGateway)[_corexGateway]);
        GatewayRegistry.registerGateway(GatewayType.Paymongo, _class_private_field_loose_base(this, _paymongoGateway)[_paymongoGateway]);
        GatewayRegistry.registerGateway(GatewayType.Solairepay, _class_private_field_loose_base(this, _solairepayGateway)[_solairepayGateway]);
    }
}
function sortMethodsByPosition(methods) {
    return methods.sort((a, b)=>a.position - b.position);
}
function getGatewayMethod(configProvided, methodFn) {
    return configProvided ? methodFn() : Promise.resolve([]);
}
async function getMethods(methodPromises) {
    const allMethods = await Promise.allSettled(methodPromises);
    let savedMethods = [];
    const allResults = allMethods.map((promiseResult)=>{
        if (promiseResult.status === 'rejected') {
            return [];
        }
        if (Array.isArray(promiseResult.value)) {
            return promiseResult.value;
        } else {
            // Handle PaymentMethods object with savedMethods property
            savedMethods = [
                ...promiseResult.value.savedMethods || []
            ];
            return promiseResult.value.methods || [];
        }
    });
    return {
        methods: allResults.flat(1),
        savedMethods: savedMethods
    };
}

function getHeaderTemplate() {
    return `
    <div class="wallet-container" part="wallet-container">
      <slot name="header">
        <div class="tabs" part="tabs">
          <magic-ui-link
            class="deposit link tab-link"
            part="deposit link tab-link"
            variant="primary"
            active="true"
          >
            <magic-ui-text
              tag="b"
              class="tab-name"
              part="tab-name-title"
              data-test-id="deposit-tab-link"
              content="${translate('galleon.navigation.deposit')}"
            ></magic-ui-text>
          </magic-ui-link>
          <magic-ui-link
            class="withdraw link tab-link"
            part="withdraw link tab-link"
            variant="primary"
          >
            <magic-ui-text
              tag="b"
              class="tab-name"
              part="tab-name-title"
              content="${translate('galleon.navigation.withdrawal')}"
            ></magic-ui-text>
          </magic-ui-link>
           <magic-ui-link
            class="bonuses link tab-link"
            part="bonuses link tab-link"
            variant="primary"
          >
            <magic-ui-text
              tag="b"
              class="tab-name"
              part="tab-name-title"
              content="${translate('galleon.bonus.title')}"
            ></magic-ui-text>
          </magic-ui-link>
        </div>
      </slot>
      <slot name="cashier-content">
        <div class="tab-content"></div>
      </slot>
      <magic-ui-text
          tag="p"
          class="self-exclude"
          part="self-exclude"
          content='${translate('galleon.info')}'
          is-markdown
      ></magic-ui-text>
    </div>
  `;
}

async function renderDepositView$1() {
    setLoading(true);
    const getDepositMethods = async ()=>{
        if (WalletGateway.instance.isInitialized()) {
            var _AppState_wallet_profile, _AppState_wallet;
            const { methods, savedMethods } = await WalletGateway.instance.getDepositMethods();
            const isFirstDeposit = ((_AppState_wallet = AppState.wallet) == null ? void 0 : (_AppState_wallet_profile = _AppState_wallet.profile) == null ? void 0 : _AppState_wallet_profile.depositCount) === 0;
            const firstDepositLimits = AppState.wallet.firstDepositLimits;
            if (isFirstDeposit && firstDepositLimits) {
                const applyLimits = (method)=>{
                    const limits = firstDepositLimits[method.currencyCode];
                    if (limits) {
                        method.minAmount = limits.min > 0 ? limits.min : method.minAmount;
                        method.maxAmount = limits.max > 0 ? limits.max : method.maxAmount;
                    }
                };
                methods.forEach(applyLimits);
            }
            AppState.methods.deposit = methods;
            AppState.methods.savedDepositMethods = savedMethods;
            setLoading(false);
            if (AppState.wallet.selectedTabName !== View.Deposit) {
                return;
            }
            createDepositView$1();
            return;
        }
        setTimeout(getDepositMethods, 100);
    };
    await getDepositMethods();
}

var _tabs$1 = /*#__PURE__*/ _class_private_field_loose_key("_tabs");
class TabController {
    addTab(name, action) {
        _class_private_field_loose_base(this, _tabs$1)[_tabs$1].set(name, action);
    }
    async selectTab(name, useDefault = false) {
        if (_class_private_field_loose_base(this, _tabs$1)[_tabs$1].has(name)) {
            const action = _class_private_field_loose_base(this, _tabs$1)[_tabs$1].get(name);
            await (action == null ? void 0 : action());
        } else {
            if (useDefault) {
                const action = _class_private_field_loose_base(this, _tabs$1)[_tabs$1].get(this.defaultTab);
                await (action == null ? void 0 : action());
            }
        }
    }
    constructor(defaultTab){
        Object.defineProperty(this, _tabs$1, {
            writable: true,
            value: void 0
        });
        this.defaultTab = defaultTab;
        _class_private_field_loose_base(this, _tabs$1)[_tabs$1] = new Map();
    }
}

/**
 * main withdrawal view
 */ async function renderWithdrawView() {
    try {
        setLoading(true);
        const [withdrawMethods, savedWithdrawMethods] = await Promise.all([
            WalletGateway.instance.getWithdrawMethods(),
            WalletGateway.instance.getPaysafeSavedWithdrawMethods()
        ]);
        if (AppState.wallet.selectedTabName !== View.Withdraw) {
            return;
        }
        AppState.methods.withdraw = withdrawMethods.methods;
        savedWithdrawMethods == null ? void 0 : savedWithdrawMethods.paymentHandles.push(...withdrawMethods.savedMethods);
        AppState.savedWithdrawMethods = savedWithdrawMethods;
        const withdrawMethodsToDisplay = [];
        withdrawMethods.methods.forEach((method)=>{
            if (shouldDisplayWithdrawMethod(method)) {
                withdrawMethodsToDisplay.push(method);
            }
        });
        AppState.methods.withdrawMethodsToDisplay = withdrawMethodsToDisplay;
        const balance = Number(AppState.wallet.balanceData.withdrawable);
        // no withdrawal methods available
        if (withdrawMethods.methods.length === 0) {
            createInsufficientFundsView();
            return;
        }
        const minAmountData = AppState.methods.withdraw.reduce((acc, loc)=>{
            if (acc.minAmount && loc.minAmount) {
                return acc.minAmount < loc.minAmount ? acc : loc;
            } else {
                return acc;
            }
        });
        if (minAmountData.minAmount && minAmountData.minAmount <= balance) {
            createWithdrawView();
        } else {
            var _minAmountData_minAmount;
            var _minAmountData_minAmount_toString;
            const data = {
                amount: (_minAmountData_minAmount_toString = (_minAmountData_minAmount = minAmountData.minAmount) == null ? void 0 : _minAmountData_minAmount.toString()) != null ? _minAmountData_minAmount_toString : '10',
                currencyCode: minAmountData.currencyCode
            };
            createInsufficientFundsView(data);
        }
    } finally{
        setLoading(false);
    }
}

function getBonusesTemplate(bonuses) {
    const HAVE_BONUS = translate('galleon.bonus.active');
    const DONT_HAVE_BONUS = translate('galleon.bonus.no.active');
    const description = bonuses.length > 0 ? HAVE_BONUS : DONT_HAVE_BONUS;
    return `
    <magic-ui-text
      tag="b"
      class="bonuses__header"
      part="bonuses__header"
      content="${translate('galleon.bonus.active.title')}"
    ></magic-ui-text>
    <magic-ui-text
      tag="p"
      class="bonuses__subheader"
      part="bonuses__subheader"
      content="${description}"
    ></magic-ui-text>
    ${bonuses.map((bonus)=>{
        const buttonText = bonus.status === 'Available' ? translate('galleon.bonus.claim') : translate('galleon.bonus.forfeit.button');
        const updateType = bonus.status === 'Available' ? 'claim' : 'forfeit';
        const currencySymbol = getCurrencySymbol(bonus.currencyCode);
        return `<div class="bonus" data-id="${bonus.id}"><table class="bonus__table">
          <thead class="bonus__header">
            <tr>
              <th colspan="2">
                <span>${translate('galleon.bonus.title')}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="bonus__row">
              <td>
                <span>
                  ${translate('galleon.bonus.title')}
                </span>
              </td>
              <td class="bonus__value">
                <span>
                  ${bonus.name}
                </span>
              </td>
            </tr>
            <tr class="bonus__row">
              <td>
                <span>
                  ${translate('galleon.bonus.id')}
                </span>
              </td>
              <td>
                <span class="bonus__value">
                  ${bonus.id}
                </span>
              </td>
            </tr>
            <tr class="bonus__row">
              <td>
                <span>
                  ${translate('galleon.bonus.status')}
                </span>
              </td>
              <td>
                <span class="bonus__value">
                  ${bonus.status}
                </span>
              </td>
            </tr>
            <tr class="bonus__row">
              <td>
                <span>
                  ${translate('galleon.bonus.amount')}
                </span>
              </td>
              <td>
                <span class="bonus__value">
                  ${bonus.grantedAmount}${currencySymbol}
                </span>
              </td>
            </tr>
            <tr class="bonus__row">
              <td>
                <span>
                  ${translate('galleon.bonus.requirements')}
                </span>
              </td>
              <td>
                <span class="bonus__value">
                  ${bonus.wageringRequirementAmount}${currencySymbol}
                </span>
              </td>
            </tr>
            <tr class="bonus__row">
              <td>
                <span>
                  ${translate('galleon.bonus.remaining')}
                </span>
              </td>
              <td>
                <span class="bonus__value">
                  ${bonus.wageredAmount}${currencySymbol}
                </span>
              </td>
            </tr>
            <tr class="bonus__row">
              <td>
                <span>
                  ${translate('galleon.bonus.issue')}
                </span>
              </td>
              <td>
                <span class="bonus__value">
                  ${new Date(bonus.createdOn).toLocaleDateString()}
                </span>
              </td>
            </tr>
            <tr class="bonus__row">
              <td>
                <span>
                  ${translate('galleon.bonus.expiry')}
                </span>
              </td>
              <td>
                <span class="bonus__value">
                  ${new Date(bonus.expiresOn).toLocaleDateString()}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="bonus__footer">
          <span class="bonus__terms">${translate('galleon.bonus.terms')}</span>
          <magic-ui-tooltip class="bonus__tooltip-popup" data-tooltip-id="${bonus.id}" controlled="true" position="top">
            <magic-ui-button
              variant="primary"
              class="bonus__forfeit"
              ${updateType === 'claim' ? `data-bonus-id` : `data-forfeit-bonus-id`}="${bonus.id}"
              data-update-type="${updateType}">
              ${buttonText}
            </magic-ui-button>
            <div slot="content" class="popup">
              <magic-ui-text
                tag="b"
                class="popup__title"
                part="popup__title"
                content="${translate('galleon.bonus.forfeit.question')}"
              ></magic-ui-text>
              <magic-ui-text
                tag="b"
                class="popup__intro"
                part="popup__intro"
                content="${translate('galleon.bonus.forfeit.introduction')}"
              ></magic-ui-text>
              <magic-ui-button
                variant="primary"
                class="popup__forfeit"
                data-bonus-id="${bonus.id}"
                data-update-type="${updateType}">
                ${translate('galleon.bonus.agreed')}
              </magic-ui-button>
              <magic-ui-text
                tag="p"
                data-cancel="${bonus.id}"
                class="popup__cancel"
                part="popup__cancel"
                content="${translate('galleon.bonus.cancel')}"
            ></magic-ui-text>
            </div>
          </magic-ui-tooltip>
          <magic-ui-text
            tag="p"
            class="bonuses__error"
            part="bonuses__error"
            content=""
          ></magic-ui-text>
        </div>
      </div>
    `;
    }).join('')}
  `;
}

function attachTermsListener(termsElements) {
    termsElements.forEach((btn)=>btn.addEventListener('click', ()=>{
            AppState.root.dispatchEvent(new CustomEvent(DispatchMessageType.OpenTermsConditions));
        }));
}
function attachOpenForfeitListener(button, bonusId) {
    const content = AppState.shadowRoot.querySelector('.tab-content');
    button.addEventListener('click', ()=>{
        const tooltipEl = content.querySelector(`[data-tooltip-id="${bonusId}"]`);
        tooltipEl.setAttribute('is-controlled-open', 'true');
    });
}
function attachClosePopupListener(button, bonusId) {
    const content = AppState.shadowRoot.querySelector('.tab-content');
    button.addEventListener('click', ()=>{
        const tooltipEl = content.querySelector(`[data-tooltip-id="${bonusId}"]`);
        tooltipEl.setAttribute('is-controlled-open', 'false');
    });
}
function attachUpdateButtonListener(button, renderBonusesCallback) {
    button.addEventListener('click', async ()=>{
        const bonusId = button.getAttribute('data-bonus-id');
        const updateType = button.getAttribute('data-update-type');
        if (!bonusId) {
            return;
        }
        button.setAttribute('disabled', 'true');
        button.setAttribute('loading', 'true');
        try {
            const res = await WalletGateway.instance.updateBonus(bonusId, updateType);
            if (res === bonusId) {
                const updatedStatus = updateType === 'claim' ? 'Claimed' : 'Forfeited';
                AppState.wallet.bonuses = AppState.wallet.bonuses.map((bonus)=>{
                    if (bonus.id === bonusId) {
                        return _extends$1({}, bonus, {
                            status: updatedStatus
                        });
                    } else {
                        return bonus;
                    }
                });
                renderBonusesCallback();
            }
            if (res.errors) {
                var _button_parentElement_parentElement, _button_parentElement;
                const errorEl = button == null ? void 0 : (_button_parentElement = button.parentElement) == null ? void 0 : (_button_parentElement_parentElement = _button_parentElement.parentElement) == null ? void 0 : _button_parentElement_parentElement.querySelector('.bonuses__error');
                if (errorEl) {
                    errorEl.setAttribute('content', res.errors.$[0]);
                }
            }
        } catch (err) {
            var _button_parentElement_parentElement1, _button_parentElement1;
            const errorEl = button == null ? void 0 : (_button_parentElement1 = button.parentElement) == null ? void 0 : (_button_parentElement_parentElement1 = _button_parentElement1.parentElement) == null ? void 0 : _button_parentElement_parentElement1.querySelector('.bonuses__error');
            if (errorEl) {
                errorEl.innerHTML = err.toString();
            }
        } finally{
            button.removeAttribute('disabled');
            button.removeAttribute('loading');
        }
    });
}

const renderBonuses = ()=>{
    if (AppState.wallet.selectedTabName !== View.Bonuses) {
        return;
    }
    const content = AppState.shadowRoot.querySelector('.tab-content');
    const filteredBonuses = AppState.wallet.bonuses.filter((bonus)=>bonus.status === 'Available' || bonus.status === 'Claimed' || bonus.status === 'InProgress');
    content.innerHTML = getBonusesTemplate(filteredBonuses);
    const termsElements = content.querySelectorAll('.bonus__terms');
    attachTermsListener(termsElements);
    filteredBonuses.map((bonus)=>{
        const isForfeit = bonus.status !== 'Available';
        const dataAttrName = isForfeit ? 'data-forfeit-bonus-id' : 'data-bonus-id';
        const button = content.querySelector(`[${dataAttrName}="${bonus.id}"]`);
        if (!button) {
            return;
        }
        if (isForfeit) {
            attachOpenForfeitListener(button, bonus.id);
            const cancelBtn = content.querySelector(`[data-cancel="${bonus.id}"]`);
            attachClosePopupListener(cancelBtn, bonus.id);
            const submitBtn = content.querySelector(`[data-bonus-id="${bonus.id}"]`);
            attachUpdateButtonListener(submitBtn, renderBonuses);
        } else {
            attachUpdateButtonListener(button, renderBonuses);
        }
    });
};
const createBonusesView = ()=>{
    const content = AppState.shadowRoot.querySelector('.tab-content');
    content.innerHTML = '';
    renderBonuses();
};

async function renderBonusesView() {
    try {
        setLoading(true);
        AppState.wallet.bonuses = await WalletGateway.instance.getBonuses();
        if (AppState.wallet.selectedTabName !== View.Bonuses) {
            return;
        }
        createBonusesView();
    } finally{
        setLoading(false);
    }
}

var scss$1 = "html,\nbody {\n  height: 100%;\n}\n\nbody {\n  background-color: var(--magic-background, #fbfbfb);\n  font: normal normal var(--magic-font-size, 14px) var(--magic-font-family, proxima-nova, Helvetica, Arial, sans-serif);\n  font-weight: var(--magic-font-weight, 400);\n  color: var(--magic-text, #747474);\n  text-size-adjust: none;\n  overflow-x: hidden;\n}\nbody:-webkit-full-screen {\n  width: 100%;\n}\nbody.no-scroll {\n  overflow: hidden;\n}\n\n* {\n  box-sizing: border-box;\n}\n*::after, *::before {\n  box-sizing: border-box;\n}\n\nh1,\nh2,\nh3,\nh4 {\n  margin: 0 0 0.5em;\n  font-family: var(--magic-header-font-family, proxima-nova, Helvetica, Arial, sans-serif);\n  font-weight: var(--magic-header-font-weight, 700);\n  color: inherit;\n  line-height: 1;\n}\n\nh1 {\n  font-size: 30px;\n}\n\nh2 {\n  font-size: 22px;\n}\n\nh3,\nh4 {\n  font-size: 18px;\n}\n\np {\n  margin: 0 0 1em;\n  font-size: 12px;\n}\n\nstrong,\nb {\n  font-weight: var(--magic-caption-font-weight, 600);\n}\n\nem,\ni {\n  font-style: italic;\n}\n\na {\n  outline: none;\n  text-decoration: none;\n  color: inherit;\n  cursor: pointer;\n}\n\nbutton {\n  margin: 0;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n}\nbutton:hover, button:focus, button:active {\n  outline: none;\n}\n\ninput,\ntextarea,\nbutton,\nselect {\n  font-family: var(--magic-font-family, proxima-nova, Helvetica, Arial, sans-serif);\n  font-size: 100%;\n  color: inherit;\n  line-height: 1;\n}\n\ninput[type=date]::-webkit-date-and-time-value {\n  margin-top: 6px;\n}\n\ninput[type=date]::-webkit-clear-button,\ninput[type=date]::-webkit-inner-spin-button {\n  margin: 0;\n  opacity: 0;\n}\n\ninput[type=date]::-webkit-calendar-picker-indicator {\n  margin-right: 30px;\n  width: 12px;\n  height: 12px;\n  color: white;\n}\ninput[type=date]::-webkit-calendar-picker-indicator:hover {\n  background-color: rgba(255, 255, 255, 0);\n}\ninput[type=date]::-webkit-calendar-picker-indicator:active {\n  color: white;\n}\n\ninput::-ms-clear {\n  display: none;\n}\n\ninput::-ms-reveal {\n  display: none;\n}\n\ninput[type=number]::-webkit-outer-spin-button,\ninput[type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n::-webkit-credentials-auto-fill-button {\n  background: transparent;\n}\n\n::-webkit-contacts-auto-fill-button {\n  background: transparent;\n}\n\n::-webkit-caps-lock-indicator {\n  content: none;\n}\n\nvideo {\n  background-color: rgba(0, 0, 0, 0);\n}\n\ndiv:focus,\nlabel:focus {\n  outline: none;\n}\n\nlabel {\n  cursor: inherit;\n}\n\n@-moz-document url-prefix() {\n  img {\n    color: rgba(255, 255, 255, 0);\n  }\n}\ninput,\ntextarea,\nbutton,\nselect,\na {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n@keyframes fade-in-animation {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes spin-animation {\n  from {\n    transform: translate3d(-50%, -50%, 0) rotate(0deg);\n  }\n  to {\n    transform: translate3d(-50%, -50%, 0) rotate(360deg);\n  }\n}\n@keyframes scale-animation {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0);\n  }\n}\n.wallet-container {\n  display: flex;\n  flex-direction: column;\n  gap: calc(var(--magic-space--large, 32px) - var(--magic-space--small, 8px));\n  background: var(--magic-background, #fbfbfb);\n}\n.wallet-container .tab-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--magic-space, 16px);\n  position: relative;\n  min-height: var(--magic-space--x-large, 64px);\n}\n\n.insufficient-funds {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 var(--magic-space--small, 8px);\n  border-radius: var(--magic-border-radius, 4px);\n  margin-bottom: var(--magic-icon-size, 24px);\n  background: var(--magic-background-light, #fff);\n}\n.insufficient-funds__heading {\n  margin: var(--magic-space, 16px) 0 var(--magic-space--small, 8px) 0;\n  color: var(--magic-caption, #161616);\n}\n.insufficient-funds__heading {\n  font-size: 1rem;\n}\n.insufficient-funds__heading b {\n  font-weight: var(--magic-font-weight-semibold, 600);\n}\n.insufficient-funds__subtitle {\n  color: var(--magic-tertiary, #141f33);\n  text-align: center;\n}\n.insufficient-funds__subtitle {\n  font-size: 0.88rem;\n}\n.insufficient-funds__logo {\n  margin-top: var(--magic-space--x-small, 4px);\n  margin-bottom: var(--magic-space--small, 8px);\n  width: 64px;\n  height: 40px;\n  box-shadow: var(--magic-shadow-2, 0 3px 4px 0 var(--magic-shadow-light, rgba(10, 31, 68, 0.1)), 0 0 1px 0 var(--magic-shadow-lighter, rgba(10, 31, 68, 0.08)), 0 0 0 0.2px var(--magic-shadow-lighter, rgba(10, 31, 68, 0.08)));\n  background: var(--magic-background, #fbfbfb);\n}\n\n.nested-iframe {\n  height: 57vh;\n}\n\n.fallback-text {\n  color: var(--magic-caption, #161616);\n  text-align: center;\n}\n.fallback-text {\n  font-size: 1rem;\n}\n\n.apple-pay__loader {\n  position: relative;\n  top: 24px;\n}\n.apple-pay__anchor {\n  height: 36px;\n  width: 100%;\n}\n\n.payment-method {\n  pointer-events: all;\n  cursor: pointer;\n  display: flex;\n  width: 100%;\n  height: 74px;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 var(--magic-space--small, 8px);\n  border-radius: var(--magic-border-radius, 4px);\n  background: var(--magic-background-light, #fff);\n}\n.payment-method--locked-amount {\n  position: relative;\n  cursor: pointer;\n}\n.payment-method__details {\n  display: flex;\n  align-items: center;\n  gap: var(--magic-space, 16px);\n}\n.payment-method__details.disabled {\n  opacity: 0.3;\n}\n.payment-method__name {\n  color: var(--magic-caption, #161616);\n}\n.payment-method__name {\n  font-size: 1rem;\n}\n.payment-method__subtitle {\n  font-size: 0.75rem;\n}\n.payment-method__logo {\n  width: 64px;\n  height: 40px;\n  box-shadow: var(--magic-shadow-2, 0 3px 4px 0 var(--magic-shadow-light, rgba(10, 31, 68, 0.1)), 0 0 1px 0 var(--magic-shadow-lighter, rgba(10, 31, 68, 0.08)), 0 0 0 0.2px var(--magic-shadow-lighter, rgba(10, 31, 68, 0.08)));\n  background: var(--magic-background, #fbfbfb);\n}\n.payment-method__icon {\n  width: var(--magic-icon-size, 24px);\n  height: var(--magic-icon-size, 24px);\n}\n.payment-method__balance {\n  color: var(--magic-secondary, #7b6aff);\n}\n\n.status-screen {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  gap: var(--magic-space, 16px);\n}\n.status-screen__container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  width: 100%;\n}\n.status-screen__title {\n  color: var(--magic-caption, #161616);\n}\n.status-screen__title {\n  font-size: 1rem;\n}\n.status-screen__icon {\n  width: var(--magic-icon-size--large, 56px);\n  height: var(--magic-icon-size--large, 56px);\n}\n.status-screen__button {\n  align-self: end;\n}\n\n.suggested-amounts {\n  display: flex;\n  flex-direction: column;\n  gap: var(--magic-space--x-small, 4px);\n}\n.suggested-amounts__title {\n  color: var(--magic-caption, #161616);\n}\n.suggested-amounts__title {\n  font-size: 1rem;\n}\n.suggested-amounts__buttons {\n  display: flex;\n  gap: var(--magic-space--small, 8px);\n  justify-content: space-between;\n}\n.suggested-amounts__button {\n  width: 33%;\n}\n\n.info-screen-container {\n  background: #f4f4f7;\n  padding: 0px var(--magic-space, 16px) var(--magic-space, 16px) var(--magic-space--small, 8px);\n  color: var(--magic-text-primary, #0c66ff);\n}\n.info-screen-container .info-screen {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: center;\n  text-align: left;\n  gap: var(--magic-space--small, 8px);\n  padding: var(--magic-space--small, 8px);\n  color: var(--magic-text-primary, #0c66ff);\n  border-radius: var(--magic-space--x-small, 4px);\n  box-shadow: var(--magic-shadow-3, 0 8px 10px 0 var(--magic-shadow-light, rgba(10, 31, 68, 0.1)), 0 0 1px 0 var(--magic-shadow-lighter, rgba(10, 31, 68, 0.08)), 0 0 0 0.2px var(--magic-shadow-lighter, rgba(10, 31, 68, 0.08)));\n  background: var(--magic-background, #fbfbfb);\n}\n\n.amount-screen {\n  background: var(--magic-background-light, #fff);\n  padding: 0px var(--magic-space--small, 8px) var(--magic-space--small, 8px) var(--magic-space--small, 8px);\n}\n.amount-screen__header {\n  display: flex;\n  width: calc(75% - var(--magic-space--small, 8px));\n  gap: var(--magic-space--small, 8px);\n  color: var(--magic-caption, #161616);\n  margin-bottom: var(--magic-space--small, 8px);\n}\n.amount-screen__title {\n  width: 50%;\n  color: var(--magic-caption, #161616);\n}\n.amount-screen__title {\n  font-size: 1rem;\n}\n.amount-screen__cvc {\n  width: 50%;\n  display: flex;\n  gap: var(--magic-space--small, 8px);\n}\n.amount-screen__submit {\n  width: 25%;\n}\n.amount-screen__deposit {\n  width: 100%;\n  display: flex;\n  gap: var(--magic-space--small, 8px);\n  justify-content: space-between;\n}\n.amount-screen__input {\n  display: flex;\n  gap: var(--magic-space--small, 8px);\n  flex-grow: 1;\n  width: 75%;\n}\n.amount-screen__field {\n  flex-grow: 1;\n}\n.amount-screen__errors {\n  display: flex;\n  width: 75%;\n  gap: var(--magic-space--small, 8px);\n  justify-content: space-between;\n}\n.amount-screen__error {\n  display: none;\n}\n.amount-screen__error.active {\n  display: flex;\n  color: var(--magic-error, #f03d3d);\n}\n.amount-screen__container.half {\n  width: 50%;\n}\n.amount-screen__error-cvc {\n  display: none;\n  width: 50%;\n}\n.amount-screen__error-cvc.active {\n  display: flex;\n  color: var(--magic-error, #f03d3d);\n}\n.amount-screen__balance__error {\n  display: none;\n}\n.amount-screen__balance__error.active {\n  display: flex;\n  color: var(--magic-error, #f03d3d);\n}\n\n.wallet-title,\n.tab-name,\n.select-method {\n  color: var(--magic-caption, #161616);\n}\n.wallet-title,\n.tab-name,\n.select-method {\n  font-size: 1rem;\n}\n\n.wallet-title {\n  text-align: center;\n}\n\n.tabs {\n  display: flex;\n  gap: var(--magic-space, 16px);\n}\n.tabs .link a {\n  color: var(--magic-dark, #000);\n}\n.tabs .link.tab-link[active=true]::part(link) {\n  border-bottom: 2px solid var(--magic-primary, #0c66ff);\n}\n.tabs .link.tab-link::part(link):hover {\n  text-decoration: none;\n}\n\nmagic-ui-button::part(is-disabled) {\n  width: 100%;\n}\n\nmagic-ui-button::part(button) {\n  width: 100%;\n  margin: 0;\n}\n\nmagic-ui-button::part(is-loading)::before {\n  left: 50%;\n  color: var(--magic-primary, #0c66ff);\n}\nmagic-ui-button[disabled]::part(is-loading) {\n  color: transparent;\n}\nmagic-ui-button::part(button--hollow button--primary):focus {\n  background-color: var(--magic-primary, #0c66ff);\n  color: var(--magic-primary-contrast, #fff);\n}\n\nmagic-ui-form-field::part(form-field) {\n  margin: 0;\n}\n\nmagic-ui-accordion::part(toggle) {\n  color: black;\n}\n\nmagic-ui-accordion::part(accordion) {\n  color: black;\n}\n\n.payment-method__logo {\n  width: 65px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 4px;\n}\n.payment-method__logo::part(icon) {\n  width: 49px;\n}\n\n.header {\n  color: var(--magic-caption, #161616);\n  font-weight: var(--magic-font-weight-semibold, 600);\n  font-size: calc(var(--magic-font-size, 14px) + 2px);\n  padding-left: 5px;\n}\n\n.bonuses {\n  display: flex;\n  justify-content: flex-start;\n  align-content: flex-start;\n}\n.bonuses::part(radio-group) {\n  margin: auto;\n  width: 100%;\n}\n.bonuses::part(wrapper) {\n  width: 100%;\n}\n.bonuses__error {\n  color: var(--magic-error, #f03d3d);\n  font-weight: var(--magic-font-weight-semibold, 600);\n  text-align: center;\n}\n\n.bonuses__item {\n  display: flex;\n  width: 100%;\n  margin-top: var(--magic-space, 16px);\n}\n\n.bonuses__item::part(radio) {\n  width: 100%;\n  display: flex;\n}\n\n.bonuses__item::part(label) {\n  width: 100%;\n}\n.bonuses__item::part(label):before {\n  top: calc(var(--bonus-height, 88px) / 2 - 5px);\n}\n.bonuses__item::part(label):after {\n  top: calc(var(--bonus-height, 88px) / 2);\n}\n\n.payment-error {\n  color: var(--magic-error, #f03d3d);\n  font-weight: var(--magic-font-weight-semibold, 600);\n  text-align: center;\n  background-color: #f4f4f7;\n  width: 100%;\n}\n.payment-error__text {\n  color: var(--magic-error, #f03d3d);\n  font-weight: var(--magic-font-weight-semibold, 600);\n  text-align: center;\n  background-color: #f4f4f7;\n  width: 100%;\n}\n.payment-error.hidden {\n  display: none;\n}\n\n.bonuses__item:last-of-type::part(label):before {\n  top: 0;\n}\n.bonuses__item:last-of-type::part(label):after {\n  top: 5px;\n}\n\n.bonuses__item::part(input) {\n  top: calc(var(--bonus-height, 88px) / 2 - 2px);\n}\n\n.bonuses__item:last-of-type::part(input) {\n  top: calc(var(--bonus-height, 88px) / 2);\n}\n\n.bonuses__item:first-child::part(radio) {\n  margin-top: 0;\n}\n\n.bonus__item-toggle {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  border-radius: calc(var(--magic-border-radius, 4px) * 2);\n}\n\n.bonuses__item-accordion {\n  display: flex;\n  width: 100%;\n  background-color: var(--magic-background, #fbfbfb);\n}\n\n.bonuses__item-accordion::part(icons) {\n  display: none;\n}\n\n.bonuses__item-accordion::part(toggle) {\n  width: 100%;\n}\n\n.bonuses__item-accordion::part(content) {\n  overflow: visible;\n}\n\n.bonuses__item-accordion--active::part(content) {\n  display: flex;\n}\n\n.bonus__item-toggle--active {\n  border-radius: calc(var(--magic-border-radius, 4px) * 2) calc(var(--magic-border-radius, 4px) * 2) 0 0;\n}\n\n.bonuses__item-title {\n  display: flex;\n  align-items: center;\n  min-height: var(--bonus-height, 88px);\n  padding: 0 var(--magic-space--small, 8px);\n  font-size: var(--magic-font-size, 14px);\n  font-weight: var(--magic-font-weight-semibold, 600);\n  color: var(--magic-primary-contrast, #fff);\n  background-image: linear-gradient(var(--magic-primary-contrast, #fff) 33%, rgba(255, 255, 255, 0) 0%);\n  background-position: left;\n  background-size: 1px 18px;\n  background-repeat: repeat-y;\n}\n\n.bonuses__item-no-bonus {\n  font-size: var(--magic-font-size, 14px);\n  font-weight: var(--magic-font-weight, 400);\n  color: var(--magic-caption, #161616);\n}\n\n.bonuses__item-description {\n  display: block;\n  padding: 12px var(--magic-space, 16px);\n  text-align: left;\n  font-size: calc(var(--magic-font-size, 14px) - 2px);\n  color: var(--magic-caption, #161616);\n  background: var(--magic-primary-contrast, #fff);\n  border-radius: 0 0 calc(var(--magic-border-radius, 4px) * 2) calc(var(--magic-border-radius, 4px) * 2);\n  box-shadow: 0px 8px 16px 0px #000026;\n}\n\n.bonus__item-logo {\n  width: 64px;\n  height: 64px;\n  margin: 12px var(--magic-space, 16px);\n  border-radius: 50%;\n}\n\n.loader-button {\n  position: absolute;\n  top: 50%;\n  right: var(--magic-space--large, 32px);\n}\n\n.suggested-amounts {\n  margin-bottom: var(--magic-space, 16px);\n}\n\n.method-container {\n  max-height: 1000px;\n  transition: max-height 0.3s ease, opacity 0.3s ease, margin 0.3s ease;\n  opacity: 1;\n}\n.method-container .payment-method {\n  background: #f4f4f7;\n}\n.method-container.removing {\n  max-height: 0;\n  opacity: 0;\n  pointer-events: none;\n  margin-bottom: 0;\n}\n.method-container .suggestion-container {\n  background: #f4f4f7;\n}\n\n.amount-screen {\n  background: #f4f4f7;\n}\n\n.paypal.status-screen__button {\n  align-self: center;\n  width: 100%;\n}\n\n.pending-withdrawals::part(accordion) {\n  background-color: #f4f4f7;\n}\n.pending-withdrawals::part(toggle) {\n  width: 100%;\n}\n.pending-withdrawals::part(icons) {\n  color: var(--magic-primary-contrast, #fff);\n  border-radius: 50%;\n  margin-right: var(--magic-space--small, 8px);\n  background-color: var(--magic-primary-contrast, #fff);\n}\n.pending-withdrawals::part(icon) {\n  color: var(--magic-dark, #000);\n}\n.pending-withdrawals__toggle {\n  padding: var(--magic-space, 16px);\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.pending-withdrawals__left-part {\n  width: 100%;\n  display: flex;\n}\n.pending-withdrawals__pending {\n  display: flex;\n  align-items: center;\n  padding: 1px 6px;\n  color: var(--magic-primary-contrast, #fff);\n  background-color: var(--magic-pending, #f38300);\n  border-radius: var(--magic-space, 16px);\n}\n.pending-withdrawals__items {\n  display: flex;\n  flex-direction: column;\n}\n.pending-withdrawals__items .withdrawal_item:first-child {\n  margin-top: 0;\n}\n.pending-withdrawals__items .withdrawal_item:last-child {\n  border-bottom: 0;\n}\n.pending-withdrawals__name {\n  margin-left: var(--magic-space--small, 8px);\n}\n.pending-withdrawals__load-more {\n  padding: var(--magic-space, 16px) 0;\n  display: flex;\n  justify-content: center;\n}\n.pending-withdrawals__load-more::part(button) {\n  font-size: var(--magic-font-size, 14px);\n  padding: 8px 12px;\n  width: 36%;\n}\n\n.withdrawal_item {\n  position: relative;\n  display: flex;\n  margin: 16px 16px 0 16px;\n  padding-bottom: 16px;\n  justify-content: space-between;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n}\n.withdrawal_item__left-part {\n  display: flex;\n  flex-direction: column;\n}\n.withdrawal_item__method {\n  font-weight: var(--magic-font-weight, 400);\n}\n.withdrawal_item__description {\n  font-weight: var(--magic-font-weight, 400);\n  color: var(--magic-text-medium, #747474);\n  font-size: calc(var(--magic-font-size, 14px) - 2px);\n}\n.withdrawal_item__icon {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n}\n\n.bonuses__header {\n  font-size: calc(var(--magic-font-size, 14px) + 2px);\n  text-align: center;\n  color: var(--magic-bonus-text, #080e2d);\n  font-weight: var(--magic-font-weight-bold, 700);\n}\n.bonuses__subheader {\n  text-align: center;\n  font-weight: var(--magic-font-weight-semibold, 600);\n  color: var(--magic-primary, #0c66ff);\n}\n\n.bonus__header {\n  text-align: center;\n  color: var(--magic-bonus-text, #080e2d);\n  font-weight: var(--magic-font-weight-bold, 700);\n}\n.bonus__table {\n  margin: 0 var(--magic-space, 16px);\n  display: flex;\n  flex-direction: column;\n}\n.bonus__table thead {\n  display: flex;\n  justify-content: center;\n}\n.bonus__row {\n  display: flex;\n  justify-content: space-between;\n  font-size: calc(var(--magic-font-size, 14px) - 2px);\n  font-weight: var(--magic-font-weight-semibold, 600);\n  color: var(--magic-bonus-text, #080e2d);\n  height: 100%;\n  padding: 8px 0;\n}\n.bonus__value {\n  color: var(--magic-caption, #161616);\n  font-weight: var(--magic-font-weight-bold, 700);\n}\n.bonus__footer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.bonus__tooltip-popup::part(content) {\n  width: 100%;\n}\n.bonus__terms {\n  margin: var(--magic-space, 16px) 0;\n  cursor: pointer;\n  text-align: center;\n  color: var(--magic-primary, #0c66ff);\n  font-weight: var(--magic-font-weight-bold, 700);\n}\n.bonus__forfeit::part(button) {\n  color: var(--magic-primary-contrast, #fff);\n  font-weight: var(--magic-font-weight-semibold, 600);\n  margin-bottom: var(--magic-space, 16px);\n}\n\n.popup {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.popup__title {\n  color: var(--magic-caption, #161616);\n  font-weight: var(--magic-font-weight-bold, 700);\n}\n.popup__intro {\n  margin: var(--magic-space--x-small, 4px) 0 var(--magic-space, 16px) 0;\n  color: var(--magic-bonus-text, #080e2d);\n  font-size: calc(var(--magic-font-size, 14px) - 2px);\n}\n.popup__cancel {\n  cursor: pointer;\n  margin-top: var(--magic-space--small, 8px);\n  text-align: center;\n  font-weight: var(--magic-font-weight-bold, 700);\n  color: var(--magic-primary, #0c66ff);\n}\n\n.bonus-bar {\n  display: flex;\n  flex-direction: column;\n  gap: var(--magic-space--x-small, 4px);\n  margin-bottom: var(--magic-space, 16px);\n}\n.bonus-bar__title {\n  color: var(--magic-caption, #161616);\n}\n.bonus-bar__progress {\n  position: relative;\n  height: 8px;\n  background-color: #cbcbd9;\n  overflow: hidden;\n  width: 100%;\n  border-radius: 100px;\n  /* Inside auto layout */\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  z-index: 0;\n}\n.bonus-bar__progress-fill {\n  height: 100%;\n  border-radius: 100px;\n  width: 0%;\n  transition: width 0.3s ease-in-out, background 0.3s ease-in-out;\n  position: absolute;\n  background: linear-gradient(135deg, var(--magic-progress-bar-filler-to, #2af598) 0%, var(--magic-progress-bar-filler-from, #08aeea) 100%);\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n  z-index: 1;\n}\n.bonus-bar__progress .fulfilled {\n  background: linear-gradient(135deg, var(--magic-progress-bar-full-from, #00ab77) 0%, var(--magic-progress-bar-full-to, #00d494) 100%);\n  transition: width 0.3s ease-in-out, background 0.3s ease-in-out;\n}\n.bonus-bar__info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--magic-space--x-small, 4px);\n}\n.bonus-bar__info-deposit, .bonus-bar__info-goal {\n  color: var(--magic-caption, #161616);\n}\n\n.card-details {\n  display: flex;\n  flex-direction: column;\n  gap: var(--magic-space--x-small, 4px);\n  margin-bottom: var(--magic-space--small, 8px);\n}\n.card-details__summary {\n  display: flex;\n  flex-direction: column;\n  gap: var(--magic-space, 16px);\n}\n.card-details__summary-button {\n  width: 90px;\n}\n.card-details__summary-info {\n  background-color: #f4f4f7;\n  display: flex;\n  padding: var(--magic-space, 16px);\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--magic-space, 16px);\n}\n.card-details__summary-title {\n  color: var(--magic-caption, #161616);\n}\n.card-details__summary-title {\n  font-size: 1rem;\n}\n.card-details__summary-subtitle {\n  font-size: 0.75rem;\n}\n.card-details__summary-method {\n  display: flex;\n  gap: var(--magic-space, 16px);\n  align-items: center;\n  flex-grow: 1;\n}\n.card-details__summary-text {\n  color: var(--magic-caption, #161616);\n}\n.card-details__summary-text {\n  font-size: 1rem;\n}\n.card-details__fields {\n  display: flex;\n  flex-direction: column;\n  gap: var(--magic-space, 16px);\n  color: var(--magic-caption, #161616);\n  margin-top: calc(var(--magic-space--large, 32px) - var(--magic-space--small, 8px));\n}\n.card-details__fields-title {\n  font-size: 1.13rem;\n}\n.card-details__fields-subtitle {\n  font-size: 1rem;\n}\n.card-details__fields-field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--magic-space--small, 8px);\n}\n.card-details__fields-data {\n  display: flex;\n  gap: var(--magic-space, 16px);\n  position: relative;\n}\n.card-details__fields-grow {\n  width: 50%;\n}\n.card-details__fields-descr {\n  display: flex;\n  align-items: center;\n  gap: var(--magic-space--small, 8px);\n}\n.card-details__fields-expiry__error {\n  display: none;\n}\n.card-details__fields-expiry__error.active {\n  display: block;\n  color: var(--magic-error, #f03d3d);\n}\n.card-details__errors-cvc {\n  display: none;\n}\n.card-details__errors-cvc.active {\n  display: block;\n  color: var(--magic-error, #f03d3d);\n}\n.card-details__errors-card {\n  display: none;\n}\n.card-details__errors-card.active {\n  display: block;\n  color: var(--magic-error, #f03d3d);\n}\n.card-details__errors-holder {\n  display: none;\n}\n.card-details__errors-holder.active {\n  display: block;\n  color: var(--magic-error, #f03d3d);\n}\n.card-details__errors-expiry {\n  display: none;\n}\n.card-details__errors-expiry.active {\n  display: block;\n  color: var(--magic-error, #f03d3d);\n}\n.card-details__submit {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: var(--magic-space--small, 8px);\n}\n.card-details__submit-container {\n  display: flex;\n  gap: var(--magic-space, 16px);\n  align-items: center;\n}\n.card-details__submit ::part(button) {\n  padding: 12px var(--magic-space--large, 32px);\n}\n.card-details__divider {\n  background-color: #000;\n  opacity: 0.15;\n  height: 1px;\n  margin-top: calc(var(--magic-space--large, 32px) - var(--magic-space--small, 8px));\n}\n\n.details__summary-info {\n  margin-top: var(--magic-space, 16px);\n}\n.details__heading {\n  margin-top: calc(var(--magic-space, 16px) + var(--magic-space--small, 8px));\n  color: var(--magic-dark, #000);\n}\n.details__heading {\n  font-size: 1.13rem;\n}\n.details__label {\n  display: flex;\n  align-items: center;\n  margin-bottom: var(--magic-space--small, 8px);\n  color: var(--magic-dark, #000);\n}\n.details__label {\n  font-size: 1rem;\n}\n.details__label magic-ui-text {\n  margin-left: var(--magic-space--small, 8px);\n}\n.details__field {\n  margin-top: var(--magic-space, 16px);\n}\n.details__field input {\n  margin-top: var(--magic-space--small, 8px);\n}\n.details__footer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin: calc(var(--magic-space, 16px) + var(--magic-space--small, 8px)) 0;\n}\n.details__footer-wrapper {\n  display: flex;\n  align-items: center;\n}\n.details__footer-wrapper .button::part(button) {\n  padding: var(--magic-font-size, 14px) calc(var(--magic-space, 16px) + 4px);\n}\n.details__footer.with-content {\n  justify-content: space-between;\n}\n.details__confirm-button {\n  margin-left: var(--magic-space, 16px);\n}\n.details_form {\n  margin-top: var(--magic-space, 16px);\n}\n.details .fields-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: var(--magic-space, 16px);\n}\n.details .fields-wrapper ::part(label) {\n  color: var(--magic-caption, #161616);\n  font-weight: var(--magic-font-weight-semibold, 600);\n}\n.details .fields-wrapper ::part(label) {\n  font-size: 1rem;\n}\n\n.tooltip {\n  cursor: pointer;\n  pointer-events: all;\n}\n.tooltip ::part(content) {\n  top: unset;\n  bottom: calc(var(--magic-icon-size, 24px) + var(--magic-space--small, 8px) + var(--magic-space--small, 8px));\n  transform: unset;\n  left: calc(50% - 12px);\n}\n.tooltip ::part(content)::before {\n  left: 8px;\n  top: unset;\n  bottom: calc(var(--magic-space--small, 8px) * -1 + 1px);\n  margin: calc(var(--magic-space--small, 8px) / 2 * 1) 0 0;\n  border-color: var(--magic-tooltip-background, var(--magic-light, #fff)) transparent transparent transparent;\n  border-width: var(--magic-space--small, 8px) calc(var(--magic-space--small, 8px) / 2) 0 calc(var(--magic-space--small, 8px) / 2);\n  filter: drop-shadow(2px 4px 2px rgba(0, 0, 0, 0.2));\n}\n.tooltip__icon {\n  width: var(--magic-icon-size, 24px);\n  height: var(--magic-icon-size, 24px);\n}\n.tooltip__content {\n  min-width: 228px;\n  padding: var(--magic-space--x-small, 4px) var(--magic-space--small, 8px);\n  max-width: 250px;\n}\n.tooltip__heading {\n  color: var(--magic-caption, #161616);\n}\n.tooltip__heading {\n  font-size: 0.88rem;\n}\n.tooltip__subtitle {\n  margin-top: var(--magic-space--x-small, 4px);\n  color: var(--magic-tertiary, #141f33);\n}\n.tooltip__subtitle {\n  font-size: 0.75rem;\n}\n.tooltip__close-icon {\n  position: absolute;\n  top: 18px;\n  right: 22px;\n  width: calc(var(--magic-icon-size, 24px) / 2);\n  height: calc(var(--magic-icon-size, 24px) / 2);\n  cursor: pointer;\n}\n@media (max-width: 540px) {\n  .tooltip ::part(tooltip) {\n    position: unset;\n  }\n  .tooltip ::part(content) {\n    bottom: 0;\n    right: 0;\n    left: unset;\n  }\n  .tooltip ::part(content)::before {\n    content: unset;\n  }\n}\n\n.controls-wrapper {\n  display: flex;\n  flex-direction: row;\n  gap: var(--magic-space--small, 8px);\n  align-items: center;\n  height: 20px;\n}\n.controls-wrapper.disabled {\n  pointer-events: none;\n  user-select: none;\n  cursor: default;\n  touch-action: none;\n}\n.controls-wrapper.disabled .net-position-container {\n  display: none;\n  pointer-events: none;\n}\n.controls-wrapper .icon {\n  height: 100%;\n}\n.controls-wrapper__remove-icon {\n  cursor: pointer;\n  pointer-events: all;\n  padding-right: var(--magic-space--xx-small, 2px);\n}\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.controls-wrapper__loading-icon {\n  cursor: default;\n  pointer-events: none;\n  animation: rotate 1s linear infinite;\n}\n.controls-wrapper .hidden {\n  display: none;\n}\n.controls-wrapper .confirm-popup {\n  width: 200px;\n  right: 20px;\n  position: absolute;\n}\n.controls-wrapper .confirm-popup .popup__intro {\n  text-align: center;\n}\n.controls-wrapper__tooltip-popup::part(content) {\n  width: 100%;\n}\n.controls-wrapper__confirm::part(button) {\n  color: var(--magic-primary-contrast, #fff);\n  font-weight: var(--magic-font-weight-semibold, 600);\n  margin-bottom: var(--magic-space, 16px);\n}\n\n.net-position-container {\n  font-size: var(--magic-font-size, 14px);\n  scale: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 var(--magic-space--small, 8px);\n  border-radius: var(--magic-space--large, 32px);\n  gap: var(--magic-space--small, 8px);\n  background: var(--magic-background-light, #fff);\n}\n.net-position-container__name {\n  color: var(--magic-caption, #161616);\n  font-size: 12px;\n}\n.net-position-container .tooltip__icon {\n  width: 18px;\n  height: 18px;\n}\n.net-position-container magic-ui-tooltip::part(content) {\n  margin-left: -120px;\n}\n.net-position-container.hidden {\n  display: none;\n}\n\n.saved-withdraw-methods {\n  display: flex;\n  gap: var(--magic-space, 16px);\n  flex-direction: column;\n}\n\n.centered-wrapper__image {\n  max-width: 100vw;\n  max-height: 100vh;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n\n.gpay-card-info-container {\n  padding: 0;\n  position: relative;\n  min-width: 240px;\n  width: 100%;\n  height: 40px;\n  min-height: 40px;\n  border-radius: 4px;\n  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 1px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;\n  cursor: pointer;\n  border: 0px;\n}\n\n.gpay-card-info-container.black,\n.gpay-card-info-animation-container.black {\n  background-color: #000;\n  box-shadow: none;\n  outline: none;\n}\n\n.gpay-card-info-container.white,\n.gpay-card-info-animation-container.white {\n  background-color: #fff;\n  outline: 1px solid #3c4043;\n}\n\n.gpay-card-info-container.black.border-inset,\n.gpay-card-info-animation-container.black.border-inset {\n  outline: none;\n  outline-offset: 0;\n}\n\n.gpay-card-info-container.white.border-inset,\n.gpay-card-info-animation-container.white.border-inset {\n  outline: none;\n  outline-offset: 0;\n}\n\n.gpay-card-info-container.black.border-toggle,\n.gpay-card-info-animation-container.black.border-toggle {\n  outline: none;\n}\n\n.gpay-card-info-container.white.border-toggle,\n.gpay-card-info-animation-container.white.border-toggle {\n  outline: none;\n}\n\n.gpay-card-info-container.black.active {\n  background-color: #5f6368;\n}\n\n.gpay-card-info-container.black.hover,\n.gpay-card-info-animation-container.black.hover {\n  background-color: #000;\n  outline: none;\n  box-shadow: none;\n}\n\n.gpay-card-info-container.white.active {\n  background-color: #fff;\n}\n\n.gpay-card-info-container.white.focus {\n  box-shadow: #e8e8e8 0 1px 1px 0, #e8e8e8 0 1px 3px;\n}\n\n.gpay-card-info-container.white.hover,\n.gpay-card-info-animation-container.white.hover {\n  background-color: #f8f8f8;\n}\n\n.gpay-card-info-container.color-scheme-default {\n  color-scheme: light dark;\n}\n\n.gpay-card-info-iframe {\n  border: 0;\n  display: block;\n  height: 100%;\n  margin: auto;\n  max-width: 100%;\n  width: 100%;\n  pointer-events: none;\n}\n\n.gpay-card-info-container-fill .gpay-card-info-iframe {\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: 100%;\n}\n\n.gpay-card-info-container-fill,\n.gpay-card-info-container-fill > .gpay-card-info-container {\n  width: 100%;\n  height: inherit;\n}\n\n.gpay-card-info-container-fill .gpay-card-info-placeholder-container {\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding-top: 0;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.gpay-card-info-container-fill .gpay-card-info-placeholder-svg-container {\n  position: relative;\n  width: 60%;\n  height: inherit;\n  max-height: 80%;\n  margin-right: -20%;\n}\n\n.gpay-card-info-container-fill .gpay-card-info-placeholder-svg-container > svg {\n  position: absolute;\n  left: 0;\n  height: 100%;\n  max-width: 100%;\n}";

var _inputChannel$1 = /*#__PURE__*/ _class_private_field_loose_key("_inputChannel"), _subscriptions$1 = /*#__PURE__*/ _class_private_field_loose_key("_subscriptions"), _tabs = /*#__PURE__*/ _class_private_field_loose_key("_tabs"), _resetState = /*#__PURE__*/ _class_private_field_loose_key("_resetState"), _applyStyles$1 = /*#__PURE__*/ _class_private_field_loose_key("_applyStyles"), _attachListeners$1 = /*#__PURE__*/ _class_private_field_loose_key("_attachListeners"), _changeWalletView = /*#__PURE__*/ _class_private_field_loose_key("_changeWalletView"), _viewHandler = /*#__PURE__*/ _class_private_field_loose_key("_viewHandler"), _depositBonusesHandler = /*#__PURE__*/ _class_private_field_loose_key("_depositBonusesHandler"), _pendingWithdrawalsHandler = /*#__PURE__*/ _class_private_field_loose_key("_pendingWithdrawalsHandler"), _monthlyTransactionsHandler = /*#__PURE__*/ _class_private_field_loose_key("_monthlyTransactionsHandler"), _translationsHandler$1 = /*#__PURE__*/ _class_private_field_loose_key("_translationsHandler"), _updateGatewaysHandler = /*#__PURE__*/ _class_private_field_loose_key("_updateGatewaysHandler"), _balanceHandler = /*#__PURE__*/ _class_private_field_loose_key("_balanceHandler"), _buildSkeletonUI = /*#__PURE__*/ _class_private_field_loose_key("_buildSkeletonUI"), _prepareTabs = /*#__PURE__*/ _class_private_field_loose_key("_prepareTabs"), _profileHandler$1 = /*#__PURE__*/ _class_private_field_loose_key("_profileHandler"), _depositParamsHandler = /*#__PURE__*/ _class_private_field_loose_key("_depositParamsHandler"), _featuresFlagHandler = /*#__PURE__*/ _class_private_field_loose_key("_featuresFlagHandler"), _magicPaymentMethodsHandler = /*#__PURE__*/ _class_private_field_loose_key("_magicPaymentMethodsHandler"), _sortMagicMethodByProvider = /*#__PURE__*/ _class_private_field_loose_key("_sortMagicMethodByProvider");
/**
 * The main web component for the Galleon cashier experience.
 *
 * This custom element is registered as `magic-galleon` and renders a full wallet UI
 * with Deposit, Withdraw and Bonuses tabs. It communicates with the host application
 * via CustomEvents using the ListenMessageType/DispatchMessageType enums.
 *
 * Events listened on the element (CustomEvent.detail payloads described in types.ts):
 * {@link ListenMessageType}
 * - ListenMessageType.InitGateways — initialize gateways with Corex config.
 * - ListenMessageType.UpdateTranslations — update locale and translations.
 * - ListenMessageType.UpdateView — switch current tab/view.
 * - ListenMessageType.UpdateGateways — update gateways config at runtime.
 * - ListenMessageType.UpdateBalance — update balance and currency.
 * - ListenMessageType.DepositBonuses — set available deposit bonuses to display.
 * - ListenMessageType.MonthlyTransactions — update the transactions list.
 * - ListenMessageType.PendingWithdrawals — update pending withdrawals list.
 * - ListenMessageType.UpdateProfile — provide player profile info for payments.
 * - ListenMessageType.DepositParams — provide additional deposit params.
 * - ListenMessageType.UpdateFeatureFlags — toggle cashier feature flags.
 * - ListenMessageType.InitMagicPaymentMethods — provide Magic payment methods.
 *
 * Events dispatched from the element (host should listen on the element):
 * - DispatchMessageType.ChangeView — request host navigation outside the cashier.
 * - DispatchMessageType.DepositCompleted / WithdrawCompleted — operation completed.
 * - DispatchMessageType.DepositResult / WithdrawResult — result payloads for ops.
 * - DispatchMessageType.WithdrawLinkingCompleted — saved method linking completed.
 * - DispatchMessageType.LogMessage — informational logs. {@link DispatchMessageType}
 *
 * @public
 */ class WalletElement extends HTMLElement {
    get currentView() {
        return AppState.wallet.selectedTabName;
    }
    connectedCallback() {
        this.attachShadow({
            mode: 'open'
        });
        _class_private_field_loose_base(this, _applyStyles$1)[_applyStyles$1]();
        _class_private_field_loose_base(this, _attachListeners$1)[_attachListeners$1]();
        this.dispatchEvent(new Event('load'));
    }
    disconnectedCallback() {
        _class_private_field_loose_base(this, _resetState)[_resetState]();
        _class_private_field_loose_base(this, _subscriptions$1)[_subscriptions$1].forEach((subscription)=>{
            subscription();
        });
    }
    constructor(){
        super(), Object.defineProperty(this, _resetState, {
            value: resetState
        }), Object.defineProperty(this, _applyStyles$1, {
            value: applyStyles$1
        }), Object.defineProperty(this, _attachListeners$1, {
            value: attachListeners$1
        }), Object.defineProperty(this, _changeWalletView, {
            value: changeWalletView
        }), Object.defineProperty(this, _viewHandler, {
            value: viewHandler
        }), Object.defineProperty(this, _depositBonusesHandler, {
            value: depositBonusesHandler
        }), Object.defineProperty(this, _pendingWithdrawalsHandler, {
            value: pendingWithdrawalsHandler
        }), Object.defineProperty(this, _monthlyTransactionsHandler, {
            value: monthlyTransactionsHandler
        }), Object.defineProperty(this, _translationsHandler$1, {
            value: translationsHandler$1
        }), Object.defineProperty(this, _updateGatewaysHandler, {
            value: updateGatewaysHandler
        }), Object.defineProperty(this, _balanceHandler, {
            value: balanceHandler
        }), Object.defineProperty(this, _buildSkeletonUI, {
            value: buildSkeletonUI
        }), Object.defineProperty(this, _prepareTabs, {
            value: prepareTabs
        }), Object.defineProperty(this, _profileHandler$1, {
            value: profileHandler$1
        }), Object.defineProperty(this, _depositParamsHandler, {
            value: depositParamsHandler
        }), Object.defineProperty(this, _featuresFlagHandler, {
            value: featuresFlagHandler
        }), Object.defineProperty(this, _magicPaymentMethodsHandler, {
            value: magicPaymentMethodsHandler
        }), Object.defineProperty(this, _sortMagicMethodByProvider, {
            value: sortMagicMethodByProvider
        }), Object.defineProperty(this, _inputChannel$1, {
            writable: true,
            value: void 0
        }), Object.defineProperty(this, _subscriptions$1, {
            writable: true,
            value: void 0
        }), Object.defineProperty(this, _tabs, {
            writable: true,
            value: void 0
        }), _class_private_field_loose_base(this, _inputChannel$1)[_inputChannel$1] = new HtmlEventMessageChannel(this), _class_private_field_loose_base(this, _subscriptions$1)[_subscriptions$1] = [], _class_private_field_loose_base(this, _tabs)[_tabs] = new TabController(View.Deposit);
        AppState.root = this;
        _class_private_field_loose_base(this, _tabs)[_tabs].addTab(View.Deposit, renderDepositView$1.bind(this));
        _class_private_field_loose_base(this, _tabs)[_tabs].addTab(View.Withdraw, renderWithdrawView.bind(this));
        _class_private_field_loose_base(this, _tabs)[_tabs].addTab(View.Bonuses, renderBonusesView.bind(this));
    }
}
function resetState() {
    const cacheState = structuredClone(defaultWalletState);
    cacheState.imageUrl = AppState.wallet.imageUrl;
    cacheState.redirectBaseUrl = AppState.wallet.redirectBaseUrl;
    AppState.wallet = cacheState;
}
function applyStyles$1() {
    const styleSheet = new CSSStyleSheet();
    styleSheet.replaceSync(scss$1);
    AppState.shadowRoot.adoptedStyleSheets.push(styleSheet);
}
function attachListeners$1() {
    _class_private_field_loose_base(this, _inputChannel$1)[_inputChannel$1].waitForMessage(ListenMessageType.InitGateways).then(async (config)=>{
        var _config_corex, _config_corex1;
        var _config_corex_skipSuggestDecimals;
        AppState.wallet.skippedDecimals.push(...(_config_corex_skipSuggestDecimals = (_config_corex = config.corex) == null ? void 0 : _config_corex.skipSuggestDecimals) != null ? _config_corex_skipSuggestDecimals : []);
        var _config_corex_firstDepositLimits;
        AppState.wallet.firstDepositLimits = (_config_corex_firstDepositLimits = (_config_corex1 = config.corex) == null ? void 0 : _config_corex1.firstDepositLimits) != null ? _config_corex_firstDepositLimits : {};
        await WalletGateway.instance.init(config);
    });
    _class_private_field_loose_base(this, _subscriptions$1)[_subscriptions$1].push(_class_private_field_loose_base(this, _inputChannel$1)[_inputChannel$1].subscribeForMessage(ListenMessageType.UpdateBalance, _class_private_field_loose_base(this, _balanceHandler)[_balanceHandler]), _class_private_field_loose_base(this, _inputChannel$1)[_inputChannel$1].subscribeForMessage(ListenMessageType.UpdateTranslations, _class_private_field_loose_base(this, _translationsHandler$1)[_translationsHandler$1]), _class_private_field_loose_base(this, _inputChannel$1)[_inputChannel$1].subscribeForMessage(ListenMessageType.UpdateView, _class_private_field_loose_base(this, _viewHandler)[_viewHandler]), _class_private_field_loose_base(this, _inputChannel$1)[_inputChannel$1].subscribeForMessage(ListenMessageType.UpdateGateways, _class_private_field_loose_base(this, _updateGatewaysHandler)[_updateGatewaysHandler]), _class_private_field_loose_base(this, _inputChannel$1)[_inputChannel$1].subscribeForMessage(ListenMessageType.DepositBonuses, _class_private_field_loose_base(this, _depositBonusesHandler)[_depositBonusesHandler]), _class_private_field_loose_base(this, _inputChannel$1)[_inputChannel$1].subscribeForMessage(ListenMessageType.MonthlyTransactions, _class_private_field_loose_base(this, _monthlyTransactionsHandler)[_monthlyTransactionsHandler]), _class_private_field_loose_base(this, _inputChannel$1)[_inputChannel$1].subscribeForMessage(ListenMessageType.PendingWithdrawals, _class_private_field_loose_base(this, _pendingWithdrawalsHandler)[_pendingWithdrawalsHandler]), _class_private_field_loose_base(this, _inputChannel$1)[_inputChannel$1].subscribeForMessage(ListenMessageType.UpdateProfile, _class_private_field_loose_base(this, _profileHandler$1)[_profileHandler$1]), _class_private_field_loose_base(this, _inputChannel$1)[_inputChannel$1].subscribeForMessage(ListenMessageType.DepositParams, _class_private_field_loose_base(this, _depositParamsHandler)[_depositParamsHandler]), _class_private_field_loose_base(this, _inputChannel$1)[_inputChannel$1].subscribeForMessage(ListenMessageType.UpdateFeatureFlags, _class_private_field_loose_base(this, _featuresFlagHandler)[_featuresFlagHandler]), _class_private_field_loose_base(this, _inputChannel$1)[_inputChannel$1].subscribeForMessage(ListenMessageType.InitMagicPaymentMethods, _class_private_field_loose_base(this, _magicPaymentMethodsHandler)[_magicPaymentMethodsHandler]));
}
async function changeWalletView(view) {
    if (!view || !viewTypes.includes(view)) {
        return;
    }
    AppState.wallet.selectedTabName = view;
    _class_private_field_loose_base(this, _buildSkeletonUI)[_buildSkeletonUI]();
    await _class_private_field_loose_base(this, _tabs)[_tabs].selectTab(view);
    const eventType = viewEventMap[view];
    if (eventType) {
        void LogEventService.logEvent({
            type: eventType
        });
    }
}
function viewHandler(event) {
    const payload = event.detail;
    if (!payload.view) {
        console.error('No view specified for event "update-view"');
        return;
    }
    AppState.wallet.lockedAmount = payload.lockedAmount;
    void _class_private_field_loose_base(this, _changeWalletView)[_changeWalletView](payload.view);
}
async function depositBonusesHandler(event) {
    const payload = event.detail;
    const bonuses = payload.bonuses;
    if (!bonuses) {
        return;
    }
    const BONUSES_TO_DISPLAY = 3;
    AppState.wallet.depositBonuses = bonuses.sort((a, b)=>a.position - b.position).slice(0, BONUSES_TO_DISPLAY);
    renderBonuses$1();
}
async function pendingWithdrawalsHandler(event) {
    const payload = event.detail;
    const { isPendingWithdrawals } = payload;
    if (!isPendingWithdrawals) {
        AppState.wallet.features.pendingWithdrawals = false;
        return;
    }
    AppState.wallet.features.pendingWithdrawals = true;
    const content = this.shadowRoot.querySelector('.tab-content');
    // remove button for fetching withdrawals when reached the end
    const withdrawals = payload.transactions;
    const filteredWithdrawals = withdrawals.filter((w)=>AppState.wallet.pendingWithdrawals.some((stateWithdrawal)=>stateWithdrawal.id !== w.id));
    var _payload_isLast;
    const withoutButton = AppState.wallet.pendingWithdrawals.length > 0 && ((_payload_isLast = payload.isLast) != null ? _payload_isLast : filteredWithdrawals.length < 1);
    if (payload.offset) {
        AppState.wallet.pendingWithdrawals.push(...filteredWithdrawals);
    } else {
        AppState.wallet.pendingWithdrawals = withdrawals;
    }
    if (this.currentView === 'withdraw') {
        appendPendingWithdrawalsTemplate(content, withoutButton);
    }
}
async function monthlyTransactionsHandler(event) {
    const payload = event.detail;
    const transactions = (payload == null ? void 0 : payload.transactions) || [];
    const filteredTransactions = transactions.filter((w)=>AppState.wallet.transactions.some((stateTransaction)=>stateTransaction.id !== w.id));
    if (payload.offset) {
        AppState.wallet.transactions.push(...filteredTransactions);
    } else {
        AppState.wallet.transactions = transactions;
    }
}
async function translationsHandler$1(event) {
    const payload = event.detail;
    if (!payload.translations) {
        console.error('The translation object is empty for event "update-translations"');
        return;
    }
    if (payload.locale) {
        AppState.wallet.locale = payload.locale;
        PaysafeCashier.instance.update({
            locale: payload.paysafeLocale
        });
        NuveiCashier.instance.update({
            locale: payload.locale
        });
    }
    WalletTranslations.instance.updateTranslations(payload.translations);
    _class_private_field_loose_base(this, _buildSkeletonUI)[_buildSkeletonUI]();
    // refresh
    _class_private_field_loose_base(this, _changeWalletView)[_changeWalletView](this.currentView);
}
async function updateGatewaysHandler(event) {
    const payload = event.detail;
    if (!payload) {
        console.error('No payload specified for event "update-gateways"');
        return;
    }
    await WalletGateway.instance.update(payload);
}
function balanceHandler(event) {
    const payload = event.detail;
    if (!payload.balance) {
        console.error('The balance object is empty for event "update-balance"');
        return;
    }
    if (AppState.wallet.balanceData.currencyCode !== payload.balance.currencyCode) {
        _class_private_field_loose_base(this, _changeWalletView)[_changeWalletView](this.currentView);
    }
    AppState.wallet.balanceData = payload.balance;
    const balanceData = AppState.wallet.balanceData;
    var _balanceData_withdrawable;
    // handle old interface to keep backward compatible using balance data
    balanceData.withdrawable = (_balanceData_withdrawable = balanceData == null ? void 0 : balanceData.withdrawable) != null ? _balanceData_withdrawable : balanceData == null ? void 0 : balanceData.balance;
    updateBalanceView();
}
function buildSkeletonUI() {
    if (!this.currentView) {
        AppState.shadowRoot.innerHTML = '';
        return;
    }
    AppState.shadowRoot.innerHTML = getHeaderTemplate();
    _class_private_field_loose_base(this, _prepareTabs)[_prepareTabs]();
}
function prepareTabs() {
    const tabs = getTabs();
    for (const tab of tabs){
        const isActive = tab.classList.contains(this.currentView);
        if (isActive) {
            tab.setAttribute('active', 'true');
        } else {
            tab.removeAttribute('active');
        }
        tab.addEventListener('click', ()=>{
            const tabName = tab.classList.item(0);
            AppState.root.dispatchEvent(new CustomEvent(DispatchMessageType.ChangeView, {
                detail: tabName
            }));
            _class_private_field_loose_base(this, _changeWalletView)[_changeWalletView](tabName);
        });
    }
}
async function profileHandler$1(event) {
    var _payload_detail;
    const payload = event.detail;
    const profile = ((_payload_detail = payload.detail) == null ? void 0 : _payload_detail.profile) || payload.profile;
    if (!profile) {
        console.error('The profile is empty');
        return;
    }
    AppState.wallet.profile = profile;
}
async function depositParamsHandler(event) {
    const payload = event.detail;
    const extraData = payload.detail || payload;
    if (!extraData) {
        console.error('The extraData is empty');
        return;
    }
    AppState.wallet.depositExtraData = extraData || {};
}
async function featuresFlagHandler(event) {
    const payload = event.detail;
    AppState.wallet.closedLoopOnly = payload.isClosedLoopEnabled;
    AppState.wallet.features = _extends$1({}, AppState.wallet.features, payload);
}
async function magicPaymentMethodsHandler(event) {
    const payload = event.detail;
    AppState.methods.magicPaymentMethodsByProvider = _class_private_field_loose_base(this, _sortMagicMethodByProvider)[_sortMagicMethodByProvider](payload.paymentMethods);
}
function sortMagicMethodByProvider(methods) {
    const methodsByProvider = {
        [ProviderType.Paysafe]: [],
        [ProviderType.Devcode]: [],
        [ProviderType.Nuvei]: [],
        [ProviderType.Paymongo]: [],
        [ProviderType.Solairepay]: []
    };
    methods.forEach((method)=>{
        if (method.status) {
            var _methodsByProvider_method_provider;
            (_methodsByProvider_method_provider = methodsByProvider[method.provider]) == null ? void 0 : _methodsByProvider_method_provider.push(method);
        }
    });
    return methodsByProvider;
}
customElements.define('magic-galleon', WalletElement);

function getDepositTemplate() {
    var _cards_;
    const cards = AppState.methods.savedDepositMethods.filter((method)=>method.methodLabel === `Creditcard`);
    const isMobile = AppState.wallet.isMobile;
    const isLandscape = screen.orientation.type.startsWith(`landscape`) && isMobile;
    const classNames = `quick-payment${isMobile ? ` is-mobile` : ``}`;
    var _cards__currencyCode;
    return `
    <div part="quick-payment" data-v-test-id="quick-payment" class="${classNames}">
      <div part="content" class="quick-payment__content content${isLandscape ? `--vertical` : ``}">
        <magic-ui-dropdown
          small
          icon-prefix="creditcard-wire"
          class="quick-payment__dropdown card"
          data-v-test-id="quick-payment-card-dropdown"
        >
        </magic-ui-dropdown>
        ${cards.length > 0 ? `
          <div class="quick-payment__cvv-wrapper">
            ${getCVVInputTemplate()}
          </div>` : ''}
        <magic-ui-tooltip controlled="" part="amount error lifted" position="bottom" label="" data-v-test-id="quick-payment-amount-tooltip" class="amount error lifted">
          <magic-ui-number 
            small=""
            maxlength="4"
            data-v-test-id="quick-payment-amount-number"
            class="quick-payment__amount"
            value=""
            placeholder="${(_cards__currencyCode = (_cards_ = cards[0]) == null ? void 0 : _cards_.currencyCode) != null ? _cards__currencyCode : 'USD'}">
          </magic-ui-number>
        </magic-ui-tooltip>
        <magic-ui-button variant="primary" disabled part="button" data-v-test-id="quick-payment-button" class="button quick-payment__button">
          ${translate('deposit.form.button')}
        </magic-ui-button>
      </div>
      <div class="quick-payment__status">
      </div>
    </div>
  `;
}
function getCVVInputTemplate() {
    return `
    <magic-ui-number 
      small="" 
      maxlength="4" 
      part="cvv" 
      placeholder="${translate('quick-deposit.card-cvv')}" 
      data-v-test-id="quick-payment-cvv-number" 
      value="" 
      class="cvv quick-payment__cvv">
    </magic-ui-number>
    `;
}

const createDepositView = ()=>{
    var _paymentContent_shadowRoot, _content_shadowRoot, _content_shadowRoot1;
    const paymentContent = document.querySelector('magic-quick-payment-content');
    const content = (_paymentContent_shadowRoot = paymentContent.shadowRoot) == null ? void 0 : _paymentContent_shadowRoot.querySelector('magic-quick-payment');
    content.innerHTML = '';
    (_content_shadowRoot = content.shadowRoot) == null ? void 0 : _content_shadowRoot.setHTMLUnsafe(getDepositTemplate());
    // Collect payment options from all registered providers
    const allPaymentOptions = Object.values(paymentProviders).flatMap((provider)=>provider.getAvailableOptions());
    // Set options to dropdown
    const dropdown = content == null ? void 0 : (_content_shadowRoot1 = content.shadowRoot) == null ? void 0 : _content_shadowRoot1.querySelector('.quick-payment__dropdown');
    // @ts-expect-error setting component parameters
    dropdown.options = allPaymentOptions;
    attachListeners$3(content);
};
async function renderDepositView() {
    const getDepositMethods = async ()=>{
        if (WalletGateway.instance.isInitialized()) {
            const { methods, savedMethods } = await WalletGateway.instance.getDepositMethods();
            const cards = AppState.methods.savedDepositMethods.filter((method)=>method.methodLabel === `Creditcard`);
            const paypalMethod = AppState.methods.deposit.find((method)=>method.paymentMethodExternalId === PaysafeMethodId.Paypal && method.provider === 'Paysafe');
            AppState.methods.deposit = methods;
            AppState.methods.savedDepositMethods = savedMethods;
            if (paypalMethod || cards.length > 0) {
                createDepositView();
            }
            return;
        }
        setTimeout(getDepositMethods, 200);
    };
    await getDepositMethods();
}

var scss = "html,\nbody {\n  height: 100%;\n}\n\nbody {\n  background-color: var(--magic-background, #fbfbfb);\n  font: normal normal var(--magic-font-size, 14px) var(--magic-font-family, proxima-nova, Helvetica, Arial, sans-serif);\n  font-weight: var(--magic-font-weight, 400);\n  color: var(--magic-text, #747474);\n  text-size-adjust: none;\n  overflow-x: hidden;\n}\nbody:-webkit-full-screen {\n  width: 100%;\n}\nbody.no-scroll {\n  overflow: hidden;\n}\n\n* {\n  box-sizing: border-box;\n}\n*::after, *::before {\n  box-sizing: border-box;\n}\n\nh1,\nh2,\nh3,\nh4 {\n  margin: 0 0 0.5em;\n  font-family: var(--magic-header-font-family, proxima-nova, Helvetica, Arial, sans-serif);\n  font-weight: var(--magic-header-font-weight, 700);\n  color: inherit;\n  line-height: 1;\n}\n\nh1 {\n  font-size: 30px;\n}\n\nh2 {\n  font-size: 22px;\n}\n\nh3,\nh4 {\n  font-size: 18px;\n}\n\np {\n  margin: 0 0 1em;\n  font-size: 12px;\n}\n\nstrong,\nb {\n  font-weight: var(--magic-caption-font-weight, 600);\n}\n\nem,\ni {\n  font-style: italic;\n}\n\na {\n  outline: none;\n  text-decoration: none;\n  color: inherit;\n  cursor: pointer;\n}\n\nbutton {\n  margin: 0;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n}\nbutton:hover, button:focus, button:active {\n  outline: none;\n}\n\ninput,\ntextarea,\nbutton,\nselect {\n  font-family: var(--magic-font-family, proxima-nova, Helvetica, Arial, sans-serif);\n  font-size: 100%;\n  color: inherit;\n  line-height: 1;\n}\n\ninput[type=date]::-webkit-date-and-time-value {\n  margin-top: 6px;\n}\n\ninput[type=date]::-webkit-clear-button,\ninput[type=date]::-webkit-inner-spin-button {\n  margin: 0;\n  opacity: 0;\n}\n\ninput[type=date]::-webkit-calendar-picker-indicator {\n  margin-right: 30px;\n  width: 12px;\n  height: 12px;\n  color: white;\n}\ninput[type=date]::-webkit-calendar-picker-indicator:hover {\n  background-color: rgba(255, 255, 255, 0);\n}\ninput[type=date]::-webkit-calendar-picker-indicator:active {\n  color: white;\n}\n\ninput::-ms-clear {\n  display: none;\n}\n\ninput::-ms-reveal {\n  display: none;\n}\n\ninput[type=number]::-webkit-outer-spin-button,\ninput[type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n::-webkit-credentials-auto-fill-button {\n  background: transparent;\n}\n\n::-webkit-contacts-auto-fill-button {\n  background: transparent;\n}\n\n::-webkit-caps-lock-indicator {\n  content: none;\n}\n\nvideo {\n  background-color: rgba(0, 0, 0, 0);\n}\n\ndiv:focus,\nlabel:focus {\n  outline: none;\n}\n\nlabel {\n  cursor: inherit;\n}\n\n@-moz-document url-prefix() {\n  img {\n    color: rgba(255, 255, 255, 0);\n  }\n}\ninput,\ntextarea,\nbutton,\nselect,\na {\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n@keyframes fade-in-animation {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes spin-animation {\n  from {\n    transform: translate3d(-50%, -50%, 0) rotate(0deg);\n  }\n  to {\n    transform: translate3d(-50%, -50%, 0) rotate(360deg);\n  }\n}\n@keyframes scale-animation {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(0);\n  }\n}\n.quick-payment {\n  display: block;\n  position: fixed;\n  top: calc(var(--magic-quick-payment-height, 48px) * -1);\n  left: 0;\n  right: 0;\n}\n@media (min-width: 1024px) {\n  .quick-payment:not(.is-mobile) {\n    position: static;\n    top: auto;\n    left: auto;\n    right: auto;\n  }\n}\n\n.quick-payment {\n  background: var(--quick-payment-background-color, var(--magic-tertiary, #141f33));\n  z-index: 10;\n  position: relative;\n  width: 100%;\n  min-height: var(--magic-quick-payment-height, 48px);\n}\n.quick-payment.is-mobile {\n  margin-top: 50px;\n}\n@media (min-width: 1024px) {\n  .quick-payment:not(.is-mobile) {\n    width: calc(100% + var(--magic-space--large, 32px));\n  }\n}\n\n.content {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  height: 48px;\n  padding: var(--magic-space--small, 8px);\n}\n.content--vertical {\n  flex-direction: column;\n  padding: 0;\n}\n.content.hidden {\n  display: none;\n}\n@media (min-width: 1024px) {\n  .content {\n    padding: var(--magic-space--small, 8px) 0;\n  }\n}\n\n.hidden {\n  display: none;\n}\n\n.card,\n.amount,\n.button {\n  margin: 0 calc(var(--magic-space--small, 8px) / 2);\n}\n\n.card {\n  flex: 1 1 140px;\n}\n.card--vertical {\n  flex: 1 1 40px;\n  width: 100%;\n}\n@media (min-width: 1024px) {\n  .card {\n    flex-grow: 0;\n  }\n}\n\n.cvv {\n  z-index: 50;\n}\n@media (min-width: 1024px) {\n  .cvv {\n    flex: 1 1 60px;\n  }\n}\n\n.quick-payment__cvv-wrapper {\n  margin: 0 calc(var(--magic-space--small, 8px) / 4);\n}\n@media (min-width: 1024px) {\n  .quick-payment__cvv-wrapper {\n    max-width: 60px;\n  }\n}\n.quick-payment__cvv-wrapper.none {\n  display: none;\n}\n\n.amount {\n  flex: 1 1 70px;\n}\n.amount--vertical {\n  flex: 1 1 40px;\n  width: 100%;\n}\n@media (min-width: 1024px) {\n  .amount {\n    flex: 0 1 90px;\n  }\n}\n\n.wrapper {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  top: 0;\n  z-index: 1;\n  will-change: transform;\n}\n.wrapper.slide-in-enter-active, .wrapper.slide-in-leave-active {\n  transition: transform calc(var(--magic-duration, 0.3s));\n}\n.wrapper.slide-in-enter-active .result, .wrapper.slide-in-leave-active .result {\n  transition: transform var(--magic-duration, 0.3s);\n}\n.wrapper.slide-in-enter .result, .wrapper.slide-in-leave-to .result {\n  transform: translate(0, 100%);\n}\n\n.result {\n  align-items: center;\n  background: var(--quick-payment-background-color, var(--magic-tertiary, #141f33));\n  color: var(--quick-payment-result-color, var(--magic-tertiary-contrast, #fff));\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  transform: translate(0, 0);\n  width: 100%;\n  will-change: transform;\n}\n\n.quick-payment__button::part(button) {\n  padding: calc(var(--magic-space--x-small, 4px) + 2px) var(--magic-space, 16px);\n  margin: 0;\n}\n@media (orientation: landscape) {\n  .quick-payment__button::part(button) {\n    display: flex;\n    margin: 0;\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n.icon--payment {\n  margin-right: var(--magic-space--small, 8px);\n}\n.icon--payment {\n  margin: var(--magic-space--x-small, 4px);\n  width: var(--magic-icon-size, 24px);\n  height: var(--magic-icon-size, 24px);\n}\n\n.quick-payment__failed,\n.quick-payment__success {\n  height: 0;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.quick-payment__failed.slide-in,\n.quick-payment__success.slide-in {\n  transition: all 0.5s ease-in-out;\n  height: 48px;\n}\n\n.quick-payment__message {\n  color: #fff;\n}";

var _inputChannel = /*#__PURE__*/ _class_private_field_loose_key("_inputChannel"), _subscriptions = /*#__PURE__*/ _class_private_field_loose_key("_subscriptions"), _applyStyles = /*#__PURE__*/ _class_private_field_loose_key("_applyStyles"), _attachListeners = /*#__PURE__*/ _class_private_field_loose_key("_attachListeners"), _profileHandler = /*#__PURE__*/ _class_private_field_loose_key("_profileHandler"), _deviceHandler = /*#__PURE__*/ _class_private_field_loose_key("_deviceHandler"), _translationsHandler = /*#__PURE__*/ _class_private_field_loose_key("_translationsHandler");
/**
 * A lightweight web component focused on rendering a streamlined Deposit view.
 *
 * Registered as `magic-quick-payment`, it is intended for simple payment flows
 * (e.g., quick deposit widgets). It listens to a subset of the cashier events
 * to initialize gateways, set locale/translations, device type and profile.
 *
 * Listens for:
 * - ListenMessageType.InitGateways: initializes gateways.
 * - ListenMessageType.UpdateTranslations: updates locale and translations.
 * - ListenMessageType.Device: updates isMobile state to render proper layout.
 * - ListenMessageType.UpdateProfile: updates user profile for payments (paysafe, devcode methods).
 *
 * @public
 */ class QuickPaymentElement extends HTMLElement {
    connectedCallback() {
        this.attachShadow({
            mode: 'open'
        });
        renderDepositView();
        _class_private_field_loose_base(this, _applyStyles)[_applyStyles]();
        _class_private_field_loose_base(this, _attachListeners)[_attachListeners]();
        this.dispatchEvent(new Event('load'));
    }
    constructor(){
        super(), Object.defineProperty(this, _applyStyles, {
            value: applyStyles
        }), Object.defineProperty(this, _attachListeners, {
            value: attachListeners
        }), Object.defineProperty(this, _profileHandler, {
            value: profileHandler
        }), Object.defineProperty(this, _deviceHandler, {
            value: deviceHandler
        }), Object.defineProperty(this, _translationsHandler, {
            value: translationsHandler
        }), Object.defineProperty(this, _inputChannel, {
            writable: true,
            value: void 0
        }), Object.defineProperty(this, _subscriptions, {
            writable: true,
            value: void 0
        }), _class_private_field_loose_base(this, _inputChannel)[_inputChannel] = new HtmlEventMessageChannel(this), _class_private_field_loose_base(this, _subscriptions)[_subscriptions] = [];
        AppState.root = this;
    }
}
function applyStyles() {
    const styleSheet = new CSSStyleSheet();
    styleSheet.replaceSync(scss);
    AppState.shadowRoot.adoptedStyleSheets.push(styleSheet);
}
function attachListeners() {
    _class_private_field_loose_base(this, _inputChannel)[_inputChannel].waitForMessage(ListenMessageType.InitGateways).then(async (config)=>{
        if (!config.corex.devcodeMerchantId) {
            return; // do not initialize if Devcode integration disabled
        }
        await WalletGateway.instance.init(config);
    });
    _class_private_field_loose_base(this, _subscriptions)[_subscriptions].push(_class_private_field_loose_base(this, _inputChannel)[_inputChannel].subscribeForMessage(ListenMessageType.UpdateTranslations, _class_private_field_loose_base(this, _translationsHandler)[_translationsHandler]), _class_private_field_loose_base(this, _inputChannel)[_inputChannel].subscribeForMessage(ListenMessageType.Device, _class_private_field_loose_base(this, _deviceHandler)[_deviceHandler]), _class_private_field_loose_base(this, _inputChannel)[_inputChannel].subscribeForMessage(ListenMessageType.UpdateProfile, _class_private_field_loose_base(this, _profileHandler)[_profileHandler]), _class_private_field_loose_base(this, _inputChannel)[_inputChannel].subscribeForMessage(ListenMessageType.Device, _class_private_field_loose_base(this, _deviceHandler)[_deviceHandler]));
    window.addEventListener('orientationchange', ()=>{
        renderDepositView();
    });
}
async function profileHandler(event) {
    var _payload_detail;
    const payload = event.detail;
    const profile = ((_payload_detail = payload.detail) == null ? void 0 : _payload_detail.profile) || payload.profile;
    if (!profile) {
        console.error('The profile is empty');
        return;
    }
    AppState.wallet.profile = profile;
}
async function deviceHandler(event) {
    const payload = event.detail;
    AppState.wallet.isMobile = payload.isMobile;
}
async function translationsHandler(event) {
    const payload = event.detail;
    if (!payload.translations) {
        console.error('The translation object is empty for event "update-translations"');
        return;
    }
    if (payload.locale) {
        AppState.wallet.locale = payload.locale;
    }
    WalletTranslations.instance.updateTranslations(payload.translations);
}
customElements.define('magic-quick-payment', QuickPaymentElement);

export { CorexProviderType, DevcodeMethodId, DispatchMessageType, GatewayType, ListenMessageType, LogActionEventName, NuveiMethodId, PaysafeMethodId, QuickPaymentElement, View, WalletElement, WalletGateway, WalletQueryParams, gatewayMethodType, viewEventMap, viewTypes };
